!(function (e, t) {
    "use strict";
    "object" == typeof module && "object" == typeof module.exports? (module.exports = e.document? t(e, !0): function (e) {if (!e.document) throw new Error("jQuery requires a window with a document");return t(e);}) : t(e);
})("undefined" != typeof window ? window : this, function (e, t) {
    "use strict";
    function n(e, t, n) {
        var i,
            o,
            r = (n = n || J).createElement("script");
        if (((r.text = e), t)) for (i in pe) (o = t[i] || (t.getAttribute && t.getAttribute(i))) && r.setAttribute(i, o);
        n.head.appendChild(r).parentNode.removeChild(r);
    }
    function i(e) {
        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? oe[re.call(e)] || "object" : typeof e;
    }
    function o(e) {
        var t = !!e && "length" in e && e.length,
            n = i(e);
        return !ue(e) && !de(e) && ("array" === n || 0 === t || ("number" == typeof t && 0 < t && t - 1 in e));
    }
    function r(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
    }
    function s(e, t, n) {
        return ue(t)
            ? he.grep(e, function (e, i) {
                  return !!t.call(e, i, e) !== n;
              })
            : t.nodeType
            ? he.grep(e, function (e) {
                  return (e === t) !== n;
              })
            : "string" != typeof t
            ? he.grep(e, function (e) {
                  return -1 < ie.call(t, e) !== n;
              })
            : he.filter(t, e, n);
    }
    function a(e, t) {
        for (; (e = e[t]) && 1 !== e.nodeType; );
        return e;
    }
    function l(e) {
        return e;
    }
    function c(e) {
        throw e;
    }
    function u(e, t, n, i) {
        var o;
        try {
            e && ue((o = e.promise)) ? o.call(e).done(t).fail(n) : e && ue((o = e.then)) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i));
        } catch (e) {
            n.apply(void 0, [e]);
        }
    }
    function d() {
        J.removeEventListener("DOMContentLoaded", d), e.removeEventListener("load", d), he.ready();
    }
    function p(e, t) {
        return t.toUpperCase();
    }
    function f(e) {
        return e.replace(Pe, "ms-").replace(Oe, p);
    }
    function h() {
        this.expando = he.expando + h.uid++;
    }
    function m(e, t, n) {
        var i, o;
        if (void 0 === n && 1 === e.nodeType)
            if (((i = "data-" + t.replace(Le, "-$&").toLowerCase()), "string" == typeof (n = e.getAttribute(i)))) {
                try {
                    n = "true" === (o = n) || ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : De.test(o) ? JSON.parse(o) : o));
                } catch (e) {}
                Ne.set(e, t, n);
            } else n = void 0;
        return n;
    }
    function v(e, t, n, i) {
        var o,
            r,
            s = 20,
            a = i
                ? function () {
                      return i.cur();
                  }
                : function () {
                      return he.css(e, t, "");
                  },
            l = a(),
            c = (n && n[3]) || (he.cssNumber[t] ? "" : "px"),
            u = e.nodeType && (he.cssNumber[t] || ("px" !== c && +l)) && Me.exec(he.css(e, t));
        if (u && u[3] !== c) {
            for (l /= 2, c = c || u[3], u = +l || 1; s--; ) he.style(e, t, u + c), (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0), (u /= r);
            (u *= 2), he.style(e, t, u + c), (n = n || []);
        }
        return n && ((u = +u || +l || 0), (o = n[1] ? u + (n[1] + 1) * n[2] : +n[2]), i && ((i.unit = c), (i.start = u), (i.end = o))), o;
    }
    function g(e, t) {
        for (var n, i, o, r, s, a, l, c = [], u = 0, d = e.length; u < d; u++)
            (i = e[u]).style &&
                ((n = i.style.display),
                t
                    ? ("none" === n && ((c[u] = Ie.get(i, "display") || null), c[u] || (i.style.display = "")),
                      "" === i.style.display &&
                          qe(i) &&
                          (c[u] =
                              ((l = s = r = void 0),
                              (s = (o = i).ownerDocument),
                              (a = o.nodeName),
                              (l = We[a]) || ((r = s.body.appendChild(s.createElement(a))), (l = he.css(r, "display")), r.parentNode.removeChild(r), "none" === l && (l = "block"), (We[a] = l)))))
                    : "none" !== n && ((c[u] = "none"), Ie.set(i, "display", n)));
        for (u = 0; u < d; u++) null != c[u] && (e[u].style.display = c[u]);
        return e;
    }
    function y(e, t) {
        var n;
        return (n = "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t || "*") : "undefined" != typeof e.querySelectorAll ? e.querySelectorAll(t || "*") : []), void 0 === t || (t && r(e, t)) ? he.merge([e], n) : n;
    }
    function b(e, t) {
        for (var n = 0, i = e.length; n < i; n++) Ie.set(e[n], "globalEval", !t || Ie.get(t[n], "globalEval"));
    }
    function w(e, t, n, o, r) {
        for (var s, a, l, c, u, d, p = t.createDocumentFragment(), f = [], h = 0, m = e.length; h < m; h++)
            if ((s = e[h]) || 0 === s)
                if ("object" === i(s)) he.merge(f, s.nodeType ? [s] : s);
                else if (Ge.test(s)) {
                    for (a = a || p.appendChild(t.createElement("div")), l = (Ze.exec(s) || ["", ""])[1].toLowerCase(), c = Ke[l] || Ke._default, a.innerHTML = c[1] + he.htmlPrefilter(s) + c[2], d = c[0]; d--; ) a = a.lastChild;
                    he.merge(f, a.childNodes), ((a = p.firstChild).textContent = "");
                } else f.push(t.createTextNode(s));
        for (p.textContent = "", h = 0; (s = f[h++]); )
            if (o && -1 < he.inArray(s, o)) r && r.push(s);
            else if (((u = Re(s)), (a = y(p.appendChild(s), "script")), u && b(a), n)) for (d = 0; (s = a[d++]); ) Ve.test(s.type || "") && n.push(s);
        return p;
    }
    function x() {
        return !0;
    }
    function k() {
        return !1;
    }
    function S(e, t) {
        return (
            (e ===
                (function () {
                    try {
                        return J.activeElement;
                    } catch (e) {}
                })()) ==
            ("focus" === t)
        );
    }
    function C(e, t, n, i, o, r) {
        var s, a;
        if ("object" == typeof t) {
            for (a in ("string" != typeof n && ((i = i || n), (n = void 0)), t)) C(e, a, n, i, t[a], r);
            return e;
        }
        if ((null == i && null == o ? ((o = n), (i = n = void 0)) : null == o && ("string" == typeof n ? ((o = i), (i = void 0)) : ((o = i), (i = n), (n = void 0))), !1 === o)) o = k;
        else if (!o) return e;
        return (
            1 === r &&
                ((s = o),
                ((o = function (e) {
                    return he().off(e), s.apply(this, arguments);
                }).guid = s.guid || (s.guid = he.guid++))),
            e.each(function () {
                he.event.add(this, t, o, i, n);
            })
        );
    }
    function T(e, t, n) {
        n
            ? (Ie.set(e, t, !1),
              he.event.add(e, t, {
                  namespace: !1,
                  handler: function (e) {
                      var i,
                          o,
                          r = Ie.get(this, t);
                      if (1 & e.isTrigger && this[t]) {
                          if (r.length) (he.event.special[t] || {}).delegateType && e.stopPropagation();
                          else if (((r = ee.call(arguments)), Ie.set(this, t, r), (i = n(this, t)), this[t](), r !== (o = Ie.get(this, t)) || i ? Ie.set(this, t, !1) : (o = {}), r !== o))
                              return e.stopImmediatePropagation(), e.preventDefault(), o.value;
                      } else r.length && (Ie.set(this, t, { value: he.event.trigger(he.extend(r[0], he.Event.prototype), r.slice(1), this) }), e.stopImmediatePropagation());
                  },
              }))
            : void 0 === Ie.get(e, t) && he.event.add(e, t, x);
    }
    function E(e, t) {
        return (r(e, "table") && r(11 !== t.nodeType ? t : t.firstChild, "tr") && he(e).children("tbody")[0]) || e;
    }
    function A(e) {
        return (e.type = (null !== e.getAttribute("type")) + "/" + e.type), e;
    }
    function _(e) {
        return "true/" === (e.type || "").slice(0, 5) ? (e.type = e.type.slice(5)) : e.removeAttribute("type"), e;
    }
    function P(e, t) {
        var n, i, o, r, s, a, l, c;
        if (1 === t.nodeType) {
            if (Ie.hasData(e) && ((r = Ie.access(e)), (s = Ie.set(t, r)), (c = r.events))) for (o in (delete s.handle, (s.events = {}), c)) for (n = 0, i = c[o].length; n < i; n++) he.event.add(t, o, c[o][n]);
            Ne.hasData(e) && ((a = Ne.access(e)), (l = he.extend({}, a)), Ne.set(t, l));
        }
    }
    function O(e, t, i, o) {
        t = te.apply([], t);
        var r,
            s,
            a,
            l,
            c,
            u,
            d = 0,
            p = e.length,
            f = p - 1,
            h = t[0],
            m = ue(h);
        if (m || (1 < p && "string" == typeof h && !ce.checkClone && it.test(h)))
            return e.each(function (n) {
                var r = e.eq(n);
                m && (t[0] = h.call(this, n, r.html())), O(r, t, i, o);
            });
        if (p && ((s = (r = w(t, e[0].ownerDocument, !1, e, o)).firstChild), 1 === r.childNodes.length && (r = s), s || o)) {
            for (l = (a = he.map(y(r, "script"), A)).length; d < p; d++) (c = r), d !== f && ((c = he.clone(c, !0, !0)), l && he.merge(a, y(c, "script"))), i.call(e[d], c, d);
            if (l)
                for (u = a[a.length - 1].ownerDocument, he.map(a, _), d = 0; d < l; d++)
                    (c = a[d]),
                        Ve.test(c.type || "") &&
                            !Ie.access(c, "globalEval") &&
                            he.contains(u, c) &&
                            (c.src && "module" !== (c.type || "").toLowerCase() ? he._evalUrl && !c.noModule && he._evalUrl(c.src, { nonce: c.nonce || c.getAttribute("nonce") }) : n(c.textContent.replace(ot, ""), c, u));
        }
        return e;
    }
    function $(e, t, n) {
        for (var i, o = t ? he.filter(t, e) : e, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || he.cleanData(y(i)), i.parentNode && (n && Re(i) && b(y(i, "script")), i.parentNode.removeChild(i));
        return e;
    }
    function I(e, t, n) {
        var i,
            o,
            r,
            s,
            a = e.style;
        return (
            (n = n || st(e)) &&
                ("" !== (s = n.getPropertyValue(t) || n[t]) || Re(e) || (s = he.style(e, t)),
                !ce.pixelBoxStyles() && rt.test(s) && at.test(t) && ((i = a.width), (o = a.minWidth), (r = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = n.width), (a.width = i), (a.minWidth = o), (a.maxWidth = r))),
            void 0 !== s ? s + "" : s
        );
    }
    function N(e, t) {
        return {
            get: function () {
                return e() ? void delete this.get : (this.get = t).apply(this, arguments);
            },
        };
    }
    function D(e) {
        var t = he.cssProps[e] || ut[e];
        return (
            t ||
            (e in ct
                ? e
                : (ut[e] =
                      (function (e) {
                          for (var t = e[0].toUpperCase() + e.slice(1), n = lt.length; n--; ) if ((e = lt[n] + t) in ct) return e;
                      })(e) || e))
        );
    }
    function L(e, t, n) {
        var i = Me.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t;
    }
    function z(e, t, n, i, o, r) {
        var s = "width" === t ? 1 : 0,
            a = 0,
            l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; s < 4; s += 2)
            "margin" === n && (l += he.css(e, n + je[s], !0, o)),
                i
                    ? ("content" === n && (l -= he.css(e, "padding" + je[s], !0, o)), "margin" !== n && (l -= he.css(e, "border" + je[s] + "Width", !0, o)))
                    : ((l += he.css(e, "padding" + je[s], !0, o)), "padding" !== n ? (l += he.css(e, "border" + je[s] + "Width", !0, o)) : (a += he.css(e, "border" + je[s] + "Width", !0, o)));
        return !i && 0 <= r && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - 0.5)) || 0), l;
    }
    function M(e, t, n) {
        var i = st(e),
            o = (!ce.boxSizingReliable() || n) && "border-box" === he.css(e, "boxSizing", !1, i),
            r = o,
            s = I(e, t, i),
            a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (rt.test(s)) {
            if (!n) return s;
            s = "auto";
        }
        return (
            ((!ce.boxSizingReliable() && o) || "auto" === s || (!parseFloat(s) && "inline" === he.css(e, "display", !1, i))) && e.getClientRects().length && ((o = "border-box" === he.css(e, "boxSizing", !1, i)), (r = a in e) && (s = e[a])),
            (s = parseFloat(s) || 0) + z(e, t, n || (o ? "border" : "content"), r, i, s) + "px"
        );
    }
    function j(e, t, n, i, o) {
        return new j.prototype.init(e, t, n, i, o);
    }
    function H() {
        vt && (!1 === J.hidden && e.requestAnimationFrame ? e.requestAnimationFrame(H) : e.setTimeout(H, he.fx.interval), he.fx.tick());
    }
    function R() {
        return (
            e.setTimeout(function () {
                mt = void 0;
            }),
            (mt = Date.now())
        );
    }
    function F(e, t) {
        var n,
            i = 0,
            o = { height: e };
        for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = je[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e), o;
    }
    function q(e, t, n) {
        for (var i, o = (B.tweeners[t] || []).concat(B.tweeners["*"]), r = 0, s = o.length; r < s; r++) if ((i = o[r].call(n, t, e))) return i;
    }
    function B(e, t, n) {
        var i,
            o,
            r = 0,
            s = B.prefilters.length,
            a = he.Deferred().always(function () {
                delete l.elem;
            }),
            l = function () {
                if (o) return !1;
                for (var t = mt || R(), n = Math.max(0, c.startTime + c.duration - t), i = 1 - (n / c.duration || 0), r = 0, s = c.tweens.length; r < s; r++) c.tweens[r].run(i);
                return a.notifyWith(e, [c, i, n]), i < 1 && s ? n : (s || a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c]), !1);
            },
            c = a.promise({
                elem: e,
                props: he.extend({}, t),
                opts: he.extend(!0, { specialEasing: {}, easing: he.easing._default }, n),
                originalProperties: t,
                originalOptions: n,
                startTime: mt || R(),
                duration: n.duration,
                tweens: [],
                createTween: function (t, n) {
                    var i = he.Tween(e, c.opts, t, n, c.opts.specialEasing[t] || c.opts.easing);
                    return c.tweens.push(i), i;
                },
                stop: function (t) {
                    var n = 0,
                        i = t ? c.tweens.length : 0;
                    if (o) return this;
                    for (o = !0; n < i; n++) c.tweens[n].run(1);
                    return t ? (a.notifyWith(e, [c, 1, 0]), a.resolveWith(e, [c, t])) : a.rejectWith(e, [c, t]), this;
                },
            }),
            u = c.props;
        for (
            !(function (e, t) {
                var n, i, o, r, s;
                for (n in e)
                    if (((o = t[(i = f(n))]), (r = e[n]), Array.isArray(r) && ((o = r[1]), (r = e[n] = r[0])), n !== i && ((e[i] = r), delete e[n]), (s = he.cssHooks[i]) && ("expand" in s)))
                        for (n in ((r = s.expand(r)), delete e[i], r)) (n in e) || ((e[n] = r[n]), (t[n] = o));
                    else t[i] = o;
            })(u, c.opts.specialEasing);
            r < s;
            r++
        )
            if ((i = B.prefilters[r].call(c, e, u, c.opts))) return ue(i.stop) && (he._queueHooks(c.elem, c.opts.queue).stop = i.stop.bind(i)), i;
        return (
            he.map(u, q, c),
            ue(c.opts.start) && c.opts.start.call(e, c),
            c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always),
            he.fx.timer(he.extend(l, { elem: e, anim: c, queue: c.opts.queue })),
            c
        );
    }
    function W(e) {
        return (e.match(Te) || []).join(" ");
    }
    function U(e) {
        return (e.getAttribute && e.getAttribute("class")) || "";
    }
    function Z(e) {
        return Array.isArray(e) ? e : ("string" == typeof e && e.match(Te)) || [];
    }
    function V(e, t, n, o) {
        var r;
        if (Array.isArray(t))
            he.each(t, function (t, i) {
                n || $t.test(e) ? o(e, i) : V(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, o);
            });
        else if (n || "object" !== i(t)) o(e, t);
        else for (r in t) V(e + "[" + r + "]", t[r], n, o);
    }
    function K(e) {
        return function (t, n) {
            "string" != typeof t && ((n = t), (t = "*"));
            var i,
                o = 0,
                r = t.toLowerCase().match(Te) || [];
            if (ue(n)) for (; (i = r[o++]); ) "+" === i[0] ? ((i = i.slice(1) || "*"), (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n);
        };
    }
    function X(e, t, n, i) {
        function o(a) {
            var l;
            return (
                (r[a] = !0),
                he.each(e[a] || [], function (e, a) {
                    var c = a(t, n, i);
                    return "string" != typeof c || s || r[c] ? (s ? !(l = c) : void 0) : (t.dataTypes.unshift(c), o(c), !1);
                }),
                l
            );
        }
        var r = {},
            s = e === qt;
        return o(t.dataTypes[0]) || (!r["*"] && o("*"));
    }
    function Y(e, t) {
        var n,
            i,
            o = he.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
        return i && he.extend(!0, e, i), e;
    }
    var G = [],
        J = e.document,
        Q = Object.getPrototypeOf,
        ee = G.slice,
        te = G.concat,
        ne = G.push,
        ie = G.indexOf,
        oe = {},
        re = oe.toString,
        se = oe.hasOwnProperty,
        ae = se.toString,
        le = ae.call(Object),
        ce = {},
        ue = function (e) {
            return "function" == typeof e && "number" != typeof e.nodeType;
        },
        de = function (e) {
            return null != e && e === e.window;
        },
        pe = { type: !0, src: !0, nonce: !0, noModule: !0 },
        fe = "3.4.1",
        he = function (e, t) {
            return new he.fn.init(e, t);
        },
        me = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    (he.fn = he.prototype = {
        jquery: fe,
        constructor: he,
        length: 0,
        toArray: function () {
            return ee.call(this);
        },
        get: function (e) {
            return null == e ? ee.call(this) : e < 0 ? this[e + this.length] : this[e];
        },
        pushStack: function (e) {
            var t = he.merge(this.constructor(), e);
            return (t.prevObject = this), t;
        },
        each: function (e) {
            return he.each(this, e);
        },
        map: function (e) {
            return this.pushStack(
                he.map(this, function (t, n) {
                    return e.call(t, n, t);
                })
            );
        },
        slice: function () {
            return this.pushStack(ee.apply(this, arguments));
        },
        first: function () {
            return this.eq(0);
        },
        last: function () {
            return this.eq(-1);
        },
        eq: function (e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : []);
        },
        end: function () {
            return this.prevObject || this.constructor();
        },
        push: ne,
        sort: G.sort,
        splice: G.splice,
    }),
        (he.extend = he.fn.extend = function () {
            var e,
                t,
                n,
                i,
                o,
                r,
                s = arguments[0] || {},
                a = 1,
                l = arguments.length,
                c = !1;
            for ("boolean" == typeof s && ((c = s), (s = arguments[a] || {}), a++), "object" == typeof s || ue(s) || (s = {}), a === l && ((s = this), a--); a < l; a++)
                if (null != (e = arguments[a]))
                    for (t in e)
                        (i = e[t]),
                            "__proto__" !== t &&
                                s !== i &&
                                (c && i && (he.isPlainObject(i) || (o = Array.isArray(i)))
                                    ? ((n = s[t]), (r = o && !Array.isArray(n) ? [] : o || he.isPlainObject(n) ? n : {}), (o = !1), (s[t] = he.extend(c, r, i)))
                                    : void 0 !== i && (s[t] = i));
            return s;
        }),
        he.extend({
            expando: "jQuery" + (fe + Math.random()).replace(/\D/g, ""),
            isReady: !0,
            error: function (e) {
                throw new Error(e);
            },
            noop: function () {},
            isPlainObject: function (e) {
                var t, n;
                return !(!e || "[object Object]" !== re.call(e) || ((t = Q(e)) && ("function" != typeof (n = se.call(t, "constructor") && t.constructor) || ae.call(n) !== le)));
            },
            isEmptyObject: function (e) {
                var t;
                for (t in e) return !1;
                return !0;
            },
            globalEval: function (e, t) {
                n(e, { nonce: t && t.nonce });
            },
            each: function (e, t) {
                var n,
                    i = 0;
                if (o(e)) for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
                else for (i in e) if (!1 === t.call(e[i], i, e[i])) break;
                return e;
            },
            trim: function (e) {
                return null == e ? "" : (e + "").replace(me, "");
            },
            makeArray: function (e, t) {
                var n = t || [];
                return null != e && (o(Object(e)) ? he.merge(n, "string" == typeof e ? [e] : e) : ne.call(n, e)), n;
            },
            inArray: function (e, t, n) {
                return null == t ? -1 : ie.call(t, e, n);
            },
            merge: function (e, t) {
                for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
                return (e.length = o), e;
            },
            grep: function (e, t, n) {
                for (var i = [], o = 0, r = e.length, s = !n; o < r; o++) !t(e[o], o) !== s && i.push(e[o]);
                return i;
            },
            map: function (e, t, n) {
                var i,
                    r,
                    s = 0,
                    a = [];
                if (o(e)) for (i = e.length; s < i; s++) null != (r = t(e[s], s, n)) && a.push(r);
                else for (s in e) null != (r = t(e[s], s, n)) && a.push(r);
                return te.apply([], a);
            },
            guid: 1,
            support: ce,
        }),
        "function" == typeof Symbol && (he.fn[Symbol.iterator] = G[Symbol.iterator]),
        he.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (e, t) {
            oe["[object " + t + "]"] = t.toLowerCase();
        });
    var ve = (function (e) {
        function t(e, t, n, i) {
            var o,
                r,
                s,
                a,
                l,
                c,
                u,
                p = t && t.ownerDocument,
                h = t ? t.nodeType : 9;
            if (((n = n || []), "string" != typeof e || !e || (1 !== h && 9 !== h && 11 !== h))) return n;
            if (!i && ((t ? t.ownerDocument || t : H) !== $ && O(t), (t = t || $), N)) {
                if (11 !== h && (l = ge.exec(e)))
                    if ((o = l[1])) {
                        if (9 === h) {
                            if (!(s = t.getElementById(o))) return n;
                            if (s.id === o) return n.push(s), n;
                        } else if (p && (s = p.getElementById(o)) && M(t, s) && s.id === o) return n.push(s), n;
                    } else {
                        if (l[2]) return G.apply(n, t.getElementsByTagName(e)), n;
                        if ((o = l[3]) && w.getElementsByClassName && t.getElementsByClassName) return G.apply(n, t.getElementsByClassName(o)), n;
                    }
                if (w.qsa && !U[e + " "] && (!D || !D.test(e)) && (1 !== h || "object" !== t.nodeName.toLowerCase())) {
                    if (((u = e), (p = t), 1 === h && ce.test(e))) {
                        for ((a = t.getAttribute("id")) ? (a = a.replace(xe, ke)) : t.setAttribute("id", (a = j)), r = (c = C(e)).length; r--; ) c[r] = "#" + a + " " + f(c[r]);
                        (u = c.join(",")), (p = (ye.test(e) && d(t.parentNode)) || t);
                    }
                    try {
                        return G.apply(n, p.querySelectorAll(u)), n;
                    } catch (t) {
                        U(e, !0);
                    } finally {
                        a === j && t.removeAttribute("id");
                    }
                }
            }
            return E(e.replace(se, "$1"), t, n, i);
        }
        function n() {
            var e = [];
            return function t(n, i) {
                return e.push(n + " ") > x.cacheLength && delete t[e.shift()], (t[n + " "] = i);
            };
        }
        function i(e) {
            return (e[j] = !0), e;
        }
        function o(e) {
            var t = $.createElement("fieldset");
            try {
                return !!e(t);
            } catch (e) {
                return !1;
            } finally {
                t.parentNode && t.parentNode.removeChild(t), (t = null);
            }
        }
        function r(e, t) {
            for (var n = e.split("|"), i = n.length; i--; ) x.attrHandle[n[i]] = t;
        }
        function s(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i) return i;
            if (n) for (; (n = n.nextSibling); ) if (n === t) return -1;
            return e ? 1 : -1;
        }
        function a(e) {
            return function (t) {
                return "input" === t.nodeName.toLowerCase() && t.type === e;
            };
        }
        function l(e) {
            return function (t) {
                var n = t.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && t.type === e;
            };
        }
        function c(e) {
            return function (t) {
                return "form" in t
                    ? t.parentNode && !1 === t.disabled
                        ? "label" in t
                            ? "label" in t.parentNode
                                ? t.parentNode.disabled === e
                                : t.disabled === e
                            : t.isDisabled === e || (t.isDisabled !== !e && Ce(t) === e)
                        : t.disabled === e
                    : "label" in t && t.disabled === e;
            };
        }
        function u(e) {
            return i(function (t) {
                return (
                    (t = +t),
                    i(function (n, i) {
                        for (var o, r = e([], n.length, t), s = r.length; s--; ) n[(o = r[s])] && (n[o] = !(i[o] = n[o]));
                    })
                );
            });
        }
        function d(e) {
            return e && "undefined" != typeof e.getElementsByTagName && e;
        }
        function p() {}
        function f(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i;
        }
        function h(e, t, n) {
            var i = t.dir,
                o = t.next,
                r = o || i,
                s = n && "parentNode" === r,
                a = F++;
            return t.first
                ? function (t, n, o) {
                      for (; (t = t[i]); ) if (1 === t.nodeType || s) return e(t, n, o);
                      return !1;
                  }
                : function (t, n, l) {
                      var c,
                          u,
                          d,
                          p = [R, a];
                      if (l) {
                          for (; (t = t[i]); ) if ((1 === t.nodeType || s) && e(t, n, l)) return !0;
                      } else
                          for (; (t = t[i]); )
                              if (1 === t.nodeType || s)
                                  if (((u = (d = t[j] || (t[j] = {}))[t.uniqueID] || (d[t.uniqueID] = {})), o && o === t.nodeName.toLowerCase())) t = t[i] || t;
                                  else {
                                      if ((c = u[r]) && c[0] === R && c[1] === a) return (p[2] = c[2]);
                                      if (((u[r] = p)[2] = e(t, n, l))) return !0;
                                  }
                      return !1;
                  };
        }
        function m(e) {
            return 1 < e.length
                ? function (t, n, i) {
                      for (var o = e.length; o--; ) if (!e[o](t, n, i)) return !1;
                      return !0;
                  }
                : e[0];
        }
        function v(e, t, n, i, o) {
            for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++) (r = e[a]) && ((n && !n(r, i, o)) || (s.push(r), c && t.push(a)));
            return s;
        }
        function g(e, n, o, r, s, a) {
            return (
                r && !r[j] && (r = g(r)),
                s && !s[j] && (s = g(s, a)),
                i(function (i, a, l, c) {
                    var u,
                        d,
                        p,
                        f = [],
                        h = [],
                        m = a.length,
                        g =
                            i ||
                            (function (e, n, i) {
                                for (var o = 0, r = n.length; o < r; o++) t(e, n[o], i);
                                return i;
                            })(n || "*", l.nodeType ? [l] : l, []),
                        y = !e || (!i && n) ? g : v(g, f, e, l, c),
                        b = o ? (s || (i ? e : m || r) ? [] : a) : y;
                    if ((o && o(y, b, l, c), r)) for (u = v(b, h), r(u, [], l, c), d = u.length; d--; ) (p = u[d]) && (b[h[d]] = !(y[h[d]] = p));
                    if (i) {
                        if (s || e) {
                            if (s) {
                                for (u = [], d = b.length; d--; ) (p = b[d]) && u.push((y[d] = p));
                                s(null, (b = []), u, c);
                            }
                            for (d = b.length; d--; ) (p = b[d]) && -1 < (u = s ? Q(i, p) : f[d]) && (i[u] = !(a[u] = p));
                        }
                    } else (b = v(b === a ? b.splice(m, b.length) : b)), s ? s(null, a, b, c) : G.apply(a, b);
                })
            );
        }
        function y(e) {
            for (
                var t,
                    n,
                    i,
                    o = e.length,
                    r = x.relative[e[0].type],
                    s = r || x.relative[" "],
                    a = r ? 1 : 0,
                    l = h(
                        function (e) {
                            return e === t;
                        },
                        s,
                        !0
                    ),
                    c = h(
                        function (e) {
                            return -1 < Q(t, e);
                        },
                        s,
                        !0
                    ),
                    u = [
                        function (e, n, i) {
                            var o = (!r && (i || n !== A)) || ((t = n).nodeType ? l(e, n, i) : c(e, n, i));
                            return (t = null), o;
                        },
                    ];
                a < o;
                a++
            )
                if ((n = x.relative[e[a].type])) u = [h(m(u), n)];
                else {
                    if ((n = x.filter[e[a].type].apply(null, e[a].matches))[j]) {
                        for (i = ++a; i < o && !x.relative[e[i].type]; i++);
                        return g(1 < a && m(u), 1 < a && f(e.slice(0, a - 1).concat({ value: " " === e[a - 2].type ? "*" : "" })).replace(se, "$1"), n, a < i && y(e.slice(a, i)), i < o && y((e = e.slice(i))), i < o && f(e));
                    }
                    u.push(n);
                }
            return m(u);
        }
        var b,
            w,
            x,
            k,
            S,
            C,
            T,
            E,
            A,
            _,
            P,
            O,
            $,
            I,
            N,
            D,
            L,
            z,
            M,
            j = "sizzle" + 1 * new Date(),
            H = e.document,
            R = 0,
            F = 0,
            q = n(),
            B = n(),
            W = n(),
            U = n(),
            Z = function (e, t) {
                return e === t && (P = !0), 0;
            },
            V = {}.hasOwnProperty,
            K = [],
            X = K.pop,
            Y = K.push,
            G = K.push,
            J = K.slice,
            Q = function (e, t) {
                for (var n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;
                return -1;
            },
            ee = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            te = "[\\x20\\t\\r\\n\\f]",
            ne = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
            ie = "\\[" + te + "*(" + ne + ")(?:" + te + "*([*^$|!~]?=)" + te + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + ne + "))|)" + te + "*\\]",
            oe = ":(" + ne + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ie + ")*)|.*)\\)|)",
            re = new RegExp(te + "+", "g"),
            se = new RegExp("^" + te + "+|((?:^|[^\\\\])(?:\\\\.)*)" + te + "+$", "g"),
            ae = new RegExp("^" + te + "*," + te + "*"),
            le = new RegExp("^" + te + "*([>+~]|" + te + ")" + te + "*"),
            ce = new RegExp(te + "|>"),
            ue = new RegExp(oe),
            de = new RegExp("^" + ne + "$"),
            pe = {
                ID: new RegExp("^#(" + ne + ")"),
                CLASS: new RegExp("^\\.(" + ne + ")"),
                TAG: new RegExp("^(" + ne + "|[*])"),
                ATTR: new RegExp("^" + ie),
                PSEUDO: new RegExp("^" + oe),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + te + "*(even|odd|(([+-]|)(\\d*)n|)" + te + "*(?:([+-]|)" + te + "*(\\d+)|))" + te + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + ee + ")$", "i"),
                needsContext: new RegExp("^" + te + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + te + "*((?:-\\d)?\\d*)" + te + "*\\)|)(?=[^-]|$)", "i"),
            },
            fe = /HTML$/i,
            he = /^(?:input|select|textarea|button)$/i,
            me = /^h\d$/i,
            ve = /^[^{]+\{\s*\[native \w/,
            ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ye = /[+~]/,
            be = new RegExp("\\\\([\\da-f]{1,6}" + te + "?|(" + te + ")|.)", "ig"),
            we = function (e, t, n) {
                var i = "0x" + t - 65536;
                return i != i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320);
            },
            xe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            ke = function (e, t) {
                return t ? ("\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " ") : "\\" + e;
            },
            Se = function () {
                O();
            },
            Ce = h(
                function (e) {
                    return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                },
                { dir: "parentNode", next: "legend" }
            );
        try {
            G.apply((K = J.call(H.childNodes)), H.childNodes), K[H.childNodes.length].nodeType;
        } catch (e) {
            G = {
                apply: K.length
                    ? function (e, t) {
                          Y.apply(e, J.call(t));
                      }
                    : function (e, t) {
                          for (var n = e.length, i = 0; (e[n++] = t[i++]); );
                          e.length = n - 1;
                      },
            };
        }
        for (b in ((w = t.support = {}),
        (S = t.isXML = function (e) {
            var t = e.namespaceURI,
                n = (e.ownerDocument || e).documentElement;
            return !fe.test(t || (n && n.nodeName) || "HTML");
        }),
        (O = t.setDocument = function (e) {
            var t,
                n,
                i = e ? e.ownerDocument || e : H;
            return (
                i !== $ &&
                    9 === i.nodeType &&
                    i.documentElement &&
                    ((I = ($ = i).documentElement),
                    (N = !S($)),
                    H !== $ && (n = $.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", Se, !1) : n.attachEvent && n.attachEvent("onunload", Se)),
                    (w.attributes = o(function (e) {
                        return (e.className = "i"), !e.getAttribute("className");
                    })),
                    (w.getElementsByTagName = o(function (e) {
                        return e.appendChild($.createComment("")), !e.getElementsByTagName("*").length;
                    })),
                    (w.getElementsByClassName = ve.test($.getElementsByClassName)),
                    (w.getById = o(function (e) {
                        return (I.appendChild(e).id = j), !$.getElementsByName || !$.getElementsByName(j).length;
                    })),
                    w.getById
                        ? ((x.filter.ID = function (e) {
                              var t = e.replace(be, we);
                              return function (e) {
                                  return e.getAttribute("id") === t;
                              };
                          }),
                          (x.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && N) {
                                  var n = t.getElementById(e);
                                  return n ? [n] : [];
                              }
                          }))
                        : ((x.filter.ID = function (e) {
                              var t = e.replace(be, we);
                              return function (e) {
                                  var n = "undefined" != typeof e.getAttributeNode && e.getAttributeNode("id");
                                  return n && n.value === t;
                              };
                          }),
                          (x.find.ID = function (e, t) {
                              if ("undefined" != typeof t.getElementById && N) {
                                  var n,
                                      i,
                                      o,
                                      r = t.getElementById(e);
                                  if (r) {
                                      if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                      for (o = t.getElementsByName(e), i = 0; (r = o[i++]); ) if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                                  }
                                  return [];
                              }
                          })),
                    (x.find.TAG = w.getElementsByTagName
                        ? function (e, t) {
                              return "undefined" != typeof t.getElementsByTagName ? t.getElementsByTagName(e) : w.qsa ? t.querySelectorAll(e) : void 0;
                          }
                        : function (e, t) {
                              var n,
                                  i = [],
                                  o = 0,
                                  r = t.getElementsByTagName(e);
                              if ("*" === e) {
                                  for (; (n = r[o++]); ) 1 === n.nodeType && i.push(n);
                                  return i;
                              }
                              return r;
                          }),
                    (x.find.CLASS =
                        w.getElementsByClassName &&
                        function (e, t) {
                            if ("undefined" != typeof t.getElementsByClassName && N) return t.getElementsByClassName(e);
                        }),
                    (L = []),
                    (D = []),
                    (w.qsa = ve.test($.querySelectorAll)) &&
                        (o(function (e) {
                            (I.appendChild(e).innerHTML = "<a id='" + j + "'></a><select id='" + j + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                e.querySelectorAll("[msallowcapture^='']").length && D.push("[*^$]=" + te + "*(?:''|\"\")"),
                                e.querySelectorAll("[selected]").length || D.push("\\[" + te + "*(?:value|" + ee + ")"),
                                e.querySelectorAll("[id~=" + j + "-]").length || D.push("~="),
                                e.querySelectorAll(":checked").length || D.push(":checked"),
                                e.querySelectorAll("a#" + j + "+*").length || D.push(".#.+[+~]");
                        }),
                        o(function (e) {
                            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var t = $.createElement("input");
                            t.setAttribute("type", "hidden"),
                                e.appendChild(t).setAttribute("name", "D"),
                                e.querySelectorAll("[name=d]").length && D.push("name" + te + "*[*^$|!~]?="),
                                2 !== e.querySelectorAll(":enabled").length && D.push(":enabled", ":disabled"),
                                (I.appendChild(e).disabled = !0),
                                2 !== e.querySelectorAll(":disabled").length && D.push(":enabled", ":disabled"),
                                e.querySelectorAll("*,:x"),
                                D.push(",.*:");
                        })),
                    (w.matchesSelector = ve.test((z = I.matches || I.webkitMatchesSelector || I.mozMatchesSelector || I.oMatchesSelector || I.msMatchesSelector))) &&
                        o(function (e) {
                            (w.disconnectedMatch = z.call(e, "*")), z.call(e, "[s!='']:x"), L.push("!=", oe);
                        }),
                    (D = D.length && new RegExp(D.join("|"))),
                    (L = L.length && new RegExp(L.join("|"))),
                    (t = ve.test(I.compareDocumentPosition)),
                    (M =
                        t || ve.test(I.contains)
                            ? function (e, t) {
                                  var n = 9 === e.nodeType ? e.documentElement : e,
                                      i = t && t.parentNode;
                                  return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)));
                              }
                            : function (e, t) {
                                  if (t) for (; (t = t.parentNode); ) if (t === e) return !0;
                                  return !1;
                              }),
                    (Z = t
                        ? function (e, t) {
                              if (e === t) return (P = !0), 0;
                              var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                              return (
                                  n ||
                                  (1 & (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || (!w.sortDetached && t.compareDocumentPosition(e) === n)
                                      ? e === $ || (e.ownerDocument === H && M(H, e))
                                          ? -1
                                          : t === $ || (t.ownerDocument === H && M(H, t))
                                          ? 1
                                          : _
                                          ? Q(_, e) - Q(_, t)
                                          : 0
                                      : 4 & n
                                      ? -1
                                      : 1)
                              );
                          }
                        : function (e, t) {
                              if (e === t) return (P = !0), 0;
                              var n,
                                  i = 0,
                                  o = e.parentNode,
                                  r = t.parentNode,
                                  a = [e],
                                  l = [t];
                              if (!o || !r) return e === $ ? -1 : t === $ ? 1 : o ? -1 : r ? 1 : _ ? Q(_, e) - Q(_, t) : 0;
                              if (o === r) return s(e, t);
                              for (n = e; (n = n.parentNode); ) a.unshift(n);
                              for (n = t; (n = n.parentNode); ) l.unshift(n);
                              for (; a[i] === l[i]; ) i++;
                              return i ? s(a[i], l[i]) : a[i] === H ? -1 : l[i] === H ? 1 : 0;
                          })),
                $
            );
        }),
        (t.matches = function (e, n) {
            return t(e, null, null, n);
        }),
        (t.matchesSelector = function (e, n) {
            if (((e.ownerDocument || e) !== $ && O(e), w.matchesSelector && N && !U[n + " "] && (!L || !L.test(n)) && (!D || !D.test(n))))
                try {
                    var i = z.call(e, n);
                    if (i || w.disconnectedMatch || (e.document && 11 !== e.document.nodeType)) return i;
                } catch (e) {
                    U(n, !0);
                }
            return 0 < t(n, $, null, [e]).length;
        }),
        (t.contains = function (e, t) {
            return (e.ownerDocument || e) !== $ && O(e), M(e, t);
        }),
        (t.attr = function (e, t) {
            (e.ownerDocument || e) !== $ && O(e);
            var n = x.attrHandle[t.toLowerCase()],
                i = n && V.call(x.attrHandle, t.toLowerCase()) ? n(e, t, !N) : void 0;
            return void 0 !== i ? i : w.attributes || !N ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
        }),
        (t.escape = function (e) {
            return (e + "").replace(xe, ke);
        }),
        (t.error = function (e) {
            throw new Error("Syntax error, unrecognized expression: " + e);
        }),
        (t.uniqueSort = function (e) {
            var t,
                n = [],
                i = 0,
                o = 0;
            if (((P = !w.detectDuplicates), (_ = !w.sortStable && e.slice(0)), e.sort(Z), P)) {
                for (; (t = e[o++]); ) t === e[o] && (i = n.push(o));
                for (; i--; ) e.splice(n[i], 1);
            }
            return (_ = null), e;
        }),
        (k = t.getText = function (e) {
            var t,
                n = "",
                i = 0,
                o = e.nodeType;
            if (o) {
                if (1 === o || 9 === o || 11 === o) {
                    if ("string" == typeof e.textContent) return e.textContent;
                    for (e = e.firstChild; e; e = e.nextSibling) n += k(e);
                } else if (3 === o || 4 === o) return e.nodeValue;
            } else for (; (t = e[i++]); ) n += k(t);
            return n;
        }),
        ((x = t.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: pe,
            attrHandle: {},
            find: {},
            relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
            preFilter: {
                ATTR: function (e) {
                    return (e[1] = e[1].replace(be, we)), (e[3] = (e[3] || e[4] || e[5] || "").replace(be, we)), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                },
                CHILD: function (e) {
                    return (
                        (e[1] = e[1].toLowerCase()),
                        "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), (e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3]))), (e[5] = +(e[7] + e[8] || "odd" === e[3]))) : e[3] && t.error(e[0]),
                        e
                    );
                },
                PSEUDO: function (e) {
                    var t,
                        n = !e[6] && e[2];
                    return pe.CHILD.test(e[0])
                        ? null
                        : (e[3] ? (e[2] = e[4] || e[5] || "") : n && ue.test(n) && (t = C(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && ((e[0] = e[0].slice(0, t)), (e[2] = n.slice(0, t))), e.slice(0, 3));
                },
            },
            filter: {
                TAG: function (e) {
                    var t = e.replace(be, we).toLowerCase();
                    return "*" === e
                        ? function () {
                              return !0;
                          }
                        : function (e) {
                              return e.nodeName && e.nodeName.toLowerCase() === t;
                          };
                },
                CLASS: function (e) {
                    var t = q[e + " "];
                    return (
                        t ||
                        ((t = new RegExp("(^|" + te + ")" + e + "(" + te + "|$)")) &&
                            q(e, function (e) {
                                return t.test(("string" == typeof e.className && e.className) || ("undefined" != typeof e.getAttribute && e.getAttribute("class")) || "");
                            }))
                    );
                },
                ATTR: function (e, n, i) {
                    return function (o) {
                        var r = t.attr(o, e);
                        return null == r
                            ? "!=" === n
                            : !n ||
                                  ((r += ""),
                                  "=" === n
                                      ? r === i
                                      : "!=" === n
                                      ? r !== i
                                      : "^=" === n
                                      ? i && 0 === r.indexOf(i)
                                      : "*=" === n
                                      ? i && -1 < r.indexOf(i)
                                      : "$=" === n
                                      ? i && r.slice(-i.length) === i
                                      : "~=" === n
                                      ? -1 < (" " + r.replace(re, " ") + " ").indexOf(i)
                                      : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"));
                    };
                },
                CHILD: function (e, t, n, i, o) {
                    var r = "nth" !== e.slice(0, 3),
                        s = "last" !== e.slice(-4),
                        a = "of-type" === t;
                    return 1 === i && 0 === o
                        ? function (e) {
                              return !!e.parentNode;
                          }
                        : function (t, n, l) {
                              var c,
                                  u,
                                  d,
                                  p,
                                  f,
                                  h,
                                  m = r !== s ? "nextSibling" : "previousSibling",
                                  v = t.parentNode,
                                  g = a && t.nodeName.toLowerCase(),
                                  y = !l && !a,
                                  b = !1;
                              if (v) {
                                  if (r) {
                                      for (; m; ) {
                                          for (p = t; (p = p[m]); ) if (a ? p.nodeName.toLowerCase() === g : 1 === p.nodeType) return !1;
                                          h = m = "only" === e && !h && "nextSibling";
                                      }
                                      return !0;
                                  }
                                  if (((h = [s ? v.firstChild : v.lastChild]), s && y)) {
                                      for (
                                          b = (f = (c = (u = (d = (p = v)[j] || (p[j] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === R && c[1]) && c[2], p = f && v.childNodes[f];
                                          (p = (++f && p && p[m]) || (b = f = 0) || h.pop());

                                      )
                                          if (1 === p.nodeType && ++b && p === t) {
                                              u[e] = [R, f, b];
                                              break;
                                          }
                                  } else if ((y && (b = f = (c = (u = (d = (p = t)[j] || (p[j] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] || [])[0] === R && c[1]), !1 === b))
                                      for (
                                          ;
                                          (p = (++f && p && p[m]) || (b = f = 0) || h.pop()) &&
                                          ((a ? p.nodeName.toLowerCase() !== g : 1 !== p.nodeType) || !++b || (y && ((u = (d = p[j] || (p[j] = {}))[p.uniqueID] || (d[p.uniqueID] = {}))[e] = [R, b]), p !== t));

                                      );
                                  return (b -= o) === i || (b % i == 0 && 0 <= b / i);
                              }
                          };
                },
                PSEUDO: function (e, n) {
                    var o,
                        r = x.pseudos[e] || x.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
                    return r[j]
                        ? r(n)
                        : 1 < r.length
                        ? ((o = [e, e, "", n]),
                          x.setFilters.hasOwnProperty(e.toLowerCase())
                              ? i(function (e, t) {
                                    for (var i, o = r(e, n), s = o.length; s--; ) e[(i = Q(e, o[s]))] = !(t[i] = o[s]);
                                })
                              : function (e) {
                                    return r(e, 0, o);
                                })
                        : r;
                },
            },
            pseudos: {
                not: i(function (e) {
                    var t = [],
                        n = [],
                        o = T(e.replace(se, "$1"));
                    return o[j]
                        ? i(function (e, t, n, i) {
                              for (var r, s = o(e, null, i, []), a = e.length; a--; ) (r = s[a]) && (e[a] = !(t[a] = r));
                          })
                        : function (e, i, r) {
                              return (t[0] = e), o(t, null, r, n), (t[0] = null), !n.pop();
                          };
                }),
                has: i(function (e) {
                    return function (n) {
                        return 0 < t(e, n).length;
                    };
                }),
                contains: i(function (e) {
                    return (
                        (e = e.replace(be, we)),
                        function (t) {
                            return -1 < (t.textContent || k(t)).indexOf(e);
                        }
                    );
                }),
                lang: i(function (e) {
                    return (
                        de.test(e || "") || t.error("unsupported lang: " + e),
                        (e = e.replace(be, we).toLowerCase()),
                        function (t) {
                            var n;
                            do if ((n = N ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang"))) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                            while ((t = t.parentNode) && 1 === t.nodeType);
                            return !1;
                        }
                    );
                }),
                target: function (t) {
                    var n = e.location && e.location.hash;
                    return n && n.slice(1) === t.id;
                },
                root: function (e) {
                    return e === I;
                },
                focus: function (e) {
                    return e === $.activeElement && (!$.hasFocus || $.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                },
                enabled: c(!1),
                disabled: c(!0),
                checked: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && !!e.checked) || ("option" === t && !!e.selected);
                },
                selected: function (e) {
                    return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                },
                empty: function (e) {
                    for (e = e.firstChild; e; e = e.nextSibling) if (e.nodeType < 6) return !1;
                    return !0;
                },
                parent: function (e) {
                    return !x.pseudos.empty(e);
                },
                header: function (e) {
                    return me.test(e.nodeName);
                },
                input: function (e) {
                    return he.test(e.nodeName);
                },
                button: function (e) {
                    var t = e.nodeName.toLowerCase();
                    return ("input" === t && "button" === e.type) || "button" === t;
                },
                text: function (e) {
                    var t;
                    return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                },
                first: u(function () {
                    return [0];
                }),
                last: u(function (e, t) {
                    return [t - 1];
                }),
                eq: u(function (e, t, n) {
                    return [n < 0 ? n + t : n];
                }),
                even: u(function (e, t) {
                    for (var n = 0; n < t; n += 2) e.push(n);
                    return e;
                }),
                odd: u(function (e, t) {
                    for (var n = 1; n < t; n += 2) e.push(n);
                    return e;
                }),
                lt: u(function (e, t, n) {
                    for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i; ) e.push(i);
                    return e;
                }),
                gt: u(function (e, t, n) {
                    for (var i = n < 0 ? n + t : n; ++i < t; ) e.push(i);
                    return e;
                }),
            },
        }).pseudos.nth = x.pseudos.eq),
        { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
            x.pseudos[b] = a(b);
        for (b in { submit: !0, reset: !0 }) x.pseudos[b] = l(b);
        return (
            (p.prototype = x.filters = x.pseudos),
            (x.setFilters = new p()),
            (C = t.tokenize = function (e, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    u = B[e + " "];
                if (u) return n ? 0 : u.slice(0);
                for (a = e, l = [], c = x.preFilter; a; ) {
                    for (s in ((i && !(o = ae.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                    (i = !1),
                    (o = le.exec(a)) && ((i = o.shift()), r.push({ value: i, type: o[0].replace(se, " ") }), (a = a.slice(i.length))),
                    x.filter))
                        !(o = pe[s].exec(a)) || (c[s] && !(o = c[s](o))) || ((i = o.shift()), r.push({ value: i, type: s, matches: o }), (a = a.slice(i.length)));
                    if (!i) break;
                }
                return n ? a.length : a ? t.error(e) : B(e, l).slice(0);
            }),
            (T = t.compile = function (e, n) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    u = [],
                    d = [],
                    p = W[e + " "];
                if (!p) {
                    for (n || (n = C(e)), o = n.length; o--; ) (p = y(n[o]))[j] ? u.push(p) : d.push(p);
                    (p = W(
                        e,
                        ((r = d),
                        (a = 0 < (s = u).length),
                        (l = 0 < r.length),
                        (c = function (e, n, i, o, c) {
                            var u,
                                d,
                                p,
                                f = 0,
                                h = "0",
                                m = e && [],
                                g = [],
                                y = A,
                                b = e || (l && x.find.TAG("*", c)),
                                w = (R += null == y ? 1 : Math.random() || 0.1),
                                k = b.length;
                            for (c && (A = n === $ || n || c); h !== k && null != (u = b[h]); h++) {
                                if (l && u) {
                                    for (d = 0, n || u.ownerDocument === $ || (O(u), (i = !N)); (p = r[d++]); )
                                        if (p(u, n || $, i)) {
                                            o.push(u);
                                            break;
                                        }
                                    c && (R = w);
                                }
                                a && ((u = !p && u) && f--, e && m.push(u));
                            }
                            if (((f += h), a && h !== f)) {
                                for (d = 0; (p = s[d++]); ) p(m, g, n, i);
                                if (e) {
                                    if (0 < f) for (; h--; ) m[h] || g[h] || (g[h] = X.call(o));
                                    g = v(g);
                                }
                                G.apply(o, g), c && !e && 0 < g.length && 1 < f + s.length && t.uniqueSort(o);
                            }
                            return c && ((R = w), (A = y)), m;
                        }),
                        a ? i(c) : c)
                    )).selector = e;
                }
                return p;
            }),
            (E = t.select = function (e, t, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l,
                    c = "function" == typeof e && e,
                    u = !i && C((e = c.selector || e));
                if (((n = n || []), 1 === u.length)) {
                    if (2 < (r = u[0] = u[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === t.nodeType && N && x.relative[r[1].type]) {
                        if (!(t = (x.find.ID(s.matches[0].replace(be, we), t) || [])[0])) return n;
                        c && (t = t.parentNode), (e = e.slice(r.shift().value.length));
                    }
                    for (o = pe.needsContext.test(e) ? 0 : r.length; o-- && ((s = r[o]), !x.relative[(a = s.type)]); )
                        if ((l = x.find[a]) && (i = l(s.matches[0].replace(be, we), (ye.test(r[0].type) && d(t.parentNode)) || t))) {
                            if ((r.splice(o, 1), !(e = i.length && f(r)))) return G.apply(n, i), n;
                            break;
                        }
                }
                return (c || T(e, u))(i, t, !N, n, !t || (ye.test(e) && d(t.parentNode)) || t), n;
            }),
            (w.sortStable = j.split("").sort(Z).join("") === j),
            (w.detectDuplicates = !!P),
            O(),
            (w.sortDetached = o(function (e) {
                return 1 & e.compareDocumentPosition($.createElement("fieldset"));
            })),
            o(function (e) {
                return (e.innerHTML = "<a href='#'></a>"), "#" === e.firstChild.getAttribute("href");
            }) ||
                r("type|href|height|width", function (e, t, n) {
                    if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                }),
            (w.attributes &&
                o(function (e) {
                    return (e.innerHTML = "<input/>"), e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                })) ||
                r("value", function (e, t, n) {
                    if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                }),
            o(function (e) {
                return null == e.getAttribute("disabled");
            }) ||
                r(ee, function (e, t, n) {
                    var i;
                    if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null;
                }),
            t
        );
    })(e);
    (he.find = ve), (he.expr = ve.selectors), (he.expr[":"] = he.expr.pseudos), (he.uniqueSort = he.unique = ve.uniqueSort), (he.text = ve.getText), (he.isXMLDoc = ve.isXML), (he.contains = ve.contains), (he.escapeSelector = ve.escape);
    var ge = function (e, t, n) {
            for (var i = [], o = void 0 !== n; (e = e[t]) && 9 !== e.nodeType; )
                if (1 === e.nodeType) {
                    if (o && he(e).is(n)) break;
                    i.push(e);
                }
            return i;
        },
        ye = function (e, t) {
            for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
            return n;
        },
        be = he.expr.match.needsContext,
        we = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    (he.filter = function (e, t, n) {
        var i = t[0];
        return (
            n && (e = ":not(" + e + ")"),
            1 === t.length && 1 === i.nodeType
                ? he.find.matchesSelector(i, e)
                    ? [i]
                    : []
                : he.find.matches(
                      e,
                      he.grep(t, function (e) {
                          return 1 === e.nodeType;
                      })
                  )
        );
    }),
        he.fn.extend({
            find: function (e) {
                var t,
                    n,
                    i = this.length,
                    o = this;
                if ("string" != typeof e)
                    return this.pushStack(
                        he(e).filter(function () {
                            for (t = 0; t < i; t++) if (he.contains(o[t], this)) return !0;
                        })
                    );
                for (n = this.pushStack([]), t = 0; t < i; t++) he.find(e, o[t], n);
                return 1 < i ? he.uniqueSort(n) : n;
            },
            filter: function (e) {
                return this.pushStack(s(this, e || [], !1));
            },
            not: function (e) {
                return this.pushStack(s(this, e || [], !0));
            },
            is: function (e) {
                return !!s(this, "string" == typeof e && be.test(e) ? he(e) : e || [], !1).length;
            },
        });
    var xe,
        ke = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    ((he.fn.init = function (e, t, n) {
        var i, o;
        if (!e) return this;
        if (((n = n || xe), "string" == typeof e)) {
            if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : ke.exec(e)) || (!i[1] && t)) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
            if (i[1]) {
                if (((t = t instanceof he ? t[0] : t), he.merge(this, he.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : J, !0)), we.test(i[1]) && he.isPlainObject(t))) for (i in t) ue(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
                return this;
            }
            return (o = J.getElementById(i[2])) && ((this[0] = o), (this.length = 1)), this;
        }
        return e.nodeType ? ((this[0] = e), (this.length = 1), this) : ue(e) ? (void 0 !== n.ready ? n.ready(e) : e(he)) : he.makeArray(e, this);
    }).prototype = he.fn),
        (xe = he(J));
    var Se = /^(?:parents|prev(?:Until|All))/,
        Ce = { children: !0, contents: !0, next: !0, prev: !0 };
    he.fn.extend({
        has: function (e) {
            var t = he(e, this),
                n = t.length;
            return this.filter(function () {
                for (var e = 0; e < n; e++) if (he.contains(this, t[e])) return !0;
            });
        },
        closest: function (e, t) {
            var n,
                i = 0,
                o = this.length,
                r = [],
                s = "string" != typeof e && he(e);
            if (!be.test(e))
                for (; i < o; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && he.find.matchesSelector(n, e))) {
                            r.push(n);
                            break;
                        }
            return this.pushStack(1 < r.length ? he.uniqueSort(r) : r);
        },
        index: function (e) {
            return e ? ("string" == typeof e ? ie.call(he(e), this[0]) : ie.call(this, e.jquery ? e[0] : e)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
        },
        add: function (e, t) {
            return this.pushStack(he.uniqueSort(he.merge(this.get(), he(e, t))));
        },
        addBack: function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
        },
    }),
        he.each(
            {
                parent: function (e) {
                    var t = e.parentNode;
                    return t && 11 !== t.nodeType ? t : null;
                },
                parents: function (e) {
                    return ge(e, "parentNode");
                },
                parentsUntil: function (e, t, n) {
                    return ge(e, "parentNode", n);
                },
                next: function (e) {
                    return a(e, "nextSibling");
                },
                prev: function (e) {
                    return a(e, "previousSibling");
                },
                nextAll: function (e) {
                    return ge(e, "nextSibling");
                },
                prevAll: function (e) {
                    return ge(e, "previousSibling");
                },
                nextUntil: function (e, t, n) {
                    return ge(e, "nextSibling", n);
                },
                prevUntil: function (e, t, n) {
                    return ge(e, "previousSibling", n);
                },
                siblings: function (e) {
                    return ye((e.parentNode || {}).firstChild, e);
                },
                children: function (e) {
                    return ye(e.firstChild);
                },
                contents: function (e) {
                    return "undefined" != typeof e.contentDocument ? e.contentDocument : (r(e, "template") && (e = e.content || e), he.merge([], e.childNodes));
                },
            },
            function (e, t) {
                he.fn[e] = function (n, i) {
                    var o = he.map(this, t, n);
                    return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = he.filter(i, o)), 1 < this.length && (Ce[e] || he.uniqueSort(o), Se.test(e) && o.reverse()), this.pushStack(o);
                };
            }
        );
    var Te = /[^\x20\t\r\n\f]+/g;
    (he.Callbacks = function (e) {
        var t, n;
        e =
            "string" == typeof e
                ? ((t = e),
                  (n = {}),
                  he.each(t.match(Te) || [], function (e, t) {
                      n[t] = !0;
                  }),
                  n)
                : he.extend({}, e);
        var o,
            r,
            s,
            a,
            l = [],
            c = [],
            u = -1,
            d = function () {
                for (a = a || e.once, s = o = !0; c.length; u = -1) for (r = c.shift(); ++u < l.length; ) !1 === l[u].apply(r[0], r[1]) && e.stopOnFalse && ((u = l.length), (r = !1));
                e.memory || (r = !1), (o = !1), a && (l = r ? [] : "");
            },
            p = {
                add: function () {
                    return (
                        l &&
                            (r && !o && ((u = l.length - 1), c.push(r)),
                            (function t(n) {
                                he.each(n, function (n, o) {
                                    ue(o) ? (e.unique && p.has(o)) || l.push(o) : o && o.length && "string" !== i(o) && t(o);
                                });
                            })(arguments),
                            r && !o && d()),
                        this
                    );
                },
                remove: function () {
                    return (
                        he.each(arguments, function (e, t) {
                            for (var n; -1 < (n = he.inArray(t, l, n)); ) l.splice(n, 1), n <= u && u--;
                        }),
                        this
                    );
                },
                has: function (e) {
                    return e ? -1 < he.inArray(e, l) : 0 < l.length;
                },
                empty: function () {
                    return l && (l = []), this;
                },
                disable: function () {
                    return (a = c = []), (l = r = ""), this;
                },
                disabled: function () {
                    return !l;
                },
                lock: function () {
                    return (a = c = []), r || o || (l = r = ""), this;
                },
                locked: function () {
                    return !!a;
                },
                fireWith: function (e, t) {
                    return a || ((t = [e, (t = t || []).slice ? t.slice() : t]), c.push(t), o || d()), this;
                },
                fire: function () {
                    return p.fireWith(this, arguments), this;
                },
                fired: function () {
                    return !!s;
                },
            };
        return p;
    }),
        he.extend({
            Deferred: function (t) {
                var n = [
                        ["notify", "progress", he.Callbacks("memory"), he.Callbacks("memory"), 2],
                        ["resolve", "done", he.Callbacks("once memory"), he.Callbacks("once memory"), 0, "resolved"],
                        ["reject", "fail", he.Callbacks("once memory"), he.Callbacks("once memory"), 1, "rejected"],
                    ],
                    i = "pending",
                    o = {
                        state: function () {
                            return i;
                        },
                        always: function () {
                            return r.done(arguments).fail(arguments), this;
                        },
                        catch: function (e) {
                            return o.then(null, e);
                        },
                        pipe: function () {
                            var e = arguments;
                            return he
                                .Deferred(function (t) {
                                    he.each(n, function (n, i) {
                                        var o = ue(e[i[4]]) && e[i[4]];
                                        r[i[1]](function () {
                                            var e = o && o.apply(this, arguments);
                                            e && ue(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[i[0] + "With"](this, o ? [e] : arguments);
                                        });
                                    }),
                                        (e = null);
                                })
                                .promise();
                        },
                        then: function (t, i, o) {
                            function r(t, n, i, o) {
                                return function () {
                                    var a = this,
                                        u = arguments,
                                        d = function () {
                                            var e, d;
                                            if (!(t < s)) {
                                                if ((e = i.apply(a, u)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                (d = e && ("object" == typeof e || "function" == typeof e) && e.then),
                                                    ue(d)
                                                        ? o
                                                            ? d.call(e, r(s, n, l, o), r(s, n, c, o))
                                                            : (s++, d.call(e, r(s, n, l, o), r(s, n, c, o), r(s, n, l, n.notifyWith)))
                                                        : (i !== l && ((a = void 0), (u = [e])), (o || n.resolveWith)(a, u));
                                            }
                                        },
                                        p = o
                                            ? d
                                            : function () {
                                                  try {
                                                      d();
                                                  } catch (e) {
                                                      he.Deferred.exceptionHook && he.Deferred.exceptionHook(e, p.stackTrace), s <= t + 1 && (i !== c && ((a = void 0), (u = [e])), n.rejectWith(a, u));
                                                  }
                                              };
                                    t ? p() : (he.Deferred.getStackHook && (p.stackTrace = he.Deferred.getStackHook()), e.setTimeout(p));
                                };
                            }
                            var s = 0;
                            return he
                                .Deferred(function (e) {
                                    n[0][3].add(r(0, e, ue(o) ? o : l, e.notifyWith)), n[1][3].add(r(0, e, ue(t) ? t : l)), n[2][3].add(r(0, e, ue(i) ? i : c));
                                })
                                .promise();
                        },
                        promise: function (e) {
                            return null != e ? he.extend(e, o) : o;
                        },
                    },
                    r = {};
                return (
                    he.each(n, function (e, t) {
                        var s = t[2],
                            a = t[5];
                        (o[t[1]] = s.add),
                            a &&
                                s.add(
                                    function () {
                                        i = a;
                                    },
                                    n[3 - e][2].disable,
                                    n[3 - e][3].disable,
                                    n[0][2].lock,
                                    n[0][3].lock
                                ),
                            s.add(t[3].fire),
                            (r[t[0]] = function () {
                                return r[t[0] + "With"](this === r ? void 0 : this, arguments), this;
                            }),
                            (r[t[0] + "With"] = s.fireWith);
                    }),
                    o.promise(r),
                    t && t.call(r, r),
                    r
                );
            },
            when: function (e) {
                var t = arguments.length,
                    n = t,
                    i = Array(n),
                    o = ee.call(arguments),
                    r = he.Deferred(),
                    s = function (e) {
                        return function (n) {
                            (i[e] = this), (o[e] = 1 < arguments.length ? ee.call(arguments) : n), --t || r.resolveWith(i, o);
                        };
                    };
                if (t <= 1 && (u(e, r.done(s(n)).resolve, r.reject, !t), "pending" === r.state() || ue(o[n] && o[n].then))) return r.then();
                for (; n--; ) u(o[n], s(n), r.reject);
                return r.promise();
            },
        });
    var Ee = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    (he.Deferred.exceptionHook = function (t, n) {
        e.console && e.console.warn && t && Ee.test(t.name) && e.console.warn("jQuery.Deferred exception: " + t.message, t.stack, n);
    }),
        (he.readyException = function (t) {
            e.setTimeout(function () {
                throw t;
            });
        });
    var Ae = he.Deferred();
    (he.fn.ready = function (e) {
        return (
            Ae.then(e).catch(function (e) {
                he.readyException(e);
            }),
            this
        );
    }),
        he.extend({
            isReady: !1,
            readyWait: 1,
            ready: function (e) {
                (!0 === e ? --he.readyWait : he.isReady) || ((he.isReady = !0) !== e && 0 < --he.readyWait) || Ae.resolveWith(J, [he]);
            },
        }),
        (he.ready.then = Ae.then),
        "complete" === J.readyState || ("loading" !== J.readyState && !J.documentElement.doScroll) ? e.setTimeout(he.ready) : (J.addEventListener("DOMContentLoaded", d), e.addEventListener("load", d));
    var _e = function (e, t, n, o, r, s, a) {
            var l = 0,
                c = e.length,
                u = null == n;
            if ("object" === i(n)) for (l in ((r = !0), n)) _e(e, t, l, n[l], !0, s, a);
            else if (
                void 0 !== o &&
                ((r = !0),
                ue(o) || (a = !0),
                u &&
                    (a
                        ? (t.call(e, o), (t = null))
                        : ((u = t),
                          (t = function (e, t, n) {
                              return u.call(he(e), n);
                          }))),
                t)
            )
                for (; l < c; l++) t(e[l], n, a ? o : o.call(e[l], l, t(e[l], n)));
            return r ? e : u ? t.call(e) : c ? t(e[0], n) : s;
        },
        Pe = /^-ms-/,
        Oe = /-([a-z])/g,
        $e = function (e) {
            return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
        };
    (h.uid = 1),
        (h.prototype = {
            cache: function (e) {
                var t = e[this.expando];
                return t || ((t = {}), $e(e) && (e.nodeType ? (e[this.expando] = t) : Object.defineProperty(e, this.expando, { value: t, configurable: !0 }))), t;
            },
            set: function (e, t, n) {
                var i,
                    o = this.cache(e);
                if ("string" == typeof t) o[f(t)] = n;
                else for (i in t) o[f(i)] = t[i];
                return o;
            },
            get: function (e, t) {
                return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][f(t)];
            },
            access: function (e, t, n) {
                return void 0 === t || (t && "string" == typeof t && void 0 === n) ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
            },
            remove: function (e, t) {
                var n,
                    i = e[this.expando];
                if (void 0 !== i) {
                    if (void 0 !== t) {
                        n = (t = Array.isArray(t) ? t.map(f) : (t = f(t)) in i ? [t] : t.match(Te) || []).length;
                        for (; n--; ) delete i[t[n]];
                    }
                    (void 0 === t || he.isEmptyObject(i)) && (e.nodeType ? (e[this.expando] = void 0) : delete e[this.expando]);
                }
            },
            hasData: function (e) {
                var t = e[this.expando];
                return void 0 !== t && !he.isEmptyObject(t);
            },
        });
    var Ie = new h(),
        Ne = new h(),
        De = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Le = /[A-Z]/g;
    he.extend({
        hasData: function (e) {
            return Ne.hasData(e) || Ie.hasData(e);
        },
        data: function (e, t, n) {
            return Ne.access(e, t, n);
        },
        removeData: function (e, t) {
            Ne.remove(e, t);
        },
        _data: function (e, t, n) {
            return Ie.access(e, t, n);
        },
        _removeData: function (e, t) {
            Ie.remove(e, t);
        },
    }),
        he.fn.extend({
            data: function (e, t) {
                var n,
                    i,
                    o,
                    r = this[0],
                    s = r && r.attributes;
                if (void 0 === e) {
                    if (this.length && ((o = Ne.get(r)), 1 === r.nodeType && !Ie.get(r, "hasDataAttrs"))) {
                        for (n = s.length; n--; ) s[n] && 0 === (i = s[n].name).indexOf("data-") && ((i = f(i.slice(5))), m(r, i, o[i]));
                        Ie.set(r, "hasDataAttrs", !0);
                    }
                    return o;
                }
                return "object" == typeof e
                    ? this.each(function () {
                          Ne.set(this, e);
                      })
                    : _e(
                          this,
                          function (t) {
                              var n;
                              return r && void 0 === t
                                  ? void 0 !== (n = Ne.get(r, e))
                                      ? n
                                      : void 0 !== (n = m(r, e))
                                      ? n
                                      : void 0
                                  : void this.each(function () {
                                        Ne.set(this, e, t);
                                    });
                          },
                          null,
                          t,
                          1 < arguments.length,
                          null,
                          !0
                      );
            },
            removeData: function (e) {
                return this.each(function () {
                    Ne.remove(this, e);
                });
            },
        }),
        he.extend({
            queue: function (e, t, n) {
                var i;
                if (e) return (t = (t || "fx") + "queue"), (i = Ie.get(e, t)), n && (!i || Array.isArray(n) ? (i = Ie.access(e, t, he.makeArray(n))) : i.push(n)), i || [];
            },
            dequeue: function (e, t) {
                t = t || "fx";
                var n = he.queue(e, t),
                    i = n.length,
                    o = n.shift(),
                    r = he._queueHooks(e, t);
                "inprogress" === o && ((o = n.shift()), i--),
                    o &&
                        ("fx" === t && n.unshift("inprogress"),
                        delete r.stop,
                        o.call(
                            e,
                            function () {
                                he.dequeue(e, t);
                            },
                            r
                        )),
                    !i && r && r.empty.fire();
            },
            _queueHooks: function (e, t) {
                var n = t + "queueHooks";
                return (
                    Ie.get(e, n) ||
                    Ie.access(e, n, {
                        empty: he.Callbacks("once memory").add(function () {
                            Ie.remove(e, [t + "queue", n]);
                        }),
                    })
                );
            },
        }),
        he.fn.extend({
            queue: function (e, t) {
                var n = 2;
                return (
                    "string" != typeof e && ((t = e), (e = "fx"), n--),
                    arguments.length < n
                        ? he.queue(this[0], e)
                        : void 0 === t
                        ? this
                        : this.each(function () {
                              var n = he.queue(this, e, t);
                              he._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && he.dequeue(this, e);
                          })
                );
            },
            dequeue: function (e) {
                return this.each(function () {
                    he.dequeue(this, e);
                });
            },
            clearQueue: function (e) {
                return this.queue(e || "fx", []);
            },
            promise: function (e, t) {
                var n,
                    i = 1,
                    o = he.Deferred(),
                    r = this,
                    s = this.length,
                    a = function () {
                        --i || o.resolveWith(r, [r]);
                    };
                for ("string" != typeof e && ((t = e), (e = void 0)), e = e || "fx"; s--; ) (n = Ie.get(r[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
                return a(), o.promise(t);
            },
        });
    var ze = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        Me = new RegExp("^(?:([+-])=|)(" + ze + ")([a-z%]*)$", "i"),
        je = ["Top", "Right", "Bottom", "Left"],
        He = J.documentElement,
        Re = function (e) {
            return he.contains(e.ownerDocument, e);
        },
        Fe = { composed: !0 };
    He.getRootNode &&
        (Re = function (e) {
            return he.contains(e.ownerDocument, e) || e.getRootNode(Fe) === e.ownerDocument;
        });
    var qe = function (e, t) {
            return "none" === (e = t || e).style.display || ("" === e.style.display && Re(e) && "none" === he.css(e, "display"));
        },
        Be = function (e, t, n, i) {
            var o,
                r,
                s = {};
            for (r in t) (s[r] = e.style[r]), (e.style[r] = t[r]);
            for (r in ((o = n.apply(e, i || [])), t)) e.style[r] = s[r];
            return o;
        },
        We = {};
    he.fn.extend({
        show: function () {
            return g(this, !0);
        },
        hide: function () {
            return g(this);
        },
        toggle: function (e) {
            return "boolean" == typeof e
                ? e
                    ? this.show()
                    : this.hide()
                : this.each(function () {
                      qe(this) ? he(this).show() : he(this).hide();
                  });
        },
    });
    var Ue = /^(?:checkbox|radio)$/i,
        Ze = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        Ve = /^$|^module$|\/(?:java|ecma)script/i,
        Ke = {
            option: [1, "<select multiple='multiple'>", "</select>"],
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
            _default: [0, "", ""],
        };
    (Ke.optgroup = Ke.option), (Ke.tbody = Ke.tfoot = Ke.colgroup = Ke.caption = Ke.thead), (Ke.th = Ke.td);
    var Xe,
        Ye,
        Ge = /<|&#?\w+;/;
    (Xe = J.createDocumentFragment().appendChild(J.createElement("div"))),
        (Ye = J.createElement("input")).setAttribute("type", "radio"),
        Ye.setAttribute("checked", "checked"),
        Ye.setAttribute("name", "t"),
        Xe.appendChild(Ye),
        (ce.checkClone = Xe.cloneNode(!0).cloneNode(!0).lastChild.checked),
        (Xe.innerHTML = "<textarea>x</textarea>"),
        (ce.noCloneChecked = !!Xe.cloneNode(!0).lastChild.defaultValue);
    var Je = /^key/,
        Qe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        et = /^([^.]*)(?:\.(.+)|)/;
    (he.event = {
        global: {},
        add: function (e, t, n, i, o) {
            var r,
                s,
                a,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                v = Ie.get(e);
            if (v)
                for (
                    n.handler && ((n = (r = n).handler), (o = r.selector)),
                        o && he.find.matchesSelector(He, o),
                        n.guid || (n.guid = he.guid++),
                        (l = v.events) || (l = v.events = {}),
                        (s = v.handle) ||
                            (s = v.handle = function (t) {
                                return "undefined" != typeof he && he.event.triggered !== t.type ? he.event.dispatch.apply(e, arguments) : void 0;
                            }),
                        c = (t = (t || "").match(Te) || [""]).length;
                    c--;

                )
                    (f = m = (a = et.exec(t[c]) || [])[1]),
                        (h = (a[2] || "").split(".").sort()),
                        f &&
                            ((d = he.event.special[f] || {}),
                            (f = (o ? d.delegateType : d.bindType) || f),
                            (d = he.event.special[f] || {}),
                            (u = he.extend({ type: f, origType: m, data: i, handler: n, guid: n.guid, selector: o, needsContext: o && he.expr.match.needsContext.test(o), namespace: h.join(".") }, r)),
                            (p = l[f]) || (((p = l[f] = []).delegateCount = 0), (d.setup && !1 !== d.setup.call(e, i, h, s)) || (e.addEventListener && e.addEventListener(f, s))),
                            d.add && (d.add.call(e, u), u.handler.guid || (u.handler.guid = n.guid)),
                            o ? p.splice(p.delegateCount++, 0, u) : p.push(u),
                            (he.event.global[f] = !0));
        },
        remove: function (e, t, n, i, o) {
            var r,
                s,
                a,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                v = Ie.hasData(e) && Ie.get(e);
            if (v && (l = v.events)) {
                for (c = (t = (t || "").match(Te) || [""]).length; c--; )
                    if (((f = m = (a = et.exec(t[c]) || [])[1]), (h = (a[2] || "").split(".").sort()), f)) {
                        for (d = he.event.special[f] || {}, p = l[(f = (i ? d.delegateType : d.bindType) || f)] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--; )
                            (u = p[r]),
                                (!o && m !== u.origType) ||
                                    (n && n.guid !== u.guid) ||
                                    (a && !a.test(u.namespace)) ||
                                    (i && i !== u.selector && ("**" !== i || !u.selector)) ||
                                    (p.splice(r, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(e, u));
                        s && !p.length && ((d.teardown && !1 !== d.teardown.call(e, h, v.handle)) || he.removeEvent(e, f, v.handle), delete l[f]);
                    } else for (f in l) he.event.remove(e, f + t[c], n, i, !0);
                he.isEmptyObject(l) && Ie.remove(e, "handle events");
            }
        },
        dispatch: function (e) {
            var t,
                n,
                i,
                o,
                r,
                s,
                a = he.event.fix(e),
                l = new Array(arguments.length),
                c = (Ie.get(this, "events") || {})[a.type] || [],
                u = he.event.special[a.type] || {};
            for (l[0] = a, t = 1; t < arguments.length; t++) l[t] = arguments[t];
            if (((a.delegateTarget = this), !u.preDispatch || !1 !== u.preDispatch.call(this, a))) {
                for (s = he.event.handlers.call(this, a, c), t = 0; (o = s[t++]) && !a.isPropagationStopped(); )
                    for (a.currentTarget = o.elem, n = 0; (r = o.handlers[n++]) && !a.isImmediatePropagationStopped(); )
                        (a.rnamespace && !1 !== r.namespace && !a.rnamespace.test(r.namespace)) ||
                            ((a.handleObj = r), (a.data = r.data), void 0 !== (i = ((he.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, l)) && !1 === (a.result = i) && (a.preventDefault(), a.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, a), a.result;
            }
        },
        handlers: function (e, t) {
            var n,
                i,
                o,
                r,
                s,
                a = [],
                l = t.delegateCount,
                c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[(o = (i = t[n]).selector + " ")] && (s[o] = i.needsContext ? -1 < he(o, this).index(c) : he.find(o, this, null, [c]).length), s[o] && r.push(i);
                        r.length && a.push({ elem: c, handlers: r });
                    }
            return (c = this), l < t.length && a.push({ elem: c, handlers: t.slice(l) }), a;
        },
        addProp: function (e, t) {
            Object.defineProperty(he.Event.prototype, e, {
                enumerable: !0,
                configurable: !0,
                get: ue(t)
                    ? function () {
                          if (this.originalEvent) return t(this.originalEvent);
                      }
                    : function () {
                          if (this.originalEvent) return this.originalEvent[e];
                      },
                set: function (t) {
                    Object.defineProperty(this, e, { enumerable: !0, configurable: !0, writable: !0, value: t });
                },
            });
        },
        fix: function (e) {
            return e[he.expando] ? e : new he.Event(e);
        },
        special: {
            load: { noBubble: !0 },
            click: {
                setup: function (e) {
                    var t = this || e;
                    return Ue.test(t.type) && t.click && r(t, "input") && T(t, "click", x), !1;
                },
                trigger: function (e) {
                    var t = this || e;
                    return Ue.test(t.type) && t.click && r(t, "input") && T(t, "click"), !0;
                },
                _default: function (e) {
                    var t = e.target;
                    return (Ue.test(t.type) && t.click && r(t, "input") && Ie.get(t, "click")) || r(t, "a");
                },
            },
            beforeunload: {
                postDispatch: function (e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                },
            },
        },
    }),
        (he.removeEvent = function (e, t, n) {
            e.removeEventListener && e.removeEventListener(t, n);
        }),
        (he.Event = function (e, t) {
            return this instanceof he.Event
                ? (e && e.type
                      ? ((this.originalEvent = e),
                        (this.type = e.type),
                        (this.isDefaultPrevented = e.defaultPrevented || (void 0 === e.defaultPrevented && !1 === e.returnValue) ? x : k),
                        (this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target),
                        (this.currentTarget = e.currentTarget),
                        (this.relatedTarget = e.relatedTarget))
                      : (this.type = e),
                  t && he.extend(this, t),
                  (this.timeStamp = (e && e.timeStamp) || Date.now()),
                  (this[he.expando] = !0),
                  void 0)
                : new he.Event(e, t);
        }),
        (he.Event.prototype = {
            constructor: he.Event,
            isDefaultPrevented: k,
            isPropagationStopped: k,
            isImmediatePropagationStopped: k,
            isSimulated: !1,
            preventDefault: function () {
                var e = this.originalEvent;
                (this.isDefaultPrevented = x), e && !this.isSimulated && e.preventDefault();
            },
            stopPropagation: function () {
                var e = this.originalEvent;
                (this.isPropagationStopped = x), e && !this.isSimulated && e.stopPropagation();
            },
            stopImmediatePropagation: function () {
                var e = this.originalEvent;
                (this.isImmediatePropagationStopped = x), e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
            },
        }),
        he.each(
            {
                altKey: !0,
                bubbles: !0,
                cancelable: !0,
                changedTouches: !0,
                ctrlKey: !0,
                detail: !0,
                eventPhase: !0,
                metaKey: !0,
                pageX: !0,
                pageY: !0,
                shiftKey: !0,
                view: !0,
                char: !0,
                code: !0,
                charCode: !0,
                key: !0,
                keyCode: !0,
                button: !0,
                buttons: !0,
                clientX: !0,
                clientY: !0,
                offsetX: !0,
                offsetY: !0,
                pointerId: !0,
                pointerType: !0,
                screenX: !0,
                screenY: !0,
                targetTouches: !0,
                toElement: !0,
                touches: !0,
                which: function (e) {
                    var t = e.button;
                    return null == e.which && Je.test(e.type) ? (null != e.charCode ? e.charCode : e.keyCode) : !e.which && void 0 !== t && Qe.test(e.type) ? (1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0) : e.which;
                },
            },
            he.event.addProp
        ),
        he.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
            he.event.special[e] = {
                setup: function () {
                    return T(this, e, S), !1;
                },
                trigger: function () {
                    return T(this, e), !0;
                },
                delegateType: t,
            };
        }),
        he.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (e, t) {
            he.event.special[e] = {
                delegateType: t,
                bindType: t,
                handle: function (e) {
                    var n,
                        i = e.relatedTarget,
                        o = e.handleObj;
                    return (i && (i === this || he.contains(this, i))) || ((e.type = o.origType), (n = o.handler.apply(this, arguments)), (e.type = t)), n;
                },
            };
        }),
        he.fn.extend({
            on: function (e, t, n, i) {
                return C(this, e, t, n, i);
            },
            one: function (e, t, n, i) {
                return C(this, e, t, n, i, 1);
            },
            off: function (e, t, n) {
                var i, o;
                if (e && e.preventDefault && e.handleObj) return (i = e.handleObj), he(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
                if ("object" == typeof e) {
                    for (o in e) this.off(o, t, e[o]);
                    return this;
                }
                return (
                    (!1 !== t && "function" != typeof t) || ((n = t), (t = void 0)),
                    !1 === n && (n = k),
                    this.each(function () {
                        he.event.remove(this, e, n, t);
                    })
                );
            },
        });
    var tt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
        nt = /<script|<style|<link/i,
        it = /checked\s*(?:[^=]|=\s*.checked.)/i,
        ot = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    he.extend({
        htmlPrefilter: function (e) {
            return e.replace(tt, "<$1></$2>");
        },
        clone: function (e, t, n) {
            var i,
                o,
                r,
                s,
                a,
                l,
                c,
                u = e.cloneNode(!0),
                d = Re(e);
            if (!(ce.noCloneChecked || (1 !== e.nodeType && 11 !== e.nodeType) || he.isXMLDoc(e)))
                for (s = y(u), i = 0, o = (r = y(e)).length; i < o; i++)
                    (a = r[i]), (l = s[i]), "input" === (c = l.nodeName.toLowerCase()) && Ue.test(a.type) ? (l.checked = a.checked) : ("input" !== c && "textarea" !== c) || (l.defaultValue = a.defaultValue);
            if (t)
                if (n) for (r = r || y(e), s = s || y(u), i = 0, o = r.length; i < o; i++) P(r[i], s[i]);
                else P(e, u);
            return 0 < (s = y(u, "script")).length && b(s, !d && y(e, "script")), u;
        },
        cleanData: function (e) {
            for (var t, n, i, o = he.event.special, r = 0; void 0 !== (n = e[r]); r++)
                if ($e(n)) {
                    if ((t = n[Ie.expando])) {
                        if (t.events) for (i in t.events) o[i] ? he.event.remove(n, i) : he.removeEvent(n, i, t.handle);
                        n[Ie.expando] = void 0;
                    }
                    n[Ne.expando] && (n[Ne.expando] = void 0);
                }
        },
    }),
        he.fn.extend({
            detach: function (e) {
                return $(this, e, !0);
            },
            remove: function (e) {
                return $(this, e);
            },
            text: function (e) {
                return _e(
                    this,
                    function (e) {
                        return void 0 === e
                            ? he.text(this)
                            : this.empty().each(function () {
                                  (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = e);
                              });
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            append: function () {
                return O(this, arguments, function (e) {
                    (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || E(this, e).appendChild(e);
                });
            },
            prepend: function () {
                return O(this, arguments, function (e) {
                    if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                        var t = E(this, e);
                        t.insertBefore(e, t.firstChild);
                    }
                });
            },
            before: function () {
                return O(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this);
                });
            },
            after: function () {
                return O(this, arguments, function (e) {
                    this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                });
            },
            empty: function () {
                for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (he.cleanData(y(e, !1)), (e.textContent = ""));
                return this;
            },
            clone: function (e, t) {
                return (
                    (e = null != e && e),
                    (t = null == t ? e : t),
                    this.map(function () {
                        return he.clone(this, e, t);
                    })
                );
            },
            html: function (e) {
                return _e(
                    this,
                    function (e) {
                        var t = this[0] || {},
                            n = 0,
                            i = this.length;
                        if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                        if ("string" == typeof e && !nt.test(e) && !Ke[(Ze.exec(e) || ["", ""])[1].toLowerCase()]) {
                            e = he.htmlPrefilter(e);
                            try {
                                for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (he.cleanData(y(t, !1)), (t.innerHTML = e));
                                t = 0;
                            } catch (e) {}
                        }
                        t && this.empty().append(e);
                    },
                    null,
                    e,
                    arguments.length
                );
            },
            replaceWith: function () {
                var e = [];
                return O(
                    this,
                    arguments,
                    function (t) {
                        var n = this.parentNode;
                        he.inArray(this, e) < 0 && (he.cleanData(y(this)), n && n.replaceChild(t, this));
                    },
                    e
                );
            },
        }),
        he.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (e, t) {
            he.fn[e] = function (e) {
                for (var n, i = [], o = he(e), r = o.length - 1, s = 0; s <= r; s++) (n = s === r ? this : this.clone(!0)), he(o[s])[t](n), ne.apply(i, n.get());
                return this.pushStack(i);
            };
        });
    var rt = new RegExp("^(" + ze + ")(?!px)[a-z%]+$", "i"),
        st = function (t) {
            var n = t.ownerDocument.defaultView;
            return (n && n.opener) || (n = e), n.getComputedStyle(t);
        },
        at = new RegExp(je.join("|"), "i");
    !(function () {
        function t() {
            if (c) {
                (l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                    (c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                    He.appendChild(l).appendChild(c);
                var t = e.getComputedStyle(c);
                (i = "1%" !== t.top),
                    (a = 12 === n(t.marginLeft)),
                    (c.style.right = "60%"),
                    (s = 36 === n(t.right)),
                    (o = 36 === n(t.width)),
                    (c.style.position = "absolute"),
                    (r = 12 === n(c.offsetWidth / 3)),
                    He.removeChild(l),
                    (c = null);
            }
        }
        function n(e) {
            return Math.round(parseFloat(e));
        }
        var i,
            o,
            r,
            s,
            a,
            l = J.createElement("div"),
            c = J.createElement("div");
        c.style &&
            ((c.style.backgroundClip = "content-box"),
            (c.cloneNode(!0).style.backgroundClip = ""),
            (ce.clearCloneStyle = "content-box" === c.style.backgroundClip),
            he.extend(ce, {
                boxSizingReliable: function () {
                    return t(), o;
                },
                pixelBoxStyles: function () {
                    return t(), s;
                },
                pixelPosition: function () {
                    return t(), i;
                },
                reliableMarginLeft: function () {
                    return t(), a;
                },
                scrollboxSize: function () {
                    return t(), r;
                },
            }));
    })();
    var lt = ["Webkit", "Moz", "ms"],
        ct = J.createElement("div").style,
        ut = {},
        dt = /^(none|table(?!-c[ea]).+)/,
        pt = /^--/,
        ft = { position: "absolute", visibility: "hidden", display: "block" },
        ht = { letterSpacing: "0", fontWeight: "400" };
    he.extend({
        cssHooks: {
            opacity: {
                get: function (e, t) {
                    if (t) {
                        var n = I(e, "opacity");
                        return "" === n ? "1" : n;
                    }
                },
            },
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
        },
        cssProps: {},
        style: function (e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o,
                    r,
                    s,
                    a = f(t),
                    l = pt.test(t),
                    c = e.style;
                if ((l || (t = D(a)), (s = he.cssHooks[t] || he.cssHooks[a]), void 0 === n)) return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : c[t];
                "string" == (r = typeof n) && (o = Me.exec(n)) && o[1] && ((n = v(e, t, o)), (r = "number")),
                    null != n &&
                        n == n &&
                        ("number" !== r || l || (n += (o && o[3]) || (he.cssNumber[a] ? "" : "px")),
                        ce.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"),
                        (s && "set" in s && void 0 === (n = s.set(e, n, i))) || (l ? c.setProperty(t, n) : (c[t] = n)));
            }
        },
        css: function (e, t, n, i) {
            var o,
                r,
                s,
                a = f(t);
            return (
                pt.test(t) || (t = D(a)),
                (s = he.cssHooks[t] || he.cssHooks[a]) && "get" in s && (o = s.get(e, !0, n)),
                void 0 === o && (o = I(e, t, i)),
                "normal" === o && t in ht && (o = ht[t]),
                "" === n || n ? ((r = parseFloat(o)), !0 === n || isFinite(r) ? r || 0 : o) : o
            );
        },
    }),
        he.each(["height", "width"], function (e, t) {
            he.cssHooks[t] = {
                get: function (e, n, i) {
                    if (n)
                        return !dt.test(he.css(e, "display")) || (e.getClientRects().length && e.getBoundingClientRect().width)
                            ? M(e, t, i)
                            : Be(e, ft, function () {
                                  return M(e, t, i);
                              });
                },
                set: function (e, n, i) {
                    var o,
                        r = st(e),
                        s = !ce.scrollboxSize() && "absolute" === r.position,
                        a = (s || i) && "border-box" === he.css(e, "boxSizing", !1, r),
                        l = i ? z(e, t, i, a, r) : 0;
                    return (
                        a && s && (l -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(r[t]) - z(e, t, "border", !1, r) - 0.5)),
                        l && (o = Me.exec(n)) && "px" !== (o[3] || "px") && ((e.style[t] = n), (n = he.css(e, t))),
                        L(0, n, l)
                    );
                },
            };
        }),
        (he.cssHooks.marginLeft = N(ce.reliableMarginLeft, function (e, t) {
            if (t)
                return (
                    (parseFloat(I(e, "marginLeft")) ||
                        e.getBoundingClientRect().left -
                            Be(e, { marginLeft: 0 }, function () {
                                return e.getBoundingClientRect().left;
                            })) + "px"
                );
        })),
        he.each({ margin: "", padding: "", border: "Width" }, function (e, t) {
            (he.cssHooks[e + t] = {
                expand: function (n) {
                    for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[e + je[i] + t] = r[i] || r[i - 2] || r[0];
                    return o;
                },
            }),
                "margin" !== e && (he.cssHooks[e + t].set = L);
        }),
        he.fn.extend({
            css: function (e, t) {
                return _e(
                    this,
                    function (e, t, n) {
                        var i,
                            o,
                            r = {},
                            s = 0;
                        if (Array.isArray(t)) {
                            for (i = st(e), o = t.length; s < o; s++) r[t[s]] = he.css(e, t[s], !1, i);
                            return r;
                        }
                        return void 0 !== n ? he.style(e, t, n) : he.css(e, t);
                    },
                    e,
                    t,
                    1 < arguments.length
                );
            },
        }),
        (((he.Tween = j).prototype = {
            constructor: j,
            init: function (e, t, n, i, o, r) {
                (this.elem = e), (this.prop = n), (this.easing = o || he.easing._default), (this.options = t), (this.start = this.now = this.cur()), (this.end = i), (this.unit = r || (he.cssNumber[n] ? "" : "px"));
            },
            cur: function () {
                var e = j.propHooks[this.prop];
                return e && e.get ? e.get(this) : j.propHooks._default.get(this);
            },
            run: function (e) {
                var t,
                    n = j.propHooks[this.prop];
                return (
                    this.options.duration ? (this.pos = t = he.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration)) : (this.pos = t = e),
                    (this.now = (this.end - this.start) * t + this.start),
                    this.options.step && this.options.step.call(this.elem, this.now, this),
                    n && n.set ? n.set(this) : j.propHooks._default.set(this),
                    this
                );
            },
        }).init.prototype = j.prototype),
        ((j.propHooks = {
            _default: {
                get: function (e) {
                    var t;
                    return 1 !== e.elem.nodeType || (null != e.elem[e.prop] && null == e.elem.style[e.prop]) ? e.elem[e.prop] : (t = he.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                },
                set: function (e) {
                    he.fx.step[e.prop] ? he.fx.step[e.prop](e) : 1 !== e.elem.nodeType || (!he.cssHooks[e.prop] && null == e.elem.style[D(e.prop)]) ? (e.elem[e.prop] = e.now) : he.style(e.elem, e.prop, e.now + e.unit);
                },
            },
        }).scrollTop = j.propHooks.scrollLeft = {
            set: function (e) {
                e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
            },
        }),
        (he.easing = {
            linear: function (e) {
                return e;
            },
            swing: function (e) {
                return 0.5 - Math.cos(e * Math.PI) / 2;
            },
            _default: "swing",
        }),
        (he.fx = j.prototype.init),
        (he.fx.step = {});
    var mt,
        vt,
        gt,
        yt,
        bt = /^(?:toggle|show|hide)$/,
        wt = /queueHooks$/;
    (he.Animation = he.extend(B, {
        tweeners: {
            "*": [
                function (e, t) {
                    var n = this.createTween(e, t);
                    return v(n.elem, e, Me.exec(t), n), n;
                },
            ],
        },
        tweener: function (e, t) {
            ue(e) ? ((t = e), (e = ["*"])) : (e = e.match(Te));
            for (var n, i = 0, o = e.length; i < o; i++) (n = e[i]), (B.tweeners[n] = B.tweeners[n] || []), B.tweeners[n].unshift(t);
        },
        prefilters: [
            function (e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    u,
                    d = "width" in t || "height" in t,
                    p = this,
                    f = {},
                    h = e.style,
                    m = e.nodeType && qe(e),
                    v = Ie.get(e, "fxshow");
                for (i in (n.queue ||
                    (null == (s = he._queueHooks(e, "fx")).unqueued &&
                        ((s.unqueued = 0),
                        (a = s.empty.fire),
                        (s.empty.fire = function () {
                            s.unqueued || a();
                        })),
                    s.unqueued++,
                    p.always(function () {
                        p.always(function () {
                            s.unqueued--, he.queue(e, "fx").length || s.empty.fire();
                        });
                    })),
                t))
                    if (((o = t[i]), bt.test(o))) {
                        if ((delete t[i], (r = r || "toggle" === o), o === (m ? "hide" : "show"))) {
                            if ("show" !== o || !v || void 0 === v[i]) continue;
                            m = !0;
                        }
                        f[i] = (v && v[i]) || he.style(e, i);
                    }
                if ((l = !he.isEmptyObject(t)) || !he.isEmptyObject(f))
                    for (i in (d &&
                        1 === e.nodeType &&
                        ((n.overflow = [h.overflow, h.overflowX, h.overflowY]),
                        null == (c = v && v.display) && (c = Ie.get(e, "display")),
                        "none" === (u = he.css(e, "display")) && (c ? (u = c) : (g([e], !0), (c = e.style.display || c), (u = he.css(e, "display")), g([e]))),
                        ("inline" === u || ("inline-block" === u && null != c)) &&
                            "none" === he.css(e, "float") &&
                            (l ||
                                (p.done(function () {
                                    h.display = c;
                                }),
                                null == c && ((u = h.display), (c = "none" === u ? "" : u))),
                            (h.display = "inline-block"))),
                    n.overflow &&
                        ((h.overflow = "hidden"),
                        p.always(function () {
                            (h.overflow = n.overflow[0]), (h.overflowX = n.overflow[1]), (h.overflowY = n.overflow[2]);
                        })),
                    (l = !1),
                    f))
                        l ||
                            (v ? "hidden" in v && (m = v.hidden) : (v = Ie.access(e, "fxshow", { display: c })),
                            r && (v.hidden = !m),
                            m && g([e], !0),
                            p.done(function () {
                                for (i in (m || g([e]), Ie.remove(e, "fxshow"), f)) he.style(e, i, f[i]);
                            })),
                            (l = q(m ? v[i] : 0, i, p)),
                            i in v || ((v[i] = l.start), m && ((l.end = l.start), (l.start = 0)));
            },
        ],
        prefilter: function (e, t) {
            t ? B.prefilters.unshift(e) : B.prefilters.push(e);
        },
    })),
        (he.speed = function (e, t, n) {
            var i = e && "object" == typeof e ? he.extend({}, e) : { complete: n || (!n && t) || (ue(e) && e), duration: e, easing: (n && t) || (t && !ue(t) && t) };
            return (
                he.fx.off ? (i.duration = 0) : "number" != typeof i.duration && (i.duration in he.fx.speeds ? (i.duration = he.fx.speeds[i.duration]) : (i.duration = he.fx.speeds._default)),
                (null != i.queue && !0 !== i.queue) || (i.queue = "fx"),
                (i.old = i.complete),
                (i.complete = function () {
                    ue(i.old) && i.old.call(this), i.queue && he.dequeue(this, i.queue);
                }),
                i
            );
        }),
        he.fn.extend({
            fadeTo: function (e, t, n, i) {
                return this.filter(qe).css("opacity", 0).show().end().animate({ opacity: t }, e, n, i);
            },
            animate: function (e, t, n, i) {
                var o = he.isEmptyObject(e),
                    r = he.speed(t, n, i),
                    s = function () {
                        var t = B(this, he.extend({}, e), r);
                        (o || Ie.get(this, "finish")) && t.stop(!0);
                    };
                return (s.finish = s), o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s);
            },
            stop: function (e, t, n) {
                var i = function (e) {
                    var t = e.stop;
                    delete e.stop, t(n);
                };
                return (
                    "string" != typeof e && ((n = t), (t = e), (e = void 0)),
                    t && !1 !== e && this.queue(e || "fx", []),
                    this.each(function () {
                        var t = !0,
                            o = null != e && e + "queueHooks",
                            r = he.timers,
                            s = Ie.get(this);
                        if (o) s[o] && s[o].stop && i(s[o]);
                        else for (o in s) s[o] && s[o].stop && wt.test(o) && i(s[o]);
                        for (o = r.length; o--; ) r[o].elem !== this || (null != e && r[o].queue !== e) || (r[o].anim.stop(n), (t = !1), r.splice(o, 1));
                        (!t && n) || he.dequeue(this, e);
                    })
                );
            },
            finish: function (e) {
                return (
                    !1 !== e && (e = e || "fx"),
                    this.each(function () {
                        var t,
                            n = Ie.get(this),
                            i = n[e + "queue"],
                            o = n[e + "queueHooks"],
                            r = he.timers,
                            s = i ? i.length : 0;
                        for (n.finish = !0, he.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--; ) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
                        for (t = 0; t < s; t++) i[t] && i[t].finish && i[t].finish.call(this);
                        delete n.finish;
                    })
                );
            },
        }),
        he.each(["toggle", "show", "hide"], function (e, t) {
            var n = he.fn[t];
            he.fn[t] = function (e, i, o) {
                return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(F(t, !0), e, i, o);
            };
        }),
        he.each({ slideDown: F("show"), slideUp: F("hide"), slideToggle: F("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (e, t) {
            he.fn[e] = function (e, n, i) {
                return this.animate(t, e, n, i);
            };
        }),
        (he.timers = []),
        (he.fx.tick = function () {
            var e,
                t = 0,
                n = he.timers;
            for (mt = Date.now(); t < n.length; t++) (e = n[t])() || n[t] !== e || n.splice(t--, 1);
            n.length || he.fx.stop(), (mt = void 0);
        }),
        (he.fx.timer = function (e) {
            he.timers.push(e), he.fx.start();
        }),
        (he.fx.interval = 13),
        (he.fx.start = function () {
            vt || ((vt = !0), H());
        }),
        (he.fx.stop = function () {
            vt = null;
        }),
        (he.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
        (he.fn.delay = function (t, n) {
            return (
                (t = (he.fx && he.fx.speeds[t]) || t),
                (n = n || "fx"),
                this.queue(n, function (n, i) {
                    var o = e.setTimeout(n, t);
                    i.stop = function () {
                        e.clearTimeout(o);
                    };
                })
            );
        }),
        (gt = J.createElement("input")),
        (yt = J.createElement("select").appendChild(J.createElement("option"))),
        (gt.type = "checkbox"),
        (ce.checkOn = "" !== gt.value),
        (ce.optSelected = yt.selected),
        ((gt = J.createElement("input")).value = "t"),
        (gt.type = "radio"),
        (ce.radioValue = "t" === gt.value);
    var xt,
        kt = he.expr.attrHandle;
    he.fn.extend({
        attr: function (e, t) {
            return _e(this, he.attr, e, t, 1 < arguments.length);
        },
        removeAttr: function (e) {
            return this.each(function () {
                he.removeAttr(this, e);
            });
        },
    }),
        he.extend({
            attr: function (e, t, n) {
                var i,
                    o,
                    r = e.nodeType;
                if (3 !== r && 8 !== r && 2 !== r)
                    return "undefined" == typeof e.getAttribute
                        ? he.prop(e, t, n)
                        : ((1 === r && he.isXMLDoc(e)) || (o = he.attrHooks[t.toLowerCase()] || (he.expr.match.bool.test(t) ? xt : void 0)),
                          void 0 !== n
                              ? null === n
                                  ? void he.removeAttr(e, t)
                                  : o && "set" in o && void 0 !== (i = o.set(e, n, t))
                                  ? i
                                  : (e.setAttribute(t, n + ""), n)
                              : o && "get" in o && null !== (i = o.get(e, t))
                              ? i
                              : null == (i = he.find.attr(e, t))
                              ? void 0
                              : i);
            },
            attrHooks: {
                type: {
                    set: function (e, t) {
                        if (!ce.radioValue && "radio" === t && r(e, "input")) {
                            var n = e.value;
                            return e.setAttribute("type", t), n && (e.value = n), t;
                        }
                    },
                },
            },
            removeAttr: function (e, t) {
                var n,
                    i = 0,
                    o = t && t.match(Te);
                if (o && 1 === e.nodeType) for (; (n = o[i++]); ) e.removeAttribute(n);
            },
        }),
        (xt = {
            set: function (e, t, n) {
                return !1 === t ? he.removeAttr(e, n) : e.setAttribute(n, n), n;
            },
        }),
        he.each(he.expr.match.bool.source.match(/\w+/g), function (e, t) {
            var n = kt[t] || he.find.attr;
            kt[t] = function (e, t, i) {
                var o,
                    r,
                    s = t.toLowerCase();
                return i || ((r = kt[s]), (kt[s] = o), (o = null != n(e, t, i) ? s : null), (kt[s] = r)), o;
            };
        });
    var St = /^(?:input|select|textarea|button)$/i,
        Ct = /^(?:a|area)$/i;
    he.fn.extend({
        prop: function (e, t) {
            return _e(this, he.prop, e, t, 1 < arguments.length);
        },
        removeProp: function (e) {
            return this.each(function () {
                delete this[he.propFix[e] || e];
            });
        },
    }),
        he.extend({
            prop: function (e, t, n) {
                var i,
                    o,
                    r = e.nodeType;
                if (3 !== r && 8 !== r && 2 !== r)
                    return (
                        (1 === r && he.isXMLDoc(e)) || ((t = he.propFix[t] || t), (o = he.propHooks[t])),
                        void 0 !== n ? (o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e[t] = n)) : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
                    );
            },
            propHooks: {
                tabIndex: {
                    get: function (e) {
                        var t = he.find.attr(e, "tabindex");
                        return t ? parseInt(t, 10) : St.test(e.nodeName) || (Ct.test(e.nodeName) && e.href) ? 0 : -1;
                    },
                },
            },
            propFix: { for: "htmlFor", class: "className" },
        }),
        ce.optSelected ||
            (he.propHooks.selected = {
                get: function (e) {
                    var t = e.parentNode;
                    return t && t.parentNode && t.parentNode.selectedIndex, null;
                },
                set: function (e) {
                    var t = e.parentNode;
                    t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                },
            }),
        he.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
            he.propFix[this.toLowerCase()] = this;
        }),
        he.fn.extend({
            addClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (ue(e))
                    return this.each(function (t) {
                        he(this).addClass(e.call(this, t, U(this)));
                    });
                if ((t = Z(e)).length)
                    for (; (n = this[l++]); )
                        if (((o = U(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
                            for (s = 0; (r = t[s++]); ) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                            o !== (a = W(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            removeClass: function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a,
                    l = 0;
                if (ue(e))
                    return this.each(function (t) {
                        he(this).removeClass(e.call(this, t, U(this)));
                    });
                if (!arguments.length) return this.attr("class", "");
                if ((t = Z(e)).length)
                    for (; (n = this[l++]); )
                        if (((o = U(n)), (i = 1 === n.nodeType && " " + W(o) + " "))) {
                            for (s = 0; (r = t[s++]); ) for (; -1 < i.indexOf(" " + r + " "); ) i = i.replace(" " + r + " ", " ");
                            o !== (a = W(i)) && n.setAttribute("class", a);
                        }
                return this;
            },
            toggleClass: function (e, t) {
                var n = typeof e,
                    i = "string" === n || Array.isArray(e);
                return "boolean" == typeof t && i
                    ? t
                        ? this.addClass(e)
                        : this.removeClass(e)
                    : ue(e)
                    ? this.each(function (n) {
                          he(this).toggleClass(e.call(this, n, U(this), t), t);
                      })
                    : this.each(function () {
                          var t, o, r, s;
                          if (i) for (o = 0, r = he(this), s = Z(e); (t = s[o++]); ) r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
                          else (void 0 !== e && "boolean" !== n) || ((t = U(this)) && Ie.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Ie.get(this, "__className__") || ""));
                      });
            },
            hasClass: function (e) {
                var t,
                    n,
                    i = 0;
                for (t = " " + e + " "; (n = this[i++]); ) if (1 === n.nodeType && -1 < (" " + W(U(n)) + " ").indexOf(t)) return !0;
                return !1;
            },
        });
    var Tt = /\r/g;
    he.fn.extend({
        val: function (e) {
            var t,
                n,
                i,
                o = this[0];
            return arguments.length
                ? ((i = ue(e)),
                  this.each(function (n) {
                      var o;
                      1 === this.nodeType &&
                          (null == (o = i ? e.call(this, n, he(this).val()) : e)
                              ? (o = "")
                              : "number" == typeof o
                              ? (o += "")
                              : Array.isArray(o) &&
                                (o = he.map(o, function (e) {
                                    return null == e ? "" : e + "";
                                })),
                          ((t = he.valHooks[this.type] || he.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value")) || (this.value = o));
                  }))
                : o
                ? (t = he.valHooks[o.type] || he.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value"))
                    ? n
                    : "string" == typeof (n = o.value)
                    ? n.replace(Tt, "")
                    : null == n
                    ? ""
                    : n
                : void 0;
        },
    }),
        he.extend({
            valHooks: {
                option: {
                    get: function (e) {
                        var t = he.find.attr(e, "value");
                        return null != t ? t : W(he.text(e));
                    },
                },
                select: {
                    get: function (e) {
                        var t,
                            n,
                            i,
                            o = e.options,
                            s = e.selectedIndex,
                            a = "select-one" === e.type,
                            l = a ? null : [],
                            c = a ? s + 1 : o.length;
                        for (i = s < 0 ? c : a ? s : 0; i < c; i++)
                            if (((n = o[i]).selected || i === s) && !n.disabled && (!n.parentNode.disabled || !r(n.parentNode, "optgroup"))) {
                                if (((t = he(n).val()), a)) return t;
                                l.push(t);
                            }
                        return l;
                    },
                    set: function (e, t) {
                        for (var n, i, o = e.options, r = he.makeArray(t), s = o.length; s--; ) ((i = o[s]).selected = -1 < he.inArray(he.valHooks.option.get(i), r)) && (n = !0);
                        return n || (e.selectedIndex = -1), r;
                    },
                },
            },
        }),
        he.each(["radio", "checkbox"], function () {
            (he.valHooks[this] = {
                set: function (e, t) {
                    if (Array.isArray(t)) return (e.checked = -1 < he.inArray(he(e).val(), t));
                },
            }),
                ce.checkOn ||
                    (he.valHooks[this].get = function (e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
        }),
        (ce.focusin = "onfocusin" in e);
    var Et = /^(?:focusinfocus|focusoutblur)$/,
        At = function (e) {
            e.stopPropagation();
        };
    he.extend(he.event, {
        trigger: function (t, n, i, o) {
            var r,
                s,
                a,
                l,
                c,
                u,
                d,
                p,
                f = [i || J],
                h = se.call(t, "type") ? t.type : t,
                m = se.call(t, "namespace") ? t.namespace.split(".") : [];
            if (
                ((s = p = a = i = i || J),
                3 !== i.nodeType &&
                    8 !== i.nodeType &&
                    !Et.test(h + he.event.triggered) &&
                    (-1 < h.indexOf(".") && ((h = (m = h.split(".")).shift()), m.sort()),
                    (c = h.indexOf(":") < 0 && "on" + h),
                    ((t = t[he.expando] ? t : new he.Event(h, "object" == typeof t && t)).isTrigger = o ? 2 : 3),
                    (t.namespace = m.join(".")),
                    (t.rnamespace = t.namespace ? new RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                    (t.result = void 0),
                    t.target || (t.target = i),
                    (n = null == n ? [t] : he.makeArray(n, [t])),
                    (d = he.event.special[h] || {}),
                    o || !d.trigger || !1 !== d.trigger.apply(i, n)))
            ) {
                if (!o && !d.noBubble && !de(i)) {
                    for (l = d.delegateType || h, Et.test(l + h) || (s = s.parentNode); s; s = s.parentNode) f.push(s), (a = s);
                    a === (i.ownerDocument || J) && f.push(a.defaultView || a.parentWindow || e);
                }
                for (r = 0; (s = f[r++]) && !t.isPropagationStopped(); )
                    (p = s),
                        (t.type = 1 < r ? l : d.bindType || h),
                        (u = (Ie.get(s, "events") || {})[t.type] && Ie.get(s, "handle")) && u.apply(s, n),
                        (u = c && s[c]) && u.apply && $e(s) && ((t.result = u.apply(s, n)), !1 === t.result && t.preventDefault());
                return (
                    (t.type = h),
                    o ||
                        t.isDefaultPrevented() ||
                        (d._default && !1 !== d._default.apply(f.pop(), n)) ||
                        !$e(i) ||
                        (c &&
                            ue(i[h]) &&
                            !de(i) &&
                            ((a = i[c]) && (i[c] = null),
                            (he.event.triggered = h),
                            t.isPropagationStopped() && p.addEventListener(h, At),
                            i[h](),
                            t.isPropagationStopped() && p.removeEventListener(h, At),
                            (he.event.triggered = void 0),
                            a && (i[c] = a))),
                    t.result
                );
            }
        },
        simulate: function (e, t, n) {
            var i = he.extend(new he.Event(), n, { type: e, isSimulated: !0 });
            he.event.trigger(i, null, t);
        },
    }),
        he.fn.extend({
            trigger: function (e, t) {
                return this.each(function () {
                    he.event.trigger(e, t, this);
                });
            },
            triggerHandler: function (e, t) {
                var n = this[0];
                if (n) return he.event.trigger(e, t, n, !0);
            },
        }),
        ce.focusin ||
            he.each({ focus: "focusin", blur: "focusout" }, function (e, t) {
                var n = function (e) {
                    he.event.simulate(t, e.target, he.event.fix(e));
                };
                he.event.special[t] = {
                    setup: function () {
                        var i = this.ownerDocument || this,
                            o = Ie.access(i, t);
                        o || i.addEventListener(e, n, !0), Ie.access(i, t, (o || 0) + 1);
                    },
                    teardown: function () {
                        var i = this.ownerDocument || this,
                            o = Ie.access(i, t) - 1;
                        o ? Ie.access(i, t, o) : (i.removeEventListener(e, n, !0), Ie.remove(i, t));
                    },
                };
            });
    var _t = e.location,
        Pt = Date.now(),
        Ot = /\?/;
    he.parseXML = function (t) {
        var n;
        if (!t || "string" != typeof t) return null;
        try {
            n = new e.DOMParser().parseFromString(t, "text/xml");
        } catch (e) {
            n = void 0;
        }
        return (n && !n.getElementsByTagName("parsererror").length) || he.error("Invalid XML: " + t), n;
    };
    var $t = /\[\]$/,
        It = /\r?\n/g,
        Nt = /^(?:submit|button|image|reset|file)$/i,
        Dt = /^(?:input|select|textarea|keygen)/i;
    (he.param = function (e, t) {
        var n,
            i = [],
            o = function (e, t) {
                var n = ue(t) ? t() : t;
                i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
            };
        if (null == e) return "";
        if (Array.isArray(e) || (e.jquery && !he.isPlainObject(e)))
            he.each(e, function () {
                o(this.name, this.value);
            });
        else for (n in e) V(n, e[n], t, o);
        return i.join("&");
    }),
        he.fn.extend({
            serialize: function () {
                return he.param(this.serializeArray());
            },
            serializeArray: function () {
                return this.map(function () {
                    var e = he.prop(this, "elements");
                    return e ? he.makeArray(e) : this;
                })
                    .filter(function () {
                        var e = this.type;
                        return this.name && !he(this).is(":disabled") && Dt.test(this.nodeName) && !Nt.test(e) && (this.checked || !Ue.test(e));
                    })
                    .map(function (e, t) {
                        var n = he(this).val();
                        return null == n
                            ? null
                            : Array.isArray(n)
                            ? he.map(n, function (e) {
                                  return { name: t.name, value: e.replace(It, "\r\n") };
                              })
                            : { name: t.name, value: n.replace(It, "\r\n") };
                    })
                    .get();
            },
        });
    var Lt = /%20/g,
        zt = /#.*$/,
        Mt = /([?&])_=[^&]*/,
        jt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ht = /^(?:GET|HEAD)$/,
        Rt = /^\/\//,
        Ft = {},
        qt = {},
        Bt = "*/".concat("*"),
        Wt = J.createElement("a");
    (Wt.href = _t.href),
        he.extend({
            active: 0,
            lastModified: {},
            etag: {},
            ajaxSettings: {
                url: _t.href,
                type: "GET",
                isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(_t.protocol),
                global: !0,
                processData: !0,
                async: !0,
                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                accepts: { "*": Bt, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": he.parseXML },
                flatOptions: { url: !0, context: !0 },
            },
            ajaxSetup: function (e, t) {
                return t ? Y(Y(e, he.ajaxSettings), t) : Y(he.ajaxSettings, e);
            },
            ajaxPrefilter: K(Ft),
            ajaxTransport: K(qt),
            ajax: function (t, n) {
                function i(t, n, i, a) {
                    var c,
                        p,
                        f,
                        w,
                        x,
                        k = n;
                    u ||
                        ((u = !0),
                        l && e.clearTimeout(l),
                        (o = void 0),
                        (s = a || ""),
                        (S.readyState = 0 < t ? 4 : 0),
                        (c = (200 <= t && t < 300) || 304 === t),
                        i &&
                            (w = (function (e, t, n) {
                                for (var i, o, r, s, a = e.contents, l = e.dataTypes; "*" === l[0]; ) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (i)
                                    for (o in a)
                                        if (a[o] && a[o].test(i)) {
                                            l.unshift(o);
                                            break;
                                        }
                                if (l[0] in n) r = l[0];
                                else {
                                    for (o in n) {
                                        if (!l[0] || e.converters[o + " " + l[0]]) {
                                            r = o;
                                            break;
                                        }
                                        s || (s = o);
                                    }
                                    r = r || s;
                                }
                                if (r) return r !== l[0] && l.unshift(r), n[r];
                            })(h, S, i)),
                        (w = (function (e, t, n, i) {
                            var o,
                                r,
                                s,
                                a,
                                l,
                                c = {},
                                u = e.dataTypes.slice();
                            if (u[1]) for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                            for (r = u.shift(); r; )
                                if ((e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), (l = r), (r = u.shift())))
                                    if ("*" === r) r = l;
                                    else if ("*" !== l && l !== r) {
                                        if (!(s = c[l + " " + r] || c["* " + r]))
                                            for (o in c)
                                                if ((a = o.split(" "))[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                                    !0 === s ? (s = c[o]) : !0 !== c[o] && ((r = a[0]), u.unshift(a[1]));
                                                    break;
                                                }
                                        if (!0 !== s)
                                            if (s && e.throws) t = s(t);
                                            else
                                                try {
                                                    t = s(t);
                                                } catch (e) {
                                                    return { state: "parsererror", error: s ? e : "No conversion from " + l + " to " + r };
                                                }
                                    }
                            return { state: "success", data: t };
                        })(h, w, S, c)),
                        c
                            ? (h.ifModified && ((x = S.getResponseHeader("Last-Modified")) && (he.lastModified[r] = x), (x = S.getResponseHeader("etag")) && (he.etag[r] = x)),
                              204 === t || "HEAD" === h.type ? (k = "nocontent") : 304 === t ? (k = "notmodified") : ((k = w.state), (p = w.data), (c = !(f = w.error))))
                            : ((f = k), (!t && k) || ((k = "error"), t < 0 && (t = 0))),
                        (S.status = t),
                        (S.statusText = (n || k) + ""),
                        c ? g.resolveWith(m, [p, k, S]) : g.rejectWith(m, [S, k, f]),
                        S.statusCode(b),
                        (b = void 0),
                        d && v.trigger(c ? "ajaxSuccess" : "ajaxError", [S, h, c ? p : f]),
                        y.fireWith(m, [S, k]),
                        d && (v.trigger("ajaxComplete", [S, h]), --he.active || he.event.trigger("ajaxStop")));
                }
                "object" == typeof t && ((n = t), (t = void 0)), (n = n || {});
                var o,
                    r,
                    s,
                    a,
                    l,
                    c,
                    u,
                    d,
                    p,
                    f,
                    h = he.ajaxSetup({}, n),
                    m = h.context || h,
                    v = h.context && (m.nodeType || m.jquery) ? he(m) : he.event,
                    g = he.Deferred(),
                    y = he.Callbacks("once memory"),
                    b = h.statusCode || {},
                    w = {},
                    x = {},
                    k = "canceled",
                    S = {
                        readyState: 0,
                        getResponseHeader: function (e) {
                            var t;
                            if (u) {
                                if (!a) for (a = {}; (t = jt.exec(s)); ) a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                t = a[e.toLowerCase() + " "];
                            }
                            return null == t ? null : t.join(", ");
                        },
                        getAllResponseHeaders: function () {
                            return u ? s : null;
                        },
                        setRequestHeader: function (e, t) {
                            return null == u && ((e = x[e.toLowerCase()] = x[e.toLowerCase()] || e), (w[e] = t)), this;
                        },
                        overrideMimeType: function (e) {
                            return null == u && (h.mimeType = e), this;
                        },
                        statusCode: function (e) {
                            var t;
                            if (e)
                                if (u) S.always(e[S.status]);
                                else for (t in e) b[t] = [b[t], e[t]];
                            return this;
                        },
                        abort: function (e) {
                            var t = e || k;
                            return o && o.abort(t), i(0, t), this;
                        },
                    };
                if (
                    (g.promise(S),
                    (h.url = ((t || h.url || _t.href) + "").replace(Rt, _t.protocol + "//")),
                    (h.type = n.method || n.type || h.method || h.type),
                    (h.dataTypes = (h.dataType || "*").toLowerCase().match(Te) || [""]),
                    null == h.crossDomain)
                ) {
                    c = J.createElement("a");
                    try {
                        (c.href = h.url), (c.href = c.href), (h.crossDomain = Wt.protocol + "//" + Wt.host != c.protocol + "//" + c.host);
                    } catch (e) {
                        h.crossDomain = !0;
                    }
                }
                if ((h.data && h.processData && "string" != typeof h.data && (h.data = he.param(h.data, h.traditional)), X(Ft, h, n, S), u)) return S;
                for (p in ((d = he.event && h.global) && 0 == he.active++ && he.event.trigger("ajaxStart"),
                (h.type = h.type.toUpperCase()),
                (h.hasContent = !Ht.test(h.type)),
                (r = h.url.replace(zt, "")),
                h.hasContent
                    ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Lt, "+"))
                    : ((f = h.url.slice(r.length)),
                      h.data && (h.processData || "string" == typeof h.data) && ((r += (Ot.test(r) ? "&" : "?") + h.data), delete h.data),
                      !1 === h.cache && ((r = r.replace(Mt, "$1")), (f = (Ot.test(r) ? "&" : "?") + "_=" + Pt++ + f)),
                      (h.url = r + f)),
                h.ifModified && (he.lastModified[r] && S.setRequestHeader("If-Modified-Since", he.lastModified[r]), he.etag[r] && S.setRequestHeader("If-None-Match", he.etag[r])),
                ((h.data && h.hasContent && !1 !== h.contentType) || n.contentType) && S.setRequestHeader("Content-Type", h.contentType),
                S.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Bt + "; q=0.01" : "") : h.accepts["*"]),
                h.headers))
                    S.setRequestHeader(p, h.headers[p]);
                if (h.beforeSend && (!1 === h.beforeSend.call(m, S, h) || u)) return S.abort();
                if (((k = "abort"), y.add(h.complete), S.done(h.success), S.fail(h.error), (o = X(qt, h, n, S)))) {
                    if (((S.readyState = 1), d && v.trigger("ajaxSend", [S, h]), u)) return S;
                    h.async &&
                        0 < h.timeout &&
                        (l = e.setTimeout(function () {
                            S.abort("timeout");
                        }, h.timeout));
                    try {
                        (u = !1), o.send(w, i);
                    } catch (e) {
                        if (u) throw e;
                        i(-1, e);
                    }
                } else i(-1, "No Transport");
                return S;
            },
            getJSON: function (e, t, n) {
                return he.get(e, t, n, "json");
            },
            getScript: function (e, t) {
                return he.get(e, void 0, t, "script");
            },
        }),
        he.each(["get", "post"], function (e, t) {
            he[t] = function (e, n, i, o) {
                return ue(n) && ((o = o || i), (i = n), (n = void 0)), he.ajax(he.extend({ url: e, type: t, dataType: o, data: n, success: i }, he.isPlainObject(e) && e));
            };
        }),
        (he._evalUrl = function (e, t) {
            return he.ajax({
                url: e,
                type: "GET",
                dataType: "script",
                cache: !0,
                async: !1,
                global: !1,
                converters: { "text script": function () {} },
                dataFilter: function (e) {
                    he.globalEval(e, t);
                },
            });
        }),
        he.fn.extend({
            wrapAll: function (e) {
                var t;
                return (
                    this[0] &&
                        (ue(e) && (e = e.call(this[0])),
                        (t = he(e, this[0].ownerDocument).eq(0).clone(!0)),
                        this[0].parentNode && t.insertBefore(this[0]),
                        t
                            .map(function () {
                                for (var e = this; e.firstElementChild; ) e = e.firstElementChild;
                                return e;
                            })
                            .append(this)),
                    this
                );
            },
            wrapInner: function (e) {
                return ue(e)
                    ? this.each(function (t) {
                          he(this).wrapInner(e.call(this, t));
                      })
                    : this.each(function () {
                          var t = he(this),
                              n = t.contents();
                          n.length ? n.wrapAll(e) : t.append(e);
                      });
            },
            wrap: function (e) {
                var t = ue(e);
                return this.each(function (n) {
                    he(this).wrapAll(t ? e.call(this, n) : e);
                });
            },
            unwrap: function (e) {
                return (
                    this.parent(e)
                        .not("body")
                        .each(function () {
                            he(this).replaceWith(this.childNodes);
                        }),
                    this
                );
            },
        }),
        (he.expr.pseudos.hidden = function (e) {
            return !he.expr.pseudos.visible(e);
        }),
        (he.expr.pseudos.visible = function (e) {
            return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
        }),
        (he.ajaxSettings.xhr = function () {
            try {
                return new e.XMLHttpRequest();
            } catch (e) {}
        });
    var Ut = { 0: 200, 1223: 204 },
        Zt = he.ajaxSettings.xhr();
    (ce.cors = !!Zt && "withCredentials" in Zt),
        (ce.ajax = Zt = !!Zt),
        he.ajaxTransport(function (t) {
            var n, i;
            if (ce.cors || (Zt && !t.crossDomain))
                return {
                    send: function (o, r) {
                        var s,
                            a = t.xhr();
                        if ((a.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)) for (s in t.xhrFields) a[s] = t.xhrFields[s];
                        for (s in (t.mimeType && a.overrideMimeType && a.overrideMimeType(t.mimeType), t.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(s, o[s]);
                        (n = function (e) {
                            return function () {
                                n &&
                                    ((n = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                    "abort" === e
                                        ? a.abort()
                                        : "error" === e
                                        ? "number" != typeof a.status
                                            ? r(0, "error")
                                            : r(a.status, a.statusText)
                                        : r(Ut[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText }, a.getAllResponseHeaders()));
                            };
                        }),
                            (a.onload = n()),
                            (i = a.onerror = a.ontimeout = n("error")),
                            void 0 !== a.onabort
                                ? (a.onabort = i)
                                : (a.onreadystatechange = function () {
                                      4 === a.readyState &&
                                          e.setTimeout(function () {
                                              n && i();
                                          });
                                  }),
                            (n = n("abort"));
                        try {
                            a.send((t.hasContent && t.data) || null);
                        } catch (e) {
                            if (n) throw e;
                        }
                    },
                    abort: function () {
                        n && n();
                    },
                };
        }),
        he.ajaxPrefilter(function (e) {
            e.crossDomain && (e.contents.script = !1);
        }),
        he.ajaxSetup({
            accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
            contents: { script: /\b(?:java|ecma)script\b/ },
            converters: {
                "text script": function (e) {
                    return he.globalEval(e), e;
                },
            },
        }),
        he.ajaxPrefilter("script", function (e) {
            void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
        }),
        he.ajaxTransport("script", function (e) {
            var t, n;
            if (e.crossDomain || e.scriptAttrs)
                return {
                    send: function (i, o) {
                        (t = he("<script>")
                            .attr(e.scriptAttrs || {})
                            .prop({ charset: e.scriptCharset, src: e.url })
                            .on(
                                "load error",
                                (n = function (e) {
                                    t.remove(), (n = null), e && o("error" === e.type ? 404 : 200, e.type);
                                })
                            )),
                            J.head.appendChild(t[0]);
                    },
                    abort: function () {
                        n && n();
                    },
                };
        });
    var Vt,
        Kt = [],
        Xt = /(=)\?(?=&|$)|\?\?/;
    he.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function () {
            var e = Kt.pop() || he.expando + "_" + Pt++;
            return (this[e] = !0), e;
        },
    }),
        he.ajaxPrefilter("json jsonp", function (t, n, i) {
            var o,
                r,
                s,
                a = !1 !== t.jsonp && (Xt.test(t.url) ? "url" : "string" == typeof t.data && 0 === (t.contentType || "").indexOf("application/x-www-form-urlencoded") && Xt.test(t.data) && "data");
            if (a || "jsonp" === t.dataTypes[0])
                return (
                    (o = t.jsonpCallback = ue(t.jsonpCallback) ? t.jsonpCallback() : t.jsonpCallback),
                    a ? (t[a] = t[a].replace(Xt, "$1" + o)) : !1 !== t.jsonp && (t.url += (Ot.test(t.url) ? "&" : "?") + t.jsonp + "=" + o),
                    (t.converters["script json"] = function () {
                        return s || he.error(o + " was not called"), s[0];
                    }),
                    (t.dataTypes[0] = "json"),
                    (r = e[o]),
                    (e[o] = function () {
                        s = arguments;
                    }),
                    i.always(function () {
                        void 0 === r ? he(e).removeProp(o) : (e[o] = r), t[o] && ((t.jsonpCallback = n.jsonpCallback), Kt.push(o)), s && ue(r) && r(s[0]), (s = r = void 0);
                    }),
                    "script"
                );
        }),
        (ce.createHTMLDocument = (((Vt = J.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === Vt.childNodes.length)),
        (he.parseHTML = function (e, t, n) {
            return "string" != typeof e
                ? []
                : ("boolean" == typeof t && ((n = t), (t = !1)),
                  t || (ce.createHTMLDocument ? (((i = (t = J.implementation.createHTMLDocument("")).createElement("base")).href = J.location.href), t.head.appendChild(i)) : (t = J)),
                  (r = !n && []),
                  (o = we.exec(e)) ? [t.createElement(o[1])] : ((o = w([e], t, r)), r && r.length && he(r).remove(), he.merge([], o.childNodes)));
            var i, o, r;
        }),
        (he.fn.load = function (e, t, n) {
            var i,
                o,
                r,
                s = this,
                a = e.indexOf(" ");
            return (
                -1 < a && ((i = W(e.slice(a))), (e = e.slice(0, a))),
                ue(t) ? ((n = t), (t = void 0)) : t && "object" == typeof t && (o = "POST"),
                0 < s.length &&
                    he
                        .ajax({ url: e, type: o || "GET", dataType: "html", data: t })
                        .done(function (e) {
                            (r = arguments), s.html(i ? he("<div>").append(he.parseHTML(e)).find(i) : e);
                        })
                        .always(
                            n &&
                                function (e, t) {
                                    s.each(function () {
                                        n.apply(this, r || [e.responseText, t, e]);
                                    });
                                }
                        ),
                this
            );
        }),
        he.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (e, t) {
            he.fn[t] = function (e) {
                return this.on(t, e);
            };
        }),
        (he.expr.pseudos.animated = function (e) {
            return he.grep(he.timers, function (t) {
                return e === t.elem;
            }).length;
        }),
        (he.offset = {
            setOffset: function (e, t, n) {
                var i,
                    o,
                    r,
                    s,
                    a,
                    l,
                    c = he.css(e, "position"),
                    u = he(e),
                    d = {};
                "static" === c && (e.style.position = "relative"),
                    (a = u.offset()),
                    (r = he.css(e, "top")),
                    (l = he.css(e, "left")),
                    ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto") ? ((s = (i = u.position()).top), (o = i.left)) : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                    ue(t) && (t = t.call(e, n, he.extend({}, a))),
                    null != t.top && (d.top = t.top - a.top + s),
                    null != t.left && (d.left = t.left - a.left + o),
                    "using" in t ? t.using.call(e, d) : u.css(d);
            },
        }),
        he.fn.extend({
            offset: function (e) {
                if (arguments.length)
                    return void 0 === e
                        ? this
                        : this.each(function (t) {
                              he.offset.setOffset(this, e, t);
                          });
                var t,
                    n,
                    i = this[0];
                return i ? (i.getClientRects().length ? ((t = i.getBoundingClientRect()), (n = i.ownerDocument.defaultView), { top: t.top + n.pageYOffset, left: t.left + n.pageXOffset }) : { top: 0, left: 0 }) : void 0;
            },
            position: function () {
                if (this[0]) {
                    var e,
                        t,
                        n,
                        i = this[0],
                        o = { top: 0, left: 0 };
                    if ("fixed" === he.css(i, "position")) t = i.getBoundingClientRect();
                    else {
                        for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === he.css(e, "position"); ) e = e.parentNode;
                        e && e !== i && 1 === e.nodeType && (((o = he(e).offset()).top += he.css(e, "borderTopWidth", !0)), (o.left += he.css(e, "borderLeftWidth", !0)));
                    }
                    return { top: t.top - o.top - he.css(i, "marginTop", !0), left: t.left - o.left - he.css(i, "marginLeft", !0) };
                }
            },
            offsetParent: function () {
                return this.map(function () {
                    for (var e = this.offsetParent; e && "static" === he.css(e, "position"); ) e = e.offsetParent;
                    return e || He;
                });
            },
        }),
        he.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (e, t) {
            var n = "pageYOffset" === t;
            he.fn[e] = function (i) {
                return _e(
                    this,
                    function (e, i, o) {
                        var r;
                        return de(e) ? (r = e) : 9 === e.nodeType && (r = e.defaultView), void 0 === o ? (r ? r[t] : e[i]) : void (r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : (e[i] = o));
                    },
                    e,
                    i,
                    arguments.length
                );
            };
        }),
        he.each(["top", "left"], function (e, t) {
            he.cssHooks[t] = N(ce.pixelPosition, function (e, n) {
                if (n) return (n = I(e, t)), rt.test(n) ? he(e).position()[t] + "px" : n;
            });
        }),
        he.each({ Height: "height", Width: "width" }, function (e, t) {
            he.each({ padding: "inner" + e, content: t, "": "outer" + e }, function (n, i) {
                he.fn[i] = function (o, r) {
                    var s = arguments.length && (n || "boolean" != typeof o),
                        a = n || (!0 === o || !0 === r ? "margin" : "border");
                    return _e(
                        this,
                        function (t, n, o) {
                            var r;
                            return de(t)
                                ? 0 === i.indexOf("outer")
                                    ? t["inner" + e]
                                    : t.document.documentElement["client" + e]
                                : 9 === t.nodeType
                                ? ((r = t.documentElement), Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e]))
                                : void 0 === o
                                ? he.css(t, n, a)
                                : he.style(t, n, o, a);
                        },
                        t,
                        s ? o : void 0,
                        s
                    );
                };
            });
        }),
        he.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (e, t) {
            he.fn[t] = function (e, n) {
                return 0 < arguments.length ? this.on(t, null, e, n) : this.trigger(t);
            };
        }),
        he.fn.extend({
            hover: function (e, t) {
                return this.mouseenter(e).mouseleave(t || e);
            },
        }),
        he.fn.extend({
            bind: function (e, t, n) {
                return this.on(e, null, t, n);
            },
            unbind: function (e, t) {
                return this.off(e, null, t);
            },
            delegate: function (e, t, n, i) {
                return this.on(t, e, n, i);
            },
            undelegate: function (e, t, n) {
                return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
            },
        }),
        (he.proxy = function (e, t) {
            var n, i, o;
            if (("string" == typeof t && ((n = e[t]), (t = e), (e = n)), ue(e)))
                return (
                    (i = ee.call(arguments, 2)),
                    ((o = function () {
                        return e.apply(t || this, i.concat(ee.call(arguments)));
                    }).guid = e.guid = e.guid || he.guid++),
                    o
                );
        }),
        (he.holdReady = function (e) {
            e ? he.readyWait++ : he.ready(!0);
        }),
        (he.isArray = Array.isArray),
        (he.parseJSON = JSON.parse),
        (he.nodeName = r),
        (he.isFunction = ue),
        (he.isWindow = de),
        (he.camelCase = f),
        (he.type = i),
        (he.now = Date.now),
        (he.isNumeric = function (e) {
            var t = he.type(e);
            return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
        }),
        "function" == typeof define &&
            define.amd &&
            define("jquery", [], function () {
                return he;
            });
    var Yt = e.jQuery,
        Gt = e.$;
    return (
        (he.noConflict = function (t) {
            return e.$ === he && (e.$ = Gt), t && e.jQuery === he && (e.jQuery = Yt), he;
        }),
        t || (e.jQuery = e.$ = he),
        he
    );
}),
    (window.theme = window.theme || {}),
    (theme.jQuery = jQuery) /*! enquire.js v2.1.2 - http://wicky.nillia.ms/enquire.js */,
    !(function (e, t, n) {
        var i = window.matchMedia;
        "undefined" != typeof module && module.exports
            ? (module.exports = n(i))
            : "function" == typeof define && define.amd
            ? define(function () {
                  return (t[e] = n(i));
              })
            : (t[e] = n(i));
    })("enquire", this, function (e) {
        "use strict";
        function t(e, t) {
            var n,
                i = 0,
                o = e.length;
            for (i; o > i && ((n = t(e[i], i)), n !== !1); i++);
        }
        function n(e) {
            return "[object Array]" === Object.prototype.toString.apply(e);
        }
        function i(e) {
            return "function" == typeof e;
        }
        function o(e) {
            (this.options = e), !e.deferSetup && this.setup();
        }
        function r(t, n) {
            (this.query = t), (this.isUnconditional = n), (this.handlers = []), (this.mql = e(t));
            var i = this;
            (this.listener = function (e) {
                (i.mql = e), i.assess();
            }),
                this.mql.addListener(this.listener);
        }
        function s() {
            if (!e) throw new Error("matchMedia not present, legacy browsers require a polyfill");
            (this.queries = {}), (this.browserIsIncapable = !e("only all").matches);
        }
        return (
            (o.prototype = {
                setup: function () {
                    this.options.setup && this.options.setup(), (this.initialised = !0);
                },
                on: function () {
                    !this.initialised && this.setup(), this.options.match && this.options.match();
                },
                off: function () {
                    this.options.unmatch && this.options.unmatch();
                },
                destroy: function () {
                    this.options.destroy ? this.options.destroy() : this.off();
                },
                equals: function (e) {
                    return this.options === e || this.options.match === e;
                },
            }),
            (r.prototype = {
                addHandler: function (e) {
                    var t = new o(e);
                    this.handlers.push(t), this.matches() && t.on();
                },
                removeHandler: function (e) {
                    var n = this.handlers;
                    t(n, function (t, i) {
                        return t.equals(e) ? (t.destroy(), !n.splice(i, 1)) : void 0;
                    });
                },
                matches: function () {
                    return this.mql.matches || this.isUnconditional;
                },
                clear: function () {
                    t(this.handlers, function (e) {
                        e.destroy();
                    }),
                        this.mql.removeListener(this.listener),
                        (this.handlers.length = 0);
                },
                assess: function () {
                    var e = this.matches() ? "on" : "off";
                    t(this.handlers, function (t) {
                        t[e]();
                    });
                },
            }),
            (s.prototype = {
                register: function (e, o, s) {
                    var a = this.queries,
                        l = s && this.browserIsIncapable;
                    return (
                        a[e] || (a[e] = new r(e, l)),
                        i(o) && (o = { match: o }),
                        n(o) || (o = [o]),
                        t(o, function (t) {
                            i(t) && (t = { match: t }), a[e].addHandler(t);
                        }),
                        this
                    );
                },
                unregister: function (e, t) {
                    var n = this.queries[e];
                    return n && (t ? n.removeHandler(t) : (n.clear(), delete this.queries[e])), this;
                },
            }),
            new s()
        );
    }),
    !(function (e) {
        function t() {}
        function n(e, t) {
            return function () {
                e.apply(t, arguments);
            };
        }
        function i(e) {
            if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
            if ("function" != typeof e) throw new TypeError("not a function");
            (this._state = 0), (this._handled = !1), (this._value = void 0), (this._deferreds = []), c(e, this);
        }
        function o(e, t) {
            for (; 3 === e._state; ) e = e._value;
            return 0 === e._state
                ? void e._deferreds.push(t)
                : ((e._handled = !0),
                  void i._immediateFn(function () {
                      var n = 1 === e._state ? t.onFulfilled : t.onRejected;
                      if (null === n) return void (1 === e._state ? r : s)(t.promise, e._value);
                      var i;
                      try {
                          i = n(e._value);
                      } catch (e) {
                          return void s(t.promise, e);
                      }
                      r(t.promise, i);
                  }));
        }
        function r(e, t) {
            try {
                if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
                if (t && ("object" == typeof t || "function" == typeof t)) {
                    var o = t.then;
                    if (t instanceof i) return (e._state = 3), (e._value = t), void a(e);
                    if ("function" == typeof o) return void c(n(o, t), e);
                }
                (e._state = 1), (e._value = t), a(e);
            } catch (t) {
                s(e, t);
            }
        }
        function s(e, t) {
            (e._state = 2), (e._value = t), a(e);
        }
        function a(e) {
            2 === e._state &&
                0 === e._deferreds.length &&
                i._immediateFn(function () {
                    e._handled || i._unhandledRejectionFn(e._value);
                });
            for (var t = 0, n = e._deferreds.length; t < n; t++) o(e, e._deferreds[t]);
            e._deferreds = null;
        }
        function l(e, t, n) {
            (this.onFulfilled = "function" == typeof e ? e : null), (this.onRejected = "function" == typeof t ? t : null), (this.promise = n);
        }
        function c(e, t) {
            var n = !1;
            try {
                e(
                    function (e) {
                        n || ((n = !0), r(t, e));
                    },
                    function (e) {
                        n || ((n = !0), s(t, e));
                    }
                );
            } catch (e) {
                if (n) return;
                (n = !0), s(t, e);
            }
        }
        var u = setTimeout;
        (i.prototype.catch = function (e) {
            return this.then(null, e);
        }),
            (i.prototype.then = function (e, n) {
                var i = new this.constructor(t);
                return o(this, new l(e, n, i)), i;
            }),
            (i.all = function (e) {
                var t = Array.prototype.slice.call(e);
                return new i(function (e, n) {
                    function i(r, s) {
                        try {
                            if (s && ("object" == typeof s || "function" == typeof s)) {
                                var a = s.then;
                                if ("function" == typeof a)
                                    return void a.call(
                                        s,
                                        function (e) {
                                            i(r, e);
                                        },
                                        n
                                    );
                            }
                            (t[r] = s), 0 === --o && e(t);
                        } catch (e) {
                            n(e);
                        }
                    }
                    if (0 === t.length) return e([]);
                    for (var o = t.length, r = 0; r < t.length; r++) i(r, t[r]);
                });
            }),
            (i.resolve = function (e) {
                return e && "object" == typeof e && e.constructor === i
                    ? e
                    : new i(function (t) {
                          t(e);
                      });
            }),
            (i.reject = function (e) {
                return new i(function (t, n) {
                    n(e);
                });
            }),
            (i.race = function (e) {
                return new i(function (t, n) {
                    for (var i = 0, o = e.length; i < o; i++) e[i].then(t, n);
                });
            }),
            (i._immediateFn =
                ("function" == typeof setImmediate &&
                    function (e) {
                        setImmediate(e);
                    }) ||
                function (e) {
                    u(e, 0);
                }),
            (i._unhandledRejectionFn = function (e) {
                "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
            }),
            (i._setImmediateFn = function (e) {
                i._immediateFn = e;
            }),
            (i._setUnhandledRejectionFn = function (e) {
                i._unhandledRejectionFn = e;
            }),
            "undefined" != typeof module && module.exports ? (module.exports = i) : e.Promise || (e.Promise = i);
    })(this),
    "function" != typeof Object.assign &&
        Object.defineProperty(Object, "assign", {
            value: function (e, t) {
                if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                for (var n = Object(e), i = 1; i < arguments.length; i++) {
                    var o = arguments[i];
                    if (null != o) for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
                }
                return n;
            },
            writable: !0,
            configurable: !0,
        }),
    Object.entries ||
        (Object.entries = function (e) {
            for (var t = Object.keys(e), n = t.length, i = new Array(n); n--; ) i[n] = [t[n], e[t[n]]];
            return i;
        }),
    (function (e) {
        "use strict";
        "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? (module.exports = e(require("jquery"))) : e(jQuery);
    })(function (e) {
        "use strict";
        var t = window.Slick || {};
        (t = (function () {
            function t(t, i) {
                var o,
                    r = this,
                    s = e("#nextArrowTemplate").prop("outerHTML"),
                    a = e("#prevArrowTemplate").prop("outerHTML");
                (r.defaults = {
                    accessibility: !0,
                    adaptiveHeight: !1,
                    appendArrows: e(t),
                    appendDots: e(t),
                    arrows: !0,
                    asNavFor: null,
                    prevArrow: a,
                    nextArrow: s,
                    autoplay: !1,
                    autoplaySpeed: 3e3,
                    centerMode: !1,
                    centerPadding: "50px",
                    cssEase: "ease",
                    customPaging: function (t, n) {
                        return e('<button type="button" data-role="none" role="button" tabindex="0" />').text(n + 1);
                    },
                    dots: !1,
                    dotsClass: "slick-dots",
                    draggable: !0,
                    easing: "linear",
                    edgeFriction: 0.35,
                    fade: !1,
                    focusOnSelect: !1,
                    infinite: !0,
                    initialSlide: 0,
                    mobileFirst: !1,
                    pauseOnHover: !0,
                    pauseOnFocus: !0,
                    pauseOnDotsHover: !1,
                    respondTo: "window",
                    responsive: null,
                    rows: 1,
                    rtl: !1,
                    slide: "",
                    slidesPerRow: 1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    swipe: !0,
                    swipeToSlide: !1,
                    touchMove: !0,
                    touchThreshold: 5,
                    useCSS: !0,
                    useTransform: !0,
                    variableWidth: !1,
                    vertical: !1,
                    verticalSwiping: !1,
                    waitForAnimate: !0,
                    zIndex: 1e3,
                    customHeightMatching: !1,
                    customSlideAdvancement: !1,
                }),
                    (r.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1,
                    }),
                    e.extend(r, r.initials),
                    (r.activeBreakpoint = null),
                    (r.animType = null),
                    (r.animProp = null),
                    (r.breakpoints = []),
                    (r.breakpointSettings = []),
                    (r.cssTransitions = !1),
                    (r.focussed = !1),
                    (r.interrupted = !1),
                    (r.hidden = "hidden"),
                    (r.paused = !0),
                    (r.positionProp = null),
                    (r.respondTo = null),
                    (r.rowCount = 1),
                    (r.shouldClick = !0),
                    (r.$slider = e(t)),
                    (r.$slidesCache = null),
                    (r.transformType = null),
                    (r.transitionType = null),
                    (r.visibilityChange = "visibilitychange"),
                    (r.windowWidth = 0),
                    (r.windowTimer = null),
                    (o = e(t).data("slick") || {}),
                    (r.options = e.extend({}, r.defaults, i, o)),
                    (r.currentSlide = r.options.initialSlide),
                    (r.originalSettings = r.options),
                    "undefined" != typeof document.mozHidden
                        ? ((r.hidden = "mozHidden"), (r.visibilityChange = "mozvisibilitychange"))
                        : "undefined" != typeof document.webkitHidden && ((r.hidden = "webkitHidden"), (r.visibilityChange = "webkitvisibilitychange")),
                    (r.autoPlay = e.proxy(r.autoPlay, r)),
                    (r.autoPlayClear = e.proxy(r.autoPlayClear, r)),
                    (r.autoPlayIterator = e.proxy(r.autoPlayIterator, r)),
                    (r.changeSlide = e.proxy(r.changeSlide, r)),
                    (r.clickHandler = e.proxy(r.clickHandler, r)),
                    (r.selectHandler = e.proxy(r.selectHandler, r)),
                    (r.setPosition = e.proxy(r.setPosition, r)),
                    (r.swipeHandler = e.proxy(r.swipeHandler, r)),
                    (r.dragHandler = e.proxy(r.dragHandler, r)),
                    (r.keyHandler = e.proxy(r.keyHandler, r)),
                    (r.instanceUid = n++),
                    (r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
                    r.registerBreakpoints(),
                    r.init(!0);
            }
            var n = 0;
            return t;
        })()),
            (t.prototype.activateADA = function () {
                var e = this;
                e.$slideTrack.find(".slick-active").attr({ "aria-hidden": "false" }).find("a, input, button, select").attr({ tabindex: "0" });
            }),
            (t.prototype.addSlide = t.prototype.slickAdd = function (t, n, i) {
                var o = this;
                if ("boolean" == typeof n) (i = n), (n = null);
                else if (n < 0 || n >= o.slideCount) return !1;
                o.unload(),
                    "number" == typeof n
                        ? 0 === n && 0 === o.$slides.length
                            ? e(t).appendTo(o.$slideTrack)
                            : i
                            ? e(t).insertBefore(o.$slides.eq(n))
                            : e(t).insertAfter(o.$slides.eq(n))
                        : i === !0
                        ? e(t).prependTo(o.$slideTrack)
                        : e(t).appendTo(o.$slideTrack),
                    (o.$slides = o.$slideTrack.children(this.options.slide)),
                    o.$slideTrack.children(this.options.slide).detach(),
                    o.$slideTrack.append(o.$slides),
                    o.$slides.each(function (t, n) {
                        e(n).attr("data-slick-index", t);
                    }),
                    (o.$slidesCache = o.$slides),
                    o.reinit();
            }),
            (t.prototype.animateHeight = function () {
                var e = this;
                if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.animate({ height: t }, e.options.speed);
                }
            }),
            (t.prototype.animateSlide = function (t, n) {
                var i = {},
                    o = this;
                o.animateHeight(),
                    o.options.rtl === !0 && o.options.vertical === !1 && (t = -t),
                    o.transformsEnabled === !1
                        ? o.options.vertical === !1
                            ? o.$slideTrack.animate({ left: t }, o.options.speed, o.options.easing, n)
                            : o.$slideTrack.animate({ top: t }, o.options.speed, o.options.easing, n)
                        : o.cssTransitions === !1
                        ? (o.options.rtl === !0 && (o.currentLeft = -o.currentLeft),
                          e({ animStart: o.currentLeft }).animate(
                              { animStart: t },
                              {
                                  duration: o.options.speed,
                                  easing: o.options.easing,
                                  step: function (e) {
                                      (e = Math.ceil(e)), o.options.vertical === !1 ? ((i[o.animType] = "translate(" + e + "px, 0px)"), o.$slideTrack.css(i)) : ((i[o.animType] = "translate(0px," + e + "px)"), o.$slideTrack.css(i));
                                  },
                                  complete: function () {
                                      n && n.call();
                                  },
                              }
                          ))
                        : (o.applyTransition(),
                          (t = Math.ceil(t)),
                          o.options.vertical === !1 ? (i[o.animType] = "translate3d(" + t + "px, 0px, 0px)") : (i[o.animType] = "translate3d(0px," + t + "px, 0px)"),
                          o.$slideTrack.css(i),
                          n &&
                              setTimeout(function () {
                                  o.disableTransition(), n.call();
                              }, o.options.speed));
            }),
            (t.prototype.getNavTarget = function () {
                var t = this,
                    n = t.options.asNavFor;
                return n && null !== n && (n = e(n).not(t.$slider)), n;
            }),
            (t.prototype.asNavFor = function (t) {
                var n = this,
                    i = n.getNavTarget();
                null !== i &&
                    "object" == typeof i &&
                    i.each(function () {
                        var n = e(this).slick("getSlick");
                        n.unslicked || n.slideHandler(t, !0);
                    });
            }),
            (t.prototype.applyTransition = function (e) {
                var t = this,
                    n = {};
                t.options.fade === !1 ? (n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase) : (n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase),
                    t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
            }),
            (t.prototype.autoPlay = function () {
                var e = this;
                e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed));
            }),
            (t.prototype.autoPlayClear = function () {
                var e = this;
                e.autoPlayTimer && clearInterval(e.autoPlayTimer);
            }),
            (t.prototype.autoPlayIterator = function () {
                var e = this,
                    t = e.currentSlide + e.options.slidesToScroll;
                e.paused ||
                    e.interrupted ||
                    e.focussed ||
                    (e.options.infinite === !1 &&
                        (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? (e.direction = 0) : 0 === e.direction && ((t = e.currentSlide - e.options.slidesToScroll), e.currentSlide - 1 === 0 && (e.direction = 1))),
                    e.slideHandler(t));
            }),
            (t.prototype.buildArrows = function () {
                var t = this;
                t.options.arrows === !0 &&
                    ((t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow")),
                    (t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow")),
                    t.slideCount > t.options.slidesToShow
                        ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),
                          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows),
                          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows),
                          t.options.infinite !== !0 && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"))
                        : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({ "aria-disabled": "true", tabindex: "-1" }));
            }),
            (t.prototype.buildDots = function () {
                var t,
                    n,
                    i = this;
                if (i.options.dots === !0 && i.slideCount > i.options.slidesToShow) {
                    for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
                    (i.$dots = n.appendTo(i.options.appendDots)), i.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false");
                }
            }),
            (t.prototype.buildOut = function () {
                var t = this;
                (t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.$slides.each(function (t, n) {
                        e(n)
                            .attr("data-slick-index", t)
                            .data("originalStyling", e(n).attr("style") || "");
                    }),
                    t.$slider.addClass("slick-slider"),
                    (t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent()),
                    (t.$list = t.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent()),
                    t.$slideTrack.css("opacity", 0),
                    (t.options.centerMode !== !0 && t.options.swipeToSlide !== !0) || (t.options.slidesToScroll = 1),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.buildDots(),
                    t.updateDots(),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    t.options.draggable === !0 && t.$list.addClass("draggable");
            }),
            (t.prototype.buildRows = function () {
                var e,
                    t,
                    n,
                    i,
                    o,
                    r,
                    s,
                    a = this;
                if (((i = document.createDocumentFragment()), (r = a.$slider.children()), a.options.rows > 1)) {
                    for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                        var l = document.createElement("div");
                        for (t = 0; t < a.options.rows; t++) {
                            var c = document.createElement("div");
                            for (n = 0; n < a.options.slidesPerRow; n++) {
                                var u = e * s + (t * a.options.slidesPerRow + n);
                                r.get(u) && c.appendChild(r.get(u));
                            }
                            l.appendChild(c);
                        }
                        i.appendChild(l);
                    }
                    a.$slider.empty().append(i),
                        a.$slider
                            .children()
                            .children()
                            .children()
                            .css({ width: 100 / a.options.slidesPerRow + "%", display: "inline-block" });
                }
            }),
            (t.prototype.checkResponsive = function (t, n) {
                var i,
                    o,
                    r,
                    s = this,
                    a = !1,
                    l = s.$slider.width(),
                    c = window.innerWidth || e(window).width();
                if (("window" === s.respondTo ? (r = c) : "slider" === s.respondTo ? (r = l) : "min" === s.respondTo && (r = Math.min(c, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive)) {
                    o = null;
                    for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (s.originalSettings.mobileFirst === !1 ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
                    null !== o
                        ? null !== s.activeBreakpoint
                            ? (o !== s.activeBreakpoint || n) &&
                              ((s.activeBreakpoint = o),
                              "unslick" === s.breakpointSettings[o] ? s.unslick(o) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                              (a = o))
                            : ((s.activeBreakpoint = o),
                              "unslick" === s.breakpointSettings[o] ? s.unslick(o) : ((s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o])), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t)),
                              (a = o))
                        : null !== s.activeBreakpoint && ((s.activeBreakpoint = null), (s.options = s.originalSettings), t === !0 && (s.currentSlide = s.options.initialSlide), s.refresh(t), (a = o)),
                        t || a === !1 || s.$slider.trigger("breakpoint", [s, a]);
                }
            }),
            (t.prototype.changeSlide = function (t, n) {
                var i,
                    o,
                    r,
                    s = this,
                    a = e(t.currentTarget);
                switch ((a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), (r = s.slideCount % s.options.slidesToScroll !== 0), (i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll), t.data.message)) {
                    case "previous":
                        (o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);
                        break;
                    case "next":
                        (o = 0 === i ? s.options.slidesToScroll : i), s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);
                        break;
                    case "index":
                        var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
                        s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
                        break;
                    default:
                        return;
                }
            }),
            (t.prototype.checkNavigable = function (e) {
                var t,
                    n,
                    i = this;
                if (((t = i.getNavigableIndexes()), (n = 0), e > t[t.length - 1])) e = t[t.length - 1];
                else
                    for (var o in t) {
                        if (e < t[o]) {
                            e = n;
                            break;
                        }
                        n = t[o];
                    }
                return e;
            }),
            (t.prototype.cleanUpEvents = function () {
                var t = this;
                t.options.dots && null !== t.$dots && e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)),
                    t.$slider.off("focus.slick blur.slick"),
                    t.options.arrows === !0 && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide)),
                    t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
                    t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
                    t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
                    t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
                    t.$list.off("click.slick", t.clickHandler),
                    e(document).off(t.visibilityChange, t.visibility),
                    t.cleanUpSlideEvents(),
                    t.options.accessibility === !0 && t.$list.off("keydown.slick", t.keyHandler),
                    t.options.focusOnSelect === !0 && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
                    e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
                    e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
                    e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
                    e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition),
                    e(document).off("ready.slick.slick-" + t.instanceUid, t.setPosition);
            }),
            (t.prototype.cleanUpSlideEvents = function () {
                var t = this;
                t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1));
            }),
            (t.prototype.cleanUpRows = function () {
                var e,
                    t = this;
                t.options.rows > 1 && ((e = t.$slides.children().children()), e.removeAttr("style"), t.$slider.empty().append(e));
            }),
            (t.prototype.clickHandler = function (e) {
                var t = this;
                t.shouldClick === !1 && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault());
            }),
            (t.prototype.destroy = function (t) {
                var n = this;
                n.autoPlayClear(),
                    (n.touchObject = {}),
                    n.cleanUpEvents(),
                    e(".slick-cloned", n.$slider).detach(),
                    n.$dots && n.$dots.remove(),
                    n.$prevArrow &&
                        n.$prevArrow.length &&
                        (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()),
                    n.$nextArrow &&
                        n.$nextArrow.length &&
                        (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()),
                    n.$slides &&
                        (n.$slides
                            .removeClass("slick-slide slick-active slick-center slick-visible slick-current")
                            .removeAttr("aria-hidden")
                            .removeAttr("data-slick-index")
                            .each(function () {
                                e(this).attr("style", e(this).data("originalStyling"));
                            }),
                        n.$slideTrack.children(this.options.slide).detach(),
                        n.$slideTrack.detach(),
                        n.$list.detach(),
                        n.$slider.append(n.$slides)),
                    n.cleanUpRows(),
                    n.$slider.removeClass("slick-slider"),
                    n.$slider.removeClass("slick-initialized"),
                    n.$slider.removeClass("slick-dotted"),
                    (n.unslicked = !0),
                    t || n.$slider.trigger("destroy", [n]);
            }),
            (t.prototype.disableTransition = function (e) {
                var t = this,
                    n = {};
                (n[t.transitionType] = ""), t.options.fade === !1 ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n);
            }),
            (t.prototype.fadeSlide = function (e, t) {
                var n = this;
                n.cssTransitions === !1
                    ? (n.$slides.eq(e).css({ zIndex: n.options.zIndex }), n.$slides.eq(e).animate({ opacity: 1 }, 0, n.options.easing, t))
                    : (n.applyTransition(e),
                      n.$slides.eq(e).css({ opacity: 1, zIndex: n.options.zIndex }),
                      t &&
                          setTimeout(function () {
                              n.disableTransition(e), t.call();
                          }, n.options.speed));
            }),
            (t.prototype.fadeSlideOut = function (e) {
                var t = this;
                t.cssTransitions === !1 ? t.$slides.eq(e).animate({ opacity: 1, zIndex: t.options.zIndex - 2 }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({ opacity: 1, zIndex: t.options.zIndex - 2 }));
            }),
            (t.prototype.filterSlides = t.prototype.slickFilter = function (e) {
                var t = this;
                null !== e && ((t.$slidesCache = t.$slides), t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit());
            }),
            (t.prototype.focusHandler = function () {
                var t = this;
                t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function (n) {
                    n.stopImmediatePropagation();
                    var i = e(this);
                    setTimeout(function () {
                        t.options.pauseOnFocus && ((t.focussed = i.is(":focus")), t.autoPlay());
                    }, 0);
                });
            }),
            (t.prototype.getCurrent = t.prototype.slickCurrentSlide = function () {
                var e = this;
                return e.currentSlide;
            }),
            (t.prototype.getDotCount = function () {
                var e = this,
                    t = 0,
                    n = 0,
                    i = 0;
                if (e.options.infinite === !0) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else if (e.options.centerMode === !0) i = e.slideCount;
                else if (e.options.asNavFor) for (; t < e.slideCount; ) ++i, (t = n + e.options.slidesToScroll), (n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow);
                else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                return i - 1;
            }),
            (t.prototype.getLeft = function (e) {
                var t,
                    n,
                    i,
                    o = this,
                    r = 0;
                return (
                    (o.slideOffset = 0),
                    (n = o.$slides.first().outerHeight(!0)),
                    o.options.infinite === !0
                        ? (o.slideCount > o.options.slidesToShow && ((o.slideOffset = o.slideWidth * o.options.slidesToShow * -1), (r = n * o.options.slidesToShow * -1)),
                          o.slideCount % o.options.slidesToScroll !== 0 &&
                              e + o.options.slidesToScroll > o.slideCount &&
                              o.slideCount > o.options.slidesToShow &&
                              (e > o.slideCount
                                  ? ((o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1), (r = (o.options.slidesToShow - (e - o.slideCount)) * n * -1))
                                  : ((o.slideOffset = (o.slideCount % o.options.slidesToScroll) * o.slideWidth * -1), (r = (o.slideCount % o.options.slidesToScroll) * n * -1))))
                        : e + o.options.slidesToShow > o.slideCount && ((o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth), (r = (e + o.options.slidesToShow - o.slideCount) * n)),
                    o.slideCount <= o.options.slidesToShow && ((o.slideOffset = 0), (r = 0)),
                    o.options.centerMode === !0 && o.options.infinite === !0
                        ? (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth)
                        : o.options.centerMode === !0 && ((o.slideOffset = 0), (o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2))),
                    (t = o.options.vertical === !1 ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + r),
                    o.options.variableWidth === !0 &&
                        ((i = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow)),
                        (t = o.options.rtl === !0 ? (i[0] ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1 : 0) : i[0] ? i[0].offsetLeft * -1 : 0),
                        o.options.centerMode === !0 &&
                            ((i = o.slideCount <= o.options.slidesToShow || o.options.infinite === !1 ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1)),
                            (t = o.options.rtl === !0 ? (i[0] ? (o.$slideTrack.width() - i[0].offsetLeft - i.width()) * -1 : 0) : i[0] ? i[0].offsetLeft * -1 : 0),
                            (t += (o.$list.width() - i.outerWidth()) / 2))),
                    t
                );
            }),
            (t.prototype.getOption = t.prototype.slickGetOption = function (e) {
                var t = this;
                return t.options[e];
            }),
            (t.prototype.getNavigableIndexes = function () {
                var e,
                    t = this,
                    n = 0,
                    i = 0,
                    o = [];
                for (t.options.infinite === !1 ? (e = t.slideCount) : ((n = t.options.slidesToScroll * -1), (i = t.options.slidesToScroll * -1), (e = 2 * t.slideCount)); n < e; )
                    o.push(n), (n = i + t.options.slidesToScroll), (i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow);
                return o;
            }),
            (t.prototype.getSlick = function () {
                return this;
            }),
            (t.prototype.getSlideCount = function () {
                var t,
                    n,
                    i,
                    o = this;
                return (
                    (i = o.options.centerMode === !0 ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0),
                    o.options.swipeToSlide === !0
                        ? (o.$slideTrack.find(".slick-slide").each(function (t, r) {
                              if (r.offsetLeft - i + e(r).outerWidth() / 2 > o.swipeLeft * -1) return (n = r), !1;
                          }),
                          (t = Math.abs(e(n).attr("data-slick-index") - o.currentSlide) || 1))
                        : o.options.slidesToScroll
                );
            }),
            (t.prototype.goTo = t.prototype.slickGoTo = function (e, t) {
                var n = this;
                n.changeSlide({ data: { message: "index", index: parseInt(e) } }, t);
            }),
            (t.prototype.init = function (t) {
                var n = this;
                if (
                    (e(n.$slider).hasClass("slick-initialized") ||
                        (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()),
                    t && n.$slider.trigger("init", [n]),
                    n.options.accessibility === !0 && n.initADA(),
                    n.options.autoplay && ((n.paused = !1), n.autoPlay()),
                    n.options.customSlideAdvancement)
                ) {
                    var i = n.options.initialSlide ? n.options.initialSlide : 0;
                    n.changeSlide({ data: { message: "index", index: parseInt(i) } });
                }
            }),
            (t.prototype.initADA = function () {
                var t = this;
                t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({ "aria-hidden": "true", tabindex: "-1" }).find("a, input, button, select").attr({ tabindex: "-1" }),
                    t.$slideTrack.attr("role", "listbox"),
                    t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function (n) {
                        e(this).attr({ role: "option", "aria-describedby": "slick-slide" + t.instanceUid + n });
                    }),
                    null !== t.$dots &&
                        t.$dots
                            .attr("role", "tablist")
                            .find("li")
                            .each(function (n) {
                                e(this).attr({ role: "presentation", "aria-selected": "false", "aria-controls": "navigation" + t.instanceUid + n, id: "slick-slide" + t.instanceUid + n });
                            })
                            .first()
                            .attr("aria-selected", "true")
                            .end()
                            .find("button")
                            .attr("role", "button")
                            .end()
                            .closest("div")
                            .attr("role", "toolbar"),
                    t.activateADA();
            }),
            (t.prototype.initArrowEvents = function () {
                var e = this;
                e.options.arrows === !0 &&
                    e.slideCount > e.options.slidesToShow &&
                    (e.$prevArrow.off("click.slick").on("click.slick", { message: "previous" }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", { message: "next" }, e.changeSlide));
            }),
            (t.prototype.initDotEvents = function () {
                var t = this;
                t.options.dots === !0 && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("click.slick", { message: "index" }, t.changeSlide),
                    t.options.dots === !0 && t.options.pauseOnDotsHover === !0 && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1));
            }),
            (t.prototype.initSlideEvents = function () {
                var t = this;
                t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)));
            }),
            (t.prototype.initializeEvents = function () {
                var t = this;
                t.initArrowEvents(),
                    t.initDotEvents(),
                    t.initSlideEvents(),
                    t.$list.on("touchstart.slick mousedown.slick", { action: "start" }, t.swipeHandler),
                    t.$list.on("touchmove.slick mousemove.slick", { action: "move" }, t.swipeHandler),
                    t.$list.on("touchend.slick mouseup.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("touchcancel.slick mouseleave.slick", { action: "end" }, t.swipeHandler),
                    t.$list.on("click.slick", t.clickHandler),
                    e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
                    t.options.accessibility === !0 && t.$list.on("keydown.slick", t.keyHandler),
                    t.options.focusOnSelect === !0 && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
                    e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
                    e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
                    e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
                    e(document).on("ready.slick.slick-" + t.instanceUid, t.setPosition);
            }),
            (t.prototype.initUI = function () {
                var e = this;
                e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.show();
            }),
            (t.prototype.keyHandler = function (e) {
                var t = this;
                e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
                    (37 === e.keyCode && t.options.accessibility === !0
                        ? t.changeSlide({ data: { message: t.options.rtl === !0 ? "next" : "previous" } })
                        : 39 === e.keyCode && t.options.accessibility === !0 && t.changeSlide({ data: { message: t.options.rtl === !0 ? "previous" : "next" } }));
            }),
            (t.prototype.loadSlider = function () {
                var e = this;
                e.setPosition(), e.$slideTrack.css({ opacity: 1 }), e.$slider.removeClass("slick-loading"), e.initUI();
            }),
            (t.prototype.next = t.prototype.slickNext = function () {
                var e = this;
                e.changeSlide({ data: { message: "next" } });
            }),
            (t.prototype.orientationChange = function () {
                var e = this;
                e.checkResponsive(), e.setPosition();
            }),
            (t.prototype.pause = t.prototype.slickPause = function () {
                var e = this;
                e.autoPlayClear(), (e.paused = !0);
            }),
            (t.prototype.play = t.prototype.slickPlay = function () {
                var e = this;
                e.autoPlay(), (e.options.autoplay = !0), (e.paused = !1), (e.focussed = !1), (e.interrupted = !1);
            }),
            (t.prototype.postSlide = function (e) {
                var t = this;
                t.unslicked || (t.$slider.trigger("afterChange", [t, e]), (t.animating = !1), t.setPosition(), (t.swipeLeft = null), t.options.autoplay && t.autoPlay(), t.options.accessibility === !0 && t.initADA());
            }),
            (t.prototype.prev = t.prototype.slickPrev = function () {
                var e = this;
                e.changeSlide({ data: { message: "previous" } });
            }),
            (t.prototype.preventDefault = function (e) {
                e.preventDefault();
            }),
            (t.prototype.refresh = function (t) {
                var n,
                    i,
                    o = this;
                (i = o.slideCount - o.options.slidesToShow),
                    !o.options.infinite && o.currentSlide > i && (o.currentSlide = i),
                    o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0),
                    (n = o.currentSlide),
                    o.destroy(!0),
                    e.extend(o, o.initials, { currentSlide: n }),
                    o.init(),
                    t || o.changeSlide({ data: { message: "index", index: n } }, !1);
            }),
            (t.prototype.registerBreakpoints = function () {
                var t,
                    n,
                    i,
                    o = this,
                    r = o.options.responsive || null;
                if ("array" === e.type(r) && r.length) {
                    o.respondTo = o.options.respondTo || "window";
                    for (t in r)
                        if (((i = o.breakpoints.length - 1), (n = r[t].breakpoint), r.hasOwnProperty(t))) {
                            for (; i >= 0; ) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
                            o.breakpoints.push(n), (o.breakpointSettings[n] = r[t].settings);
                        }
                    o.breakpoints.sort(function (e, t) {
                        return o.options.mobileFirst ? e - t : t - e;
                    });
                }
            }),
            (t.prototype.reinit = function () {
                var t = this;
                (t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide")),
                    (t.slideCount = t.$slides.length),
                    t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
                    t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
                    t.registerBreakpoints(),
                    t.setProps(),
                    t.setupInfinite(),
                    t.buildArrows(),
                    t.updateArrows(),
                    t.initArrowEvents(),
                    t.buildDots(),
                    t.updateDots(),
                    t.initDotEvents(),
                    t.cleanUpSlideEvents(),
                    t.initSlideEvents(),
                    t.checkResponsive(!1, !0),
                    t.options.focusOnSelect === !0 && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
                    t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
                    t.setPosition(),
                    t.focusHandler(),
                    (t.paused = !t.options.autoplay),
                    t.autoPlay(),
                    t.$slider.trigger("reInit", [t]);
            }),
            (t.prototype.resize = function () {
                var t = this;
                e(window).width() !== t.windowWidth &&
                    (clearTimeout(t.windowDelay),
                    (t.windowDelay = window.setTimeout(function () {
                        (t.windowWidth = e(window).width()), t.checkResponsive(), t.unslicked || t.setPosition();
                    }, 50)));
            }),
            (t.prototype.removeSlide = t.prototype.slickRemove = function (e, t, n) {
                var i = this;
                return (
                    "boolean" == typeof e ? ((t = e), (e = t === !0 ? 0 : i.slideCount - 1)) : (e = t === !0 ? --e : e),
                    !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) &&
                        (i.unload(),
                        n === !0 ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
                        (i.$slides = i.$slideTrack.children(this.options.slide)),
                        i.$slideTrack.children(this.options.slide).detach(),
                        i.$slideTrack.append(i.$slides),
                        (i.$slidesCache = i.$slides),
                        void i.reinit())
                );
            }),
            (t.prototype.setCSS = function (e) {
                var t,
                    n,
                    i = this,
                    o = {};
                i.options.rtl === !0 && (e = -e),
                    (t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px"),
                    (o[i.positionProp] = e),
                    i.transformsEnabled === !1
                        ? i.$slideTrack.css(o)
                        : ((o = {}),
                          i.cssTransitions === !1
                              ? ((o[i.animType] = "translate(" + t + ", " + n + ")"), i.$slideTrack.css(o))
                              : (i.options.customSlideAdvancement !== !0 && (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"), i.$slideTrack.css(o)));
            }),
            (t.prototype.setDimensions = function () {
                var e,
                    t = this,
                    n = t.options.customHeightMatching && t.options.asNavFor;
                n && (e = t.getNavTarget().height()),
                    (!n || e < 50) && (e = t.$slides.first().outerHeight(!0) * t.options.slidesToShow),
                    t.options.vertical === !1
                        ? t.options.centerMode === !0 && t.$list.css({ padding: "0px " + t.options.centerPadding })
                        : (t.$list.height(e), t.options.centerMode === !0 && t.$list.css({ padding: t.options.centerPadding + " 0px" })),
                    (t.listWidth = t.$list.width()),
                    (t.listHeight = t.$list.height()),
                    t.options.vertical === !1 && t.options.variableWidth === !1
                        ? ((t.slideWidth = Math.ceil(t.listWidth / t.options.slidesToShow)), t.$slideTrack.width(Math.ceil(t.slideWidth * t.$slideTrack.children(".slick-slide").length)))
                        : t.options.variableWidth === !0
                        ? t.$slideTrack.width(5e3 * t.slideCount)
                        : ((t.slideWidth = Math.ceil(t.listWidth)), t.$slideTrack.height(Math.ceil(t.$slides.first().outerHeight(!0) * t.$slideTrack.children(".slick-slide").length)));
                var i = t.$slides.first().outerWidth(!0) - t.$slides.first().width();
                t.options.variableWidth === !1 && t.$slideTrack.children(".slick-slide").width(t.slideWidth - i);
            }),
            (t.prototype.setFade = function () {
                var t,
                    n = this;
                n.$slides.each(function (i, o) {
                    (t = n.slideWidth * i * -1),
                        n.options.rtl === !0 ? e(o).css({ position: "relative", right: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 1 }) : e(o).css({ position: "relative", left: t, top: 0, zIndex: n.options.zIndex - 2, opacity: 1 });
                }),
                    n.$slides.eq(n.currentSlide).css({ zIndex: n.options.zIndex - 1, opacity: 1 });
            }),
            (t.prototype.setHeight = function () {
                var e = this;
                if (1 === e.options.slidesToShow && e.options.adaptiveHeight === !0 && e.options.vertical === !1) {
                    var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
                    e.$list.css("height", t);
                }
            }),
            (t.prototype.setOption = t.prototype.slickSetOption = function () {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s = this,
                    a = !1;
                if (
                    ("object" === e.type(arguments[0])
                        ? ((i = arguments[0]), (a = arguments[1]), (r = "multiple"))
                        : "string" === e.type(arguments[0]) &&
                          ((i = arguments[0]), (o = arguments[1]), (a = arguments[2]), "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? (r = "responsive") : "undefined" != typeof arguments[1] && (r = "single")),
                    "single" === r)
                )
                    s.options[i] = o;
                else if ("multiple" === r)
                    e.each(i, function (e, t) {
                        s.options[e] = t;
                    });
                else if ("responsive" === r)
                    for (n in o)
                        if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
                        else {
                            for (t = s.options.responsive.length - 1; t >= 0; ) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
                            s.options.responsive.push(o[n]);
                        }
                a && (s.unload(), s.reinit());
            }),
            (t.prototype.setPosition = function () {
                var e = this;
                e.setDimensions(), e.setHeight(), e.options.fade === !1 ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e]);
            }),
            (t.prototype.setProps = function () {
                var e = this,
                    t = document.body.style;
                (e.positionProp = e.options.vertical === !0 ? "top" : "left"),
                    "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
                    (void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition) || (e.options.useCSS === !0 && (e.cssTransitions = !0)),
                    e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : (e.options.zIndex = e.defaults.zIndex)),
                    void 0 !== t.OTransform && ((e.animType = "OTransform"), (e.transformType = "-o-transform"), (e.transitionType = "OTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.MozTransform &&
                        ((e.animType = "MozTransform"), (e.transformType = "-moz-transform"), (e.transitionType = "MozTransition"), void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
                    void 0 !== t.webkitTransform &&
                        ((e.animType = "webkitTransform"), (e.transformType = "-webkit-transform"), (e.transitionType = "webkitTransition"), void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
                    void 0 !== t.msTransform && ((e.animType = "msTransform"), (e.transformType = "-ms-transform"), (e.transitionType = "msTransition"), void 0 === t.msTransform && (e.animType = !1)),
                    void 0 !== t.transform && e.animType !== !1 && ((e.animType = "transform"), (e.transformType = "transform"), (e.transitionType = "transition")),
                    (e.transformsEnabled = e.options.useTransform && null !== e.animType && e.animType !== !1);
            }),
            (t.prototype.setSlideClasses = function (e) {
                var t,
                    n,
                    i,
                    o,
                    r = this;
                (n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true")),
                    r.$slides.eq(e).addClass("slick-current"),
                    r.options.centerMode === !0
                        ? ((t = Math.floor(r.options.slidesToShow / 2)),
                          r.options.infinite === !0 &&
                              (e >= t && e <= r.slideCount - 1 - t
                                  ? r.$slides
                                        .slice(e - t, e + t + 1)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")
                                  : ((i = r.options.slidesToShow + e),
                                    n
                                        .slice(i - t + 1, i + t + 2)
                                        .addClass("slick-active")
                                        .attr("aria-hidden", "false")),
                              0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")),
                          r.$slides.eq(e).addClass("slick-center"))
                        : e >= 0 && e <= r.slideCount - r.options.slidesToShow
                        ? r.$slides
                              .slice(e, e + r.options.slidesToShow)
                              .addClass("slick-active")
                              .attr("aria-hidden", "false")
                        : n.length <= r.options.slidesToShow
                        ? n.addClass("slick-active").attr("aria-hidden", "false")
                        : ((o = r.slideCount % r.options.slidesToShow),
                          (i = r.options.infinite === !0 ? r.options.slidesToShow + e : e),
                          r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow
                              ? n
                                    .slice(i - (r.options.slidesToShow - o), i + o)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false")
                              : n
                                    .slice(i, i + r.options.slidesToShow)
                                    .addClass("slick-active")
                                    .attr("aria-hidden", "false"));
            }),
            (t.prototype.setupInfinite = function () {
                var t,
                    n,
                    i,
                    o = this;
                if ((o.options.fade === !0 && (o.options.centerMode = !1), o.options.infinite === !0 && o.options.fade === !1 && ((n = null), o.slideCount > o.options.slidesToShow))) {
                    for (i = o.options.centerMode === !0 ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1)
                        (n = t - 1),
                            e(o.$slides[n])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", n - o.slideCount)
                                .prependTo(o.$slideTrack)
                                .addClass("slick-cloned");
                    for (t = 0; t < i; t += 1)
                        (n = t),
                            e(o.$slides[n])
                                .clone(!0)
                                .attr("id", "")
                                .attr("data-slick-index", n + o.slideCount)
                                .appendTo(o.$slideTrack)
                                .addClass("slick-cloned");
                    o.$slideTrack
                        .find(".slick-cloned")
                        .find("[id]")
                        .each(function () {
                            e(this).attr("id", "");
                        });
                }
            }),
            (t.prototype.interrupt = function (e) {
                var t = this;
                e || t.autoPlay(), (t.interrupted = e);
            }),
            (t.prototype.selectHandler = function (t) {
                var n = this,
                    i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
                    o = parseInt(i.attr("data-slick-index"));
                return o || (o = 0), n.slideCount <= n.options.slidesToShow ? (n.setSlideClasses(o), void n.asNavFor(o)) : void n.slideHandler(o);
            }),
            (t.prototype.slideHandler = function (t, n, i) {
                var o,
                    r,
                    s,
                    a,
                    l = null,
                    c = this;
                if (((n = n || !1), !((c.animating === !0 && c.options.waitForAnimate === !0) || (c.options.fade === !0 && c.currentSlide === t)))) {
                    n === !1 && c.asNavFor(t), (o = t), (l = c.getLeft(o));
                    var u = !1;
                    if ((c.slideCount <= c.options.slidesToShow && (u = !0), c.options.customSlideAdvancement)) {
                        var d = "beside" === c.$slider.data("position"),
                            p = c.$slider.find(".slick-slide[data-slick-index=" + o + "]"),
                            f = p.length,
                            h = c.$slider.find(".slick-track"),
                            m = 0,
                            v = d ? c.$list.height() : c.$list.width();
                        h.find(".slick-slide").each(function () {
                            m += d ? e(this).outerHeight(!0) : e(this).outerWidth(!0);
                        });
                        var g = (d ? h.position().top * -1 : h.position().left * -1, m > v);
                        if (g) {
                            var y,
                                b,
                                w,
                                x = m - v;
                            d ? ((w = f ? p.outerHeight(!0) : 0), (y = f ? p.position().top : 0), (b = y - w)) : ((w = f ? p.outerWidth(!0) : 0), (y = f ? p.position().left : 0), (b = y - w)),
                                b >= 0 && (y = b),
                                (1 !== t && 0 !== t) || (y = 0),
                                y > x && (y = x);
                        }
                        (l = y * -1), m <= v && (u = !0);
                    }
                    if (((a = c.getLeft(c.currentSlide)), (c.currentLeft = null === c.swipeLeft ? a : c.swipeLeft), c.options.infinite === !1 && c.options.centerMode === !1 && (t < 0 || t > c.getDotCount() * c.options.slidesToScroll))) {
                        if (u) return;
                        return void (
                            c.options.fade === !1 &&
                            ((o = c.currentSlide),
                            i !== !0
                                ? c.animateSlide(a, function () {
                                      c.postSlide(o);
                                  })
                                : c.postSlide(o))
                        );
                    }
                    return c.options.infinite === !1 && c.options.centerMode === !0 && (t < 0 || t > c.slideCount - c.options.slidesToScroll)
                        ? void (
                              c.options.fade === !1 &&
                              ((o = c.currentSlide),
                              i !== !0
                                  ? c.animateSlide(a, function () {
                                        c.postSlide(o);
                                    })
                                  : c.postSlide(o))
                          )
                        : (c.options.autoplay && clearInterval(c.autoPlayTimer),
                          (r =
                              o < 0
                                  ? c.slideCount % c.options.slidesToScroll !== 0
                                      ? c.slideCount - (c.slideCount % c.options.slidesToScroll)
                                      : c.slideCount + o
                                  : o >= c.slideCount
                                  ? c.slideCount % c.options.slidesToScroll !== 0
                                      ? 0
                                      : o - c.slideCount
                                  : o),
                          (c.animating = !0),
                          c.$slider.trigger("beforeChange", [c, c.currentSlide, r]),
                          (s = c.currentSlide),
                          (c.currentSlide = r),
                          c.setSlideClasses(c.currentSlide),
                          c.options.vertical && u && (i = !0),
                          c.updateDots(),
                          c.updateArrows(),
                          c.options.fade === !0
                              ? (i !== !0
                                    ? (c.fadeSlideOut(s),
                                      c.fadeSlide(r, function () {
                                          c.postSlide(r);
                                      }))
                                    : c.postSlide(r),
                                void c.animateHeight())
                              : void (i !== !0
                                    ? (0 === r && c.options.vertical && (l = 0),
                                      c.animateSlide(l, function () {
                                          c.postSlide(r);
                                      }))
                                    : c.postSlide(r)));
                }
            }),
            (t.prototype.startLoad = function () {
                var e = this;
                e.options.arrows === !0 && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
                    e.options.dots === !0 && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
                    e.$slider.addClass("slick-loading");
            }),
            (t.prototype.swipeDirection = function () {
                var e,
                    t,
                    n,
                    i,
                    o = this;
                return (
                    (e = o.touchObject.startX - o.touchObject.curX),
                    (t = o.touchObject.startY - o.touchObject.curY),
                    (n = Math.atan2(t, e)),
                    (i = Math.round((180 * n) / Math.PI)),
                    i < 0 && (i = 360 - Math.abs(i)),
                    i <= 45 && i >= 0
                        ? o.options.rtl === !1
                            ? "left"
                            : "right"
                        : i <= 360 && i >= 315
                        ? o.options.rtl === !1
                            ? "left"
                            : "right"
                        : i >= 135 && i <= 225
                        ? o.options.rtl === !1
                            ? "right"
                            : "left"
                        : o.options.verticalSwiping === !0
                        ? i >= 35 && i <= 135
                            ? "down"
                            : "up"
                        : "vertical"
                );
            }),
            (t.prototype.swipeEnd = function (e) {
                var t,
                    n,
                    i = this;
                if (((i.dragging = !1), (i.interrupted = !1), (i.shouldClick = !(i.touchObject.swipeLength > 10)), void 0 === i.touchObject.curX)) return !1;
                if ((i.touchObject.edgeHit === !0 && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe)) {
                    switch ((n = i.swipeDirection())) {
                        case "left":
                        case "down":
                            (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount()), (i.currentDirection = 0);
                            break;
                        case "right":
                        case "up":
                            (t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount()), (i.currentDirection = 1);
                    }
                    "vertical" != n && (i.slideHandler(t), (i.touchObject = {}), i.$slider.trigger("swipe", [i, n]));
                } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), (i.touchObject = {}));
            }),
            (t.prototype.swipeHandler = function (e) {
                var t = this;
                if (!(t.options.swipe === !1 || ("ontouchend" in document && t.options.swipe === !1) || (t.options.draggable === !1 && e.type.indexOf("mouse") !== -1)))
                    switch (
                        ((t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1),
                        (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
                        t.options.verticalSwiping === !0 && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold),
                        e.data.action)
                    ) {
                        case "start":
                            t.swipeStart(e);
                            break;
                        case "move":
                            t.swipeMove(e);
                            break;
                        case "end":
                            t.swipeEnd(e);
                    }
            }),
            (t.prototype.swipeMove = function (e) {
                var t,
                    n,
                    i,
                    o,
                    r,
                    s = this;
                return (
                    (r = void 0 !== e.originalEvent ? e.originalEvent.touches : null),
                    !(!s.dragging || (r && 1 !== r.length)) &&
                        ((t = s.getLeft(s.currentSlide)),
                        (s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX),
                        (s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY),
                        (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2)))),
                        s.options.verticalSwiping === !0 && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))),
                        (n = s.swipeDirection()),
                        "vertical" !== n
                            ? (void 0 !== e.originalEvent && s.touchObject.swipeLength > 4 && e.preventDefault(),
                              (o = (s.options.rtl === !1 ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1)),
                              s.options.verticalSwiping === !0 && (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1),
                              (i = s.touchObject.swipeLength),
                              (s.touchObject.edgeHit = !1),
                              s.options.infinite === !1 &&
                                  ((0 === s.currentSlide && "right" === n) || (s.currentSlide >= s.getDotCount() && "left" === n)) &&
                                  ((i = s.touchObject.swipeLength * s.options.edgeFriction), (s.touchObject.edgeHit = !0)),
                              s.options.vertical === !1 ? (s.swipeLeft = t + i * o) : (s.swipeLeft = t + i * (s.$list.height() / s.listWidth) * o),
                              s.options.verticalSwiping === !0 && (s.swipeLeft = t + i * o),
                              s.options.fade !== !0 && s.options.touchMove !== !1 && (s.animating === !0 ? ((s.swipeLeft = null), !1) : void s.setCSS(s.swipeLeft)))
                            : void 0)
                );
            }),
            (t.prototype.swipeStart = function (e) {
                var t,
                    n = this;
                return (
                    (n.interrupted = !0),
                    1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow
                        ? ((n.touchObject = {}), !1)
                        : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
                          (n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX),
                          (n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY),
                          void (n.dragging = !0))
                );
            }),
            (t.prototype.unfilterSlides = t.prototype.slickUnfilter = function () {
                var e = this;
                null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit());
            }),
            (t.prototype.unload = function () {
                var t = this;
                e(".slick-cloned", t.$slider).remove(),
                    t.$dots && t.$dots.remove(),
                    t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
                    t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
                    t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "");
            }),
            (t.prototype.unslick = function (e) {
                var t = this;
                t.$slider.trigger("unslick", [t, e]), t.destroy();
            }),
            (t.prototype.updateArrows = function () {
                var e,
                    t = this;
                (e = Math.floor(t.options.slidesToShow / 2)),
                    t.options.arrows === !0 &&
                        t.slideCount > t.options.slidesToShow &&
                        !t.options.infinite &&
                        (t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"),
                        0 === t.currentSlide
                            ? (t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : t.currentSlide >= t.slideCount - t.options.slidesToShow && t.options.centerMode === !1
                            ? (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"))
                            : t.currentSlide >= t.slideCount - 1 &&
                              t.options.centerMode === !0 &&
                              (t.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), t.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")));
            }),
            (t.prototype.updateDots = function () {
                var e = this;
                null !== e.$dots &&
                    (e.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"),
                    e.$dots
                        .find("li")
                        .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
                        .addClass("slick-active")
                        .attr("aria-hidden", "false"));
            }),
            (t.prototype.visibility = function () {
                var e = this;
                e.options.autoplay && (document[e.hidden] ? (e.interrupted = !0) : (e.interrupted = !1));
            }),
            (e.fn.slick = function () {
                var e,
                    n,
                    i = this,
                    o = arguments[0],
                    r = Array.prototype.slice.call(arguments, 1),
                    s = i.length;
                for (e = 0; e < s; e++) if (("object" == typeof o || "undefined" == typeof o ? (i[e].slick = new t(i[e], o)) : (n = i[e].slick[o].apply(i[e].slick, r)), "undefined" != typeof n)) return n;
                return i;
            });
    }) /*! lazysizes respimg - v4.0.1 */,
    !(function (e, t) {
        var n = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
        "use strict";
        var i,
            o = (n && n.cfg) || e.lazySizesConfig,
            r = t.createElement("img"),
            s = "sizes" in r && "srcset" in r,
            a = /\s+\d+h/g,
            l = (function () {
                var e = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                    n = Array.prototype.forEach;
                return function (i) {
                    var o = t.createElement("img"),
                        r = function (t) {
                            var n,
                                i = t.getAttribute(lazySizesConfig.srcsetAttr);
                            i && (i.match(e) && ((n = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1), n && t.setAttribute("data-aspectratio", n)), t.setAttribute(lazySizesConfig.srcsetAttr, i.replace(a, "")));
                        },
                        s = function (e) {
                            var t = e.target.parentNode;
                            t && "PICTURE" == t.nodeName && n.call(t.getElementsByTagName("source"), r), r(e.target);
                        },
                        l = function () {
                            o.currentSrc && t.removeEventListener("lazybeforeunveil", s);
                        };
                    i[1] && (t.addEventListener("lazybeforeunveil", s), (o.onload = l), (o.onerror = l), (o.srcset = "data:,a 1w 1h"), o.complete && l());
                };
            })();
        if (
            (o || ((o = {}), (e.lazySizesConfig = o)),
            o.supportsType ||
                (o.supportsType = function (e) {
                    return !e;
                }),
            !e.picturefill && !o.pf)
        ) {
            if (e.HTMLPictureElement && s) return t.msElementsFromPoint && l(navigator.userAgent.match(/Edge\/(\d+)/)), void (o.pf = function () {});
            (o.pf = function (t) {
                var n, o;
                if (!e.picturefill) for (n = 0, o = t.elements.length; o > n; n++) i(t.elements[n]);
            }),
                (i = (function () {
                    var r = function (e, t) {
                            return e.w - t.w;
                        },
                        l = /^\s*\d+\.*\d*px\s*$/,
                        c = function (e) {
                            var t,
                                n,
                                i = e.length,
                                o = e[i - 1],
                                r = 0;
                            for (r; i > r; r++)
                                if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
                                    !o.cached && (t = e[r - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                                    break;
                                }
                            return o;
                        },
                        u = (function () {
                            var e,
                                t = /(([^,\s].[^\s]+)\s+(\d+)w)/g,
                                n = /\s/,
                                i = function (t, n, i, o) {
                                    e.push({ c: n, u: i, w: 1 * o });
                                };
                            return function (o) {
                                return (e = []), (o = o.trim()), o.replace(a, "").replace(t, i), e.length || !o || n.test(o) || e.push({ c: o, u: o, w: 99 }), e;
                            };
                        })(),
                        d = function () {
                            d.init ||
                                ((d.init = !0),
                                addEventListener(
                                    "resize",
                                    (function () {
                                        var e,
                                            n = t.getElementsByClassName("lazymatchmedia"),
                                            o = function () {
                                                var e, t;
                                                for (e = 0, t = n.length; t > e; e++) i(n[e]);
                                            };
                                        return function () {
                                            clearTimeout(e), (e = setTimeout(o, 66));
                                        };
                                    })()
                                ));
                        },
                        p = function (t, i) {
                            var r,
                                s = t.getAttribute("srcset") || t.getAttribute(o.srcsetAttr);
                            !s && i && (s = t._lazypolyfill ? t._lazypolyfill._set : t.getAttribute(o.srcAttr) || t.getAttribute("src")),
                                (t._lazypolyfill && t._lazypolyfill._set == s) ||
                                    ((r = u(s || "")),
                                    i && t.parentNode && ((r.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase()), r.isPicture && e.matchMedia && (n.aC(t, "lazymatchmedia"), d())),
                                    (r._set = s),
                                    Object.defineProperty(t, "_lazypolyfill", { value: r, writable: !0 }));
                        },
                        f = function (t) {
                            var i = e.devicePixelRatio || 1,
                                o = n.getX && n.getX(t);
                            return Math.min(o || i, 2.5, i);
                        },
                        h = function (t) {
                            return e.matchMedia
                                ? (h = function (e) {
                                      return !e || (matchMedia(e) || {}).matches;
                                  })(t)
                                : !t;
                        },
                        m = function (e) {
                            var t, i, s, a, u, d, m;
                            if (((a = e), p(a, !0), (u = a._lazypolyfill), u.isPicture))
                                for (i = 0, t = e.parentNode.getElementsByTagName("source"), s = t.length; s > i; i++)
                                    if (o.supportsType(t[i].getAttribute("type"), e) && h(t[i].getAttribute("media"))) {
                                        (a = t[i]), p(a), (u = a._lazypolyfill);
                                        break;
                                    }
                            return (
                                u.length > 1
                                    ? ((m = a.getAttribute("sizes") || ""), (m = (l.test(m) && parseInt(m, 10)) || n.gW(e, e.parentNode)), (u.d = f(e)), !u.src || !u.w || u.w < m ? ((u.w = m), (d = c(u.sort(r))), (u.src = d)) : (d = u.src))
                                    : (d = u[0]),
                                d
                            );
                        },
                        v = function (e) {
                            if (!s || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                                var t = m(e);
                                t && t.u && e._lazypolyfill.cur != t.u && ((e._lazypolyfill.cur = t.u), (t.cached = !0), e.setAttribute(o.srcAttr, t.u), e.setAttribute("src", t.u));
                            }
                        };
                    return (v.parse = u), v;
                })()),
                o.loadedClass &&
                    o.loadingClass &&
                    !(function () {
                        var e = [];
                        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function (t) {
                            e.push(t + o.loadedClass), e.push(t + o.loadingClass);
                        }),
                            o.pf({ elements: t.querySelectorAll(e.join(", ")) });
                    })();
        }
    }) /*! lazysizes rias - v4.0.1 */,
    !(function (e, t) {
        var n = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
        "use strict";
        function i(t, n) {
            var i,
                o,
                r,
                s,
                a = e.getComputedStyle(t);
            (o = t.parentNode),
                (s = { isPicture: !(!o || !p.test(o.nodeName || "")) }),
                (r = function (e, n) {
                    var i = t.getAttribute("data-" + e);
                    if (!i) {
                        var o = a.getPropertyValue("--ls-" + e);
                        o && (i = o.trim());
                    }
                    if (i) {
                        if ("true" == i) i = !0;
                        else if ("false" == i) i = !1;
                        else if (d.test(i)) i = parseFloat(i);
                        else if ("function" == typeof c[e]) i = c[e](t, i);
                        else if (v.test(i))
                            try {
                                i = JSON.parse(i);
                            } catch (e) {}
                        s[e] = i;
                    } else e in c && "function" != typeof c[e] ? (s[e] = c[e]) : n && "function" == typeof c[e] && (s[e] = c[e](t, i));
                });
            for (i in c) r(i);
            return (
                n.replace(m, function (e, t) {
                    t in s || r(t, !0);
                }),
                s
            );
        }
        function o(e, t) {
            var n = [],
                i = function (e, n) {
                    return u[typeof t[n]] ? t[n] : e;
                };
            return (
                (n.srcset = []),
                t.absUrl && (y.setAttribute("href", e), (e = y.href)),
                (e = ((t.prefix || "") + e + (t.postfix || "")).replace(m, i)),
                t.widths.forEach(function (i) {
                    var o = t.widthmap[i] || i,
                        r = { u: e.replace(f, o).replace(h, t.ratio ? Math.round(i * t.ratio) : ""), w: i };
                    n.push(r), n.srcset.push((r.c = r.u + " " + i + "w"));
                }),
                n
            );
        }
        function r(e, n, i) {
            var r = 0,
                s = 0,
                a = i;
            if (e) {
                if ("container" === n.ratio) {
                    for (r = a.scrollWidth, s = a.scrollHeight; !((r && s) || a === t); ) (a = a.parentNode), (r = a.scrollWidth), (s = a.scrollHeight);
                    r && s && (n.ratio = s / r);
                }
                (e = o(e, n)),
                    (e.isPicture = n.isPicture),
                    w && "IMG" == i.nodeName.toUpperCase() ? i.removeAttribute(l.srcsetAttr) : i.setAttribute(l.srcsetAttr, e.srcset.join(", ")),
                    Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
            }
        }
        function s(e, t) {
            var o = i(e, t);
            return c.modifyOptions.call(e, { target: e, details: o, detail: o }), n.fire(e, "lazyriasmodifyoptions", o), o;
        }
        function a(e) {
            return e.getAttribute(e.getAttribute("data-srcattr") || c.srcAttr) || e.getAttribute(l.srcsetAttr) || e.getAttribute(l.srcAttr) || e.getAttribute("data-pfsrcset") || "";
        }
        var l,
            c,
            u = { string: 1, number: 1 },
            d = /^\-*\+*\d+\.*\d*$/,
            p = /^picture$/i,
            f = /\s*\{\s*width\s*\}\s*/i,
            h = /\s*\{\s*height\s*\}\s*/i,
            m = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
            v = /^\[.*\]|\{.*\}$/,
            g = /^(?:auto|\d+(px)?)$/,
            y = t.createElement("a"),
            b = t.createElement("img"),
            w = "srcset" in b && !("sizes" in b),
            x = !!e.HTMLPictureElement && !w;
        !(function () {
            var t,
                i = function () {},
                o = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: i, widthmap: {}, ratio: !1 };
            (l = (n && n.cfg) || e.lazySizesConfig),
                l || ((l = {}), (e.lazySizesConfig = l)),
                l.supportsType ||
                    (l.supportsType = function (e) {
                        return !e;
                    }),
                l.rias || (l.rias = {}),
                (c = l.rias),
                "widths" in c ||
                    ((c.widths = []),
                    (function (e) {
                        for (var t, n = 0; !t || 3e3 > t; ) (n += 5), n > 30 && (n += 1), (t = 36 * n), e.push(t);
                    })(c.widths));
            for (t in o) t in c || (c[t] = o[t]);
        })(),
            addEventListener(
                "lazybeforesizes",
                function (e) {
                    if (e.detail.instance == n) {
                        var t, i, o, u, d, p, h, m, v, y, b, w, S;
                        if (((t = e.target), e.detail.dataAttr && !e.defaultPrevented && !c.disabled && (v = t.getAttribute(l.sizesAttr) || t.getAttribute("sizes")) && g.test(v))) {
                            if (((i = a(t)), (o = s(t, i)), (b = f.test(o.prefix) || f.test(o.postfix)), o.isPicture && (u = t.parentNode)))
                                for (d = u.getElementsByTagName("source"), p = 0, h = d.length; h > p; p++) (b || f.test((m = a(d[p])))) && (r(m, o, d[p]), (w = !0));
                            b || f.test(i) ? (r(i, o, t), (w = !0)) : w && ((S = []), (S.srcset = []), (S.isPicture = !0), Object.defineProperty(t, "_lazyrias", { value: S, writable: !0 })),
                                w && (x ? t.removeAttribute(l.srcAttr) : "auto" != v && ((y = { width: parseInt(v, 10) }), k({ target: t, detail: y })));
                        }
                    }
                },
                !0
            );
        var k = (function () {
            var i = function (e, t) {
                    return e.w - t.w;
                },
                o = function (e) {
                    var t,
                        n,
                        i = e.length,
                        o = e[i - 1],
                        r = 0;
                    for (r; i > r; r++)
                        if (((o = e[r]), (o.d = o.w / e.w), o.d >= e.d)) {
                            !o.cached && (t = e[r - 1]) && t.d > e.d - 0.13 * Math.pow(e.d, 2.2) && ((n = Math.pow(t.d - 0.6, 1.6)), t.cached && (t.d += 0.15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                            break;
                        }
                    return o;
                },
                r = function (e, t) {
                    var i;
                    return (
                        !e._lazyrias &&
                            n.pWS &&
                            (i = n.pWS(e.getAttribute(l.srcsetAttr || ""))).length &&
                            (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }), t && e.parentNode && (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
                        e._lazyrias
                    );
                },
                s = function (t) {
                    var i = e.devicePixelRatio || 1,
                        o = n.getX && n.getX(t);
                    return Math.min(o || i, 2.4, i);
                },
                a = function (t, n) {
                    var a, l, c, u, d, p;
                    if (((d = t._lazyrias), d.isPicture && e.matchMedia))
                        for (l = 0, a = t.parentNode.getElementsByTagName("source"), c = a.length; c > l; l++)
                            if (r(a[l]) && !a[l].getAttribute("type") && (!(u = a[l].getAttribute("media")) || (matchMedia(u) || {}).matches)) {
                                d = a[l]._lazyrias;
                                break;
                            }
                    return (!d.w || d.w < n) && ((d.w = n), (d.d = s(t)), (p = o(d.sort(i)))), p;
                },
                c = function (i) {
                    if (i.detail.instance == n) {
                        var o,
                            s = i.target;
                        return !w && (e.respimage || e.picturefill || lazySizesConfig.pf)
                            ? void t.removeEventListener("lazybeforesizes", c)
                            : void (
                                  ("_lazyrias" in s || (i.detail.dataAttr && r(s, !0))) &&
                                  ((o = a(s, i.detail.width)),
                                  o &&
                                      o.u &&
                                      s._lazyrias.cur != o.u &&
                                      ((s._lazyrias.cur = o.u),
                                      (o.cached = !0),
                                      n.rAF(function () {
                                          s.setAttribute(l.srcAttr, o.u), s.setAttribute("src", o.u);
                                      })))
                              );
                    }
                };
            return x ? (c = function () {}) : addEventListener("lazybeforesizes", c), c;
        })();
    }) /*! lazysizes bgset - v4.0.1 */,
    !(function (e, t) {
        var n = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
        "use strict";
        if (e.addEventListener) {
            var i = /\s+/g,
                o = /\s*\|\s+|\s+\|\s*/g,
                r = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                s = /\(|\)|'/,
                a = { contain: 1, cover: 1 },
                l = function (e) {
                    var t = n.gW(e, e.parentNode);
                    return (!e._lazysizesWidth || t > e._lazysizesWidth) && (e._lazysizesWidth = t), e._lazysizesWidth;
                },
                c = function (e) {
                    var t;
                    return (t = (getComputedStyle(e) || { getPropertyValue: function () {} }).getPropertyValue("background-size")), !a[t] && a[e.style.backgroundSize] && (t = e.style.backgroundSize), t;
                },
                u = function (e, n, s) {
                    var a = t.createElement("picture"),
                        l = n.getAttribute(lazySizesConfig.sizesAttr),
                        c = n.getAttribute("data-ratio"),
                        u = n.getAttribute("data-optimumx");
                    n._lazybgset && n._lazybgset.parentNode == n && n.removeChild(n._lazybgset),
                        Object.defineProperty(s, "_lazybgset", { value: n, writable: !0 }),
                        Object.defineProperty(n, "_lazybgset", { value: a, writable: !0 }),
                        (e = e.replace(i, " ").split(o)),
                        (a.style.display = "none"),
                        (s.className = lazySizesConfig.lazyClass),
                        1 != e.length || l || (l = "auto"),
                        e.forEach(function (e) {
                            var n = t.createElement("source");
                            l && "auto" != l && n.setAttribute("sizes", l),
                                e.match(r) && (n.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && n.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)),
                                a.appendChild(n);
                        }),
                        l && (s.setAttribute(lazySizesConfig.sizesAttr, l), n.removeAttribute(lazySizesConfig.sizesAttr), n.removeAttribute("sizes")),
                        u && s.setAttribute("data-optimumx", u),
                        c && s.setAttribute("data-ratio", c),
                        a.appendChild(s),
                        n.appendChild(a);
                },
                d = function (e) {
                    if (e.target._lazybgset) {
                        var t = e.target,
                            i = t._lazybgset,
                            o = t.currentSrc || t.src;
                        o && (i.style.backgroundImage = "url(" + (s.test(o) ? JSON.stringify(o) : o) + ")"), t._lazybgsetLoading && (n.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading);
                    }
                };
            addEventListener("lazybeforeunveil", function (e) {
                var i, o, r;
                !e.defaultPrevented &&
                    (i = e.target.getAttribute("data-bgset")) &&
                    ((r = e.target),
                    (o = t.createElement("img")),
                    (o.alt = ""),
                    (o._lazybgsetLoading = !0),
                    (e.detail.firesLoad = !0),
                    u(i, r, o),
                    setTimeout(function () {
                        n.loader.unveil(o),
                            n.rAF(function () {
                                n.fire(o, "_lazyloaded", {}, !0, !0), o.complete && d({ target: o });
                            });
                    }));
            }),
                t.addEventListener("load", d, !0),
                e.addEventListener(
                    "lazybeforesizes",
                    function (e) {
                        if (e.detail.instance == n && e.target._lazybgset && e.detail.dataAttr) {
                            var t = e.target._lazybgset,
                                i = c(t);
                            a[i] &&
                                ((e.target._lazysizesParentFit = i),
                                n.rAF(function () {
                                    e.target.setAttribute("data-parent-fit", i), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit;
                                }));
                        }
                    },
                    !0
                ),
                t.documentElement.addEventListener("lazybeforesizes", function (e) {
                    !e.defaultPrevented && e.target._lazybgset && e.detail.instance == n && (e.detail.width = l(e.target._lazybgset));
                });
        }
    }) /*! lazysizes object-fit - v4.1.2 */,
    !(function (e, t) {
        var n = function (i) {
            t(e.lazySizes, i), e.removeEventListener("lazyunveilread", n, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n, i) {
        "use strict";
        function o(e) {
            var t = getComputedStyle(e, null) || {},
                n = t.fontFamily || "",
                i = n.match(c) || "",
                o = (i && n.match(u)) || "";
            return o && (o = o[1]), { fit: (i && i[1]) || "", position: f[o] || o || "center" };
        }
        function r(e, t) {
            var i,
                o,
                r = n.cfg,
                s = e.cloneNode(!1),
                a = s.style,
                l = function () {
                    var t = e.currentSrc || e.src;
                    t && o !== t && ((o = t), (a.backgroundImage = "url(" + (p.test(t) ? JSON.stringify(t) : t) + ")"), i || ((i = !0), n.rC(s, r.loadingClass), n.aC(s, r.loadedClass)));
                },
                c = function () {
                    n.rAF(l);
                };
            (e._lazysizesParentFit = t.fit),
                e.addEventListener("lazyloaded", c, !0),
                e.addEventListener("load", c, !0),
                s.addEventListener("load", function () {
                    var e = s.currentSrc || s.src;
                    e && e != d && ((s.src = d), (s.srcset = ""));
                }),
                n.rAF(function () {
                    var i = e,
                        o = e.parentNode;
                    "PICTURE" == o.nodeName.toUpperCase() && ((i = o), (o = o.parentNode)),
                        n.rC(s, r.loadedClass),
                        n.rC(s, r.lazyClass),
                        n.aC(s, r.loadingClass),
                        n.aC(s, r.objectFitClass || "lazysizes-display-clone"),
                        s.getAttribute(r.srcsetAttr) && s.setAttribute(r.srcsetAttr, ""),
                        s.getAttribute(r.srcAttr) && s.setAttribute(r.srcAttr, ""),
                        (s.src = d),
                        (s.srcset = ""),
                        (a.backgroundRepeat = "no-repeat"),
                        (a.backgroundPosition = t.position),
                        (a.backgroundSize = t.fit),
                        (i.style.display = "none"),
                        e.setAttribute("data-parent-fit", t.fit),
                        e.setAttribute("data-parent-container", "prev"),
                        o.insertBefore(s, i),
                        e._lazysizesParentFit && delete e._lazysizesParentFit,
                        e.complete && l();
                });
        }
        var s = t.createElement("a").style,
            a = "objectFit" in s,
            l = a && "objectPosition" in s,
            c = /object-fit["']*\s*:\s*["']*(contain|cover)/,
            u = /object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,
            d = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
            p = /\(|\)|'/,
            f = { center: "center", "50% 50%": "center" };
        if (!a || !l) {
            var h = function (e) {
                if (e.detail.instance == n) {
                    var t = e.target,
                        i = o(t);
                    !i.fit || (a && "center" == i.position) || r(t, i);
                }
            };
            e.addEventListener("lazyunveilread", h, !0), i && i.detail && h(i);
        }
    }) /*! lazysizes parent-fit - v4.1.2 */,
    !(function (e, t) {
        var n = function () {
            t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0);
        };
        (t = t.bind(null, e, e.document)), "object" == typeof module && module.exports ? t(require("lazysizes")) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0);
    })(window, function (e, t, n) {
        "use strict";
        if (e.addEventListener) {
            var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                r = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                s = /^picture$/i,
                a = function (e) {
                    return getComputedStyle(e, null) || {};
                },
                l = {
                    getParent: function (t, n) {
                        var i = t,
                            o = t.parentNode;
                        return (
                            (n && "prev" != n) || !o || !s.test(o.nodeName || "") || (o = o.parentNode),
                            "self" != n && (i = "prev" == n ? t.previousElementSibling : n && (o.closest || e.jQuery) ? (o.closest ? o.closest(n) : jQuery(o).closest(n)[0]) || o : o),
                            i
                        );
                    },
                    getFit: function (e) {
                        var t,
                            n,
                            i = a(e),
                            s = i.content || i.fontFamily,
                            c = { fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit") };
                        return (
                            !c.fit && s && (t = s.match(o)) && (c.fit = t[1]),
                            c.fit ? ((n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")), !n && s && (t = s.match(r)) && (n = t[1]), (c.parent = l.getParent(e, n))) : (c.fit = i.objectFit),
                            c
                        );
                    },
                    getImageRatio: function (t) {
                        var n,
                            o,
                            r,
                            a,
                            l,
                            c = t.parentNode,
                            u = c && s.test(c.nodeName || "") ? c.querySelectorAll("source, img") : [t];
                        for (n = 0; n < u.length; n++)
                            if (
                                ((t = u[n]),
                                (o = t.getAttribute(lazySizesConfig.srcsetAttr) || t.getAttribute("srcset") || t.getAttribute("data-pfsrcset") || t.getAttribute("data-risrcset") || ""),
                                (r = t._lsMedia || t.getAttribute("media")),
                                (r = lazySizesConfig.customMedia[t.getAttribute("data-media") || r] || r),
                                o && (!r || ((e.matchMedia && matchMedia(r)) || {}).matches))
                            ) {
                                (a = parseFloat(t.getAttribute("data-aspectratio"))), !a && (l = o.match(i)) && (a = "w" == l[2] ? l[1] / l[3] : l[3] / l[1]);
                                break;
                            }
                        return a;
                    },
                    calculateSize: function (e, t) {
                        var n,
                            i,
                            o,
                            r,
                            s = this.getFit(e),
                            a = s.fit,
                            l = s.parent;
                        return "width" == a || (("contain" == a || "cover" == a) && (o = this.getImageRatio(e)))
                            ? (l ? (t = l.clientWidth) : (l = e), (r = t), "width" == a ? (r = t) : ((i = l.clientHeight), i > 40 && (n = t / i) && (("cover" == a && o > n) || ("contain" == a && n > o)) && (r = t * (o / n))), r)
                            : t;
                    },
                };
            (n.parentFit = l),
                t.addEventListener("lazybeforesizes", function (e) {
                    if (!e.defaultPrevented && e.detail.instance == n) {
                        var t = e.target;
                        e.detail.width = l.calculateSize(t, e.detail.width);
                    }
                });
        }
    }) /*! lazysizes - v4.0.2 */,
    !(function (e, t) {
        var n = t(e, e.document);
        (e.lazySizes = n), "object" == typeof module && module.exports && (module.exports = n);
    })(window, function (e, t) {
        "use strict";
        if (t.getElementsByClassName) {
            var n,
                i,
                o = t.documentElement,
                r = e.Date,
                s = e.HTMLPictureElement,
                a = "addEventListener",
                l = "getAttribute",
                c = e[a],
                u = e.setTimeout,
                d = e.requestAnimationFrame || u,
                p = e.requestIdleCallback,
                f = /^picture$/i,
                h = ["load", "error", "lazyincluded", "_lazyloaded"],
                m = {},
                v = Array.prototype.forEach,
                g = function (e, t) {
                    return m[t] || (m[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), m[t].test(e[l]("class") || "") && m[t];
                },
                y = function (e, t) {
                    g(e, t) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + t);
                },
                b = function (e, t) {
                    var n;
                    (n = g(e, t)) && e.setAttribute("class", (e[l]("class") || "").replace(n, " "));
                },
                w = function (e, t, n) {
                    var i = n ? a : "removeEventListener";
                    n && w(e, t),
                        h.forEach(function (n) {
                            e[i](n, t);
                        });
                },
                x = function (e, i, o, r, s) {
                    var a = t.createEvent("CustomEvent");
                    return o || (o = {}), (o.instance = n), a.initCustomEvent(i, !r, !s, o), e.dispatchEvent(a), a;
                },
                k = function (t, n) {
                    var o;
                    !s && (o = e.picturefill || i.pf) ? o({ reevaluate: !0, elements: [t] }) : n && n.src && (t.src = n.src);
                },
                S = function (e, t) {
                    return (getComputedStyle(e, null) || {})[t];
                },
                C = function (e, t, n) {
                    for (n = n || e.offsetWidth; n < i.minSize && t && !e._lazysizesWidth; ) (n = t.offsetWidth), (t = t.parentNode);
                    return n;
                },
                T = (function () {
                    var e,
                        n,
                        i = [],
                        o = [],
                        r = i,
                        s = function () {
                            var t = r;
                            for (r = i.length ? o : i, e = !0, n = !1; t.length; ) t.shift()();
                            e = !1;
                        },
                        a = function (i, o) {
                            e && !o ? i.apply(this, arguments) : (r.push(i), n || ((n = !0), (t.hidden ? u : d)(s)));
                        };
                    return (a._lsFlush = s), a;
                })(),
                E = function (e, t) {
                    return t
                        ? function () {
                              T(e);
                          }
                        : function () {
                              var t = this,
                                  n = arguments;
                              T(function () {
                                  e.apply(t, n);
                              });
                          };
                },
                A = function (e) {
                    var t,
                        n = 0,
                        o = i.throttleDelay,
                        s = i.ricTimeout,
                        a = function () {
                            (t = !1), (n = r.now()), e();
                        },
                        l =
                            p && s > 49
                                ? function () {
                                      p(a, { timeout: s }), s !== i.ricTimeout && (s = i.ricTimeout);
                                  }
                                : E(function () {
                                      u(a);
                                  }, !0);
                    return function (e) {
                        var i;
                        (e = !0 === e) && (s = 33), t || ((t = !0), (i = o - (r.now() - n)), i < 0 && (i = 0), e || i < 9 ? l() : u(l, i));
                    };
                },
                _ = function (e) {
                    var t,
                        n,
                        i = 99,
                        o = function () {
                            (t = null), e();
                        },
                        s = function () {
                            var e = r.now() - n;
                            e < i ? u(s, i - e) : (p || o)(o);
                        };
                    return function () {
                        (n = r.now()), t || (t = u(s, i));
                    };
                };
            !(function () {
                var t,
                    n = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: 0.8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 0,
                        throttleDelay: 125,
                    };
                i = e.lazySizesConfig || e.lazysizesConfig || {};
                for (t in n) t in i || (i[t] = n[t]);
                (e.lazySizesConfig = i),
                    u(function () {
                        i.init && $();
                    });
            })();
            var P = (function () {
                    var s,
                        d,
                        p,
                        h,
                        m,
                        C,
                        P,
                        $,
                        I,
                        N,
                        D,
                        L,
                        z,
                        M,
                        j = /^img$/i,
                        H = /^iframe$/i,
                        R = "onscroll" in e && !/glebot/.test(navigator.userAgent),
                        F = 0,
                        q = 0,
                        B = 0,
                        W = -1,
                        U = function (e) {
                            B--, e && e.target && w(e.target, U), (!e || B < 0 || !e.target) && (B = 0);
                        },
                        Z = function (e, n) {
                            var i,
                                r = e,
                                s = "hidden" == S(t.body, "visibility") || "hidden" != S(e, "visibility");
                            for ($ -= n, D += n, I -= n, N += n; s && (r = r.offsetParent) && r != t.body && r != o; )
                                (s = (S(r, "opacity") || 1) > 0) && "visible" != S(r, "overflow") && ((i = r.getBoundingClientRect()), (s = N > i.left && I < i.right && D > i.top - 1 && $ < i.bottom + 1));
                            return s;
                        },
                        V = function () {
                            var e,
                                r,
                                a,
                                c,
                                u,
                                p,
                                f,
                                m,
                                v,
                                g = n.elements;
                            if ((h = i.loadMode) && B < 8 && (e = g.length)) {
                                (r = 0),
                                    W++,
                                    null == z && ("expand" in i || (i.expand = o.clientHeight > 500 && o.clientWidth > 500 ? 500 : 370), (L = i.expand), (z = L * i.expFactor)),
                                    q < z && B < 1 && W > 2 && h > 2 && !t.hidden ? ((q = z), (W = 0)) : (q = h > 1 && W > 1 && B < 6 ? L : F);
                                for (; r < e; r++)
                                    if (g[r] && !g[r]._lazyRace)
                                        if (R)
                                            if (
                                                (((m = g[r][l]("data-expand")) && (p = 1 * m)) || (p = q),
                                                v !== p && ((C = innerWidth + p * M), (P = innerHeight + p), (f = -1 * p), (v = p)),
                                                (a = g[r].getBoundingClientRect()),
                                                (D = a.bottom) >= f &&
                                                    ($ = a.top) <= P &&
                                                    (N = a.right) >= f * M &&
                                                    (I = a.left) <= C &&
                                                    (D || N || I || $) &&
                                                    (i.loadHidden || "hidden" != S(g[r], "visibility")) &&
                                                    ((d && B < 3 && !m && (h < 3 || W < 4)) || Z(g[r], p)))
                                            ) {
                                                if ((te(g[r]), (u = !0), B > 9)) break;
                                            } else !u && d && !c && B < 4 && W < 4 && h > 2 && (s[0] || i.preloadAfterLoad) && (s[0] || (!m && (D || N || I || $ || "auto" != g[r][l](i.sizesAttr)))) && (c = s[0] || g[r]);
                                        else te(g[r]);
                                c && !u && te(c);
                            }
                        },
                        K = A(V),
                        X = function (e) {
                            y(e.target, i.loadedClass), b(e.target, i.loadingClass), w(e.target, G), x(e.target, "lazyloaded");
                        },
                        Y = E(X),
                        G = function (e) {
                            Y({ target: e.target });
                        },
                        J = function (e, t) {
                            try {
                                e.contentWindow.location.replace(t);
                            } catch (n) {
                                e.src = t;
                            }
                        },
                        Q = function (e) {
                            var t,
                                n = e[l](i.srcsetAttr);
                            (t = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n);
                        },
                        ee = E(function (e, t, n, o, r) {
                            var s, a, c, d, h, m;
                            (h = x(e, "lazybeforeunveil", t)).defaultPrevented ||
                                (o && (n ? y(e, i.autosizesClass) : e.setAttribute("sizes", o)),
                                (a = e[l](i.srcsetAttr)),
                                (s = e[l](i.srcAttr)),
                                r && ((c = e.parentNode), (d = c && f.test(c.nodeName || ""))),
                                (m = t.firesLoad || ("src" in e && (a || s || d))),
                                (h = { target: e }),
                                m && (w(e, U, !0), clearTimeout(p), (p = u(U, 2500)), y(e, i.loadingClass), w(e, G, !0)),
                                d && v.call(c.getElementsByTagName("source"), Q),
                                a ? e.setAttribute("srcset", a) : s && !d && (H.test(e.nodeName) ? J(e, s) : (e.src = s)),
                                r && (a || d) && k(e, { src: s })),
                                e._lazyRace && delete e._lazyRace,
                                b(e, i.lazyClass),
                                T(function () {
                                    (!m || (e.complete && e.naturalWidth > 1)) && (m ? U(h) : B--, X(h));
                                }, !0);
                        }),
                        te = function (e) {
                            var t,
                                n = j.test(e.nodeName),
                                o = n && (e[l](i.sizesAttr) || e[l]("sizes")),
                                r = "auto" == o;
                            ((!r && d) || !n || (!e[l]("src") && !e.srcset) || e.complete || g(e, i.errorClass) || !g(e, i.lazyClass)) &&
                                ((t = x(e, "lazyunveilread").detail), r && O.updateElem(e, !0, e.offsetWidth), (e._lazyRace = !0), B++, ee(e, t, r, o, n));
                        },
                        ne = function () {
                            if (!d) {
                                if (r.now() - m < 999) return void u(ne, 999);
                                var e = _(function () {
                                    (i.loadMode = 3), K();
                                });
                                (d = !0),
                                    (i.loadMode = 3),
                                    K(),
                                    c(
                                        "scroll",
                                        function () {
                                            3 == i.loadMode && (i.loadMode = 2), e();
                                        },
                                        !0
                                    );
                            }
                        };
                    return {
                        _: function () {
                            (m = r.now()),
                                (n.elements = t.getElementsByClassName(i.lazyClass)),
                                (s = t.getElementsByClassName(i.lazyClass + " " + i.preloadClass)),
                                (M = i.hFac),
                                c("scroll", K, !0),
                                c("resize", K, !0),
                                e.MutationObserver ? new MutationObserver(K).observe(o, { childList: !0, subtree: !0, attributes: !0 }) : (o[a]("DOMNodeInserted", K, !0), o[a]("DOMAttrModified", K, !0), setInterval(K, 999)),
                                c("hashchange", K, !0),
                                ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (e) {
                                    t[a](e, K, !0);
                                }),
                                /d$|^c/.test(t.readyState) ? ne() : (c("load", ne), t[a]("DOMContentLoaded", K), u(ne, 2e4)),
                                n.elements.length ? (V(), T._lsFlush()) : K();
                        },
                        checkElems: K,
                        unveil: te,
                    };
                })(),
                O = (function () {
                    var e,
                        n = E(function (e, t, n, i) {
                            var o, r, s;
                            if (((e._lazysizesWidth = i), (i += "px"), e.setAttribute("sizes", i), f.test(t.nodeName || ""))) for (o = t.getElementsByTagName("source"), r = 0, s = o.length; r < s; r++) o[r].setAttribute("sizes", i);
                            n.detail.dataAttr || k(e, n.detail);
                        }),
                        o = function (e, t, i) {
                            var o,
                                r = e.parentNode;
                            r && ((i = C(e, r, i)), (o = x(e, "lazybeforesizes", { width: i, dataAttr: !!t })), o.defaultPrevented || ((i = o.detail.width) && i !== e._lazysizesWidth && n(e, r, o, i)));
                        },
                        r = function () {
                            var t,
                                n = e.length;
                            if (n) for (t = 0; t < n; t++) o(e[t]);
                        },
                        s = _(r);
                    return {
                        _: function () {
                            (e = t.getElementsByClassName(i.autosizesClass)), c("resize", s);
                        },
                        checkElems: s,
                        updateElem: o,
                    };
                })(),
                $ = function () {
                    $.i || (($.i = !0), O._(), P._());
                };
            return (n = { cfg: i, autoSizer: O, loader: P, init: $, uP: k, aC: y, rC: b, hC: g, fire: x, gW: C, rAF: T });
        }
    }),
    !(function (e, t) {
        "object" == typeof exports && "object" == typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? (exports.Handlebars = t()) : (e.Handlebars = t());
    })(this, function () {
        return (function (e) {
            function t(i) {
                if (n[i]) return n[i].exports;
                var o = (n[i] = { exports: {}, id: i, loaded: !1 });
                return e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
            }
            var n = {};
            return (t.m = e), (t.c = n), (t.p = ""), t(0);
        })([
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o() {
                    var e = g();
                    return (
                        (e.compile = function (t, n) {
                            return u.compile(t, n, e);
                        }),
                        (e.precompile = function (t, n) {
                            return u.precompile(t, n, e);
                        }),
                        (e.AST = l.default),
                        (e.Compiler = u.Compiler),
                        (e.JavaScriptCompiler = p.default),
                        (e.Parser = c.parser),
                        (e.parse = c.parse),
                        e
                    );
                }
                t.__esModule = !0;
                var r = n(1),
                    s = i(r),
                    a = n(19),
                    l = i(a),
                    c = n(20),
                    u = n(25),
                    d = n(26),
                    p = i(d),
                    f = n(23),
                    h = i(f),
                    m = n(18),
                    v = i(m),
                    g = s.default.create,
                    y = o();
                (y.create = o), v.default(y), (y.Visitor = h.default), (y.default = y), (t.default = y), (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                    return (t.default = e), t;
                }
                function r() {
                    var e = new a.HandlebarsEnvironment();
                    return (
                        f.extend(e, a),
                        (e.SafeString = c.default),
                        (e.Exception = d.default),
                        (e.Utils = f),
                        (e.escapeExpression = f.escapeExpression),
                        (e.VM = m),
                        (e.template = function (t) {
                            return m.template(t, e);
                        }),
                        e
                    );
                }
                t.__esModule = !0;
                var s = n(2),
                    a = o(s),
                    l = n(16),
                    c = i(l),
                    u = n(4),
                    d = i(u),
                    p = n(3),
                    f = o(p),
                    h = n(17),
                    m = o(h),
                    v = n(18),
                    g = i(v),
                    y = r();
                (y.create = r), g.default(y), (y.default = y), (t.default = y), (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e, t, n) {
                    (this.helpers = e || {}), (this.partials = t || {}), (this.decorators = n || {}), l.registerDefaultHelpers(this), c.registerDefaultDecorators(this);
                }
                (t.__esModule = !0), (t.HandlebarsEnvironment = o);
                var r = n(3),
                    s = n(4),
                    a = i(s),
                    l = n(5),
                    c = n(13),
                    u = n(15),
                    d = i(u),
                    p = "4.0.5";
                t.VERSION = p;
                var f = 7;
                t.COMPILER_REVISION = f;
                var h = { 1: "<= 1.0.rc.2", 2: "== 1.0.0-rc.3", 3: "== 1.0.0-rc.4", 4: "== 1.x.x", 5: "== 2.0.0-alpha.x", 6: ">= 2.0.0-beta.1", 7: ">= 4.0.0" };
                t.REVISION_CHANGES = h;
                var m = "[object Object]";
                o.prototype = {
                    constructor: o,
                    logger: d.default,
                    log: d.default.log,
                    registerHelper: function (e, t) {
                        if (r.toString.call(e) === m) {
                            if (t) throw new a.default("Arg not supported with multiple helpers");
                            r.extend(this.helpers, e);
                        } else this.helpers[e] = t;
                    },
                    unregisterHelper: function (e) {
                        delete this.helpers[e];
                    },
                    registerPartial: function (e, t) {
                        if (r.toString.call(e) === m) r.extend(this.partials, e);
                        else {
                            if ("undefined" == typeof t) throw new a.default('Attempting to register a partial called "' + e + '" as undefined');
                            this.partials[e] = t;
                        }
                    },
                    unregisterPartial: function (e) {
                        delete this.partials[e];
                    },
                    registerDecorator: function (e, t) {
                        if (r.toString.call(e) === m) {
                            if (t) throw new a.default("Arg not supported with multiple decorators");
                            r.extend(this.decorators, e);
                        } else this.decorators[e] = t;
                    },
                    unregisterDecorator: function (e) {
                        delete this.decorators[e];
                    },
                };
                var v = d.default.log;
                (t.log = v), (t.createFrame = r.createFrame), (t.logger = d.default);
            },
            function (e, t) {
                "use strict";
                function n(e) {
                    return l[e];
                }
                function i(e) {
                    for (var t = 1; t < arguments.length; t++) for (var n in arguments[t]) Object.prototype.hasOwnProperty.call(arguments[t], n) && (e[n] = arguments[t][n]);
                    return e;
                }
                function o(e, t) {
                    for (var n = 0, i = e.length; i > n; n++) if (e[n] === t) return n;
                    return -1;
                }
                function r(e) {
                    if ("string" != typeof e) {
                        if (e && e.toHTML) return e.toHTML();
                        if (null == e) return "";
                        if (!e) return e + "";
                        e = "" + e;
                    }
                    return u.test(e) ? e.replace(c, n) : e;
                }
                function s(e) {
                    return (!e && 0 !== e) || !(!f(e) || 0 !== e.length);
                }
                function a(e) {
                    var t = i({}, e);
                    return (t._parent = e), t;
                }
                (t.__esModule = !0), (t.extend = i), (t.indexOf = o), (t.escapeExpression = r), (t.isEmpty = s), (t.createFrame = a);
                var l = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#x27;", "`": "&#x60;", "=": "&#x3D;" },
                    c = /[&<>"'`=]/g,
                    u = /[&<>"'`=]/,
                    d = Object.prototype.toString;
                t.toString = d;
                var p = function (e) {
                    return "function" == typeof e;
                };
                p(/x/) &&
                    (t.isFunction = p = function (e) {
                        return "function" == typeof e && "[object Function]" === d.call(e);
                    }),
                    (t.isFunction = p);
                var f =
                    Array.isArray ||
                    function (e) {
                        return !(!e || "object" != typeof e) && "[object Array]" === d.call(e);
                    };
                t.isArray = f;
            },
            function (e, t) {
                "use strict";
                function n(e, t) {
                    var o = t && t.loc,
                        r = void 0,
                        s = void 0;
                    o && ((r = o.start.line), (s = o.start.column), (e += " - " + r + ":" + s));
                    for (var a = Error.prototype.constructor.call(this, e), l = 0; l < i.length; l++) this[i[l]] = a[i[l]];
                    Error.captureStackTrace && Error.captureStackTrace(this, n);
                    try {
                        o && ((this.lineNumber = r), Object.defineProperty ? Object.defineProperty(this, "column", { value: s }) : (this.column = s));
                    } catch (e) {}
                }
                t.__esModule = !0;
                var i = ["description", "fileName", "lineNumber", "message", "name", "number", "stack"];
                (n.prototype = new Error()), (t.default = n), (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    s.default(e), l.default(e), u.default(e), p.default(e), h.default(e), v.default(e), y.default(e);
                }
                (t.__esModule = !0), (t.registerDefaultHelpers = o);
                var r = n(6),
                    s = i(r),
                    a = n(7),
                    l = i(a),
                    c = n(8),
                    u = i(c),
                    d = n(9),
                    p = i(d),
                    f = n(10),
                    h = i(f),
                    m = n(11),
                    v = i(m),
                    g = n(12),
                    y = i(g);
            },
            function (e, t, n) {
                "use strict";
                t.__esModule = !0;
                var i = n(3);
                (t.default = function (e) {
                    e.registerHelper("blockHelperMissing", function (t, n) {
                        var o = n.inverse,
                            r = n.fn;
                        return t === !0 ? r(this) : t === !1 || null == t ? o(this) : i.isArray(t) ? (t.length > 0 ? e.helpers.each(t, n) : o(this)) : r(t, n);
                    });
                }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                t.__esModule = !0;
                var o = n(3),
                    r = n(4),
                    s = i(r);
                (t.default = function (e) {
                    e.registerHelper("each", function (e, t) {
                        function n(t, n, o) {
                            c && ((c.key = t), (c.index = n), (c.first = 0 === n), (c.last = !!o)), (l += i(e[t], { data: c, blockParams: [e[t], t] }));
                        }
                        if (!t) throw new s.default("Must pass iterator to #each");
                        var i = t.fn,
                            r = t.inverse,
                            a = 0,
                            l = "",
                            c = void 0;
                        if ((o.isFunction(e) && (e = e.call(this)), t.data && (c = o.createFrame(t.data)), e && "object" == typeof e))
                            if (o.isArray(e)) for (var u = e.length; u > a; a++) a in e && n(a, a, a === e.length - 1);
                            else {
                                var d = void 0;
                                for (var p in e) e.hasOwnProperty(p) && (void 0 !== d && n(d, a - 1), (d = p), a++);
                                void 0 !== d && n(d, a - 1, !0);
                            }
                        return 0 === a && (l = r(this)), l;
                    });
                }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                t.__esModule = !0;
                var o = n(4),
                    r = i(o);
                (t.default = function (e) {
                    e.registerHelper("helperMissing", function () {
                        if (1 !== arguments.length) throw new r.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
                    });
                }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                t.__esModule = !0;
                var i = n(3);
                (t.default = function (e) {
                    e.registerHelper("if", function (e, t) {
                        return i.isFunction(e) && (e = e.call(this)), (!t.hash.includeZero && !e) || i.isEmpty(e) ? t.inverse(this) : t.fn(this);
                    }),
                        e.registerHelper("unless", function (t, n) {
                            return e.helpers.if.call(this, t, { fn: n.inverse, inverse: n.fn, hash: n.hash });
                        });
                }),
                    (e.exports = t.default);
            },
            function (e, t) {
                "use strict";
                (t.__esModule = !0),
                    (t.default = function (e) {
                        e.registerHelper("log", function () {
                            for (var t = [void 0], n = arguments[arguments.length - 1], i = 0; i < arguments.length - 1; i++) t.push(arguments[i]);
                            var o = 1;
                            null != n.hash.level ? (o = n.hash.level) : n.data && null != n.data.level && (o = n.data.level), (t[0] = o), e.log.apply(e, t);
                        });
                    }),
                    (e.exports = t.default);
            },
            function (e, t) {
                "use strict";
                (t.__esModule = !0),
                    (t.default = function (e) {
                        e.registerHelper("lookup", function (e, t) {
                            return e && e[t];
                        });
                    }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                t.__esModule = !0;
                var i = n(3);
                (t.default = function (e) {
                    e.registerHelper("with", function (e, t) {
                        i.isFunction(e) && (e = e.call(this));
                        var n = t.fn;
                        if (i.isEmpty(e)) return t.inverse(this);
                        var o = t.data;
                        return n(e, { data: o, blockParams: [e] });
                    });
                }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    s.default(e);
                }
                (t.__esModule = !0), (t.registerDefaultDecorators = o);
                var r = n(14),
                    s = i(r);
            },
            function (e, t, n) {
                "use strict";
                t.__esModule = !0;
                var i = n(3);
                (t.default = function (e) {
                    e.registerDecorator("inline", function (e, t, n, o) {
                        var r = e;
                        return (
                            t.partials ||
                                ((t.partials = {}),
                                (r = function (o, r) {
                                    var s = n.partials;
                                    n.partials = i.extend({}, s, t.partials);
                                    var a = e(o, r);
                                    return (n.partials = s), a;
                                })),
                            (t.partials[o.args[0]] = o.fn),
                            r
                        );
                    });
                }),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                t.__esModule = !0;
                var i = n(3),
                    o = {
                        methodMap: ["debug", "info", "warn", "error"],
                        level: "info",
                        lookupLevel: function (e) {
                            if ("string" == typeof e) {
                                var t = i.indexOf(o.methodMap, e.toLowerCase());
                                e = t >= 0 ? t : parseInt(e, 10);
                            }
                            return e;
                        },
                        log: function (e) {
                            if (((e = o.lookupLevel(e)), "undefined" != typeof console && o.lookupLevel(o.level) <= e)) {
                                var t = o.methodMap[e];
                                console[t] || (t = "log");
                                for (var n = arguments.length, i = Array(n > 1 ? n - 1 : 0), r = 1; n > r; r++) i[r - 1] = arguments[r];
                                console[t].apply(console, i);
                            }
                        },
                    };
                (t.default = o), (e.exports = t.default);
            },
            function (e, t) {
                "use strict";
                function n(e) {
                    this.string = e;
                }
                (t.__esModule = !0),
                    (n.prototype.toString = n.prototype.toHTML = function () {
                        return "" + this.string;
                    }),
                    (t.default = n),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                    return (t.default = e), t;
                }
                function r(e) {
                    var t = (e && e[0]) || 1,
                        n = g.COMPILER_REVISION;
                    if (t !== n) {
                        if (n > t) {
                            var i = g.REVISION_CHANGES[n],
                                o = g.REVISION_CHANGES[t];
                            throw new v.default(
                                "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                                    i +
                                    ") or downgrade your runtime to an older version (" +
                                    o +
                                    ")."
                            );
                        }
                        throw new v.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + e[1] + ").");
                    }
                }
                function s(e, t) {
                    function n(n, i, o) {
                        o.hash && (i = h.extend({}, i, o.hash)), (n = t.VM.resolvePartial.call(this, n, i, o));
                        var r = t.VM.invokePartial.call(this, n, i, o);
                        if ((null == r && t.compile && ((o.partials[o.name] = t.compile(n, e.compilerOptions, t)), (r = o.partials[o.name](i, o))), null != r)) {
                            if (o.indent) {
                                for (var s = r.split("\n"), a = 0, l = s.length; l > a && (s[a] || a + 1 !== l); a++) s[a] = o.indent + s[a];
                                r = s.join("\n");
                            }
                            return r;
                        }
                        throw new v.default("The partial " + o.name + " could not be compiled when running in runtime-only mode");
                    }
                    function i(t) {
                        function n(t) {
                            return "" + e.main(r, t, r.helpers, r.partials, s, l, a);
                        }
                        var i = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                            s = i.data;
                        o(i), !i.partial && e.useData && (s = d(t, s));
                        var a = void 0,
                            l = e.useBlockParams ? [] : void 0;
                        return e.useDepths && (a = i.depths ? (t != i.depths[0] ? [t].concat(i.depths) : i.depths) : [t]), (n = p(e.main, n, r, i.depths || [], s, l))(t, i);
                    }
                    function o(n) {
                        n.partial
                            ? ((r.helpers = n.helpers), (r.partials = n.partials), (r.decorators = n.decorators))
                            : ((r.helpers = r.merge(n.helpers, t.helpers)), e.usePartial && (r.partials = r.merge(n.partials, t.partials)), (e.usePartial || e.useDecorators) && (r.decorators = r.merge(n.decorators, t.decorators)));
                    }
                    if (!t) throw new v.default("No environment passed to template");
                    if (!e || !e.main) throw new v.default("Unknown template object: " + typeof e);
                    (e.main.decorator = e.main_d), t.VM.checkRevision(e.compiler);
                    var r = {
                        strict: function (e, t) {
                            if (!(t in e)) throw new v.default('"' + t + '" not defined in ' + e);
                            return e[t];
                        },
                        lookup: function (e, t) {
                            for (var n = e.length, i = 0; n > i; i++) if (e[i] && null != e[i][t]) return e[i][t];
                        },
                        lambda: function (e, t) {
                            return "function" == typeof e ? e.call(t) : e;
                        },
                        escapeExpression: h.escapeExpression,
                        invokePartial: n,
                        fn: function (t) {
                            var n = e[t];
                            return (n.decorator = e[t + "_d"]), n;
                        },
                        programs: [],
                        program: function (e, t, n, i, o) {
                            var r = this.programs[e],
                                s = this.fn(e);
                            return t || o || i || n ? (r = a(this, e, s, t, n, i, o)) : r || (r = this.programs[e] = a(this, e, s)), r;
                        },
                        data: function (e, t) {
                            for (; e && t--; ) e = e._parent;
                            return e;
                        },
                        merge: function (e, t) {
                            var n = e || t;
                            return e && t && e !== t && (n = h.extend({}, t, e)), n;
                        },
                        noop: t.VM.noop,
                        compilerInfo: e.compiler,
                    };
                    return (i.isTop = !0), i;
                }
                function a(e, t, n, i, o, r, s) {
                    function a(t) {
                        var o = arguments.length <= 1 || void 0 === arguments[1] ? {} : arguments[1],
                            a = s;
                        return s && t != s[0] && (a = [t].concat(s)), n(e, t, e.helpers, e.partials, o.data || i, r && [o.blockParams].concat(r), a);
                    }
                    return (a = p(n, a, e, s, i, r)), (a.program = t), (a.depth = s ? s.length : 0), (a.blockParams = o || 0), a;
                }
                function l(e, t, n) {
                    if (e) e.call || n.name || ((n.name = e), (e = n.partials[e]));
                    else if ("@partial-block" === n.name) {
                        for (var i = n.data; i["partial-block"] === u; ) i = i._parent;
                        (e = i["partial-block"]), (i["partial-block"] = u);
                    } else e = n.partials[n.name];
                    return e;
                }
                function c(e, t, n) {
                    n.partial = !0;
                    var i = void 0;
                    if ((n.fn && n.fn !== u && ((n.data = g.createFrame(n.data)), (i = n.data["partial-block"] = n.fn), i.partials && (n.partials = h.extend({}, n.partials, i.partials))), void 0 === e && i && (e = i), void 0 === e))
                        throw new v.default("The partial " + n.name + " could not be found");
                    return e instanceof Function ? e(t, n) : void 0;
                }
                function u() {
                    return "";
                }
                function d(e, t) {
                    return (t && "root" in t) || ((t = t ? g.createFrame(t) : {}), (t.root = e)), t;
                }
                function p(e, t, n, i, o, r) {
                    if (e.decorator) {
                        var s = {};
                        (t = e.decorator(t, s, n, i && i[0], o, r, i)), h.extend(t, s);
                    }
                    return t;
                }
                (t.__esModule = !0), (t.checkRevision = r), (t.template = s), (t.wrapProgram = a), (t.resolvePartial = l), (t.invokePartial = c), (t.noop = u);
                var f = n(3),
                    h = o(f),
                    m = n(4),
                    v = i(m),
                    g = n(2);
            },
            function (e, t) {
                (function (n) {
                    "use strict";
                    (t.__esModule = !0),
                        (t.default = function (e) {
                            var t = "undefined" != typeof n ? n : window,
                                i = t.Handlebars;
                            e.noConflict = function () {
                                return t.Handlebars === e && (t.Handlebars = i), e;
                            };
                        }),
                        (e.exports = t.default);
                }.call(
                    t,
                    (function () {
                        return this;
                    })()
                ));
            },
            function (e, t) {
                "use strict";
                t.__esModule = !0;
                var n = {
                    helpers: {
                        helperExpression: function (e) {
                            return "SubExpression" === e.type || (("MustacheStatement" === e.type || "BlockStatement" === e.type) && !!((e.params && e.params.length) || e.hash));
                        },
                        scopedId: function (e) {
                            return /^\.|this\b/.test(e.original);
                        },
                        simpleId: function (e) {
                            return 1 === e.parts.length && !n.helpers.scopedId(e) && !e.depth;
                        },
                    },
                };
                (t.default = n), (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
                    return (t.default = e), t;
                }
                function o(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function r(e, t) {
                    if ("Program" === e.type) return e;
                    (a.default.yy = f),
                        (f.locInfo = function (e) {
                            return new f.SourceLocation(t && t.srcName, e);
                        });
                    var n = new c.default(t);
                    return n.accept(a.default.parse(e));
                }
                (t.__esModule = !0), (t.parse = r);
                var s = n(21),
                    a = o(s),
                    l = n(22),
                    c = o(l),
                    u = n(24),
                    d = i(u),
                    p = n(3);
                t.parser = a.default;
                var f = {};
                p.extend(f, d);
            },
            function (e, t) {
                "use strict";
                var n = (function () {
                    function e() {
                        this.yy = {};
                    }
                    var t = function (e, t, n, i) {
                            for (n = n || {}, i = e.length; i--; n[e[i]] = t);
                            return n;
                        },
                        n = [2, 46],
                        i = [1, 20],
                        o = [5, 14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
                        r = [1, 35],
                        s = [1, 28],
                        a = [1, 29],
                        l = [1, 30],
                        c = [1, 31],
                        u = [1, 32],
                        d = [1, 34],
                        p = [14, 15, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60],
                        f = [14, 15, 19, 29, 34, 44, 47, 48, 51, 55, 60],
                        h = [1, 44],
                        m = [14, 15, 19, 29, 34, 47, 48, 51, 55, 60],
                        v = [33, 65, 72, 80, 81, 82, 83, 84, 85],
                        g = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85],
                        y = [1, 51],
                        b = [23, 33, 54, 65, 68, 72, 75, 80, 81, 82, 83, 84, 85, 87],
                        w = [2, 45],
                        x = [54, 65, 72, 80, 81, 82, 83, 84, 85],
                        k = [1, 58],
                        S = [1, 59],
                        C = [15, 18],
                        T = [1, 67],
                        E = [33, 65, 72, 75, 80, 81, 82, 83, 84, 85],
                        A = [23, 65, 72, 80, 81, 82, 83, 84, 85],
                        _ = [1, 79],
                        P = [65, 68, 72, 80, 81, 82, 83, 84, 85],
                        O = [33, 75],
                        $ = [23, 33, 54, 68, 72, 75],
                        I = [1, 109],
                        N = [1, 121],
                        D = [72, 77],
                        L = {
                            trace: function () {},
                            yy: {},
                            symbols_: {
                                error: 2,
                                root: 3,
                                program: 4,
                                EOF: 5,
                                program_repetition0: 6,
                                statement: 7,
                                mustache: 8,
                                block: 9,
                                rawBlock: 10,
                                partial: 11,
                                partialBlock: 12,
                                content: 13,
                                COMMENT: 14,
                                CONTENT: 15,
                                openRawBlock: 16,
                                rawBlock_repetition_plus0: 17,
                                END_RAW_BLOCK: 18,
                                OPEN_RAW_BLOCK: 19,
                                helperName: 20,
                                openRawBlock_repetition0: 21,
                                openRawBlock_option0: 22,
                                CLOSE_RAW_BLOCK: 23,
                                openBlock: 24,
                                block_option0: 25,
                                closeBlock: 26,
                                openInverse: 27,
                                block_option1: 28,
                                OPEN_BLOCK: 29,
                                openBlock_repetition0: 30,
                                openBlock_option0: 31,
                                openBlock_option1: 32,
                                CLOSE: 33,
                                OPEN_INVERSE: 34,
                                openInverse_repetition0: 35,
                                openInverse_option0: 36,
                                openInverse_option1: 37,
                                openInverseChain: 38,
                                OPEN_INVERSE_CHAIN: 39,
                                openInverseChain_repetition0: 40,
                                openInverseChain_option0: 41,
                                openInverseChain_option1: 42,
                                inverseAndProgram: 43,
                                INVERSE: 44,
                                inverseChain: 45,
                                inverseChain_option0: 46,
                                OPEN_ENDBLOCK: 47,
                                OPEN: 48,
                                mustache_repetition0: 49,
                                mustache_option0: 50,
                                OPEN_UNESCAPED: 51,
                                mustache_repetition1: 52,
                                mustache_option1: 53,
                                CLOSE_UNESCAPED: 54,
                                OPEN_PARTIAL: 55,
                                partialName: 56,
                                partial_repetition0: 57,
                                partial_option0: 58,
                                openPartialBlock: 59,
                                OPEN_PARTIAL_BLOCK: 60,
                                openPartialBlock_repetition0: 61,
                                openPartialBlock_option0: 62,
                                param: 63,
                                sexpr: 64,
                                OPEN_SEXPR: 65,
                                sexpr_repetition0: 66,
                                sexpr_option0: 67,
                                CLOSE_SEXPR: 68,
                                hash: 69,
                                hash_repetition_plus0: 70,
                                hashSegment: 71,
                                ID: 72,
                                EQUALS: 73,
                                blockParams: 74,
                                OPEN_BLOCK_PARAMS: 75,
                                blockParams_repetition_plus0: 76,
                                CLOSE_BLOCK_PARAMS: 77,
                                path: 78,
                                dataName: 79,
                                STRING: 80,
                                NUMBER: 81,
                                BOOLEAN: 82,
                                UNDEFINED: 83,
                                NULL: 84,
                                DATA: 85,
                                pathSegments: 86,
                                SEP: 87,
                                $accept: 0,
                                $end: 1,
                            },
                            terminals_: {
                                2: "error",
                                5: "EOF",
                                14: "COMMENT",
                                15: "CONTENT",
                                18: "END_RAW_BLOCK",
                                19: "OPEN_RAW_BLOCK",
                                23: "CLOSE_RAW_BLOCK",
                                29: "OPEN_BLOCK",
                                33: "CLOSE",
                                34: "OPEN_INVERSE",
                                39: "OPEN_INVERSE_CHAIN",
                                44: "INVERSE",
                                47: "OPEN_ENDBLOCK",
                                48: "OPEN",
                                51: "OPEN_UNESCAPED",
                                54: "CLOSE_UNESCAPED",
                                55: "OPEN_PARTIAL",
                                60: "OPEN_PARTIAL_BLOCK",
                                65: "OPEN_SEXPR",
                                68: "CLOSE_SEXPR",
                                72: "ID",
                                73: "EQUALS",
                                75: "OPEN_BLOCK_PARAMS",
                                77: "CLOSE_BLOCK_PARAMS",
                                80: "STRING",
                                81: "NUMBER",
                                82: "BOOLEAN",
                                83: "UNDEFINED",
                                84: "NULL",
                                85: "DATA",
                                87: "SEP",
                            },
                            productions_: [
                                0,
                                [3, 2],
                                [4, 1],
                                [7, 1],
                                [7, 1],
                                [7, 1],
                                [7, 1],
                                [7, 1],
                                [7, 1],
                                [7, 1],
                                [13, 1],
                                [10, 3],
                                [16, 5],
                                [9, 4],
                                [9, 4],
                                [24, 6],
                                [27, 6],
                                [38, 6],
                                [43, 2],
                                [45, 3],
                                [45, 1],
                                [26, 3],
                                [8, 5],
                                [8, 5],
                                [11, 5],
                                [12, 3],
                                [59, 5],
                                [63, 1],
                                [63, 1],
                                [64, 5],
                                [69, 1],
                                [71, 3],
                                [74, 3],
                                [20, 1],
                                [20, 1],
                                [20, 1],
                                [20, 1],
                                [20, 1],
                                [20, 1],
                                [20, 1],
                                [56, 1],
                                [56, 1],
                                [79, 2],
                                [78, 1],
                                [86, 3],
                                [86, 1],
                                [6, 0],
                                [6, 2],
                                [17, 1],
                                [17, 2],
                                [21, 0],
                                [21, 2],
                                [22, 0],
                                [22, 1],
                                [25, 0],
                                [25, 1],
                                [28, 0],
                                [28, 1],
                                [30, 0],
                                [30, 2],
                                [31, 0],
                                [31, 1],
                                [32, 0],
                                [32, 1],
                                [35, 0],
                                [35, 2],
                                [36, 0],
                                [36, 1],
                                [37, 0],
                                [37, 1],
                                [40, 0],
                                [40, 2],
                                [41, 0],
                                [41, 1],
                                [42, 0],
                                [42, 1],
                                [46, 0],
                                [46, 1],
                                [49, 0],
                                [49, 2],
                                [50, 0],
                                [50, 1],
                                [52, 0],
                                [52, 2],
                                [53, 0],
                                [53, 1],
                                [57, 0],
                                [57, 2],
                                [58, 0],
                                [58, 1],
                                [61, 0],
                                [61, 2],
                                [62, 0],
                                [62, 1],
                                [66, 0],
                                [66, 2],
                                [67, 0],
                                [67, 1],
                                [70, 1],
                                [70, 2],
                                [76, 1],
                                [76, 2],
                            ],
                            performAction: function (e, t, n, i, o, r, s) {
                                var a = r.length - 1;
                                switch (o) {
                                    case 1:
                                        return r[a - 1];
                                    case 2:
                                        this.$ = i.prepareProgram(r[a]);
                                        break;
                                    case 3:
                                    case 4:
                                    case 5:
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 20:
                                    case 27:
                                    case 28:
                                    case 33:
                                    case 34:
                                    case 40:
                                    case 41:
                                        this.$ = r[a];
                                        break;
                                    case 9:
                                        this.$ = { type: "CommentStatement", value: i.stripComment(r[a]), strip: i.stripFlags(r[a], r[a]), loc: i.locInfo(this._$) };
                                        break;
                                    case 10:
                                        this.$ = { type: "ContentStatement", original: r[a], value: r[a], loc: i.locInfo(this._$) };
                                        break;
                                    case 11:
                                        this.$ = i.prepareRawBlock(r[a - 2], r[a - 1], r[a], this._$);
                                        break;
                                    case 12:
                                        this.$ = { path: r[a - 3], params: r[a - 2], hash: r[a - 1] };
                                        break;
                                    case 13:
                                        this.$ = i.prepareBlock(r[a - 3], r[a - 2], r[a - 1], r[a], !1, this._$);
                                        break;
                                    case 14:
                                        this.$ = i.prepareBlock(r[a - 3], r[a - 2], r[a - 1], r[a], !0, this._$);
                                        break;
                                    case 15:
                                        this.$ = { open: r[a - 5], path: r[a - 4], params: r[a - 3], hash: r[a - 2], blockParams: r[a - 1], strip: i.stripFlags(r[a - 5], r[a]) };
                                        break;
                                    case 16:
                                    case 17:
                                        this.$ = { path: r[a - 4], params: r[a - 3], hash: r[a - 2], blockParams: r[a - 1], strip: i.stripFlags(r[a - 5], r[a]) };
                                        break;
                                    case 18:
                                        this.$ = { strip: i.stripFlags(r[a - 1], r[a - 1]), program: r[a] };
                                        break;
                                    case 19:
                                        var l = i.prepareBlock(r[a - 2], r[a - 1], r[a], r[a], !1, this._$),
                                            c = i.prepareProgram([l], r[a - 1].loc);
                                        (c.chained = !0), (this.$ = { strip: r[a - 2].strip, program: c, chain: !0 });
                                        break;
                                    case 21:
                                        this.$ = { path: r[a - 1], strip: i.stripFlags(r[a - 2], r[a]) };
                                        break;
                                    case 22:
                                    case 23:
                                        this.$ = i.prepareMustache(r[a - 3], r[a - 2], r[a - 1], r[a - 4], i.stripFlags(r[a - 4], r[a]), this._$);
                                        break;
                                    case 24:
                                        this.$ = { type: "PartialStatement", name: r[a - 3], params: r[a - 2], hash: r[a - 1], indent: "", strip: i.stripFlags(r[a - 4], r[a]), loc: i.locInfo(this._$) };
                                        break;
                                    case 25:
                                        this.$ = i.preparePartialBlock(r[a - 2], r[a - 1], r[a], this._$);
                                        break;
                                    case 26:
                                        this.$ = { path: r[a - 3], params: r[a - 2], hash: r[a - 1], strip: i.stripFlags(r[a - 4], r[a]) };
                                        break;
                                    case 29:
                                        this.$ = { type: "SubExpression", path: r[a - 3], params: r[a - 2], hash: r[a - 1], loc: i.locInfo(this._$) };
                                        break;
                                    case 30:
                                        this.$ = { type: "Hash", pairs: r[a], loc: i.locInfo(this._$) };
                                        break;
                                    case 31:
                                        this.$ = { type: "HashPair", key: i.id(r[a - 2]), value: r[a], loc: i.locInfo(this._$) };
                                        break;
                                    case 32:
                                        this.$ = i.id(r[a - 1]);
                                        break;
                                    case 35:
                                        this.$ = { type: "StringLiteral", value: r[a], original: r[a], loc: i.locInfo(this._$) };
                                        break;
                                    case 36:
                                        this.$ = { type: "NumberLiteral", value: Number(r[a]), original: Number(r[a]), loc: i.locInfo(this._$) };
                                        break;
                                    case 37:
                                        this.$ = { type: "BooleanLiteral", value: "true" === r[a], original: "true" === r[a], loc: i.locInfo(this._$) };
                                        break;
                                    case 38:
                                        this.$ = { type: "UndefinedLiteral", original: void 0, value: void 0, loc: i.locInfo(this._$) };
                                        break;
                                    case 39:
                                        this.$ = { type: "NullLiteral", original: null, value: null, loc: i.locInfo(this._$) };
                                        break;
                                    case 42:
                                        this.$ = i.preparePath(!0, r[a], this._$);
                                        break;
                                    case 43:
                                        this.$ = i.preparePath(!1, r[a], this._$);
                                        break;
                                    case 44:
                                        r[a - 2].push({ part: i.id(r[a]), original: r[a], separator: r[a - 1] }), (this.$ = r[a - 2]);
                                        break;
                                    case 45:
                                        this.$ = [{ part: i.id(r[a]), original: r[a] }];
                                        break;
                                    case 46:
                                    case 50:
                                    case 58:
                                    case 64:
                                    case 70:
                                    case 78:
                                    case 82:
                                    case 86:
                                    case 90:
                                    case 94:
                                        this.$ = [];
                                        break;
                                    case 47:
                                    case 49:
                                    case 51:
                                    case 59:
                                    case 65:
                                    case 71:
                                    case 79:
                                    case 83:
                                    case 87:
                                    case 91:
                                    case 95:
                                    case 99:
                                    case 101:
                                        r[a - 1].push(r[a]);
                                        break;
                                    case 48:
                                    case 98:
                                    case 100:
                                        this.$ = [r[a]];
                                }
                            },
                            table: [
                                t([5, 14, 15, 19, 29, 34, 48, 51, 55, 60], n, { 3: 1, 4: 2, 6: 3 }),
                                { 1: [3] },
                                { 5: [1, 4] },
                                t([5, 39, 44, 47], [2, 2], {
                                    7: 5,
                                    8: 6,
                                    9: 7,
                                    10: 8,
                                    11: 9,
                                    12: 10,
                                    13: 11,
                                    24: 15,
                                    27: 16,
                                    16: 17,
                                    59: 19,
                                    14: [1, 12],
                                    15: i,
                                    19: [1, 23],
                                    29: [1, 21],
                                    34: [1, 22],
                                    48: [1, 13],
                                    51: [1, 14],
                                    55: [1, 18],
                                    60: [1, 24],
                                }),
                                { 1: [2, 1] },
                                t(o, [2, 47]),
                                t(o, [2, 3]),
                                t(o, [2, 4]),
                                t(o, [2, 5]),
                                t(o, [2, 6]),
                                t(o, [2, 7]),
                                t(o, [2, 8]),
                                t(o, [2, 9]),
                                { 20: 25, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 20: 36, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(p, n, { 6: 3, 4: 37 }),
                                t(f, n, { 6: 3, 4: 38 }),
                                { 13: 40, 15: i, 17: 39 },
                                { 20: 42, 56: 41, 64: 43, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(m, n, { 6: 3, 4: 45 }),
                                t([5, 14, 15, 18, 19, 29, 34, 39, 44, 47, 48, 51, 55, 60], [2, 10]),
                                { 20: 46, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 20: 47, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 20: 48, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 20: 42, 56: 49, 64: 43, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(v, [2, 78], { 49: 50 }),
                                t(g, [2, 33]),
                                t(g, [2, 34]),
                                t(g, [2, 35]),
                                t(g, [2, 36]),
                                t(g, [2, 37]),
                                t(g, [2, 38]),
                                t(g, [2, 39]),
                                t(g, [2, 43], { 87: y }),
                                { 72: r, 86: 52 },
                                t(b, w),
                                t(x, [2, 82], { 52: 53 }),
                                { 25: 54, 38: 56, 39: k, 43: 57, 44: S, 45: 55, 47: [2, 54] },
                                { 28: 60, 43: 61, 44: S, 47: [2, 56] },
                                { 13: 63, 15: i, 18: [1, 62] },
                                t(C, [2, 48]),
                                t(v, [2, 86], { 57: 64 }),
                                t(v, [2, 40]),
                                t(v, [2, 41]),
                                { 20: 65, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 26: 66, 47: T },
                                t(E, [2, 58], { 30: 68 }),
                                t(E, [2, 64], { 35: 69 }),
                                t(A, [2, 50], { 21: 70 }),
                                t(v, [2, 90], { 61: 71 }),
                                { 20: 75, 33: [2, 80], 50: 72, 63: 73, 64: 76, 65: h, 69: 74, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 72: [1, 80] },
                                t(g, [2, 42], { 87: y }),
                                { 20: 75, 53: 81, 54: [2, 84], 63: 82, 64: 76, 65: h, 69: 83, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 26: 84, 47: T },
                                { 47: [2, 55] },
                                t(p, n, { 6: 3, 4: 85 }),
                                { 47: [2, 20] },
                                { 20: 86, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(m, n, { 6: 3, 4: 87 }),
                                { 26: 88, 47: T },
                                { 47: [2, 57] },
                                t(o, [2, 11]),
                                t(C, [2, 49]),
                                { 20: 75, 33: [2, 88], 58: 89, 63: 90, 64: 76, 65: h, 69: 91, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(P, [2, 94], { 66: 92 }),
                                t(o, [2, 25]),
                                { 20: 93, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(O, [2, 60], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 31: 94, 63: 95, 69: 96, 65: h, 72: _, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d }),
                                t(O, [2, 66], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 36: 97, 63: 98, 69: 99, 65: h, 72: _, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d }),
                                { 20: 75, 22: 100, 23: [2, 52], 63: 101, 64: 76, 65: h, 69: 102, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 20: 75, 33: [2, 92], 62: 103, 63: 104, 64: 76, 65: h, 69: 105, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 33: [1, 106] },
                                t(v, [2, 79]),
                                { 33: [2, 81] },
                                t(g, [2, 27]),
                                t(g, [2, 28]),
                                t([23, 33, 54, 68, 75], [2, 30], { 71: 107, 72: [1, 108] }),
                                t($, [2, 98]),
                                t(b, w, { 73: I }),
                                t(b, [2, 44]),
                                { 54: [1, 110] },
                                t(x, [2, 83]),
                                { 54: [2, 85] },
                                t(o, [2, 13]),
                                { 38: 56, 39: k, 43: 57, 44: S, 45: 112, 46: 111, 47: [2, 76] },
                                t(E, [2, 70], { 40: 113 }),
                                { 47: [2, 18] },
                                t(o, [2, 14]),
                                { 33: [1, 114] },
                                t(v, [2, 87]),
                                { 33: [2, 89] },
                                { 20: 75, 63: 116, 64: 76, 65: h, 67: 115, 68: [2, 96], 69: 117, 70: 77, 71: 78, 72: _, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                { 33: [1, 118] },
                                { 32: 119, 33: [2, 62], 74: 120, 75: N },
                                t(E, [2, 59]),
                                t(O, [2, 61]),
                                { 33: [2, 68], 37: 122, 74: 123, 75: N },
                                t(E, [2, 65]),
                                t(O, [2, 67]),
                                { 23: [1, 124] },
                                t(A, [2, 51]),
                                { 23: [2, 53] },
                                { 33: [1, 125] },
                                t(v, [2, 91]),
                                { 33: [2, 93] },
                                t(o, [2, 22]),
                                t($, [2, 99]),
                                { 73: I },
                                { 20: 75, 63: 126, 64: 76, 65: h, 72: r, 78: 26, 79: 27, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d, 86: 33 },
                                t(o, [2, 23]),
                                { 47: [2, 19] },
                                { 47: [2, 77] },
                                t(O, [2, 72], { 78: 26, 79: 27, 86: 33, 20: 75, 64: 76, 70: 77, 71: 78, 41: 127, 63: 128, 69: 129, 65: h, 72: _, 80: s, 81: a, 82: l, 83: c, 84: u, 85: d }),
                                t(o, [2, 24]),
                                { 68: [1, 130] },
                                t(P, [2, 95]),
                                { 68: [2, 97] },
                                t(o, [2, 21]),
                                { 33: [1, 131] },
                                { 33: [2, 63] },
                                { 72: [1, 133], 76: 132 },
                                { 33: [1, 134] },
                                { 33: [2, 69] },
                                { 15: [2, 12] },
                                t(m, [2, 26]),
                                t($, [2, 31]),
                                { 33: [2, 74], 42: 135, 74: 136, 75: N },
                                t(E, [2, 71]),
                                t(O, [2, 73]),
                                t(g, [2, 29]),
                                t(p, [2, 15]),
                                { 72: [1, 138], 77: [1, 137] },
                                t(D, [2, 100]),
                                t(f, [2, 16]),
                                { 33: [1, 139] },
                                { 33: [2, 75] },
                                { 33: [2, 32] },
                                t(D, [2, 101]),
                                t(p, [2, 17]),
                            ],
                            defaultActions: {
                                4: [2, 1],
                                55: [2, 55],
                                57: [2, 20],
                                61: [2, 57],
                                74: [2, 81],
                                83: [2, 85],
                                87: [2, 18],
                                91: [2, 89],
                                102: [2, 53],
                                105: [2, 93],
                                111: [2, 19],
                                112: [2, 77],
                                117: [2, 97],
                                120: [2, 63],
                                123: [2, 69],
                                124: [2, 12],
                                136: [2, 75],
                                137: [2, 32],
                            },
                            parseError: function (e, t) {
                                if (!t.recoverable) {
                                    var n = function (e, t) {
                                        (this.message = e), (this.hash = t);
                                    };
                                    throw ((n.prototype = new Error()), new n(e, t));
                                }
                                this.trace(e);
                            },
                            parse: function (e) {
                                var t = this,
                                    n = [0],
                                    i = [null],
                                    o = [],
                                    r = this.table,
                                    s = "",
                                    a = 0,
                                    l = 0,
                                    c = 0,
                                    u = 2,
                                    d = 1,
                                    p = o.slice.call(arguments, 1),
                                    f = Object.create(this.lexer),
                                    h = { yy: {} };
                                for (var m in this.yy) Object.prototype.hasOwnProperty.call(this.yy, m) && (h.yy[m] = this.yy[m]);
                                f.setInput(e, h.yy), (h.yy.lexer = f), (h.yy.parser = this), "undefined" == typeof f.yylloc && (f.yylloc = {});
                                var v = f.yylloc;
                                o.push(v);
                                var g = f.options && f.options.ranges;
                                "function" == typeof h.yy.parseError ? (this.parseError = h.yy.parseError) : (this.parseError = Object.getPrototypeOf(this).parseError);
                                for (
                                    var y,
                                        b,
                                        w,
                                        x,
                                        k,
                                        S,
                                        C,
                                        T,
                                        E,
                                        A = function () {
                                            var e;
                                            return (e = f.lex() || d), "number" != typeof e && (e = t.symbols_[e] || e), e;
                                        },
                                        _ = {};
                                    ;

                                ) {
                                    if (
                                        ((w = n[n.length - 1]),
                                        this.defaultActions[w] ? (x = this.defaultActions[w]) : ((null !== y && "undefined" != typeof y) || (y = A()), (x = r[w] && r[w][y])),
                                        "undefined" == typeof x || !x.length || !x[0])
                                    ) {
                                        var P = "";
                                        E = [];
                                        for (S in r[w]) this.terminals_[S] && S > u && E.push("'" + this.terminals_[S] + "'");
                                        (P = f.showPosition
                                            ? "Parse error on line " + (a + 1) + ":\n" + f.showPosition() + "\nExpecting " + E.join(", ") + ", got '" + (this.terminals_[y] || y) + "'"
                                            : "Parse error on line " + (a + 1) + ": Unexpected " + (y == d ? "end of input" : "'" + (this.terminals_[y] || y) + "'")),
                                            this.parseError(P, { text: f.match, token: this.terminals_[y] || y, line: f.yylineno, loc: v, expected: E });
                                    }
                                    if (x[0] instanceof Array && x.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + w + ", token: " + y);
                                    switch (x[0]) {
                                        case 1:
                                            n.push(y), i.push(f.yytext), o.push(f.yylloc), n.push(x[1]), (y = null), b ? ((y = b), (b = null)) : ((l = f.yyleng), (s = f.yytext), (a = f.yylineno), (v = f.yylloc), c > 0 && c--);
                                            break;
                                        case 2:
                                            if (
                                                ((C = this.productions_[x[1]][1]),
                                                (_.$ = i[i.length - C]),
                                                (_._$ = { first_line: o[o.length - (C || 1)].first_line, last_line: o[o.length - 1].last_line, first_column: o[o.length - (C || 1)].first_column, last_column: o[o.length - 1].last_column }),
                                                g && (_._$.range = [o[o.length - (C || 1)].range[0], o[o.length - 1].range[1]]),
                                                (k = this.performAction.apply(_, [s, l, a, h.yy, x[1], i, o].concat(p))),
                                                "undefined" != typeof k)
                                            )
                                                return k;
                                            C && ((n = n.slice(0, -1 * C * 2)), (i = i.slice(0, -1 * C)), (o = o.slice(0, -1 * C))),
                                                n.push(this.productions_[x[1]][0]),
                                                i.push(_.$),
                                                o.push(_._$),
                                                (T = r[n[n.length - 2]][n[n.length - 1]]),
                                                n.push(T);
                                            break;
                                        case 3:
                                            return !0;
                                    }
                                }
                                return !0;
                            },
                        },
                        z = (function () {
                            var e = {
                                EOF: 1,
                                parseError: function (e, t) {
                                    if (!this.yy.parser) throw new Error(e);
                                    this.yy.parser.parseError(e, t);
                                },
                                setInput: function (e, t) {
                                    return (
                                        (this.yy = t || this.yy || {}),
                                        (this._input = e),
                                        (this._more = this._backtrack = this.done = !1),
                                        (this.yylineno = this.yyleng = 0),
                                        (this.yytext = this.matched = this.match = ""),
                                        (this.conditionStack = ["INITIAL"]),
                                        (this.yylloc = { first_line: 1, first_column: 0, last_line: 1, last_column: 0 }),
                                        this.options.ranges && (this.yylloc.range = [0, 0]),
                                        (this.offset = 0),
                                        this
                                    );
                                },
                                input: function () {
                                    var e = this._input[0];
                                    (this.yytext += e), this.yyleng++, this.offset++, (this.match += e), (this.matched += e);
                                    var t = e.match(/(?:\r\n?|\n).*/g);
                                    return t ? (this.yylineno++, this.yylloc.last_line++) : this.yylloc.last_column++, this.options.ranges && this.yylloc.range[1]++, (this._input = this._input.slice(1)), e;
                                },
                                unput: function (e) {
                                    var t = e.length,
                                        n = e.split(/(?:\r\n?|\n)/g);
                                    (this._input = e + this._input), (this.yytext = this.yytext.substr(0, this.yytext.length - t)), (this.offset -= t);
                                    var i = this.match.split(/(?:\r\n?|\n)/g);
                                    (this.match = this.match.substr(0, this.match.length - 1)), (this.matched = this.matched.substr(0, this.matched.length - 1)), n.length - 1 && (this.yylineno -= n.length - 1);
                                    var o = this.yylloc.range;
                                    return (
                                        (this.yylloc = {
                                            first_line: this.yylloc.first_line,
                                            last_line: this.yylineno + 1,
                                            first_column: this.yylloc.first_column,
                                            last_column: n ? (n.length === i.length ? this.yylloc.first_column : 0) + i[i.length - n.length].length - n[0].length : this.yylloc.first_column - t,
                                        }),
                                        this.options.ranges && (this.yylloc.range = [o[0], o[0] + this.yyleng - t]),
                                        (this.yyleng = this.yytext.length),
                                        this
                                    );
                                },
                                more: function () {
                                    return (this._more = !0), this;
                                },
                                reject: function () {
                                    return this.options.backtrack_lexer
                                        ? ((this._backtrack = !0), this)
                                        : this.parseError(
                                              "Lexical error on line " +
                                                  (this.yylineno + 1) +
                                                  ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" +
                                                  this.showPosition(),
                                              { text: "", token: null, line: this.yylineno }
                                          );
                                },
                                less: function (e) {
                                    this.unput(this.match.slice(e));
                                },
                                pastInput: function () {
                                    var e = this.matched.substr(0, this.matched.length - this.match.length);
                                    return (e.length > 20 ? "..." : "") + e.substr(-20).replace(/\n/g, "");
                                },
                                upcomingInput: function () {
                                    var e = this.match;
                                    return e.length < 20 && (e += this._input.substr(0, 20 - e.length)), (e.substr(0, 20) + (e.length > 20 ? "..." : "")).replace(/\n/g, "");
                                },
                                showPosition: function () {
                                    var e = this.pastInput(),
                                        t = new Array(e.length + 1).join("-");
                                    return e + this.upcomingInput() + "\n" + t + "^";
                                },
                                test_match: function (e, t) {
                                    var n, i, o;
                                    if (
                                        (this.options.backtrack_lexer &&
                                            ((o = {
                                                yylineno: this.yylineno,
                                                yylloc: { first_line: this.yylloc.first_line, last_line: this.last_line, first_column: this.yylloc.first_column, last_column: this.yylloc.last_column },
                                                yytext: this.yytext,
                                                match: this.match,
                                                matches: this.matches,
                                                matched: this.matched,
                                                yyleng: this.yyleng,
                                                offset: this.offset,
                                                _more: this._more,
                                                _input: this._input,
                                                yy: this.yy,
                                                conditionStack: this.conditionStack.slice(0),
                                                done: this.done,
                                            }),
                                            this.options.ranges && (o.yylloc.range = this.yylloc.range.slice(0))),
                                        (i = e[0].match(/(?:\r\n?|\n).*/g)),
                                        i && (this.yylineno += i.length),
                                        (this.yylloc = {
                                            first_line: this.yylloc.last_line,
                                            last_line: this.yylineno + 1,
                                            first_column: this.yylloc.last_column,
                                            last_column: i ? i[i.length - 1].length - i[i.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + e[0].length,
                                        }),
                                        (this.yytext += e[0]),
                                        (this.match += e[0]),
                                        (this.matches = e),
                                        (this.yyleng = this.yytext.length),
                                        this.options.ranges && (this.yylloc.range = [this.offset, (this.offset += this.yyleng)]),
                                        (this._more = !1),
                                        (this._backtrack = !1),
                                        (this._input = this._input.slice(e[0].length)),
                                        (this.matched += e[0]),
                                        (n = this.performAction.call(this, this.yy, this, t, this.conditionStack[this.conditionStack.length - 1])),
                                        this.done && this._input && (this.done = !1),
                                        n)
                                    )
                                        return n;
                                    if (this._backtrack) {
                                        for (var r in o) this[r] = o[r];
                                        return !1;
                                    }
                                    return !1;
                                },
                                next: function () {
                                    if (this.done) return this.EOF;
                                    this._input || (this.done = !0);
                                    var e, t, n, i;
                                    this._more || ((this.yytext = ""), (this.match = ""));
                                    for (var o = this._currentRules(), r = 0; r < o.length; r++)
                                        if (((n = this._input.match(this.rules[o[r]])), n && (!t || n[0].length > t[0].length))) {
                                            if (((t = n), (i = r), this.options.backtrack_lexer)) {
                                                if (((e = this.test_match(n, o[r])), e !== !1)) return e;
                                                if (this._backtrack) {
                                                    t = !1;
                                                    continue;
                                                }
                                                return !1;
                                            }
                                            if (!this.options.flex) break;
                                        }
                                    return t
                                        ? ((e = this.test_match(t, o[i])), e !== !1 && e)
                                        : "" === this._input
                                        ? this.EOF
                                        : this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), { text: "", token: null, line: this.yylineno });
                                },
                                lex: function () {
                                    var e = this.next();
                                    return e ? e : this.lex();
                                },
                                begin: function (e) {
                                    this.conditionStack.push(e);
                                },
                                popState: function () {
                                    var e = this.conditionStack.length - 1;
                                    return e > 0 ? this.conditionStack.pop() : this.conditionStack[0];
                                },
                                _currentRules: function () {
                                    return this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1] ? this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules : this.conditions.INITIAL.rules;
                                },
                                topState: function (e) {
                                    return (e = this.conditionStack.length - 1 - Math.abs(e || 0)), e >= 0 ? this.conditionStack[e] : "INITIAL";
                                },
                                pushState: function (e) {
                                    this.begin(e);
                                },
                                stateStackSize: function () {
                                    return this.conditionStack.length;
                                },
                                options: {},
                                performAction: function (e, t, n, i) {
                                    function o(e, n) {
                                        return (t.yytext = t.yytext.substr(e, t.yyleng - n));
                                    }
                                    switch (n) {
                                        case 0:
                                            if (("\\\\" === t.yytext.slice(-2) ? (o(0, 1), this.begin("mu")) : "\\" === t.yytext.slice(-1) ? (o(0, 1), this.begin("emu")) : this.begin("mu"), t.yytext)) return 15;
                                            break;
                                        case 1:
                                            return 15;
                                        case 2:
                                            return this.popState(), 15;
                                        case 3:
                                            return this.begin("raw"), 15;
                                        case 4:
                                            return this.popState(), "raw" === this.conditionStack[this.conditionStack.length - 1] ? 15 : ((t.yytext = t.yytext.substr(5, t.yyleng - 9)), 18);
                                        case 5:
                                            return 15;
                                        case 6:
                                            return this.popState(), 14;
                                        case 7:
                                            return 65;
                                        case 8:
                                            return 68;
                                        case 9:
                                            return 19;
                                        case 10:
                                            return this.popState(), this.begin("raw"), 23;
                                        case 11:
                                            return 55;
                                        case 12:
                                            return 60;
                                        case 13:
                                            return 29;
                                        case 14:
                                            return 47;
                                        case 15:
                                            return this.popState(), 44;
                                        case 16:
                                            return this.popState(), 44;
                                        case 17:
                                            return 34;
                                        case 18:
                                            return 39;
                                        case 19:
                                            return 51;
                                        case 20:
                                            return 48;
                                        case 21:
                                            this.unput(t.yytext), this.popState(), this.begin("com");
                                            break;
                                        case 22:
                                            return this.popState(), 14;
                                        case 23:
                                            return 48;
                                        case 24:
                                            return 73;
                                        case 25:
                                            return 72;
                                        case 26:
                                            return 72;
                                        case 27:
                                            return 87;
                                        case 28:
                                            break;
                                        case 29:
                                            return this.popState(), 54;
                                        case 30:
                                            return this.popState(), 33;
                                        case 31:
                                            return (t.yytext = o(1, 2).replace(/\\"/g, '"')), 80;
                                        case 32:
                                            return (t.yytext = o(1, 2).replace(/\\'/g, "'")), 80;
                                        case 33:
                                            return 85;
                                        case 34:
                                            return 82;
                                        case 35:
                                            return 82;
                                        case 36:
                                            return 83;
                                        case 37:
                                            return 84;
                                        case 38:
                                            return 81;
                                        case 39:
                                            return 75;
                                        case 40:
                                            return 77;
                                        case 41:
                                            return 72;
                                        case 42:
                                            return (t.yytext = t.yytext.replace(/\\([\\\]])/g, "$1")), 72;
                                        case 43:
                                            return "INVALID";
                                        case 44:
                                            return 5;
                                    }
                                },
                                rules: [
                                    /^(?:[^\x00]*?(?=(\{\{)))/,
                                    /^(?:[^\x00]+)/,
                                    /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                                    /^(?:\{\{\{\{(?=[^\/]))/,
                                    /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                                    /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
                                    /^(?:[\s\S]*?--(~)?\}\})/,
                                    /^(?:\()/,
                                    /^(?:\))/,
                                    /^(?:\{\{\{\{)/,
                                    /^(?:\}\}\}\})/,
                                    /^(?:\{\{(~)?>)/,
                                    /^(?:\{\{(~)?#>)/,
                                    /^(?:\{\{(~)?#\*?)/,
                                    /^(?:\{\{(~)?\/)/,
                                    /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                                    /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                                    /^(?:\{\{(~)?\^)/,
                                    /^(?:\{\{(~)?\s*else\b)/,
                                    /^(?:\{\{(~)?\{)/,
                                    /^(?:\{\{(~)?&)/,
                                    /^(?:\{\{(~)?!--)/,
                                    /^(?:\{\{(~)?![\s\S]*?\}\})/,
                                    /^(?:\{\{(~)?\*?)/,
                                    /^(?:=)/,
                                    /^(?:\.\.)/,
                                    /^(?:\.(?=([=~}\s\/.)|])))/,
                                    /^(?:[\/.])/,
                                    /^(?:\s+)/,
                                    /^(?:\}(~)?\}\})/,
                                    /^(?:(~)?\}\})/,
                                    /^(?:"(\\["]|[^"])*")/,
                                    /^(?:'(\\[']|[^'])*')/,
                                    /^(?:@)/,
                                    /^(?:true(?=([~}\s)])))/,
                                    /^(?:false(?=([~}\s)])))/,
                                    /^(?:undefined(?=([~}\s)])))/,
                                    /^(?:null(?=([~}\s)])))/,
                                    /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                                    /^(?:as\s+\|)/,
                                    /^(?:\|)/,
                                    /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                                    /^(?:\[(\\\]|[^\]])*\])/,
                                    /^(?:.)/,
                                    /^(?:$)/,
                                ],
                                conditions: {
                                    mu: { rules: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44], inclusive: !1 },
                                    emu: { rules: [2], inclusive: !1 },
                                    com: { rules: [6], inclusive: !1 },
                                    raw: { rules: [3, 4, 5], inclusive: !1 },
                                    INITIAL: { rules: [0, 1, 44], inclusive: !0 },
                                },
                            };
                            return e;
                        })();
                    return (L.lexer = z), (e.prototype = L), (L.Parser = e), new e();
                })();
                (t.__esModule = !0), (t.default = n);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o() {
                    var e = arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
                    this.options = e;
                }
                function r(e, t, n) {
                    void 0 === t && (t = e.length);
                    var i = e[t - 1],
                        o = e[t - 2];
                    return i ? ("ContentStatement" === i.type ? (o || !n ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(i.original) : void 0) : n;
                }
                function s(e, t, n) {
                    void 0 === t && (t = -1);
                    var i = e[t + 1],
                        o = e[t + 2];
                    return i ? ("ContentStatement" === i.type ? (o || !n ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(i.original) : void 0) : n;
                }
                function a(e, t, n) {
                    var i = e[null == t ? 0 : t + 1];
                    if (i && "ContentStatement" === i.type && (n || !i.rightStripped)) {
                        var o = i.value;
                        (i.value = i.value.replace(n ? /^\s+/ : /^[ \t]*\r?\n?/, "")), (i.rightStripped = i.value !== o);
                    }
                }
                function l(e, t, n) {
                    var i = e[null == t ? e.length - 1 : t - 1];
                    if (i && "ContentStatement" === i.type && (n || !i.leftStripped)) {
                        var o = i.value;
                        return (i.value = i.value.replace(n ? /\s+$/ : /[ \t]+$/, "")), (i.leftStripped = i.value !== o), i.leftStripped;
                    }
                }
                t.__esModule = !0;
                var c = n(23),
                    u = i(c);
                (o.prototype = new u.default()),
                    (o.prototype.Program = function (e) {
                        var t = !this.options.ignoreStandalone,
                            n = !this.isRootSeen;
                        this.isRootSeen = !0;
                        for (var i = e.body, o = 0, c = i.length; c > o; o++) {
                            var u = i[o],
                                d = this.accept(u);
                            if (d) {
                                var p = r(i, o, n),
                                    f = s(i, o, n),
                                    h = d.openStandalone && p,
                                    m = d.closeStandalone && f,
                                    v = d.inlineStandalone && p && f;
                                d.close && a(i, o, !0),
                                    d.open && l(i, o, !0),
                                    t && v && (a(i, o), l(i, o) && "PartialStatement" === u.type && (u.indent = /([ \t]+$)/.exec(i[o - 1].original)[1])),
                                    t && h && (a((u.program || u.inverse).body), l(i, o)),
                                    t && m && (a(i, o), l((u.inverse || u.program).body));
                            }
                        }
                        return e;
                    }),
                    (o.prototype.BlockStatement = o.prototype.DecoratorBlock = o.prototype.PartialBlockStatement = function (e) {
                        this.accept(e.program), this.accept(e.inverse);
                        var t = e.program || e.inverse,
                            n = e.program && e.inverse,
                            i = n,
                            o = n;
                        if (n && n.chained) for (i = n.body[0].program; o.chained; ) o = o.body[o.body.length - 1].program;
                        var c = { open: e.openStrip.open, close: e.closeStrip.close, openStandalone: s(t.body), closeStandalone: r((i || t).body) };
                        if ((e.openStrip.close && a(t.body, null, !0), n)) {
                            var u = e.inverseStrip;
                            u.open && l(t.body, null, !0), u.close && a(i.body, null, !0), e.closeStrip.open && l(o.body, null, !0), !this.options.ignoreStandalone && r(t.body) && s(i.body) && (l(t.body), a(i.body));
                        } else e.closeStrip.open && l(t.body, null, !0);
                        return c;
                    }),
                    (o.prototype.Decorator = o.prototype.MustacheStatement = function (e) {
                        return e.strip;
                    }),
                    (o.prototype.PartialStatement = o.prototype.CommentStatement = function (e) {
                        var t = e.strip || {};
                        return { inlineStandalone: !0, open: t.open, close: t.close };
                    }),
                    (t.default = o),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o() {
                    this.parents = [];
                }
                function r(e) {
                    this.acceptRequired(e, "path"), this.acceptArray(e.params), this.acceptKey(e, "hash");
                }
                function s(e) {
                    r.call(this, e), this.acceptKey(e, "program"), this.acceptKey(e, "inverse");
                }
                function a(e) {
                    this.acceptRequired(e, "name"), this.acceptArray(e.params), this.acceptKey(e, "hash");
                }
                t.__esModule = !0;
                var l = n(4),
                    c = i(l);
                (o.prototype = {
                    constructor: o,
                    mutating: !1,
                    acceptKey: function (e, t) {
                        var n = this.accept(e[t]);
                        if (this.mutating) {
                            if (n && !o.prototype[n.type]) throw new c.default('Unexpected node type "' + n.type + '" found when accepting ' + t + " on " + e.type);
                            e[t] = n;
                        }
                    },
                    acceptRequired: function (e, t) {
                        if ((this.acceptKey(e, t), !e[t])) throw new c.default(e.type + " requires " + t);
                    },
                    acceptArray: function (e) {
                        for (var t = 0, n = e.length; n > t; t++) this.acceptKey(e, t), e[t] || (e.splice(t, 1), t--, n--);
                    },
                    accept: function (e) {
                        if (e) {
                            if (!this[e.type]) throw new c.default("Unknown type: " + e.type, e);
                            this.current && this.parents.unshift(this.current), (this.current = e);
                            var t = this[e.type](e);
                            return (this.current = this.parents.shift()), !this.mutating || t ? t : t !== !1 ? e : void 0;
                        }
                    },
                    Program: function (e) {
                        this.acceptArray(e.body);
                    },
                    MustacheStatement: r,
                    Decorator: r,
                    BlockStatement: s,
                    DecoratorBlock: s,
                    PartialStatement: a,
                    PartialBlockStatement: function (e) {
                        a.call(this, e), this.acceptKey(e, "program");
                    },
                    ContentStatement: function () {},
                    CommentStatement: function () {},
                    SubExpression: r,
                    PathExpression: function () {},
                    StringLiteral: function () {},
                    NumberLiteral: function () {},
                    BooleanLiteral: function () {},
                    UndefinedLiteral: function () {},
                    NullLiteral: function () {},
                    Hash: function (e) {
                        this.acceptArray(e.pairs);
                    },
                    HashPair: function (e) {
                        this.acceptRequired(e, "value");
                    },
                }),
                    (t.default = o),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e, t) {
                    if (((t = t.path ? t.path.original : t), e.path.original !== t)) {
                        var n = { loc: e.path.loc };
                        throw new v.default(e.path.original + " doesn't match " + t, n);
                    }
                }
                function r(e, t) {
                    (this.source = e), (this.start = { line: t.first_line, column: t.first_column }), (this.end = { line: t.last_line, column: t.last_column });
                }
                function s(e) {
                    return /^\[.*\]$/.test(e) ? e.substr(1, e.length - 2) : e;
                }
                function a(e, t) {
                    return { open: "~" === e.charAt(2), close: "~" === t.charAt(t.length - 3) };
                }
                function l(e) {
                    return e.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
                }
                function c(e, t, n) {
                    n = this.locInfo(n);
                    for (var i = e ? "@" : "", o = [], r = 0, s = 0, a = t.length; a > s; s++) {
                        var l = t[s].part,
                            c = t[s].original !== l;
                        if (((i += (t[s].separator || "") + l), c || (".." !== l && "." !== l && "this" !== l))) o.push(l);
                        else {
                            if (o.length > 0) throw new v.default("Invalid path: " + i, { loc: n });
                            ".." === l && r++;
                        }
                    }
                    return { type: "PathExpression", data: e, depth: r, parts: o, original: i, loc: n };
                }
                function u(e, t, n, i, o, r) {
                    var s = i.charAt(3) || i.charAt(2),
                        a = "{" !== s && "&" !== s,
                        l = /\*/.test(i);
                    return { type: l ? "Decorator" : "MustacheStatement", path: e, params: t, hash: n, escaped: a, strip: o, loc: this.locInfo(r) };
                }
                function d(e, t, n, i) {
                    o(e, n), (i = this.locInfo(i));
                    var r = { type: "Program", body: t, strip: {}, loc: i };
                    return { type: "BlockStatement", path: e.path, params: e.params, hash: e.hash, program: r, openStrip: {}, inverseStrip: {}, closeStrip: {}, loc: i };
                }
                function p(e, t, n, i, r, s) {
                    i && i.path && o(e, i);
                    var a = /\*/.test(e.open);
                    t.blockParams = e.blockParams;
                    var l = void 0,
                        c = void 0;
                    if (n) {
                        if (a) throw new v.default("Unexpected inverse block on decorator", n);
                        n.chain && (n.program.body[0].closeStrip = i.strip), (c = n.strip), (l = n.program);
                    }
                    return (
                        r && ((r = l), (l = t), (t = r)),
                        { type: a ? "DecoratorBlock" : "BlockStatement", path: e.path, params: e.params, hash: e.hash, program: t, inverse: l, openStrip: e.strip, inverseStrip: c, closeStrip: i && i.strip, loc: this.locInfo(s) }
                    );
                }
                function f(e, t) {
                    if (!t && e.length) {
                        var n = e[0].loc,
                            i = e[e.length - 1].loc;
                        n && i && (t = { source: n.source, start: { line: n.start.line, column: n.start.column }, end: { line: i.end.line, column: i.end.column } });
                    }
                    return { type: "Program", body: e, strip: {}, loc: t };
                }
                function h(e, t, n, i) {
                    return o(e, n), { type: "PartialBlockStatement", name: e.path, params: e.params, hash: e.hash, program: t, openStrip: e.strip, closeStrip: n && n.strip, loc: this.locInfo(i) };
                }
                (t.__esModule = !0),
                    (t.SourceLocation = r),
                    (t.id = s),
                    (t.stripFlags = a),
                    (t.stripComment = l),
                    (t.preparePath = c),
                    (t.prepareMustache = u),
                    (t.prepareRawBlock = d),
                    (t.prepareBlock = p),
                    (t.prepareProgram = f),
                    (t.preparePartialBlock = h);
                var m = n(4),
                    v = i(m);
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o() {}
                function r(e, t, n) {
                    void 0 === t && (t = {}), a(e, t);
                    var i = l(e, t, n);
                    return new n.JavaScriptCompiler().compile(i, t);
                }
                function s(e, t, n) {
                    function i() {
                        var i = l(e, t, n),
                            o = new n.JavaScriptCompiler().compile(i, t, void 0, !0);
                        return n.template(o);
                    }
                    void 0 === t && (t = {}), a(e, t);
                    var o = void 0;
                    return function (e, t) {
                        return o || (o = i()), o.call(this, e, t);
                    };
                }
                function a(e, t) {
                    if (null == e || ("string" != typeof e && "Program" !== e.type)) throw new p.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed " + e);
                    if (t.trackIds || t.stringParams) throw new p.default("TrackIds and stringParams are no longer supported. See Github #1145");
                    "data" in t || (t.data = !0), t.compat && (t.useDepths = !0);
                }
                function l(e, t, n) {
                    var i = n.parse(e, t);
                    return new n.Compiler().compile(i, t);
                }
                function c(e, t) {
                    if (e === t) return !0;
                    if (f.isArray(e) && f.isArray(t) && e.length === t.length) {
                        for (var n = 0; n < e.length; n++) if (!c(e[n], t[n])) return !1;
                        return !0;
                    }
                }
                function u(e) {
                    if (!e.path.parts) {
                        var t = e.path;
                        e.path = { type: "PathExpression", data: !1, depth: 0, parts: [t.original + ""], original: t.original + "", loc: t.loc };
                    }
                }
                (t.__esModule = !0), (t.Compiler = o), (t.precompile = r), (t.compile = s);
                var d = n(4),
                    p = i(d),
                    f = n(3),
                    h = n(19),
                    m = i(h),
                    v = [].slice;
                o.prototype = {
                    compiler: o,
                    equals: function (e) {
                        var t = this.opcodes.length;
                        if (e.opcodes.length !== t) return !1;
                        for (var n = 0; t > n; n++) {
                            var i = this.opcodes[n],
                                o = e.opcodes[n];
                            if (i.opcode !== o.opcode || !c(i.args, o.args)) return !1;
                        }
                        t = this.children.length;
                        for (var n = 0; t > n; n++) if (!this.children[n].equals(e.children[n])) return !1;
                        return !0;
                    },
                    guid: 0,
                    compile: function (e, t) {
                        (this.sourceNode = []), (this.opcodes = []), (this.children = []), (this.options = t), (t.blockParams = t.blockParams || []);
                        var n = t.knownHelpers;
                        if (((t.knownHelpers = { helperMissing: !0, blockHelperMissing: !0, each: !0, if: !0, unless: !0, with: !0, log: !0, lookup: !0 }), n)) for (var i in n) i in n && (t.knownHelpers[i] = n[i]);
                        return this.accept(e);
                    },
                    compileProgram: function (e) {
                        var t = new this.compiler(),
                            n = t.compile(e, this.options),
                            i = this.guid++;
                        return (this.usePartial = this.usePartial || n.usePartial), (this.children[i] = n), (this.useDepths = this.useDepths || n.useDepths), i;
                    },
                    accept: function (e) {
                        if (!this[e.type]) throw new p.default("Unknown type: " + e.type, e);
                        this.sourceNode.unshift(e);
                        var t = this[e.type](e);
                        return this.sourceNode.shift(), t;
                    },
                    Program: function (e) {
                        this.options.blockParams.unshift(e.blockParams);
                        for (var t = e.body, n = t.length, i = 0; n > i; i++) this.accept(t[i]);
                        return this.options.blockParams.shift(), (this.isSimple = 1 === n), (this.blockParams = e.blockParams ? e.blockParams.length : 0), this;
                    },
                    BlockStatement: function (e) {
                        u(e);
                        var t = e.program,
                            n = e.inverse;
                        (t = t && this.compileProgram(t)), (n = n && this.compileProgram(n));
                        var i = this.classifySexpr(e);
                        "helper" === i
                            ? this.helperSexpr(e, t, n)
                            : "simple" === i
                            ? (this.simpleSexpr(e), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("blockValue", e.path.original))
                            : (this.ambiguousSexpr(e, t, n), this.opcode("pushProgram", t), this.opcode("pushProgram", n), this.opcode("emptyHash"), this.opcode("ambiguousBlockValue")),
                            this.opcode("append");
                    },
                    DecoratorBlock: function (e) {
                        var t = e.program && this.compileProgram(e.program),
                            n = this.setupFullMustacheParams(e, t, void 0),
                            i = e.path;
                        (this.useDecorators = !0), this.opcode("registerDecorator", n.length, i.original);
                    },
                    PartialStatement: function (e) {
                        this.usePartial = !0;
                        var t = e.program;
                        t && (t = this.compileProgram(e.program));
                        var n = e.params;
                        if (n.length > 1) throw new p.default("Unsupported number of partial arguments: " + n.length, e);
                        n.length || (this.options.explicitPartialContext ? this.opcode("pushLiteral", "undefined") : n.push({ type: "PathExpression", parts: [], depth: 0 }));
                        var i = e.name.original,
                            o = "SubExpression" === e.name.type;
                        o && this.accept(e.name), this.setupFullMustacheParams(e, t, void 0, !0);
                        var r = e.indent || "";
                        this.options.preventIndent && r && (this.opcode("appendContent", r), (r = "")), this.opcode("invokePartial", o, i, r), this.opcode("append");
                    },
                    PartialBlockStatement: function (e) {
                        this.PartialStatement(e);
                    },
                    MustacheStatement: function (e) {
                        this.SubExpression(e), e.escaped && !this.options.noEscape ? this.opcode("appendEscaped") : this.opcode("append");
                    },
                    Decorator: function (e) {
                        this.DecoratorBlock(e);
                    },
                    ContentStatement: function (e) {
                        e.value && this.opcode("appendContent", e.value);
                    },
                    CommentStatement: function () {},
                    SubExpression: function (e) {
                        u(e);
                        var t = this.classifySexpr(e);
                        "simple" === t ? this.simpleSexpr(e) : "helper" === t ? this.helperSexpr(e) : this.ambiguousSexpr(e);
                    },
                    ambiguousSexpr: function (e, t, n) {
                        var i = e.path,
                            o = i.parts[0],
                            r = null != t || null != n;
                        this.opcode("getContext", i.depth), this.opcode("pushProgram", t), this.opcode("pushProgram", n), (i.strict = !0), this.accept(i), this.opcode("invokeAmbiguous", o, r);
                    },
                    simpleSexpr: function (e) {
                        var t = e.path;
                        (t.strict = !0), this.accept(t), this.opcode("resolvePossibleLambda");
                    },
                    helperSexpr: function (e, t, n) {
                        var i = this.setupFullMustacheParams(e, t, n),
                            o = e.path,
                            r = o.parts[0];
                        if (this.options.knownHelpers[r]) this.opcode("invokeKnownHelper", i.length, r);
                        else {
                            if (this.options.knownHelpersOnly) throw new p.default("You specified knownHelpersOnly, but used the unknown helper " + r, e);
                            (o.strict = !0), (o.falsy = !0), this.accept(o), this.opcode("invokeHelper", i.length, o.original, m.default.helpers.simpleId(o));
                        }
                    },
                    PathExpression: function (e) {
                        this.addDepth(e.depth), this.opcode("getContext", e.depth);
                        var t = e.parts[0],
                            n = m.default.helpers.scopedId(e),
                            i = !e.depth && !n && this.blockParamIndex(t);
                        i
                            ? this.opcode("lookupBlockParam", i, e.parts)
                            : t
                            ? e.data
                                ? ((this.options.data = !0), this.opcode("lookupData", e.depth, e.parts, e.strict))
                                : this.opcode("lookupOnContext", e.parts, e.falsy, e.strict, n)
                            : this.opcode("pushContext");
                    },
                    StringLiteral: function (e) {
                        this.opcode("pushString", e.value);
                    },
                    NumberLiteral: function (e) {
                        this.opcode("pushLiteral", e.value);
                    },
                    BooleanLiteral: function (e) {
                        this.opcode("pushLiteral", e.value);
                    },
                    UndefinedLiteral: function () {
                        this.opcode("pushLiteral", "undefined");
                    },
                    NullLiteral: function () {
                        this.opcode("pushLiteral", "null");
                    },
                    Hash: function (e) {
                        var t = e.pairs,
                            n = 0,
                            i = t.length;
                        for (this.opcode("pushHash"); i > n; n++) this.pushParam(t[n].value);
                        for (; n--; ) this.opcode("assignToHash", t[n].key);
                        this.opcode("popHash");
                    },
                    opcode: function (e) {
                        this.opcodes.push({ opcode: e, args: v.call(arguments, 1), loc: this.sourceNode[0].loc });
                    },
                    addDepth: function (e) {
                        e && (this.useDepths = !0);
                    },
                    classifySexpr: function (e) {
                        var t = m.default.helpers.simpleId(e.path),
                            n = t && !!this.blockParamIndex(e.path.parts[0]),
                            i = !n && m.default.helpers.helperExpression(e),
                            o = !n && (i || t);
                        if (o && !i) {
                            var r = e.path.parts[0],
                                s = this.options;
                            s.knownHelpers[r] ? (i = !0) : s.knownHelpersOnly && (o = !1);
                        }
                        return i ? "helper" : o ? "ambiguous" : "simple";
                    },
                    pushParams: function (e) {
                        for (var t = 0, n = e.length; n > t; t++) this.pushParam(e[t]);
                    },
                    pushParam: function (e) {
                        this.accept(e);
                    },
                    setupFullMustacheParams: function (e, t, n, i) {
                        var o = e.params;
                        return this.pushParams(o), this.opcode("pushProgram", t), this.opcode("pushProgram", n), e.hash ? this.accept(e.hash) : this.opcode("emptyHash", i), o;
                    },
                    blockParamIndex: function (e) {
                        for (var t = 0, n = this.options.blockParams.length; n > t; t++) {
                            var i = this.options.blockParams[t],
                                o = i && f.indexOf(i, e);
                            if (i && o >= 0) return [t, o];
                        }
                    },
                };
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                function o(e) {
                    this.value = e;
                }
                function r() {}
                function s(e, t, n, i) {
                    var o = t.popStack(),
                        r = 0,
                        s = n.length;
                    for (e && s--; s > r; r++) o = t.nameLookup(o, n[r], i);
                    return e ? [t.aliasable("container.strict"), "(", o, ", ", t.quotedString(n[r]), ")"] : o;
                }
                t.__esModule = !0;
                var a = n(2),
                    l = n(4),
                    c = i(l),
                    u = n(3),
                    d = n(27),
                    p = i(d);
                (r.prototype = {
                    nameLookup: function (e, t) {
                        return r.isValidJavaScriptVariableName(t) ? [e, ".", t] : [e, "[", JSON.stringify(t), "]"];
                    },
                    depthedLookup: function (e) {
                        return [this.aliasable("container.lookup"), '(depths, "', e, '")'];
                    },
                    compilerInfo: function () {
                        var e = a.COMPILER_REVISION,
                            t = a.REVISION_CHANGES[e];
                        return [e, t];
                    },
                    appendToBuffer: function (e, t, n) {
                        return u.isArray(e) || (e = [e]), (e = this.source.wrap(e, t)), this.environment.isSimple ? ["return ", e, ";"] : n ? ["buffer += ", e, ";"] : ((e.appendToBuffer = !0), e);
                    },
                    initializeBuffer: function () {
                        return this.quotedString("");
                    },
                    compile: function (e, t, n, i) {
                        (this.environment = e),
                            (this.options = t),
                            (this.precompile = !i),
                            (this.name = this.environment.name),
                            (this.isChild = !!n),
                            (this.context = n || { decorators: [], programs: [], environments: [] }),
                            this.preamble(),
                            (this.stackSlot = 0),
                            (this.stackVars = []),
                            (this.aliases = {}),
                            (this.registers = { list: [] }),
                            (this.hashes = []),
                            (this.compileStack = []),
                            (this.inlineStack = []),
                            (this.blockParams = []),
                            this.compileChildren(e, t),
                            (this.useDepths = this.useDepths || e.useDepths || e.useDecorators || this.options.compat),
                            (this.useBlockParams = this.useBlockParams || e.useBlockParams);
                        var o = e.opcodes,
                            r = void 0,
                            s = void 0,
                            a = void 0,
                            l = void 0;
                        for (a = 0, l = o.length; l > a; a++) (r = o[a]), (this.source.currentLocation = r.loc), (s = s || r.loc), this[r.opcode].apply(this, r.args);
                        if (((this.source.currentLocation = s), this.pushSource(""), this.stackSlot || this.inlineStack.length || this.compileStack.length)) throw new c.default("Compile completed with content left on stack");
                        this.decorators.isEmpty()
                            ? (this.decorators = void 0)
                            : ((this.useDecorators = !0),
                              this.decorators.prepend("var decorators = container.decorators;\n"),
                              this.decorators.push("return fn;"),
                              i
                                  ? (this.decorators = Function.apply(this, ["fn", "props", "container", "depth0", "data", "blockParams", "depths", this.decorators.merge()]))
                                  : (this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"), this.decorators.push("}\n"), (this.decorators = this.decorators.merge())));
                        var u = this.createFunctionContext(i);
                        if (this.isChild) return u;
                        var d = { compiler: this.compilerInfo(), main: u };
                        this.decorators && ((d.main_d = this.decorators), (d.useDecorators = !0));
                        var p = this.context,
                            f = p.programs,
                            h = p.decorators;
                        for (a = 0, l = f.length; l > a; a++) f[a] && ((d[a] = f[a]), h[a] && ((d[a + "_d"] = h[a]), (d.useDecorators = !0)));
                        return (
                            this.environment.usePartial && (d.usePartial = !0),
                            this.options.data && (d.useData = !0),
                            this.useDepths && (d.useDepths = !0),
                            this.useBlockParams && (d.useBlockParams = !0),
                            this.options.compat && (d.compat = !0),
                            i
                                ? (d.compilerOptions = this.options)
                                : ((d.compiler = JSON.stringify(d.compiler)),
                                  (this.source.currentLocation = { start: { line: 1, column: 0 } }),
                                  (d = this.objectLiteral(d)),
                                  t.srcName ? ((d = d.toStringWithSourceMap({ file: t.destName })), (d.map = d.map && d.map.toString())) : (d = d.toString())),
                            d
                        );
                    },
                    preamble: function () {
                        (this.lastContext = 0), (this.source = new p.default(this.options.srcName)), (this.decorators = new p.default(this.options.srcName));
                    },
                    createFunctionContext: function (e) {
                        var t = "",
                            n = this.stackVars.concat(this.registers.list);
                        n.length > 0 && (t += ", " + n.join(", "));
                        var i = 0;
                        for (var o in this.aliases) {
                            var r = this.aliases[o];
                            this.aliases.hasOwnProperty(o) && r.children && r.referenceCount > 1 && ((t += ", alias" + ++i + "=" + o), (r.children[0] = "alias" + i));
                        }
                        var s = ["container", "depth0", "helpers", "partials", "data"];
                        (this.useBlockParams || this.useDepths) && s.push("blockParams"), this.useDepths && s.push("depths");
                        var a = this.mergeSource(t);
                        return e ? (s.push(a), Function.apply(this, s)) : this.source.wrap(["function(", s.join(","), ") {\n  ", a, "}"]);
                    },
                    mergeSource: function (e) {
                        var t = this.environment.isSimple,
                            n = !this.forceBuffer,
                            i = void 0,
                            o = void 0,
                            r = void 0,
                            s = void 0;
                        return (
                            this.source.each(function (e) {
                                e.appendToBuffer ? (r ? e.prepend("  + ") : (r = e), (s = e)) : (r && (o ? r.prepend("buffer += ") : (i = !0), s.add(";"), (r = s = void 0)), (o = !0), t || (n = !1));
                            }),
                            n
                                ? r
                                    ? (r.prepend("return "), s.add(";"))
                                    : o || this.source.push('return "";')
                                : ((e += ", buffer = " + (i ? "" : this.initializeBuffer())), r ? (r.prepend("return buffer + "), s.add(";")) : this.source.push("return buffer;")),
                            e && this.source.prepend("var " + e.substring(2) + (i ? "" : ";\n")),
                            this.source.merge()
                        );
                    },
                    blockValue: function (e) {
                        var t = this.aliasable("helpers.blockHelperMissing"),
                            n = [this.contextName(0)];
                        this.setupHelperArgs(e, 0, n);
                        var i = this.popStack();
                        n.splice(1, 0, i), this.push(this.source.functionCall(t, "call", n));
                    },
                    ambiguousBlockValue: function () {
                        var e = this.aliasable("helpers.blockHelperMissing"),
                            t = [this.contextName(0)];
                        this.setupHelperArgs("", 0, t, !0), this.flushInline();
                        var n = this.topStack();
                        t.splice(1, 0, n), this.pushSource(["if (!", this.lastHelper, ") { ", n, " = ", this.source.functionCall(e, "call", t), "}"]);
                    },
                    appendContent: function (e) {
                        this.pendingContent ? (e = this.pendingContent + e) : (this.pendingLocation = this.source.currentLocation), (this.pendingContent = e);
                    },
                    append: function () {
                        if (this.isInline())
                            this.replaceStack(function (e) {
                                return [" != null ? ", e, ' : ""'];
                            }),
                                this.pushSource(this.appendToBuffer(this.popStack()));
                        else {
                            var e = this.popStack();
                            this.pushSource(["if (", e, " != null) { ", this.appendToBuffer(e, void 0, !0), " }"]), this.environment.isSimple && this.pushSource(["else { ", this.appendToBuffer("''", void 0, !0), " }"]);
                        }
                    },
                    appendEscaped: function () {
                        this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"), "(", this.popStack(), ")"]));
                    },
                    getContext: function (e) {
                        this.lastContext = e;
                    },
                    pushContext: function () {
                        this.pushStackLiteral(this.contextName(this.lastContext));
                    },
                    lookupOnContext: function (e, t, n, i) {
                        var o = 0;
                        i || !this.options.compat || this.lastContext ? this.pushContext() : this.push(this.depthedLookup(e[o++])), this.resolvePath("context", e, o, t, n);
                    },
                    lookupBlockParam: function (e, t) {
                        (this.useBlockParams = !0), this.push(["blockParams[", e[0], "][", e[1], "]"]), this.resolvePath("context", t, 1);
                    },
                    lookupData: function (e, t, n) {
                        e ? this.pushStackLiteral("container.data(data, " + e + ")") : this.pushStackLiteral("data"), this.resolvePath("data", t, 0, !0, n);
                    },
                    resolvePath: function (e, t, n, i, o) {
                        var r = this;
                        if (this.options.strict || this.options.assumeObjects) return void this.push(s(this.options.strict && o, this, t, e));
                        for (var a = t.length; a > n; n++)
                            this.replaceStack(function (o) {
                                var s = r.nameLookup(o, t[n], e);
                                return i ? [" && ", s] : [" != null ? ", s, " : ", o];
                            });
                    },
                    resolvePossibleLambda: function () {
                        this.push([this.aliasable("container.lambda"), "(", this.popStack(), ", ", this.contextName(0), ")"]);
                    },
                    emptyHash: function (e) {
                        this.pushStackLiteral(e ? "undefined" : "{}");
                    },
                    pushHash: function () {
                        this.hash && this.hashes.push(this.hash), (this.hash = { values: {} });
                    },
                    popHash: function () {
                        var e = this.hash;
                        (this.hash = this.hashes.pop()), this.push(this.objectLiteral(e.values));
                    },
                    pushString: function (e) {
                        this.pushStackLiteral(this.quotedString(e));
                    },
                    pushLiteral: function (e) {
                        this.pushStackLiteral(e);
                    },
                    pushProgram: function (e) {
                        null != e ? this.pushStackLiteral(this.programExpression(e)) : this.pushStackLiteral(null);
                    },
                    registerDecorator: function (e, t) {
                        var n = this.nameLookup("decorators", t, "decorator"),
                            i = this.setupHelperArgs(t, e);
                        this.decorators.push(["fn = ", this.decorators.functionCall(n, "", ["fn", "props", "container", i]), " || fn;"]);
                    },
                    invokeHelper: function (e, t, n) {
                        var i = this.popStack(),
                            o = this.setupHelper(e, t),
                            r = n ? [o.name, " || "] : "",
                            s = ["("].concat(r, i);
                        this.options.strict || s.push(" || ", this.aliasable("helpers.helperMissing")), s.push(")"), this.push(this.source.functionCall(s, "call", o.callParams));
                    },
                    invokeKnownHelper: function (e, t) {
                        var n = this.setupHelper(e, t);
                        this.push(this.source.functionCall(n.name, "call", n.callParams));
                    },
                    invokeAmbiguous: function (e, t) {
                        this.useRegister("helper");
                        var n = this.popStack();
                        this.emptyHash();
                        var i = this.setupHelper(0, e, t),
                            o = (this.lastHelper = this.nameLookup("helpers", e, "helper")),
                            r = ["(", "(helper = ", o, " || ", n, ")"];
                        this.options.strict || ((r[0] = "(helper = "), r.push(" != null ? helper : ", this.aliasable("helpers.helperMissing"))),
                            this.push(["(", r, i.paramsInit ? ["),(", i.paramsInit] : [], "),", "(typeof helper === ", this.aliasable('"function"'), " ? ", this.source.functionCall("helper", "call", i.callParams), " : helper))"]);
                    },
                    invokePartial: function (e, t, n) {
                        var i = [],
                            o = this.setupParams(t, 1, i);
                        e && ((t = this.popStack()), delete o.name),
                            n && (o.indent = JSON.stringify(n)),
                            (o.helpers = "helpers"),
                            (o.partials = "partials"),
                            (o.decorators = "container.decorators"),
                            e ? i.unshift(t) : i.unshift(this.nameLookup("partials", t, "partial")),
                            this.options.compat && (o.depths = "depths"),
                            (o = this.objectLiteral(o)),
                            i.push(o),
                            this.push(this.source.functionCall("container.invokePartial", "", i));
                    },
                    assignToHash: function (e) {
                        this.hash.values[e] = this.popStack();
                    },
                    compiler: r,
                    compileChildren: function (e, t) {
                        for (var n = e.children, i = void 0, o = void 0, r = 0, s = n.length; s > r; r++) {
                            (i = n[r]), (o = new this.compiler());
                            var a = this.matchExistingProgram(i);
                            if (null == a) {
                                this.context.programs.push("");
                                var l = this.context.programs.length;
                                (i.index = l),
                                    (i.name = "program" + l),
                                    (this.context.programs[l] = o.compile(i, t, this.context, !this.precompile)),
                                    (this.context.decorators[l] = o.decorators),
                                    (this.context.environments[l] = i),
                                    (this.useDepths = this.useDepths || o.useDepths),
                                    (this.useBlockParams = this.useBlockParams || o.useBlockParams),
                                    (i.useDepths = this.useDepths),
                                    (i.useBlockParams = this.useBlockParams);
                            } else (i.index = a.index), (i.name = "program" + a.index), (this.useDepths = this.useDepths || a.useDepths), (this.useBlockParams = this.useBlockParams || a.useBlockParams);
                        }
                    },
                    matchExistingProgram: function (e) {
                        for (var t = 0, n = this.context.environments.length; n > t; t++) {
                            var i = this.context.environments[t];
                            if (i && i.equals(e)) return i;
                        }
                    },
                    programExpression: function (e) {
                        var t = this.environment.children[e],
                            n = [t.index, "data", t.blockParams];
                        return (this.useBlockParams || this.useDepths) && n.push("blockParams"), this.useDepths && n.push("depths"), "container.program(" + n.join(", ") + ")";
                    },
                    useRegister: function (e) {
                        this.registers[e] || ((this.registers[e] = !0), this.registers.list.push(e));
                    },
                    push: function (e) {
                        return e instanceof o || (e = this.source.wrap(e)), this.inlineStack.push(e), e;
                    },
                    pushStackLiteral: function (e) {
                        this.push(new o(e));
                    },
                    pushSource: function (e) {
                        this.pendingContent && (this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation)), (this.pendingContent = void 0)), e && this.source.push(e);
                    },
                    replaceStack: function (e) {
                        var t = ["("],
                            n = void 0,
                            i = void 0,
                            r = void 0;
                        if (!this.isInline()) throw new c.default("replaceStack on non-inline");
                        var s = this.popStack(!0);
                        if (s instanceof o) (n = [s.value]), (t = ["(", n]), (r = !0);
                        else {
                            i = !0;
                            var a = this.incrStack();
                            (t = ["((", this.push(a), " = ", s, ")"]), (n = this.topStack());
                        }
                        var l = e.call(this, n);
                        r || this.popStack(), i && this.stackSlot--, this.push(t.concat(l, ")"));
                    },
                    incrStack: function () {
                        return this.stackSlot++, this.stackSlot > this.stackVars.length && this.stackVars.push("stack" + this.stackSlot), this.topStackName();
                    },
                    topStackName: function () {
                        return "stack" + this.stackSlot;
                    },
                    flushInline: function () {
                        var e = this.inlineStack;
                        this.inlineStack = [];
                        for (var t = 0, n = e.length; n > t; t++) {
                            var i = e[t];
                            if (i instanceof o) this.compileStack.push(i);
                            else {
                                var r = this.incrStack();
                                this.pushSource([r, " = ", i, ";"]), this.compileStack.push(r);
                            }
                        }
                    },
                    isInline: function () {
                        return this.inlineStack.length;
                    },
                    popStack: function (e) {
                        var t = this.isInline(),
                            n = (t ? this.inlineStack : this.compileStack).pop();
                        if (!e && n instanceof o) return n.value;
                        if (!t) {
                            if (!this.stackSlot) throw new c.default("Invalid stack pop");
                            this.stackSlot--;
                        }
                        return n;
                    },
                    topStack: function () {
                        var e = this.isInline() ? this.inlineStack : this.compileStack,
                            t = e[e.length - 1];
                        return t instanceof o ? t.value : t;
                    },
                    contextName: function (e) {
                        return this.useDepths && e ? "depths[" + e + "]" : "depth" + e;
                    },
                    quotedString: function (e) {
                        return this.source.quotedString(e);
                    },
                    objectLiteral: function (e) {
                        return this.source.objectLiteral(e);
                    },
                    aliasable: function (e) {
                        var t = this.aliases[e];
                        return t ? (t.referenceCount++, t) : ((t = this.aliases[e] = this.source.wrap(e)), (t.aliasable = !0), (t.referenceCount = 1), t);
                    },
                    setupHelper: function (e, t, n) {
                        var i = [],
                            o = this.setupHelperArgs(t, e, i, n),
                            r = this.nameLookup("helpers", t, "helper"),
                            s = this.aliasable(this.contextName(0) + " != null ? " + this.contextName(0) + " : {}");
                        return { params: i, paramsInit: o, name: r, callParams: [s].concat(i) };
                    },
                    setupParams: function (e, t, n) {
                        var i = {},
                            o = !n,
                            r = void 0;
                        o && (n = []), (i.name = this.quotedString(e)), (i.hash = this.popStack());
                        var s = this.popStack(),
                            a = this.popStack();
                        (a || s) && ((i.fn = a || "container.noop"), (i.inverse = s || "container.noop"));
                        for (var l = t; l--; ) (r = this.popStack()), (n[l] = r);
                        return o && (i.args = this.source.generateArray(n)), this.options.data && (i.data = "data"), this.useBlockParams && (i.blockParams = "blockParams"), i;
                    },
                    setupHelperArgs: function (e, t, n, i) {
                        var o = this.setupParams(e, t, n);
                        return (o = this.objectLiteral(o)), i ? (this.useRegister("options"), n.push("options"), ["options=", o]) : n ? (n.push(o), "") : o;
                    },
                }),
                    (function () {
                        for (
                            var e = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                                    " "
                                ),
                                t = (r.RESERVED_WORDS = {}),
                                n = 0,
                                i = e.length;
                            i > n;
                            n++
                        )
                            t[e[n]] = !0;
                    })(),
                    (r.isValidJavaScriptVariableName = function (e) {
                        return !r.RESERVED_WORDS[e] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e);
                    }),
                    (t.default = r),
                    (e.exports = t.default);
            },
            function (e, t, n) {
                "use strict";
                function i(e, t, n) {
                    if (r.isArray(e)) {
                        for (var i = [], o = 0, s = e.length; s > o; o++) i.push(t.wrap(e[o], n));
                        return i;
                    }
                    return "boolean" == typeof e || "number" == typeof e ? e + "" : e;
                }
                function o(e) {
                    (this.srcFile = e), (this.source = []);
                }
                t.__esModule = !0;
                var r = n(3),
                    s = void 0;
                try {
                } catch (e) {}
                s ||
                    ((s = function (e, t, n, i) {
                        (this.src = ""), i && this.add(i);
                    }),
                    (s.prototype = {
                        add: function (e) {
                            r.isArray(e) && (e = e.join("")), (this.src += e);
                        },
                        prepend: function (e) {
                            r.isArray(e) && (e = e.join("")), (this.src = e + this.src);
                        },
                        toStringWithSourceMap: function () {
                            return { code: this.toString() };
                        },
                        toString: function () {
                            return this.src;
                        },
                    })),
                    (o.prototype = {
                        isEmpty: function () {
                            return !this.source.length;
                        },
                        prepend: function (e, t) {
                            this.source.unshift(this.wrap(e, t));
                        },
                        push: function (e, t) {
                            this.source.push(this.wrap(e, t));
                        },
                        merge: function () {
                            var e = this.empty();
                            return (
                                this.each(function (t) {
                                    e.add(["  ", t, "\n"]);
                                }),
                                e
                            );
                        },
                        each: function (e) {
                            for (var t = 0, n = this.source.length; n > t; t++) e(this.source[t]);
                        },
                        empty: function () {
                            var e = this.currentLocation || { start: {} };
                            return new s(e.start.line, e.start.column, this.srcFile);
                        },
                        wrap: function (e) {
                            var t = arguments.length <= 1 || void 0 === arguments[1] ? this.currentLocation || { start: {} } : arguments[1];
                            return e instanceof s ? e : ((e = i(e, this, t)), new s(t.start.line, t.start.column, this.srcFile, e));
                        },
                        functionCall: function (e, t, n) {
                            return (n = this.generateList(n)), this.wrap([e, t ? "." + t + "(" : "(", n, ")"]);
                        },
                        quotedString: function (e) {
                            return (
                                '"' +
                                (e + "")
                                    .replace(/\\/g, "\\\\")
                                    .replace(/"/g, '\\"')
                                    .replace(/\n/g, "\\n")
                                    .replace(/\r/g, "\\r")
                                    .replace(/\u2028/g, "\\u2028")
                                    .replace(/\u2029/g, "\\u2029") +
                                '"'
                            );
                        },
                        objectLiteral: function (e) {
                            var t = [];
                            for (var n in e)
                                if (e.hasOwnProperty(n)) {
                                    var o = i(e[n], this);
                                    "undefined" !== o && t.push([this.quotedString(n), ":", o]);
                                }
                            var r = this.generateList(t);
                            return r.prepend("{"), r.add("}"), r;
                        },
                        generateList: function (e) {
                            for (var t = this.empty(), n = 0, o = e.length; o > n; n++) n && t.add(","), t.add(i(e[n], this));
                            return t;
                        },
                        generateArray: function (e) {
                            var t = this.generateList(e);
                            return t.prepend("["), t.add("]"), t;
                        },
                    }),
                    (t.default = o),
                    (e.exports = t.default);
            },
        ]);
    }),
    !(function (e) {
        e.fn.prepareTransition = function () {
            return this.each(function () {
                var t = e(this);
                t.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function () {
                    t.removeClass("is-transitioning");
                });
                var n = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"],
                    i = 0;
                e.each(n, function (e, n) {
                    i = parseFloat(t.css(n)) || i;
                }),
                    0 != i && (t.addClass("is-transitioning"), t[0].offsetWidth);
            });
        };
    })(jQuery),
    (function (e, t) {
        var n,
            i = e.jQuery || e.Cowboy || (e.Cowboy = {});
        (i.throttle = n = function (e, n, o, r) {
            function s() {
                function i() {
                    (l = +new Date()), o.apply(c, d);
                }
                function s() {
                    a = t;
                }
                var c = this,
                    u = +new Date() - l,
                    d = arguments;
                r && !a && i(), a && clearTimeout(a), r === t && u > e ? i() : n !== !0 && (a = setTimeout(r ? s : i, r === t ? e - u : e));
            }
            var a,
                l = 0;
            return "boolean" != typeof n && ((r = o), (o = n), (n = t)), i.guid && (s.guid = o.guid = o.guid || i.guid++), s;
        }),
            (i.debounce = function (e, i, o) {
                return o === t ? n(e, i, !1) : n(e, o, i !== !1);
            });
    })(this),
    !(function (e, t) {
        "object" == typeof exports && "object" == typeof module ? (module.exports = t()) : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? (exports.AOS = t()) : (e.AOS = t());
    })(this, function () {
        return (function (e) {
            function t(i) {
                if (n[i]) return n[i].exports;
                var o = (n[i] = { exports: {}, id: i, loaded: !1 });
                return e[i].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
            }
            var n = {};
            return (t.m = e), (t.c = n), (t.p = "dist/"), t(0);
        })([
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                var o =
                        Object.assign ||
                        function (e) {
                            for (var t = 1; t < arguments.length; t++) {
                                var n = arguments[t];
                                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                            }
                            return e;
                        },
                    r = n(1),
                    s = (i(r), n(6)),
                    a = i(s),
                    l = n(7),
                    c = i(l),
                    u = n(8),
                    d = i(u),
                    p = n(9),
                    f = i(p),
                    h = n(10),
                    m = i(h),
                    v = n(11),
                    g = i(v),
                    y = n(14),
                    b = i(y),
                    w = [],
                    x = !1,
                    k = document.all && !window.atob,
                    S = { offset: 120, delay: 0, easing: "ease", duration: 400, disable: !1, once: !1, startEvent: "DOMContentLoaded", disableMutationObserver: !1 },
                    C = function () {
                        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        if ((e && (x = !0), x)) return (w = (0, g.default)(w, S)), (0, m.default)(w, S.once), w;
                    },
                    T = function () {
                        (w = (0, b.default)()), C();
                    },
                    E = function () {
                        w.forEach(function (e, t) {
                            e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
                        });
                    },
                    A = function (e) {
                        return e === !0 || ("mobile" === e && f.default.mobile()) || ("phone" === e && f.default.phone()) || ("tablet" === e && f.default.tablet()) || ("function" == typeof e && e() === !0);
                    },
                    _ = function (e) {
                        return (
                            (S = o(S, e)),
                            (w = (0, b.default)()),
                            A(S.disable) || k
                                ? E()
                                : (document.querySelector("body").setAttribute("data-aos-easing", S.easing),
                                  document.querySelector("body").setAttribute("data-aos-duration", S.duration),
                                  document.querySelector("body").setAttribute("data-aos-delay", S.delay),
                                  "DOMContentLoaded" === S.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1
                                      ? C(!0)
                                      : "load" === S.startEvent
                                      ? window.addEventListener(S.startEvent, function () {
                                            C(!0);
                                        })
                                      : document.addEventListener(S.startEvent, function () {
                                            C(!0);
                                        }),
                                  window.addEventListener("resize", (0, c.default)(C, 50, !0)),
                                  window.addEventListener("orientationchange", (0, c.default)(C, 50, !0)),
                                  window.addEventListener(
                                      "scroll",
                                      (0, a.default)(function () {
                                          (0, m.default)(w, S.once);
                                      }, 99)
                                  ),
                                  S.disableMutationObserver || (0, d.default)("[data-aos]", T),
                                  w)
                        );
                    };
                e.exports = { init: _, refresh: C, refreshHard: T };
            },
            function (e, t) {},
            ,
            ,
            ,
            ,
            function (e, t) {
                (function (t) {
                    "use strict";
                    function n(e, t, n) {
                        function i(t) {
                            var n = m,
                                i = v;
                            return (m = v = void 0), (x = t), (y = e.apply(i, n));
                        }
                        function r(e) {
                            return (x = e), (b = setTimeout(u, t)), T ? i(e) : y;
                        }
                        function s(e) {
                            var n = e - w,
                                i = e - x,
                                o = t - n;
                            return E ? S(o, g - i) : o;
                        }
                        function l(e) {
                            var n = e - w,
                                i = e - x;
                            return void 0 === w || n >= t || n < 0 || (E && i >= g);
                        }
                        function u() {
                            var e = C();
                            return l(e) ? d(e) : void (b = setTimeout(u, s(e)));
                        }
                        function d(e) {
                            return (b = void 0), A && m ? i(e) : ((m = v = void 0), y);
                        }
                        function p() {
                            void 0 !== b && clearTimeout(b), (x = 0), (m = w = v = b = void 0);
                        }
                        function f() {
                            return void 0 === b ? y : d(C());
                        }
                        function h() {
                            var e = C(),
                                n = l(e);
                            if (((m = arguments), (v = this), (w = e), n)) {
                                if (void 0 === b) return r(w);
                                if (E) return (b = setTimeout(u, t)), i(w);
                            }
                            return void 0 === b && (b = setTimeout(u, t)), y;
                        }
                        var m,
                            v,
                            g,
                            y,
                            b,
                            w,
                            x = 0,
                            T = !1,
                            E = !1,
                            A = !0;
                        if ("function" != typeof e) throw new TypeError(c);
                        return (t = a(t) || 0), o(n) && ((T = !!n.leading), (E = "maxWait" in n), (g = E ? k(a(n.maxWait) || 0, t) : g), (A = "trailing" in n ? !!n.trailing : A)), (h.cancel = p), (h.flush = f), h;
                    }
                    function i(e, t, i) {
                        var r = !0,
                            s = !0;
                        if ("function" != typeof e) throw new TypeError(c);
                        return o(i) && ((r = "leading" in i ? !!i.leading : r), (s = "trailing" in i ? !!i.trailing : s)), n(e, t, { leading: r, maxWait: t, trailing: s });
                    }
                    function o(e) {
                        var t = "undefined" == typeof e ? "undefined" : l(e);
                        return !!e && ("object" == t || "function" == t);
                    }
                    function r(e) {
                        return !!e && "object" == ("undefined" == typeof e ? "undefined" : l(e));
                    }
                    function s(e) {
                        return "symbol" == ("undefined" == typeof e ? "undefined" : l(e)) || (r(e) && x.call(e) == d);
                    }
                    function a(e) {
                        if ("number" == typeof e) return e;
                        if (s(e)) return u;
                        if (o(e)) {
                            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                            e = o(t) ? t + "" : t;
                        }
                        if ("string" != typeof e) return 0 === e ? e : +e;
                        e = e.replace(p, "");
                        var n = h.test(e);
                        return n || m.test(e) ? v(e.slice(2), n ? 2 : 8) : f.test(e) ? u : +e;
                    }
                    var l =
                            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                ? function (e) {
                                      return typeof e;
                                  }
                                : function (e) {
                                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                  },
                        c = "Expected a function",
                        u = NaN,
                        d = "[object Symbol]",
                        p = /^\s+|\s+$/g,
                        f = /^[-+]0x[0-9a-f]+$/i,
                        h = /^0b[01]+$/i,
                        m = /^0o[0-7]+$/i,
                        v = parseInt,
                        g = "object" == ("undefined" == typeof t ? "undefined" : l(t)) && t && t.Object === Object && t,
                        y = "object" == ("undefined" == typeof self ? "undefined" : l(self)) && self && self.Object === Object && self,
                        b = g || y || Function("return this")(),
                        w = Object.prototype,
                        x = w.toString,
                        k = Math.max,
                        S = Math.min,
                        C = function () {
                            return b.Date.now();
                        };
                    e.exports = i;
                }.call(
                    t,
                    (function () {
                        return this;
                    })()
                ));
            },
            function (e, t) {
                (function (t) {
                    "use strict";
                    function n(e, t, n) {
                        function o(t) {
                            var n = m,
                                i = v;
                            return (m = v = void 0), (C = t), (y = e.apply(i, n));
                        }
                        function r(e) {
                            return (C = e), (b = setTimeout(u, t)), T ? o(e) : y;
                        }
                        function a(e) {
                            var n = e - w,
                                i = e - C,
                                o = t - n;
                            return E ? k(o, g - i) : o;
                        }
                        function c(e) {
                            var n = e - w,
                                i = e - C;
                            return void 0 === w || n >= t || n < 0 || (E && i >= g);
                        }
                        function u() {
                            var e = S();
                            return c(e) ? d(e) : void (b = setTimeout(u, a(e)));
                        }
                        function d(e) {
                            return (b = void 0), A && m ? o(e) : ((m = v = void 0), y);
                        }
                        function p() {
                            void 0 !== b && clearTimeout(b), (C = 0), (m = w = v = b = void 0);
                        }
                        function f() {
                            return void 0 === b ? y : d(S());
                        }
                        function h() {
                            var e = S(),
                                n = c(e);
                            if (((m = arguments), (v = this), (w = e), n)) {
                                if (void 0 === b) return r(w);
                                if (E) return (b = setTimeout(u, t)), o(w);
                            }
                            return void 0 === b && (b = setTimeout(u, t)), y;
                        }
                        var m,
                            v,
                            g,
                            y,
                            b,
                            w,
                            C = 0,
                            T = !1,
                            E = !1,
                            A = !0;
                        if ("function" != typeof e) throw new TypeError(l);
                        return (t = s(t) || 0), i(n) && ((T = !!n.leading), (E = "maxWait" in n), (g = E ? x(s(n.maxWait) || 0, t) : g), (A = "trailing" in n ? !!n.trailing : A)), (h.cancel = p), (h.flush = f), h;
                    }
                    function i(e) {
                        var t = "undefined" == typeof e ? "undefined" : a(e);
                        return !!e && ("object" == t || "function" == t);
                    }
                    function o(e) {
                        return !!e && "object" == ("undefined" == typeof e ? "undefined" : a(e));
                    }
                    function r(e) {
                        return "symbol" == ("undefined" == typeof e ? "undefined" : a(e)) || (o(e) && w.call(e) == u);
                    }
                    function s(e) {
                        if ("number" == typeof e) return e;
                        if (r(e)) return c;
                        if (i(e)) {
                            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                            e = i(t) ? t + "" : t;
                        }
                        if ("string" != typeof e) return 0 === e ? e : +e;
                        e = e.replace(d, "");
                        var n = f.test(e);
                        return n || h.test(e) ? m(e.slice(2), n ? 2 : 8) : p.test(e) ? c : +e;
                    }
                    var a =
                            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                ? function (e) {
                                      return typeof e;
                                  }
                                : function (e) {
                                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                  },
                        l = "Expected a function",
                        c = NaN,
                        u = "[object Symbol]",
                        d = /^\s+|\s+$/g,
                        p = /^[-+]0x[0-9a-f]+$/i,
                        f = /^0b[01]+$/i,
                        h = /^0o[0-7]+$/i,
                        m = parseInt,
                        v = "object" == ("undefined" == typeof t ? "undefined" : a(t)) && t && t.Object === Object && t,
                        g = "object" == ("undefined" == typeof self ? "undefined" : a(self)) && self && self.Object === Object && self,
                        y = v || g || Function("return this")(),
                        b = Object.prototype,
                        w = b.toString,
                        x = Math.max,
                        k = Math.min,
                        S = function () {
                            return y.Date.now();
                        };
                    e.exports = n;
                }.call(
                    t,
                    (function () {
                        return this;
                    })()
                ));
            },
            function (e, t) {
                "use strict";
                function n(e, t) {
                    var n = new r(i);
                    (s = t), n.observe(o.documentElement, { childList: !0, subtree: !0, removedNodes: !0 });
                }
                function i(e) {
                    e &&
                        e.forEach(function (e) {
                            var t = Array.prototype.slice.call(e.addedNodes),
                                n = Array.prototype.slice.call(e.removedNodes),
                                i = t.concat(n).filter(function (e) {
                                    return e.hasAttribute && e.hasAttribute("data-aos");
                                }).length;
                            i && s();
                        });
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var o = window.document,
                    r = window.MutationObserver || window.WebKitMutationObserver,
                    s = function () {};
                t.default = n;
            },
            function (e, t) {
                "use strict";
                function n(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function i() {
                    return navigator.userAgent || navigator.vendor || window.opera || "";
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var o = (function () {
                        function e(e, t) {
                            for (var n = 0; n < t.length; n++) {
                                var i = t[n];
                                (i.enumerable = i.enumerable || !1), (i.configurable = !0), "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                            }
                        }
                        return function (t, n, i) {
                            return n && e(t.prototype, n), i && e(t, i), t;
                        };
                    })(),
                    r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
                    s = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
                    a = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
                    l = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
                    c = (function () {
                        function e() {
                            n(this, e);
                        }
                        return (
                            o(e, [
                                {
                                    key: "phone",
                                    value: function () {
                                        var e = i();
                                        return !(!r.test(e) && !s.test(e.substr(0, 4)));
                                    },
                                },
                                {
                                    key: "mobile",
                                    value: function () {
                                        var e = i();
                                        return !(!a.test(e) && !l.test(e.substr(0, 4)));
                                    },
                                },
                                {
                                    key: "tablet",
                                    value: function () {
                                        return this.mobile() && !this.phone();
                                    },
                                },
                            ]),
                            e
                        );
                    })();
                t.default = new c();
            },
            function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = function (e, t, n) {
                        var i = e.node.getAttribute("data-aos-once");
                        t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof i && ("false" === i || (!n && "true" !== i)) && e.node.classList.remove("aos-animate");
                    },
                    i = function (e, t) {
                        var i = window.pageYOffset,
                            o = window.innerHeight;
                        e.forEach(function (e, r) {
                            n(e, o + i, t);
                        });
                    };
                t.default = i;
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var o = n(12),
                    r = i(o),
                    s = function (e, t) {
                        return (
                            e.forEach(function (e, n) {
                                e.node.classList.add("aos-init"), (e.position = (0, r.default)(e.node, t.offset));
                            }),
                            e
                        );
                    };
                t.default = s;
            },
            function (e, t, n) {
                "use strict";
                function i(e) {
                    return e && e.__esModule ? e : { default: e };
                }
                Object.defineProperty(t, "__esModule", { value: !0 });
                var o = n(13),
                    r = i(o),
                    s = function (e, t) {
                        var n = 0,
                            i = 0,
                            o = window.innerHeight,
                            s = { offset: e.getAttribute("data-aos-offset"), anchor: e.getAttribute("data-aos-anchor"), anchorPlacement: e.getAttribute("data-aos-anchor-placement") };
                        switch ((s.offset && !isNaN(s.offset) && (i = parseInt(s.offset)), s.anchor && document.querySelectorAll(s.anchor) && (e = document.querySelectorAll(s.anchor)[0]), (n = (0, r.default)(e).top), s.anchorPlacement)) {
                            case "top-bottom":
                                break;
                            case "center-bottom":
                                n += e.offsetHeight / 2;
                                break;
                            case "bottom-bottom":
                                n += e.offsetHeight;
                                break;
                            case "top-center":
                                n += o / 2;
                                break;
                            case "bottom-center":
                                n += o / 2 + e.offsetHeight;
                                break;
                            case "center-center":
                                n += o / 2 + e.offsetHeight / 2;
                                break;
                            case "top-top":
                                n += o;
                                break;
                            case "bottom-top":
                                n += e.offsetHeight + o;
                                break;
                            case "center-top":
                                n += e.offsetHeight / 2 + o;
                        }
                        return s.anchorPlacement || s.offset || isNaN(t) || (i = t), n + i;
                    };
                t.default = s;
            },
            function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = function (e) {
                    for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop); )
                        (t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0)), (n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0)), (e = e.offsetParent);
                    return { top: n, left: t };
                };
                t.default = n;
            },
            function (e, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", { value: !0 });
                var n = function (e) {
                    e = e || document.querySelectorAll("[data-aos]");
                    var t = [];
                    return (
                        [].forEach.call(e, function (e, n) {
                            t.push({ node: e });
                        }),
                        t
                    );
                };
                t.default = n;
            },
        ]);
    }),
    (function (e) {
        var t = !1;
        if (("function" == typeof define && define.amd && (define(e), (t = !0)), "object" == typeof exports && ((module.exports = e()), (t = !0)), !t)) {
            var n = window.Cookies,
                i = (window.Cookies = e());
            i.noConflict = function () {
                return (window.Cookies = n), i;
            };
        }
    })(function () {
        function e() {
            for (var e = 0, t = {}; e < arguments.length; e++) {
                var n = arguments[e];
                for (var i in n) t[i] = n[i];
            }
            return t;
        }
        function t(n) {
            function i(t, o, r) {
                var s;
                if ("undefined" != typeof document) {
                    if (arguments.length > 1) {
                        if (((r = e({ path: "/" }, i.defaults, r)), "number" == typeof r.expires)) {
                            var a = new Date();
                            a.setMilliseconds(a.getMilliseconds() + 864e5 * r.expires), (r.expires = a);
                        }
                        r.expires = r.expires ? r.expires.toUTCString() : "";
                        try {
                            (s = JSON.stringify(o)), /^[\{\[]/.test(s) && (o = s);
                        } catch (e) {}
                        (o = n.write ? n.write(o, t) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent)),
                            (t = encodeURIComponent(String(t))),
                            (t = t.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)),
                            (t = t.replace(/[\(\)]/g, escape));
                        var l = "";
                        for (var c in r) r[c] && ((l += "; " + c), r[c] !== !0 && (l += "=" + r[c]));
                        return (document.cookie = t + "=" + o + l);
                    }
                    t || (s = {});
                    for (var u = document.cookie ? document.cookie.split("; ") : [], d = /(%[0-9A-Z]{2})+/g, p = 0; p < u.length; p++) {
                        var f = u[p].split("="),
                            h = f.slice(1).join("=");
                        this.json || '"' !== h.charAt(0) || (h = h.slice(1, -1));
                        try {
                            var m = f[0].replace(d, decodeURIComponent);
                            if (((h = n.read ? n.read(h, m) : n(h, m) || h.replace(d, decodeURIComponent)), this.json))
                                try {
                                    h = JSON.parse(h);
                                } catch (e) {}
                            if (t === m) {
                                s = h;
                                break;
                            }
                            t || (s[m] = h);
                        } catch (e) {}
                    }
                    return s;
                }
            }
            return (
                (i.set = i),
                (i.get = function (e) {
                    return i.call(i, e);
                }),
                (i.getJSON = function () {
                    return i.apply({ json: !0 }, [].slice.call(arguments));
                }),
                (i.defaults = {}),
                (i.remove = function (t, n) {
                    i(t, "", e(n, { expires: -1 }));
                }),
                (i.withConverter = t),
                i
            );
        }
        return t(function () {});
    }),
    (function (e, t) {
        "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipe = t());
    })(this, function () {
        "use strict";
        var e = function (e, t, n, i) {
            var o = {
                features: null,
                bind: function (e, t, n, i) {
                    var o = (i ? "remove" : "add") + "EventListener";
                    t = t.split(" ");
                    for (var r = 0; r < t.length; r++) t[r] && e[o](t[r], n, !1);
                },
                isArray: function (e) {
                    return e instanceof Array;
                },
                createEl: function (e, t) {
                    var n = document.createElement(t || "div");
                    return e && (n.className = e), n;
                },
                getScrollY: function () {
                    var e = window.pageYOffset;
                    return void 0 !== e ? e : document.documentElement.scrollTop;
                },
                unbind: function (e, t, n) {
                    o.bind(e, t, n, !0);
                },
                removeClass: function (e, t) {
                    var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                    e.className = e.className
                        .replace(n, " ")
                        .replace(/^\s\s*/, "")
                        .replace(/\s\s*$/, "");
                },
                addClass: function (e, t) {
                    o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t);
                },
                hasClass: function (e, t) {
                    return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className);
                },
                getChildByClass: function (e, t) {
                    for (var n = e.firstChild; n; ) {
                        if (o.hasClass(n, t)) return n;
                        n = n.nextSibling;
                    }
                },
                arraySearch: function (e, t, n) {
                    for (var i = e.length; i--; ) if (e[i][n] === t) return i;
                    return -1;
                },
                extend: function (e, t, n) {
                    for (var i in t)
                        if (t.hasOwnProperty(i)) {
                            if (n && e.hasOwnProperty(i)) continue;
                            e[i] = t[i];
                        }
                },
                easing: {
                    sine: {
                        out: function (e) {
                            return Math.sin(e * (Math.PI / 2));
                        },
                        inOut: function (e) {
                            return -(Math.cos(Math.PI * e) - 1) / 2;
                        },
                    },
                    cubic: {
                        out: function (e) {
                            return --e * e * e + 1;
                        },
                    },
                },
                detectFeatures: function () {
                    if (o.features) return o.features;
                    var e = o.createEl(),
                        t = e.style,
                        n = "",
                        i = {};
                    if (
                        ((i.oldIE = document.all && !document.addEventListener),
                        (i.touch = "ontouchstart" in window),
                        window.requestAnimationFrame && ((i.raf = window.requestAnimationFrame), (i.caf = window.cancelAnimationFrame)),
                        (i.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled),
                        !i.pointerEvent)
                    ) {
                        var r = navigator.userAgent;
                        if (/iP(hone|od)/.test(navigator.platform)) {
                            var s = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                            s && s.length > 0 && ((s = parseInt(s[1], 10)), s >= 1 && s < 8 && (i.isOldIOSPhone = !0));
                        }
                        var a = r.match(/Android\s([0-9\.]*)/),
                            l = a ? a[1] : 0;
                        (l = parseFloat(l)), l >= 1 && (l < 4.4 && (i.isOldAndroid = !0), (i.androidVersion = l)), (i.isMobileOpera = /opera mini|opera mobi/i.test(r));
                    }
                    for (var c, u, d = ["transform", "perspective", "animationName"], p = ["", "webkit", "Moz", "ms", "O"], f = 0; f < 4; f++) {
                        n = p[f];
                        for (var h = 0; h < 3; h++) (c = d[h]), (u = n + (n ? c.charAt(0).toUpperCase() + c.slice(1) : c)), !i[c] && u in t && (i[c] = u);
                        n && !i.raf && ((n = n.toLowerCase()), (i.raf = window[n + "RequestAnimationFrame"]), i.raf && (i.caf = window[n + "CancelAnimationFrame"] || window[n + "CancelRequestAnimationFrame"]));
                    }
                    if (!i.raf) {
                        var m = 0;
                        (i.raf = function (e) {
                            var t = new Date().getTime(),
                                n = Math.max(0, 16 - (t - m)),
                                i = window.setTimeout(function () {
                                    e(t + n);
                                }, n);
                            return (m = t + n), i;
                        }),
                            (i.caf = function (e) {
                                clearTimeout(e);
                            });
                    }
                    return (i.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect), (o.features = i), i;
                },
            };
            o.detectFeatures(),
                o.features.oldIE &&
                    (o.bind = function (e, t, n, i) {
                        t = t.split(" ");
                        for (
                            var o,
                                r = (i ? "detach" : "attach") + "Event",
                                s = function () {
                                    n.handleEvent.call(n);
                                },
                                a = 0;
                            a < t.length;
                            a++
                        )
                            if ((o = t[a]))
                                if ("object" == typeof n && n.handleEvent) {
                                    if (i) {
                                        if (!n["oldIE" + o]) return !1;
                                    } else n["oldIE" + o] = s;
                                    e[r]("on" + o, n["oldIE" + o]);
                                } else e[r]("on" + o, n);
                    });
            var r = this,
                s = 25,
                a = 3,
                l = {
                    allowPanToNext: !0,
                    spacing: 0.12,
                    bgOpacity: 1,
                    mouseUsed: !1,
                    loop: !0,
                    pinchToClose: !0,
                    closeOnScroll: !0,
                    closeOnVerticalDrag: !0,
                    verticalDragRange: 0.75,
                    hideAnimationDuration: 333,
                    showAnimationDuration: 333,
                    showHideOpacity: !1,
                    focus: !0,
                    escKey: !0,
                    arrowKeys: !0,
                    mainScrollEndFriction: 0.35,
                    panEndFriction: 0.35,
                    isClickableElement: function (e) {
                        return "A" === e.tagName;
                    },
                    getDoubleTapZoom: function (e, t) {
                        return e ? 1 : t.initialZoomLevel < 0.7 ? 1 : 1.33;
                    },
                    maxSpreadZoom: 1.33,
                    modal: !0,
                    scaleMode: "fit",
                };
            o.extend(l, i);
            var c,
                u,
                d,
                p,
                f,
                h,
                m,
                v,
                g,
                y,
                b,
                w,
                x,
                k,
                S,
                C,
                T,
                E,
                A,
                _,
                P,
                O,
                $,
                I,
                N,
                D,
                L,
                z,
                M,
                j,
                H,
                R,
                F,
                q,
                B,
                W,
                U,
                Z,
                V,
                K,
                X,
                Y,
                G,
                J,
                Q,
                ee,
                te,
                ne,
                ie,
                oe,
                re,
                se,
                ae,
                le,
                ce,
                ue,
                de,
                pe = function () {
                    return { x: 0, y: 0 };
                },
                fe = pe(),
                he = pe(),
                me = pe(),
                ve = {},
                ge = 0,
                ye = {},
                be = pe(),
                we = 0,
                xe = !0,
                ke = [],
                Se = {},
                Ce = !1,
                Te = function (e, t) {
                    o.extend(r, t.publicMethods), ke.push(e);
                },
                Ee = function (e) {
                    var t = en();
                    return e > t - 1 ? e - t : e < 0 ? t + e : e;
                },
                Ae = {},
                _e = function (e, t) {
                    return Ae[e] || (Ae[e] = []), Ae[e].push(t);
                },
                Pe = function (e) {
                    var t = Ae[e];
                    if (t) {
                        var n = Array.prototype.slice.call(arguments);
                        n.shift();
                        for (var i = 0; i < t.length; i++) t[i].apply(r, n);
                    }
                },
                Oe = function () {
                    return new Date().getTime();
                },
                $e = function (e) {
                    (ce = e), (r.bg.style.opacity = e * l.bgOpacity);
                },
                Ie = function (e, t, n, i, o) {
                    (!Ce || (o && o !== r.currItem)) && (i /= o ? o.fitRatio : r.currItem.fitRatio), (e[O] = w + t + "px, " + n + "px" + x + " scale(" + i + ")");
                },
                Ne = function (e) {
                    oe && (e && (y > r.currItem.fitRatio ? Ce || (fn(r.currItem, !1, !0), (Ce = !0)) : Ce && (fn(r.currItem), (Ce = !1))), Ie(oe, me.x, me.y, y));
                },
                De = function (e) {
                    e.container && Ie(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e);
                },
                Le = function (e, t) {
                    t[O] = w + e + "px, 0px" + x;
                },
                ze = function (e, t) {
                    if (!l.loop && t) {
                        var n = p + (be.x * ge - e) / be.x,
                            i = Math.round(e - bt.x);
                        ((n < 0 && i > 0) || (n >= en() - 1 && i < 0)) && (e = bt.x + i * l.mainScrollEndFriction);
                    }
                    (bt.x = e), Le(e, f);
                },
                Me = function (e, t) {
                    var n = wt[e] - ye[e];
                    return he[e] + fe[e] + n - n * (t / b);
                },
                je = function (e, t) {
                    (e.x = t.x), (e.y = t.y), t.id && (e.id = t.id);
                },
                He = function (e) {
                    (e.x = Math.round(e.x)), (e.y = Math.round(e.y));
                },
                Re = null,
                Fe = function () {
                    Re && (o.unbind(document, "mousemove", Fe), o.addClass(e, "pswp--has_mouse"), (l.mouseUsed = !0), Pe("mouseUsed")),
                        (Re = setTimeout(function () {
                            Re = null;
                        }, 100));
                },
                qe = function () {
                    o.bind(document, "keydown", r), H.transform && o.bind(r.scrollWrap, "click", r), l.mouseUsed || o.bind(document, "mousemove", Fe), o.bind(window, "resize scroll orientationchange", r), Pe("bindEvents");
                },
                Be = function () {
                    o.unbind(window, "resize scroll orientationchange", r),
                        o.unbind(window, "scroll", g.scroll),
                        o.unbind(document, "keydown", r),
                        o.unbind(document, "mousemove", Fe),
                        H.transform && o.unbind(r.scrollWrap, "click", r),
                        V && o.unbind(window, m, r),
                        clearTimeout(R),
                        Pe("unbindEvents");
                },
                We = function (e, t) {
                    var n = cn(r.currItem, ve, e);
                    return t && (ie = n), n;
                },
                Ue = function (e) {
                    return e || (e = r.currItem), e.initialZoomLevel;
                },
                Ze = function (e) {
                    return e || (e = r.currItem), e.w > 0 ? l.maxSpreadZoom : 1;
                },
                Ve = function (e, t, n, i) {
                    return i === r.currItem.initialZoomLevel ? ((n[e] = r.currItem.initialPosition[e]), !0) : ((n[e] = Me(e, i)), n[e] > t.min[e] ? ((n[e] = t.min[e]), !0) : n[e] < t.max[e] && ((n[e] = t.max[e]), !0));
                },
                Ke = function () {
                    if (O) {
                        var t = H.perspective && !I;
                        return (w = "translate" + (t ? "3d(" : "(")), void (x = H.perspective ? ", 0px)" : ")");
                    }
                    (O = "left"),
                        o.addClass(e, "pswp--ie"),
                        (Le = function (e, t) {
                            t.left = e + "px";
                        }),
                        (De = function (e) {
                            var t = e.fitRatio > 1 ? 1 : e.fitRatio,
                                n = e.container.style,
                                i = t * e.w,
                                o = t * e.h;
                            (n.width = i + "px"), (n.height = o + "px"), (n.left = e.initialPosition.x + "px"), (n.top = e.initialPosition.y + "px");
                        }),
                        (Ne = function () {
                            if (oe) {
                                var e = oe,
                                    t = r.currItem,
                                    n = t.fitRatio > 1 ? 1 : t.fitRatio,
                                    i = n * t.w,
                                    o = n * t.h;
                                (e.width = i + "px"), (e.height = o + "px"), (e.left = me.x + "px"), (e.top = me.y + "px");
                            }
                        });
                },
                Xe = function (e) {
                    var t = "";
                    l.escKey && 27 === e.keyCode ? (t = "close") : l.arrowKeys && (37 === e.keyCode ? (t = "prev") : 39 === e.keyCode && (t = "next")),
                        t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : (e.returnValue = !1), r[t]()));
                },
                Ye = function (e) {
                    e && (Y || X || re || U) && (e.preventDefault(), e.stopPropagation());
                },
                Ge = function () {
                    r.setScrollOffset(0, o.getScrollY());
                },
                Je = {},
                Qe = 0,
                et = function (e) {
                    Je[e] && (Je[e].raf && D(Je[e].raf), Qe--, delete Je[e]);
                },
                tt = function (e) {
                    Je[e] && et(e), Je[e] || (Qe++, (Je[e] = {}));
                },
                nt = function () {
                    for (var e in Je) Je.hasOwnProperty(e) && et(e);
                },
                it = function (e, t, n, i, o, r, s) {
                    var a,
                        l = Oe();
                    tt(e);
                    var c = function () {
                        if (Je[e]) {
                            if (((a = Oe() - l), a >= i)) return et(e), r(n), void (s && s());
                            r((n - t) * o(a / i) + t), (Je[e].raf = N(c));
                        }
                    };
                    c();
                },
                ot = {
                    shout: Pe,
                    listen: _e,
                    viewportSize: ve,
                    options: l,
                    isMainScrollAnimating: function () {
                        return re;
                    },
                    getZoomLevel: function () {
                        return y;
                    },
                    getCurrentIndex: function () {
                        return p;
                    },
                    isDragging: function () {
                        return V;
                    },
                    isZooming: function () {
                        return ee;
                    },
                    setScrollOffset: function (e, t) {
                        (ye.x = e), (j = ye.y = t), Pe("updateScrollOffset", ye);
                    },
                    applyZoomPan: function (e, t, n, i) {
                        (me.x = t), (me.y = n), (y = e), Ne(i);
                    },
                    init: function () {
                        if (!c && !u) {
                            var n;
                            (r.framework = o),
                                (r.template = e),
                                (r.bg = o.getChildByClass(e, "pswp__bg")),
                                (L = e.className),
                                (c = !0),
                                (H = o.detectFeatures()),
                                (N = H.raf),
                                (D = H.caf),
                                (O = H.transform),
                                (M = H.oldIE),
                                (r.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap")),
                                (r.container = o.getChildByClass(r.scrollWrap, "pswp__container")),
                                (f = r.container.style),
                                (r.itemHolders = C = [
                                    { el: r.container.children[0], wrap: 0, index: -1 },
                                    { el: r.container.children[1], wrap: 0, index: -1 },
                                    { el: r.container.children[2], wrap: 0, index: -1 },
                                ]),
                                (C[0].el.style.display = C[2].el.style.display = "none"),
                                Ke(),
                                (g = {
                                    resize: r.updateSize,
                                    orientationchange: function () {
                                        clearTimeout(R),
                                            (R = setTimeout(function () {
                                                ve.x !== r.scrollWrap.clientWidth && r.updateSize();
                                            }, 500));
                                    },
                                    scroll: Ge,
                                    keydown: Xe,
                                    click: Ye,
                                });
                            var i = H.isOldIOSPhone || H.isOldAndroid || H.isMobileOpera;
                            for ((H.animationName && H.transform && !i) || (l.showAnimationDuration = l.hideAnimationDuration = 0), n = 0; n < ke.length; n++) r["init" + ke[n]]();
                            if (t) {
                                var s = (r.ui = new t(r, o));
                                s.init();
                            }
                            Pe("firstUpdate"),
                                (p = p || l.index || 0),
                                (isNaN(p) || p < 0 || p >= en()) && (p = 0),
                                (r.currItem = Qt(p)),
                                (H.isOldIOSPhone || H.isOldAndroid) && (xe = !1),
                                e.setAttribute("aria-hidden", "false"),
                                l.modal && (xe ? (e.style.position = "fixed") : ((e.style.position = "absolute"), (e.style.top = o.getScrollY() + "px"))),
                                void 0 === j && (Pe("initialLayout"), (j = z = o.getScrollY()));
                            var d = "pswp--open ";
                            for (
                                l.mainClass && (d += l.mainClass + " "),
                                    l.showHideOpacity && (d += "pswp--animate_opacity "),
                                    d += I ? "pswp--touch" : "pswp--notouch",
                                    d += H.animationName ? " pswp--css_animation" : "",
                                    d += H.svg ? " pswp--svg" : "",
                                    o.addClass(e, d),
                                    r.updateSize(),
                                    h = -1,
                                    we = null,
                                    n = 0;
                                n < a;
                                n++
                            )
                                Le((n + h) * be.x, C[n].el.style);
                            M || o.bind(r.scrollWrap, v, r),
                                _e("initialZoomInEnd", function () {
                                    r.setContent(C[0], p - 1), r.setContent(C[2], p + 1), (C[0].el.style.display = C[2].el.style.display = "block"), l.focus && e.focus(), qe();
                                }),
                                r.setContent(C[1], p),
                                r.updateCurrItem(),
                                Pe("afterInit"),
                                xe ||
                                    (k = setInterval(function () {
                                        Qe || V || ee || y !== r.currItem.initialZoomLevel || r.updateSize();
                                    }, 1e3)),
                                o.addClass(e, "pswp--visible");
                        }
                    },
                    close: function () {
                        c && ((c = !1), (u = !0), Pe("close"), Be(), nn(r.currItem, null, !0, r.destroy));
                    },
                    destroy: function () {
                        Pe("destroy"), Xt && clearTimeout(Xt), e.setAttribute("aria-hidden", "true"), (e.className = L), k && clearInterval(k), o.unbind(r.scrollWrap, v, r), o.unbind(window, "scroll", r), Tt(), nt(), (Ae = null);
                    },
                    panTo: function (e, t, n) {
                        n || (e > ie.min.x ? (e = ie.min.x) : e < ie.max.x && (e = ie.max.x), t > ie.min.y ? (t = ie.min.y) : t < ie.max.y && (t = ie.max.y)), (me.x = e), (me.y = t), Ne();
                    },
                    handleEvent: function (e) {
                        (e = e || window.event), g[e.type] && g[e.type](e);
                    },
                    goTo: function (e) {
                        e = Ee(e);
                        var t = e - p;
                        (we = t), (p = e), (r.currItem = Qt(p)), (ge -= t), ze(be.x * ge), nt(), (re = !1), r.updateCurrItem();
                    },
                    next: function () {
                        r.goTo(p + 1);
                    },
                    prev: function () {
                        r.goTo(p - 1);
                    },
                    updateCurrZoomItem: function (e) {
                        if ((e && Pe("beforeChange", 0), C[1].el.children.length)) {
                            var t = C[1].el.children[0];
                            oe = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null;
                        } else oe = null;
                        (ie = r.currItem.bounds), (b = y = r.currItem.initialZoomLevel), (me.x = ie.center.x), (me.y = ie.center.y), e && Pe("afterChange");
                    },
                    invalidateCurrItems: function () {
                        S = !0;
                        for (var e = 0; e < a; e++) C[e].item && (C[e].item.needsUpdate = !0);
                    },
                    updateCurrItem: function (e) {
                        if (0 !== we) {
                            var t,
                                n = Math.abs(we);
                            if (!(e && n < 2)) {
                                (r.currItem = Qt(p)), (Ce = !1), Pe("beforeChange", we), n >= a && ((h += we + (we > 0 ? -a : a)), (n = a));
                                for (var i = 0; i < n; i++)
                                    we > 0
                                        ? ((t = C.shift()), (C[a - 1] = t), h++, Le((h + 2) * be.x, t.el.style), r.setContent(t, p - n + i + 1 + 1))
                                        : ((t = C.pop()), C.unshift(t), h--, Le(h * be.x, t.el.style), r.setContent(t, p + n - i - 1 - 1));
                                if (oe && 1 === Math.abs(we)) {
                                    var o = Qt(T);
                                    o.initialZoomLevel !== y && (cn(o, ve), fn(o), De(o));
                                }
                                (we = 0), r.updateCurrZoomItem(), (T = p), Pe("afterChange");
                            }
                        }
                    },
                    updateSize: function (t) {
                        if (!xe && l.modal) {
                            var n = o.getScrollY();
                            if ((j !== n && ((e.style.top = n + "px"), (j = n)), !t && Se.x === window.innerWidth && Se.y === window.innerHeight)) return;
                            (Se.x = window.innerWidth), (Se.y = window.innerHeight), (e.style.height = Se.y + "px");
                        }
                        if (((ve.x = r.scrollWrap.clientWidth), (ve.y = r.scrollWrap.clientHeight), Ge(), (be.x = ve.x + Math.round(ve.x * l.spacing)), (be.y = ve.y), ze(be.x * ge), Pe("beforeResize"), void 0 !== h)) {
                            for (var i, s, c, u = 0; u < a; u++)
                                (i = C[u]),
                                    Le((u + h) * be.x, i.el.style),
                                    (c = p + u - 1),
                                    l.loop && en() > 2 && (c = Ee(c)),
                                    (s = Qt(c)),
                                    s && (S || s.needsUpdate || !s.bounds)
                                        ? (r.cleanSlide(s), r.setContent(i, c), 1 === u && ((r.currItem = s), r.updateCurrZoomItem(!0)), (s.needsUpdate = !1))
                                        : i.index === -1 && c >= 0 && r.setContent(i, c),
                                    s && s.container && (cn(s, ve), fn(s), De(s));
                            S = !1;
                        }
                        (b = y = r.currItem.initialZoomLevel), (ie = r.currItem.bounds), ie && ((me.x = ie.center.x), (me.y = ie.center.y), Ne(!0)), Pe("resize");
                    },
                    zoomTo: function (e, t, n, i, r) {
                        t && ((b = y), (wt.x = Math.abs(t.x) - me.x), (wt.y = Math.abs(t.y) - me.y), je(he, me));
                        var s = We(e, !1),
                            a = {};
                        Ve("x", s, a, e), Ve("y", s, a, e);
                        var l = y,
                            c = { x: me.x, y: me.y };
                        He(a);
                        var u = function (t) {
                            1 === t ? ((y = e), (me.x = a.x), (me.y = a.y)) : ((y = (e - l) * t + l), (me.x = (a.x - c.x) * t + c.x), (me.y = (a.y - c.y) * t + c.y)), r && r(t), Ne(1 === t);
                        };
                        n ? it("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, u) : u(1);
                    },
                },
                rt = 30,
                st = 10,
                at = {},
                lt = {},
                ct = {},
                ut = {},
                dt = {},
                pt = [],
                ft = {},
                ht = [],
                mt = {},
                vt = 0,
                gt = pe(),
                yt = 0,
                bt = pe(),
                wt = pe(),
                xt = pe(),
                kt = function (e, t) {
                    return e.x === t.x && e.y === t.y;
                },
                St = function (e, t) {
                    return Math.abs(e.x - t.x) < s && Math.abs(e.y - t.y) < s;
                },
                Ct = function (e, t) {
                    return (mt.x = Math.abs(e.x - t.x)), (mt.y = Math.abs(e.y - t.y)), Math.sqrt(mt.x * mt.x + mt.y * mt.y);
                },
                Tt = function () {
                    G && (D(G), (G = null));
                },
                Et = function () {
                    V && ((G = N(Et)), qt());
                },
                At = function () {
                    return !("fit" === l.scaleMode && y === r.currItem.initialZoomLevel);
                },
                _t = function (e, t) {
                    return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : _t(e.parentNode, t));
                },
                Pt = {},
                Ot = function (e, t) {
                    return (Pt.prevent = !_t(e.target, l.isClickableElement)), Pe("preventDragEvent", e, t, Pt), Pt.prevent;
                },
                $t = function (e, t) {
                    return (t.x = e.pageX), (t.y = e.pageY), (t.id = e.identifier), t;
                },
                It = function (e, t, n) {
                    (n.x = 0.5 * (e.x + t.x)), (n.y = 0.5 * (e.y + t.y));
                },
                Nt = function (e, t, n) {
                    if (e - q > 50) {
                        var i = ht.length > 2 ? ht.shift() : {};
                        (i.x = t), (i.y = n), ht.push(i), (q = e);
                    }
                },
                Dt = function () {
                    var e = me.y - r.currItem.initialPosition.y;
                    return 1 - Math.abs(e / (ve.y / 2));
                },
                Lt = {},
                zt = {},
                Mt = [],
                jt = function (e) {
                    for (; Mt.length > 0; ) Mt.pop();
                    return (
                        $
                            ? ((de = 0),
                              pt.forEach(function (e) {
                                  0 === de ? (Mt[0] = e) : 1 === de && (Mt[1] = e), de++;
                              }))
                            : e.type.indexOf("touch") > -1
                            ? e.touches && e.touches.length > 0 && ((Mt[0] = $t(e.touches[0], Lt)), e.touches.length > 1 && (Mt[1] = $t(e.touches[1], zt)))
                            : ((Lt.x = e.pageX), (Lt.y = e.pageY), (Lt.id = ""), (Mt[0] = Lt)),
                        Mt
                    );
                },
                Ht = function (e, t) {
                    var n,
                        i,
                        o,
                        s,
                        a = 0,
                        c = me[e] + t[e],
                        u = t[e] > 0,
                        d = bt.x + t.x,
                        p = bt.x - ft.x;
                    return (
                        (n = c > ie.min[e] || c < ie.max[e] ? l.panEndFriction : 1),
                        (c = me[e] + t[e] * n),
                        (!l.allowPanToNext && y !== r.currItem.initialZoomLevel) ||
                        (oe
                            ? "h" !== se ||
                              "x" !== e ||
                              X ||
                              (u
                                  ? (c > ie.min[e] && ((n = l.panEndFriction), (a = ie.min[e] - c), (i = ie.min[e] - he[e])), (i <= 0 || p < 0) && en() > 1 ? ((s = d), p < 0 && d > ft.x && (s = ft.x)) : ie.min.x !== ie.max.x && (o = c))
                                  : (c < ie.max[e] && ((n = l.panEndFriction), (a = c - ie.max[e]), (i = he[e] - ie.max[e])), (i <= 0 || p > 0) && en() > 1 ? ((s = d), p > 0 && d < ft.x && (s = ft.x)) : ie.min.x !== ie.max.x && (o = c)))
                            : (s = d),
                        "x" !== e)
                            ? void (re || J || (y > r.currItem.fitRatio && (me[e] += t[e] * n)))
                            : (void 0 !== s && (ze(s, !0), (J = s !== ft.x)), ie.min.x !== ie.max.x && (void 0 !== o ? (me.x = o) : J || (me.x += t.x * n)), void 0 !== s)
                    );
                },
                Rt = function (e) {
                    if (!("mousedown" === e.type && e.button > 0)) {
                        if (Jt) return void e.preventDefault();
                        if (!Z || "mousedown" !== e.type) {
                            if ((Ot(e, !0) && e.preventDefault(), Pe("pointerDown"), $)) {
                                var t = o.arraySearch(pt, e.pointerId, "id");
                                t < 0 && (t = pt.length), (pt[t] = { x: e.pageX, y: e.pageY, id: e.pointerId });
                            }
                            var n = jt(e),
                                i = n.length;
                            (Q = null),
                                nt(),
                                (V && 1 !== i) ||
                                    ((V = ae = !0),
                                    o.bind(window, m, r),
                                    (W = ue = le = U = J = Y = K = X = !1),
                                    (se = null),
                                    Pe("firstTouchStart", n),
                                    je(he, me),
                                    (fe.x = fe.y = 0),
                                    je(ut, n[0]),
                                    je(dt, ut),
                                    (ft.x = be.x * ge),
                                    (ht = [{ x: ut.x, y: ut.y }]),
                                    (q = F = Oe()),
                                    We(y, !0),
                                    Tt(),
                                    Et()),
                                !ee &&
                                    i > 1 &&
                                    !re &&
                                    !J &&
                                    ((b = y), (X = !1), (ee = K = !0), (fe.y = fe.x = 0), je(he, me), je(at, n[0]), je(lt, n[1]), It(at, lt, xt), (wt.x = Math.abs(xt.x) - me.x), (wt.y = Math.abs(xt.y) - me.y), (te = ne = Ct(at, lt)));
                        }
                    }
                },
                Ft = function (e) {
                    if ((e.preventDefault(), $)) {
                        var t = o.arraySearch(pt, e.pointerId, "id");
                        if (t > -1) {
                            var n = pt[t];
                            (n.x = e.pageX), (n.y = e.pageY);
                        }
                    }
                    if (V) {
                        var i = jt(e);
                        if (se || Y || ee) Q = i;
                        else if (bt.x !== be.x * ge) se = "h";
                        else {
                            var r = Math.abs(i[0].x - ut.x) - Math.abs(i[0].y - ut.y);
                            Math.abs(r) >= st && ((se = r > 0 ? "h" : "v"), (Q = i));
                        }
                    }
                },
                qt = function () {
                    if (Q) {
                        var e = Q.length;
                        if (0 !== e)
                            if ((je(at, Q[0]), (ct.x = at.x - ut.x), (ct.y = at.y - ut.y), ee && e > 1)) {
                                if (((ut.x = at.x), (ut.y = at.y), !ct.x && !ct.y && kt(Q[1], lt))) return;
                                je(lt, Q[1]), X || ((X = !0), Pe("zoomGestureStarted"));
                                var t = Ct(at, lt),
                                    n = Vt(t);
                                n > r.currItem.initialZoomLevel + r.currItem.initialZoomLevel / 15 && (ue = !0);
                                var i = 1,
                                    o = Ue(),
                                    s = Ze();
                                if (n < o)
                                    if (l.pinchToClose && !ue && b <= r.currItem.initialZoomLevel) {
                                        var a = o - n,
                                            c = 1 - a / (o / 1.2);
                                        $e(c), Pe("onPinchClose", c), (le = !0);
                                    } else (i = (o - n) / o), i > 1 && (i = 1), (n = o - i * (o / 3));
                                else n > s && ((i = (n - s) / (6 * o)), i > 1 && (i = 1), (n = s + i * o));
                                i < 0 && (i = 0), (te = t), It(at, lt, gt), (fe.x += gt.x - xt.x), (fe.y += gt.y - xt.y), je(xt, gt), (me.x = Me("x", n)), (me.y = Me("y", n)), (W = n > y), (y = n), Ne();
                            } else {
                                if (!se) return;
                                if ((ae && ((ae = !1), Math.abs(ct.x) >= st && (ct.x -= Q[0].x - dt.x), Math.abs(ct.y) >= st && (ct.y -= Q[0].y - dt.y)), (ut.x = at.x), (ut.y = at.y), 0 === ct.x && 0 === ct.y)) return;
                                if ("v" === se && l.closeOnVerticalDrag && !At()) {
                                    (fe.y += ct.y), (me.y += ct.y);
                                    var u = Dt();
                                    return (U = !0), Pe("onVerticalDrag", u), $e(u), void Ne();
                                }
                                Nt(Oe(), at.x, at.y), (Y = !0), (ie = r.currItem.bounds);
                                var d = Ht("x", ct);
                                d || (Ht("y", ct), He(me), Ne());
                            }
                    }
                },
                Bt = function (e) {
                    if (H.isOldAndroid) {
                        if (Z && "mouseup" === e.type) return;
                        e.type.indexOf("touch") > -1 &&
                            (clearTimeout(Z),
                            (Z = setTimeout(function () {
                                Z = 0;
                            }, 600)));
                    }
                    Pe("pointerUp"), Ot(e, !1) && e.preventDefault();
                    var t;
                    if ($) {
                        var n = o.arraySearch(pt, e.pointerId, "id");
                        if (n > -1)
                            if (((t = pt.splice(n, 1)[0]), navigator.msPointerEnabled)) {
                                var i = { 4: "mouse", 2: "touch", 3: "pen" };
                                (t.type = i[e.pointerType]), t.type || (t.type = e.pointerType || "mouse");
                            } else t.type = e.pointerType || "mouse";
                    }
                    var s,
                        a = jt(e),
                        c = a.length;
                    if (("mouseup" === e.type && (c = 0), 2 === c)) return (Q = null), !0;
                    1 === c && je(dt, a[0]),
                        0 !== c ||
                            se ||
                            re ||
                            (t || ("mouseup" === e.type ? (t = { x: e.pageX, y: e.pageY, type: "mouse" }) : e.changedTouches && e.changedTouches[0] && (t = { x: e.changedTouches[0].pageX, y: e.changedTouches[0].pageY, type: "touch" })),
                            Pe("touchRelease", e, t));
                    var u = -1;
                    if (
                        (0 === c && ((V = !1), o.unbind(window, m, r), Tt(), ee ? (u = 0) : yt !== -1 && (u = Oe() - yt)),
                        (yt = 1 === c ? Oe() : -1),
                        (s = u !== -1 && u < 150 ? "zoom" : "swipe"),
                        ee && c < 2 && ((ee = !1), 1 === c && (s = "zoomPointerUp"), Pe("zoomGestureEnded")),
                        (Q = null),
                        Y || X || re || U)
                    )
                        if ((nt(), B || (B = Wt()), B.calculateSwipeSpeed("x"), U)) {
                            var d = Dt();
                            if (d < l.verticalDragRange) r.close();
                            else {
                                var p = me.y,
                                    f = ce;
                                it("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
                                    (me.y = (r.currItem.initialPosition.y - p) * e + p), $e((1 - f) * e + f), Ne();
                                }),
                                    Pe("onVerticalDrag", 1);
                            }
                        } else {
                            if ((J || re) && 0 === c) {
                                var h = Zt(s, B);
                                if (h) return;
                                s = "zoomPointerUp";
                            }
                            if (!re) return "swipe" !== s ? void Kt() : void (!J && y > r.currItem.fitRatio && Ut(B));
                        }
                },
                Wt = function () {
                    var e,
                        t,
                        n = {
                            lastFlickOffset: {},
                            lastFlickDist: {},
                            lastFlickSpeed: {},
                            slowDownRatio: {},
                            slowDownRatioReverse: {},
                            speedDecelerationRatio: {},
                            speedDecelerationRatioAbs: {},
                            distanceOffset: {},
                            backAnimDestination: {},
                            backAnimStarted: {},
                            calculateSwipeSpeed: function (i) {
                                ht.length > 1 ? ((e = Oe() - q + 50), (t = ht[ht.length - 2][i])) : ((e = Oe() - F), (t = dt[i])),
                                    (n.lastFlickOffset[i] = ut[i] - t),
                                    (n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i])),
                                    n.lastFlickDist[i] > 20 ? (n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e) : (n.lastFlickSpeed[i] = 0),
                                    Math.abs(n.lastFlickSpeed[i]) < 0.1 && (n.lastFlickSpeed[i] = 0),
                                    (n.slowDownRatio[i] = 0.95),
                                    (n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i]),
                                    (n.speedDecelerationRatio[i] = 1);
                            },
                            calculateOverBoundsAnimOffset: function (e, t) {
                                n.backAnimStarted[e] ||
                                    (me[e] > ie.min[e] ? (n.backAnimDestination[e] = ie.min[e]) : me[e] < ie.max[e] && (n.backAnimDestination[e] = ie.max[e]),
                                    void 0 !== n.backAnimDestination[e] &&
                                        ((n.slowDownRatio[e] = 0.7),
                                        (n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e]),
                                        n.speedDecelerationRatioAbs[e] < 0.05 &&
                                            ((n.lastFlickSpeed[e] = 0),
                                            (n.backAnimStarted[e] = !0),
                                            it("bounceZoomPan" + e, me[e], n.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
                                                (me[e] = t), Ne();
                                            }))));
                            },
                            calculateAnimOffset: function (e) {
                                n.backAnimStarted[e] ||
                                    ((n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - (n.slowDownRatioReverse[e] * n.timeDiff) / 10)),
                                    (n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e])),
                                    (n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff),
                                    (me[e] += n.distanceOffset[e]));
                            },
                            panAnimLoop: function () {
                                if (
                                    Je.zoomPan &&
                                    ((Je.zoomPan.raf = N(n.panAnimLoop)),
                                    (n.now = Oe()),
                                    (n.timeDiff = n.now - n.lastNow),
                                    (n.lastNow = n.now),
                                    n.calculateAnimOffset("x"),
                                    n.calculateAnimOffset("y"),
                                    Ne(),
                                    n.calculateOverBoundsAnimOffset("x"),
                                    n.calculateOverBoundsAnimOffset("y"),
                                    n.speedDecelerationRatioAbs.x < 0.05 && n.speedDecelerationRatioAbs.y < 0.05)
                                )
                                    return (me.x = Math.round(me.x)), (me.y = Math.round(me.y)), Ne(), void et("zoomPan");
                            },
                        };
                    return n;
                },
                Ut = function (e) {
                    return (
                        e.calculateSwipeSpeed("y"),
                        (ie = r.currItem.bounds),
                        (e.backAnimDestination = {}),
                        (e.backAnimStarted = {}),
                        Math.abs(e.lastFlickSpeed.x) <= 0.05 && Math.abs(e.lastFlickSpeed.y) <= 0.05
                            ? ((e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0), e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0)
                            : (tt("zoomPan"), (e.lastNow = Oe()), void e.panAnimLoop())
                    );
                },
                Zt = function (e, t) {
                    var n;
                    re || (vt = p);
                    var i;
                    if ("swipe" === e) {
                        var s = ut.x - dt.x,
                            a = t.lastFlickDist.x < 10;
                        s > rt && (a || t.lastFlickOffset.x > 20) ? (i = -1) : s < -rt && (a || t.lastFlickOffset.x < -20) && (i = 1);
                    }
                    var c;
                    i && ((p += i), p < 0 ? ((p = l.loop ? en() - 1 : 0), (c = !0)) : p >= en() && ((p = l.loop ? 0 : en() - 1), (c = !0)), (c && !l.loop) || ((we += i), (ge -= i), (n = !0)));
                    var u,
                        d = be.x * ge,
                        f = Math.abs(d - bt.x);
                    return (
                        n || d > bt.x == t.lastFlickSpeed.x > 0 ? ((u = Math.abs(t.lastFlickSpeed.x) > 0 ? f / Math.abs(t.lastFlickSpeed.x) : 333), (u = Math.min(u, 400)), (u = Math.max(u, 250))) : (u = 333),
                        vt === p && (n = !1),
                        (re = !0),
                        Pe("mainScrollAnimStart"),
                        it("mainScroll", bt.x, d, u, o.easing.cubic.out, ze, function () {
                            nt(), (re = !1), (vt = -1), (n || vt !== p) && r.updateCurrItem(), Pe("mainScrollAnimComplete");
                        }),
                        n && r.updateCurrItem(!0),
                        n
                    );
                },
                Vt = function (e) {
                    return (1 / ne) * e * b;
                },
                Kt = function () {
                    var e = y,
                        t = Ue(),
                        n = Ze();
                    y < t ? (e = t) : y > n && (e = n);
                    var i,
                        s = 1,
                        a = ce;
                    return le && !W && !ue && y < t
                        ? (r.close(), !0)
                        : (le &&
                              (i = function (e) {
                                  $e((s - a) * e + a);
                              }),
                          r.zoomTo(e, 0, 200, o.easing.cubic.out, i),
                          !0);
                };
            Te("Gestures", {
                publicMethods: {
                    initGestures: function () {
                        var e = function (e, t, n, i, o) {
                            (E = e + t), (A = e + n), (_ = e + i), (P = o ? e + o : "");
                        };
                        ($ = H.pointerEvent),
                            $ && H.touch && (H.touch = !1),
                            $
                                ? navigator.msPointerEnabled
                                    ? e("MSPointer", "Down", "Move", "Up", "Cancel")
                                    : e("pointer", "down", "move", "up", "cancel")
                                : H.touch
                                ? (e("touch", "start", "move", "end", "cancel"), (I = !0))
                                : e("mouse", "down", "move", "up"),
                            (m = A + " " + _ + " " + P),
                            (v = E),
                            $ && !I && (I = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
                            (r.likelyTouchDevice = I),
                            (g[E] = Rt),
                            (g[A] = Ft),
                            (g[_] = Bt),
                            P && (g[P] = g[_]),
                            H.touch && ((v += " mousedown"), (m += " mousemove mouseup"), (g.mousedown = g[E]), (g.mousemove = g[A]), (g.mouseup = g[_])),
                            I || (l.allowPanToNext = !1);
                    },
                },
            });
            var Xt,
                Yt,
                Gt,
                Jt,
                Qt,
                en,
                tn,
                nn = function (t, n, i, s) {
                    Xt && clearTimeout(Xt), (Jt = !0), (Gt = !0);
                    var a;
                    t.initialLayout ? ((a = t.initialLayout), (t.initialLayout = null)) : (a = l.getThumbBoundsFn && l.getThumbBoundsFn(p));
                    var c = i ? l.hideAnimationDuration : l.showAnimationDuration,
                        u = function () {
                            et("initialZoom"),
                                i ? (r.template.removeAttribute("style"), r.bg.removeAttribute("style")) : ($e(1), n && (n.style.display = "block"), o.addClass(e, "pswp--animated-in"), Pe("initialZoom" + (i ? "OutEnd" : "InEnd"))),
                                s && s(),
                                (Jt = !1);
                        };
                    if (!c || !a || void 0 === a.x)
                        return (
                            Pe("initialZoom" + (i ? "Out" : "In")),
                            (y = t.initialZoomLevel),
                            je(me, t.initialPosition),
                            Ne(),
                            (e.style.opacity = i ? 0 : 1),
                            $e(1),
                            void (c
                                ? setTimeout(function () {
                                      u();
                                  }, c)
                                : u())
                        );
                    var f = function () {
                        var n = d,
                            s = !r.currItem.src || r.currItem.loadError || l.showHideOpacity;
                        t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
                            i || ((y = a.w / t.w), (me.x = a.x), (me.y = a.y - z), (r[s ? "template" : "bg"].style.opacity = 0.001), Ne()),
                            tt("initialZoom"),
                            i && !n && o.removeClass(e, "pswp--animated-in"),
                            s &&
                                (i
                                    ? o[(n ? "remove" : "add") + "Class"](e, "pswp--animate_opacity")
                                    : setTimeout(function () {
                                          o.addClass(e, "pswp--animate_opacity");
                                      }, 30)),
                            (Xt = setTimeout(
                                function () {
                                    if ((Pe("initialZoom" + (i ? "Out" : "In")), i)) {
                                        var r = a.w / t.w,
                                            l = { x: me.x, y: me.y },
                                            d = y,
                                            p = ce,
                                            f = function (t) {
                                                1 === t ? ((y = r), (me.x = a.x), (me.y = a.y - j)) : ((y = (r - d) * t + d), (me.x = (a.x - l.x) * t + l.x), (me.y = (a.y - j - l.y) * t + l.y)),
                                                    Ne(),
                                                    s ? (e.style.opacity = 1 - t) : $e(p - t * p);
                                            };
                                        n ? it("initialZoom", 0, 1, c, o.easing.cubic.out, f, u) : (f(1), (Xt = setTimeout(u, c + 20)));
                                    } else (y = t.initialZoomLevel), je(me, t.initialPosition), Ne(), $e(1), s ? (e.style.opacity = 1) : $e(1), (Xt = setTimeout(u, c + 20));
                                },
                                i ? 25 : 90
                            ));
                    };
                    f();
                },
                on = {},
                rn = [],
                sn = {
                    index: 0,
                    errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                    forceProgressiveLoading: !1,
                    preload: [1, 1],
                    getNumItemsFn: function () {
                        return Yt.length;
                    },
                },
                an = function () {
                    return { center: { x: 0, y: 0 }, max: { x: 0, y: 0 }, min: { x: 0, y: 0 } };
                },
                ln = function (e, t, n) {
                    var i = e.bounds;
                    (i.center.x = Math.round((on.x - t) / 2)),
                        (i.center.y = Math.round((on.y - n) / 2) + e.vGap.top),
                        (i.max.x = t > on.x ? Math.round(on.x - t) : i.center.x),
                        (i.max.y = n > on.y ? Math.round(on.y - n) + e.vGap.top : i.center.y),
                        (i.min.x = t > on.x ? 0 : i.center.x),
                        (i.min.y = n > on.y ? e.vGap.top : i.center.y);
                },
                cn = function (e, t, n) {
                    if (e.src && !e.loadError) {
                        var i = !n;
                        if ((i && (e.vGap || (e.vGap = { top: 0, bottom: 0 }), Pe("parseVerticalMargin", e)), (on.x = t.x), (on.y = t.y - e.vGap.top - e.vGap.bottom), i)) {
                            var o = on.x / e.w,
                                r = on.y / e.h;
                            e.fitRatio = o < r ? o : r;
                            var s = l.scaleMode;
                            "orig" === s ? (n = 1) : "fit" === s ? (n = e.fitRatio) : "zoom" === s && (n = Math.max(e.initialZoomLevel || 1, e.fitRatio)), n > 1 && (n = 1), (e.initialZoomLevel = n), e.bounds || (e.bounds = an());
                        }
                        if (!n) return;
                        return ln(e, e.w * n, e.h * n), i && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds;
                    }
                    return (e.w = e.h = 0), (e.initialZoomLevel = e.fitRatio = 1), (e.bounds = an()), (e.initialPosition = e.bounds.center), e.bounds;
                },
                un = function (e, t, n, i, o, s) {
                    t.loadError ||
                        (i &&
                            ((t.imageAppended = !0),
                            fn(t, i, t === r.currItem && Ce),
                            n.appendChild(i),
                            s &&
                                setTimeout(function () {
                                    t && t.loaded && t.placeholder && ((t.placeholder.style.display = "none"), (t.placeholder = null));
                                }, 500)));
                },
                dn = function (e) {
                    (e.loading = !0), (e.loaded = !1);
                    var t = (e.img = o.createEl("pswp__img", "img")),
                        n = function () {
                            (e.loading = !1), (e.loaded = !0), e.loadComplete ? e.loadComplete(e) : (e.img = null), (t.onload = t.onerror = null), (t = null);
                        };
                    return (
                        (t.onload = n),
                        (t.onerror = function () {
                            (e.loadError = !0), n();
                        }),
                        (t.src = e.src),
                        t
                    );
                },
                pn = function (e, t) {
                    if (e.src && e.loadError && e.container) return t && (e.container.innerHTML = ""), (e.container.innerHTML = l.errorMsg.replace("%url%", e.src)), !0;
                },
                fn = function (e, t, n) {
                    if (e.src) {
                        t || (t = e.container.lastChild);
                        var i = n ? e.w : Math.round(e.w * e.fitRatio),
                            o = n ? e.h : Math.round(e.h * e.fitRatio);
                        e.placeholder && !e.loaded && ((e.placeholder.style.width = i + "px"), (e.placeholder.style.height = o + "px")), (t.style.width = i + "px"), (t.style.height = o + "px");
                    }
                },
                hn = function () {
                    if (rn.length) {
                        for (var e, t = 0; t < rn.length; t++) (e = rn[t]), e.holder.index === e.index && un(e.index, e.item, e.baseDiv, e.img, !1, e.clearPlaceholder);
                        rn = [];
                    }
                };
            Te("Controller", {
                publicMethods: {
                    lazyLoadItem: function (e) {
                        e = Ee(e);
                        var t = Qt(e);
                        t && ((!t.loaded && !t.loading) || S) && (Pe("gettingData", e, t), t.src && dn(t));
                    },
                    initController: function () {
                        o.extend(l, sn, !0),
                            (r.items = Yt = n),
                            (Qt = r.getItemAt),
                            (en = l.getNumItemsFn),
                            (tn = l.loop),
                            en() < 3 && (l.loop = !1),
                            _e("beforeChange", function (e) {
                                var t,
                                    n = l.preload,
                                    i = null === e || e >= 0,
                                    o = Math.min(n[0], en()),
                                    s = Math.min(n[1], en());
                                for (t = 1; t <= (i ? s : o); t++) r.lazyLoadItem(p + t);
                                for (t = 1; t <= (i ? o : s); t++) r.lazyLoadItem(p - t);
                            }),
                            _e("initialLayout", function () {
                                r.currItem.initialLayout = l.getThumbBoundsFn && l.getThumbBoundsFn(p);
                            }),
                            _e("mainScrollAnimComplete", hn),
                            _e("initialZoomInEnd", hn),
                            _e("destroy", function () {
                                for (var e, t = 0; t < Yt.length; t++)
                                    (e = Yt[t]), e.container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                rn = null;
                            });
                    },
                    getItemAt: function (e) {
                        return e >= 0 && void 0 !== Yt[e] && Yt[e];
                    },
                    allowProgressiveImg: function () {
                        return l.forceProgressiveLoading || !I || l.mouseUsed || screen.width > 1200;
                    },
                    setContent: function (e, t) {
                        l.loop && (t = Ee(t));
                        var n = r.getItemAt(e.index);
                        n && (n.container = null);
                        var i,
                            s = r.getItemAt(t);
                        if (!s) return void (e.el.innerHTML = "");
                        Pe("gettingData", t, s), (e.index = t), (e.item = s);
                        var a = (s.container = o.createEl("pswp__zoom-wrap"));
                        if ((!s.src && s.html && (s.html.tagName ? a.appendChild(s.html) : (a.innerHTML = s.html)), pn(s), cn(s, ve), !s.src || s.loadError || s.loaded))
                            s.src && !s.loadError && ((i = o.createEl("pswp__img", "img")), (i.style.opacity = 1), (i.src = s.src), fn(s, i), un(t, s, a, i, !0));
                        else {
                            if (
                                ((s.loadComplete = function (n) {
                                    if (c) {
                                        if (e && e.index === t) {
                                            if (pn(n, !0)) return (n.loadComplete = n.img = null), cn(n, ve), De(n), void (e.index === p && r.updateCurrZoomItem());
                                            n.imageAppended
                                                ? !Jt && n.placeholder && ((n.placeholder.style.display = "none"), (n.placeholder = null))
                                                : H.transform && (re || Jt)
                                                ? rn.push({ item: n, baseDiv: a, img: n.img, index: t, holder: e, clearPlaceholder: !0 })
                                                : un(t, n, a, n.img, re || Jt, !0);
                                        }
                                        (n.loadComplete = null), (n.img = null), Pe("imageLoadComplete", t, n);
                                    }
                                }),
                                o.features.transform)
                            ) {
                                var u = "pswp__img pswp__img--placeholder";
                                u += s.msrc ? "" : " pswp__img--placeholder--blank";
                                var d = o.createEl(u, s.msrc ? "img" : "");
                                s.msrc && (d.src = s.msrc), fn(s, d), a.appendChild(d), (s.placeholder = d);
                            }
                            s.loading || dn(s), r.allowProgressiveImg() && (!Gt && H.transform ? rn.push({ item: s, baseDiv: a, img: s.img, index: t, holder: e }) : un(t, s, a, s.img, !0, !0));
                        }
                        Gt || t !== p ? De(s) : ((oe = a.style), nn(s, i || s.img)), (e.el.innerHTML = ""), e.el.appendChild(a);
                    },
                    cleanSlide: function (e) {
                        e.img && (e.img.onload = e.img.onerror = null), (e.loaded = e.loading = e.img = e.imageAppended = !1);
                    },
                },
            });
            var mn,
                vn = {},
                gn = function (e, t, n) {
                    var i = document.createEvent("CustomEvent"),
                        o = { origEvent: e, target: e.target, releasePoint: t, pointerType: n || "touch" };
                    i.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(i);
                };
            Te("Tap", {
                publicMethods: {
                    initTap: function () {
                        _e("firstTouchStart", r.onTapStart),
                            _e("touchRelease", r.onTapRelease),
                            _e("destroy", function () {
                                (vn = {}), (mn = null);
                            });
                    },
                    onTapStart: function (e) {
                        e.length > 1 && (clearTimeout(mn), (mn = null));
                    },
                    onTapRelease: function (e, t) {
                        if (t && !Y && !K && !Qe) {
                            var n = t;
                            if (mn && (clearTimeout(mn), (mn = null), St(n, vn))) return void Pe("doubleTap", n);
                            if ("mouse" === t.type) return void gn(e, t, "mouse");
                            var i = e.target.tagName.toUpperCase();
                            if ("BUTTON" === i || o.hasClass(e.target, "pswp__single-tap")) return void gn(e, t);
                            je(vn, n),
                                (mn = setTimeout(function () {
                                    gn(e, t), (mn = null);
                                }, 300));
                        }
                    },
                },
            });
            var yn;
            Te("DesktopZoom", {
                publicMethods: {
                    initDesktopZoom: function () {
                        M ||
                            (I
                                ? _e("mouseUsed", function () {
                                      r.setupDesktopZoom();
                                  })
                                : r.setupDesktopZoom(!0));
                    },
                    setupDesktopZoom: function (t) {
                        yn = {};
                        var n = "wheel mousewheel DOMMouseScroll";
                        _e("bindEvents", function () {
                            o.bind(e, n, r.handleMouseWheel);
                        }),
                            _e("unbindEvents", function () {
                                yn && o.unbind(e, n, r.handleMouseWheel);
                            }),
                            (r.mouseZoomedIn = !1);
                        var i,
                            s = function () {
                                r.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"), (r.mouseZoomedIn = !1)), y < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"), a();
                            },
                            a = function () {
                                i && (o.removeClass(e, "pswp--dragging"), (i = !1));
                            };
                        _e("resize", s),
                            _e("afterChange", s),
                            _e("pointerDown", function () {
                                r.mouseZoomedIn && ((i = !0), o.addClass(e, "pswp--dragging"));
                            }),
                            _e("pointerUp", a),
                            t || s();
                    },
                    handleMouseWheel: function (e) {
                        if (y <= r.currItem.fitRatio) return l.modal && (!l.closeOnScroll || Qe || V ? e.preventDefault() : O && Math.abs(e.deltaY) > 2 && ((d = !0), r.close())), !0;
                        if ((e.stopPropagation(), (yn.x = 0), "deltaX" in e)) 1 === e.deltaMode ? ((yn.x = 18 * e.deltaX), (yn.y = 18 * e.deltaY)) : ((yn.x = e.deltaX), (yn.y = e.deltaY));
                        else if ("wheelDelta" in e) e.wheelDeltaX && (yn.x = -0.16 * e.wheelDeltaX), e.wheelDeltaY ? (yn.y = -0.16 * e.wheelDeltaY) : (yn.y = -0.16 * e.wheelDelta);
                        else {
                            if (!("detail" in e)) return;
                            yn.y = e.detail;
                        }
                        We(y, !0);
                        var t = me.x - yn.x,
                            n = me.y - yn.y;
                        (l.modal || (t <= ie.min.x && t >= ie.max.x && n <= ie.min.y && n >= ie.max.y)) && e.preventDefault(), r.panTo(t, n);
                    },
                    toggleDesktopZoom: function (t) {
                        t = t || { x: ve.x / 2 + ye.x, y: ve.y / 2 + ye.y };
                        var n = l.getDoubleTapZoom(!0, r.currItem),
                            i = y === n;
                        (r.mouseZoomedIn = !i), r.zoomTo(i ? r.currItem.initialZoomLevel : n, t, 333), o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in");
                    },
                },
            }),
                o.extend(r, ot);
        };
        return e;
    }),
    !(function (e, t) {
        "function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? (module.exports = t()) : (e.PhotoSwipeUI_Default = t());
    })(this, function () {
        "use strict";
        var e = function (e, t) {
            var n,
                i,
                o,
                r,
                s,
                a,
                l,
                c,
                u,
                d,
                p,
                f,
                h,
                m,
                v,
                g,
                y,
                b,
                w,
                x = this,
                k = !1,
                S = !0,
                C = !0,
                T = {
                    barsSize: { top: 44, bottom: "auto" },
                    closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                    timeToIdle: 4e3,
                    timeToIdleOutside: 1e3,
                    loadingIndicatorDelay: 1e3,
                    addCaptionHTMLFn: function (e, t) {
                        return e.title ? ((t.children[0].innerHTML = e.title), !0) : ((t.children[0].innerHTML = ""), !1);
                    },
                    closeEl: !0,
                    captionEl: !0,
                    fullscreenEl: !0,
                    zoomEl: !0,
                    shareEl: !0,
                    counterEl: !0,
                    arrowEl: !0,
                    preloaderEl: !0,
                    tapToClose: !1,
                    tapToToggleControls: !0,
                    clickToCloseNonZoomable: !0,
                    shareButtons: [
                        { id: "facebook", label: "Share on Facebook", url: "https://www.facebook.com/sharer/sharer.php?u={{url}}" },
                        { id: "twitter", label: "Tweet", url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}" },
                        { id: "pinterest", label: "Pin it", url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}" },
                        { id: "download", label: "Download image", url: "{{raw_image_url}}", download: !0 },
                    ],
                    getImageURLForShare: function () {
                        return e.currItem.src || "";
                    },
                    getPageURLForShare: function () {
                        return window.location.href;
                    },
                    getTextForShare: function () {
                        return e.currItem.title || "";
                    },
                    indexIndicatorSep: " / ",
                    fitControlsWidth: 1200,
                },
                E = function (e) {
                    if (g) return !0;
                    (e = e || window.event), v.timeToIdle && v.mouseUsed && !u && z();
                    for (var n, i, o = e.target || e.srcElement, r = o.getAttribute("class") || "", s = 0; s < W.length; s++) (n = W[s]), n.onTap && r.indexOf("pswp__" + n.name) > -1 && (n.onTap(), (i = !0));
                    if (i) {
                        e.stopPropagation && e.stopPropagation(), (g = !0);
                        var a = t.features.isOldAndroid ? 600 : 30;
                        y = setTimeout(function () {
                            g = !1;
                        }, a);
                    }
                },
                A = function () {
                    return !e.likelyTouchDevice || v.mouseUsed || screen.width > v.fitControlsWidth;
                },
                _ = function (e, n, i) {
                    t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n);
                },
                P = function () {
                    var e = 1 === v.getNumItemsFn();
                    e !== m && (_(i, "ui--one-slide", e), (m = e));
                },
                O = function () {
                    _(l, "share-modal--hidden", C);
                },
                $ = function () {
                    return (
                        (C = !C),
                        C
                            ? (t.removeClass(l, "pswp__share-modal--fade-in"),
                              setTimeout(function () {
                                  C && O();
                              }, 300))
                            : (O(),
                              setTimeout(function () {
                                  C || t.addClass(l, "pswp__share-modal--fade-in");
                              }, 30)),
                        C || N(),
                        !1
                    );
                },
                I = function (t) {
                    t = t || window.event;
                    var n = t.target || t.srcElement;
                    return (
                        e.shout("shareLinkClick", t, n),
                        !(
                            !n.href ||
                            (!n.hasAttribute("download") &&
                                (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), C || $(), 1))
                        )
                    );
                },
                N = function () {
                    for (var e, t, n, i, o, r = "", s = 0; s < v.shareButtons.length; s++)
                        (e = v.shareButtons[s]),
                            (n = v.getImageURLForShare(e)),
                            (i = v.getPageURLForShare(e)),
                            (o = v.getTextForShare(e)),
                            (t = e.url.replace("{{url}}", encodeURIComponent(i)).replace("{{image_url}}", encodeURIComponent(n)).replace("{{raw_image_url}}", n).replace("{{text}}", encodeURIComponent(o))),
                            (r += '<a href="' + t + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>"),
                            v.parseShareButtonOut && (r = v.parseShareButtonOut(e, r));
                    (l.children[0].innerHTML = r), (l.children[0].onclick = I);
                },
                D = function (e) {
                    for (var n = 0; n < v.closeElClasses.length; n++) if (t.hasClass(e, "pswp__" + v.closeElClasses[n])) return !0;
                },
                L = 0,
                z = function () {
                    clearTimeout(w), (L = 0), u && x.setIdle(!1);
                },
                M = function (e) {
                    e = e ? e : window.event;
                    var t = e.relatedTarget || e.toElement;
                    (t && "HTML" !== t.nodeName) ||
                        (clearTimeout(w),
                        (w = setTimeout(function () {
                            x.setIdle(!0);
                        }, v.timeToIdleOutside)));
                },
                j = function () {
                    v.fullscreenEl &&
                        !t.features.isOldAndroid &&
                        (n || (n = x.getFullscreenAPI()), n ? (t.bind(document, n.eventK, x.updateFullscreen), x.updateFullscreen(), t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs"));
                },
                H = function () {
                    v.preloaderEl &&
                        (R(!0),
                        d("beforeChange", function () {
                            clearTimeout(h),
                                (h = setTimeout(function () {
                                    e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || (e.currItem.img && !e.currItem.img.naturalWidth)) && R(!1) : R(!0);
                                }, v.loadingIndicatorDelay));
                        }),
                        d("imageLoadComplete", function (t, n) {
                            e.currItem === n && R(!0);
                        }));
                },
                R = function (e) {
                    f !== e && (_(p, "preloader--active", !e), (f = e));
                },
                F = function (e) {
                    var n = e.vGap;
                    if (A()) {
                        var s = v.barsSize;
                        if (v.captionEl && "auto" === s.bottom)
                            if ((r || ((r = t.createEl("pswp__caption pswp__caption--fake")), r.appendChild(t.createEl("pswp__caption__center")), i.insertBefore(r, o), t.addClass(i, "pswp__ui--fit")), v.addCaptionHTMLFn(e, r, !0))) {
                                var a = r.clientHeight;
                                n.bottom = parseInt(a, 10) || 44;
                            } else n.bottom = s.top;
                        else n.bottom = "auto" === s.bottom ? 0 : s.bottom;
                        n.top = s.top;
                    } else n.top = n.bottom = 0;
                },
                q = function () {
                    v.timeToIdle &&
                        d("mouseUsed", function () {
                            t.bind(document, "mousemove", z),
                                t.bind(document, "mouseout", M),
                                (b = setInterval(function () {
                                    L++, 2 === L && x.setIdle(!0);
                                }, v.timeToIdle / 2));
                        });
                },
                B = function () {
                    d("onVerticalDrag", function (e) {
                        S && e < 0.95 ? x.hideControls() : !S && e >= 0.95 && x.showControls();
                    });
                    var e;
                    d("onPinchClose", function (t) {
                        S && t < 0.9 ? (x.hideControls(), (e = !0)) : e && !S && t > 0.9 && x.showControls();
                    }),
                        d("zoomGestureEnded", function () {
                            (e = !1), e && !S && x.showControls();
                        });
                },
                W = [
                    {
                        name: "caption",
                        option: "captionEl",
                        onInit: function (e) {
                            o = e;
                        },
                    },
                    {
                        name: "share-modal",
                        option: "shareEl",
                        onInit: function (e) {
                            l = e;
                        },
                        onTap: function () {
                            $();
                        },
                    },
                    {
                        name: "button--share",
                        option: "shareEl",
                        onInit: function (e) {
                            a = e;
                        },
                        onTap: function () {
                            $();
                        },
                    },
                    { name: "button--zoom", option: "zoomEl", onTap: e.toggleDesktopZoom },
                    {
                        name: "counter",
                        option: "counterEl",
                        onInit: function (e) {
                            s = e;
                        },
                    },
                    { name: "button--close", option: "closeEl", onTap: e.close },
                    { name: "button--arrow--left", option: "arrowEl", onTap: e.prev },
                    { name: "button--arrow--right", option: "arrowEl", onTap: e.next },
                    {
                        name: "button--fs",
                        option: "fullscreenEl",
                        onTap: function () {
                            n.isFullscreen() ? n.exit() : n.enter();
                        },
                    },
                    {
                        name: "preloader",
                        option: "preloaderEl",
                        onInit: function (e) {
                            p = e;
                        },
                    },
                ],
                U = function () {
                    var e,
                        n,
                        o,
                        r = function (i) {
                            if (i)
                                for (var r = i.length, s = 0; s < r; s++) {
                                    (e = i[s]), (n = e.className);
                                    for (var a = 0; a < W.length; a++)
                                        (o = W[a]), n.indexOf("pswp__" + o.name) > -1 && (v[o.option] ? (t.removeClass(e, "pswp__element--disabled"), o.onInit && o.onInit(e)) : t.addClass(e, "pswp__element--disabled"));
                                }
                        };
                    r(i.children);
                    var s = t.getChildByClass(i, "pswp__top-bar");
                    s && r(s.children);
                };
            (x.init = function () {
                t.extend(e.options, T, !0),
                    (v = e.options),
                    (i = t.getChildByClass(e.scrollWrap, "pswp__ui")),
                    (d = e.listen),
                    B(),
                    d("beforeChange", x.update),
                    d("doubleTap", function (t) {
                        var n = e.currItem.initialZoomLevel;
                        e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(v.getDoubleTapZoom(!1, e.currItem), t, 333);
                    }),
                    d("preventDragEvent", function (e, t, n) {
                        var i = e.target || e.srcElement;
                        i && i.getAttribute("class") && e.type.indexOf("mouse") > -1 && (i.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1);
                    }),
                    d("bindEvents", function () {
                        t.bind(i, "pswpTap click", E), t.bind(e.scrollWrap, "pswpTap", x.onGlobalTap), e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", x.onMouseOver);
                    }),
                    d("unbindEvents", function () {
                        C || $(),
                            b && clearInterval(b),
                            t.unbind(document, "mouseout", M),
                            t.unbind(document, "mousemove", z),
                            t.unbind(i, "pswpTap click", E),
                            t.unbind(e.scrollWrap, "pswpTap", x.onGlobalTap),
                            t.unbind(e.scrollWrap, "mouseover", x.onMouseOver),
                            n && (t.unbind(document, n.eventK, x.updateFullscreen), n.isFullscreen() && ((v.hideAnimationDuration = 0), n.exit()), (n = null));
                    }),
                    d("destroy", function () {
                        v.captionEl && (r && i.removeChild(r), t.removeClass(o, "pswp__caption--empty")), l && (l.children[0].onclick = null), t.removeClass(i, "pswp__ui--over-close"), t.addClass(i, "pswp__ui--hidden"), x.setIdle(!1);
                    }),
                    v.showAnimationDuration || t.removeClass(i, "pswp__ui--hidden"),
                    d("initialZoomIn", function () {
                        v.showAnimationDuration && t.removeClass(i, "pswp__ui--hidden");
                    }),
                    d("initialZoomOut", function () {
                        t.addClass(i, "pswp__ui--hidden");
                    }),
                    d("parseVerticalMargin", F),
                    U(),
                    v.shareEl && a && l && (C = !0),
                    P(),
                    q(),
                    j(),
                    H();
            }),
                (x.setIdle = function (e) {
                    (u = e), _(i, "ui--idle", e);
                }),
                (x.update = function () {
                    S && e.currItem ? (x.updateIndexIndicator(), v.captionEl && (v.addCaptionHTMLFn(e.currItem, o), _(o, "caption--empty", !e.currItem.title)), (k = !0)) : (k = !1), C || $(), P();
                }),
                (x.updateFullscreen = function (i) {
                    i &&
                        setTimeout(function () {
                            e.setScrollOffset(0, t.getScrollY());
                        }, 50),
                        t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs");
                }),
                (x.updateIndexIndicator = function () {
                    v.counterEl && (s.innerHTML = e.getCurrentIndex() + 1 + v.indexIndicatorSep + v.getNumItemsFn());
                }),
                (x.onGlobalTap = function (n) {
                    n = n || window.event;
                    var i = n.target || n.srcElement;
                    if (!g)
                        if (n.detail && "mouse" === n.detail.pointerType) {
                            if (D(i)) return void e.close();
                            t.hasClass(i, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? v.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint));
                        } else if ((v.tapToToggleControls && (S ? x.hideControls() : x.showControls()), v.tapToClose && (t.hasClass(i, "pswp__img") || D(i)))) return void e.close();
                }),
                (x.onMouseOver = function (e) {
                    e = e || window.event;
                    var t = e.target || e.srcElement;
                    _(i, "ui--over-close", D(t));
                }),
                (x.hideControls = function () {
                    t.addClass(i, "pswp__ui--hidden"), (S = !1);
                }),
                (x.showControls = function () {
                    (S = !0), k || x.update(), t.removeClass(i, "pswp__ui--hidden");
                }),
                (x.supportsFullscreen = function () {
                    var e = document;
                    return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen);
                }),
                (x.getFullscreenAPI = function () {
                    var t,
                        n = document.documentElement,
                        i = "fullscreenchange";
                    return (
                        n.requestFullscreen
                            ? (t = { enterK: "requestFullscreen", exitK: "exitFullscreen", elementK: "fullscreenElement", eventK: i })
                            : n.mozRequestFullScreen
                            ? (t = { enterK: "mozRequestFullScreen", exitK: "mozCancelFullScreen", elementK: "mozFullScreenElement", eventK: "moz" + i })
                            : n.webkitRequestFullscreen
                            ? (t = { enterK: "webkitRequestFullscreen", exitK: "webkitExitFullscreen", elementK: "webkitFullscreenElement", eventK: "webkit" + i })
                            : n.msRequestFullscreen && (t = { enterK: "msRequestFullscreen", exitK: "msExitFullscreen", elementK: "msFullscreenElement", eventK: "MSFullscreenChange" }),
                        t &&
                            ((t.enter = function () {
                                return (c = v.closeOnScroll), (v.closeOnScroll = !1), "webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
                            }),
                            (t.exit = function () {
                                return (v.closeOnScroll = c), document[this.exitK]();
                            }),
                            (t.isFullscreen = function () {
                                return document[this.elementK];
                            })),
                        t
                    );
                });
        };
        return e;
    });